/*
 * @license
 * PIPELINE Theme (c) Groupthought Themes
 *
 * This file is included for advanced development by
 * Shopify Agencies. Modified versions of the theme
 * code are not supported by Shopify or Groupthought.
 *
 * Add any minor JS changes in assets/custom.js, this
 * will make it easier to update the theme in the future.
 *
 */

import Alpine from 'alpinejs';

(function () {
  const env = {NODE_ENV: 'production'};
  try {
    if (process) {
      process.env = Object.assign({}, process.env);
      Object.assign(process.env, env);
      return;
    }
  } catch (e) {} // avoid ReferenceError: process is not defined
  globalThis.process = {env: env};
})();

// packages/collapse/src/index.js
function src_default$5(Alpine) {
  Alpine.directive('collapse', collapse);
  collapse.inline = (el, {modifiers}) => {
    if (!modifiers.includes('min')) return;
    el._x_doShow = () => {};
    el._x_doHide = () => {};
  };
  function collapse(el, {modifiers}) {
    let duration = modifierValue(modifiers, 'duration', 250) / 1e3;
    let floor = modifierValue(modifiers, 'min', 0);
    let fullyHide = !modifiers.includes('min');
    if (!el._x_isShown) el.style.height = `${floor}px`;
    if (!el._x_isShown && fullyHide) el.hidden = true;
    if (!el._x_isShown) el.style.overflow = 'hidden';
    let setFunction = (el2, styles) => {
      let revertFunction = Alpine.setStyles(el2, styles);
      return styles.height ? () => {} : revertFunction;
    };
    let transitionStyles = {
      transitionProperty: 'height',
      transitionDuration: `${duration}s`,
      transitionTimingFunction: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
    };
    el._x_transition = {
      in(before = () => {}, after = () => {}) {
        if (fullyHide) el.hidden = false;
        if (fullyHide) el.style.display = null;
        let current = el.getBoundingClientRect().height;
        el.style.height = 'auto';
        let full = el.getBoundingClientRect().height;
        if (current === full) {
          current = floor;
        }
        Alpine.transition(
          el,
          Alpine.setStyles,
          {
            during: transitionStyles,
            start: {height: current + 'px'},
            end: {height: full + 'px'},
          },
          () => (el._x_isShown = true),
          () => {
            if (Math.abs(el.getBoundingClientRect().height - full) < 1) {
              el.style.overflow = null;
            }
          },
        );
      },
      out(before = () => {}, after = () => {}) {
        let full = el.getBoundingClientRect().height;
        Alpine.transition(
          el,
          setFunction,
          {
            during: transitionStyles,
            start: {height: full + 'px'},
            end: {height: floor + 'px'},
          },
          () => (el.style.overflow = 'hidden'),
          () => {
            el._x_isShown = false;
            if (el.style.height == `${floor}px` && fullyHide) {
              el.style.display = 'none';
              el.hidden = true;
            }
          },
        );
      },
    };
  }
}
function modifierValue(modifiers, key, fallback) {
  if (modifiers.indexOf(key) === -1) return fallback;
  const rawValue = modifiers[modifiers.indexOf(key) + 1];
  if (!rawValue) return fallback;
  if (key === 'duration') {
    let match = rawValue.match(/([0-9]+)ms/);
    if (match) return match[1];
  }
  if (key === 'min') {
    let match = rawValue.match(/([0-9]+)px/);
    if (match) return match[1];
  }
  return rawValue;
}

// packages/collapse/builds/module.js
var module_default$5 = src_default$5;

// node_modules/tabbable/dist/index.esm.js
var candidateSelectors$1 = [
  'input',
  'select',
  'textarea',
  'a[href]',
  'button',
  '[tabindex]:not(slot)',
  'audio[controls]',
  'video[controls]',
  '[contenteditable]:not([contenteditable="false"])',
  'details>summary:first-of-type',
  'details',
];
var candidateSelector$1 = /* @__PURE__ */ candidateSelectors$1.join(',');
var NoElement$1 = typeof Element === 'undefined';
var matches$1 = NoElement$1
  ? function () {}
  : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode$1 =
  !NoElement$1 && Element.prototype.getRootNode
    ? function (element) {
        return element.getRootNode();
      }
    : function (element) {
        return element.ownerDocument;
      };
var getCandidates$1 = function getCandidates2(el, includeContainer, filter) {
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector$1));
  if (includeContainer && matches$1.call(el, candidateSelector$1)) {
    candidates.unshift(el);
  }
  candidates = candidates.filter(filter);
  return candidates;
};
var getCandidatesIteratively$1 = function getCandidatesIteratively2(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);
  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();
    if (element.tagName === 'SLOT') {
      var assigned = element.assignedElements();
      var content = assigned.length ? assigned : element.children;
      var nestedCandidates = getCandidatesIteratively2(content, true, options);
      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scope: element,
          candidates: nestedCandidates,
        });
      }
    } else {
      var validCandidate = matches$1.call(element, candidateSelector$1);
      if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      }
      var shadowRoot =
        element.shadowRoot || // check for an undisclosed shadow
        (typeof options.getShadowRoot === 'function' && options.getShadowRoot(element));
      var validShadowRoot = !options.shadowRootFilter || options.shadowRootFilter(element);
      if (shadowRoot && validShadowRoot) {
        var _nestedCandidates = getCandidatesIteratively2(
          shadowRoot === true ? element.children : shadowRoot.children,
          true,
          options,
        );
        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scope: element,
            candidates: _nestedCandidates,
          });
        }
      } else {
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }
  return candidates;
};
var getTabindex = function getTabindex2(node, isScope) {
  if (node.tabIndex < 0) {
    if (
      (isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || node.isContentEditable) &&
      isNaN(parseInt(node.getAttribute('tabindex'), 10))
    ) {
      return 0;
    }
  }
  return node.tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables2(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput$1 = function isInput2(node) {
  return node.tagName === 'INPUT';
};
var isHiddenInput$2 = function isHiddenInput2(node) {
  return isInput$1(node) && node.type === 'hidden';
};
var isDetailsWithSummary$1 = function isDetailsWithSummary2(node) {
  var r =
    node.tagName === 'DETAILS' &&
    Array.prototype.slice.apply(node.children).some(function (child) {
      return child.tagName === 'SUMMARY';
    });
  return r;
};
var getCheckedRadio = function getCheckedRadio2(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};
var isTabbableRadio = function isTabbableRadio2(node) {
  if (!node.name) {
    return true;
  }
  var radioScope = node.form || getRootNode$1(node);
  var queryRadios = function queryRadios2(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };
  var radioSet;
  if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      console.error(
        'Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s',
        err.message,
      );
      return false;
    }
  }
  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};
var isRadio = function isRadio2(node) {
  return isInput$1(node) && node.type === 'radio';
};
var isNonTabbableRadio = function isNonTabbableRadio2(node) {
  return isRadio(node) && !isTabbableRadio(node);
};
var isZeroArea$1 = function isZeroArea2(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
    width = _node$getBoundingClie.width,
    height = _node$getBoundingClie.height;
  return width === 0 && height === 0;
};
var isHidden$1 = function isHidden2(node, _ref) {
  var displayCheck = _ref.displayCheck,
    getShadowRoot = _ref.getShadowRoot;
  if (getComputedStyle(node).visibility === 'hidden') {
    return true;
  }
  var isDirectSummary = matches$1.call(node, 'details>summary:first-of-type');
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
  if (matches$1.call(nodeUnderDetails, 'details:not([open]) *')) {
    return true;
  }
  var nodeRootHost = getRootNode$1(node).host;
  var nodeIsAttached =
    (nodeRootHost === null || nodeRootHost === void 0 ? void 0 : nodeRootHost.ownerDocument.contains(nodeRootHost)) ||
    node.ownerDocument.contains(node);
  if (!displayCheck || displayCheck === 'full') {
    if (typeof getShadowRoot === 'function') {
      var originalNode = node;
      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode$1(node);
        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true) {
          return isZeroArea$1(node);
        } else if (node.assignedSlot) {
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          node = rootNode.host;
        } else {
          node = parentElement;
        }
      }
      node = originalNode;
    }
    if (nodeIsAttached) {
      return !node.getClientRects().length;
    }
  } else if (displayCheck === 'non-zero-area') {
    return isZeroArea$1(node);
  }
  return false;
};
var isDisabledFromFieldset$1 = function isDisabledFromFieldset2(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement;
    while (parentNode) {
      if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);
          if (child.tagName === 'LEGEND') {
            return matches$1.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
          }
        }
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }
  return false;
};
var isNodeMatchingSelectorFocusable$1 = function isNodeMatchingSelectorFocusable2(options, node) {
  if (
    node.disabled ||
    isHiddenInput$2(node) ||
    isHidden$1(node, options) || // For a details element with a summary, the summary element gets the focus
    isDetailsWithSummary$1(node) ||
    isDisabledFromFieldset$1(node)
  ) {
    return false;
  }
  return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable2(options, node) {
  if (isNonTabbableRadio(node) || getTabindex(node) < 0 || !isNodeMatchingSelectorFocusable$1(options, node)) {
    return false;
  }
  return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable2(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  }
  return false;
};
var sortByOrder = function sortByOrder2(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function (item, i) {
    var isScope = !!item.scope;
    var element = isScope ? item.scope : item;
    var candidateTabindex = getTabindex(element, isScope);
    var elements = isScope ? sortByOrder2(item.candidates) : element;
    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        item,
        isScope,
        content: elements,
      });
    }
  });
  return orderedTabbables
    .sort(sortOrderedTabbables)
    .reduce(function (acc, sortable) {
      sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
      return acc;
    }, [])
    .concat(regularTabbables);
};
var tabbable = function tabbable2(el, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively$1([el], options.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options),
      flatten: false,
      getShadowRoot: options.getShadowRoot,
      shadowRootFilter: isValidShadowRootTabbable,
    });
  } else {
    candidates = getCandidates$1(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  }
  return sortByOrder(candidates);
};
var focusable$1 = function focusable2(el, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively$1([el], options.includeContainer, {
      filter: isNodeMatchingSelectorFocusable$1.bind(null, options),
      flatten: true,
      getShadowRoot: options.getShadowRoot,
    });
  } else {
    candidates = getCandidates$1(el, options.includeContainer, isNodeMatchingSelectorFocusable$1.bind(null, options));
  }
  return candidates;
};
var isTabbable = function isTabbable2(node, options) {
  options = options || {};
  if (!node) {
    throw new Error('No node provided');
  }
  if (matches$1.call(node, candidateSelector$1) === false) {
    return false;
  }
  return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector$1 = /* @__PURE__ */ candidateSelectors$1.concat('iframe').join(',');
var isFocusable$1 = function isFocusable2(node, options) {
  options = options || {};
  if (!node) {
    throw new Error('No node provided');
  }
  if (matches$1.call(node, focusableCandidateSelector$1) === false) {
    return false;
  }
  return isNodeMatchingSelectorFocusable$1(options, node);
};

// node_modules/focus-trap/dist/focus-trap.esm.js
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    (enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols));
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
        : ownKeys(Object(source)).forEach(function (key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
          });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var activeFocusTraps = (function () {
  var trapQueue = [];
  return {
    activateTrap: function activateTrap(trap) {
      if (trapQueue.length > 0) {
        var activeTrap = trapQueue[trapQueue.length - 1];
        if (activeTrap !== trap) {
          activeTrap.pause();
        }
      }
      var trapIndex = trapQueue.indexOf(trap);
      if (trapIndex === -1) {
        trapQueue.push(trap);
      } else {
        trapQueue.splice(trapIndex, 1);
        trapQueue.push(trap);
      }
    },
    deactivateTrap: function deactivateTrap(trap) {
      var trapIndex = trapQueue.indexOf(trap);
      if (trapIndex !== -1) {
        trapQueue.splice(trapIndex, 1);
      }
      if (trapQueue.length > 0) {
        trapQueue[trapQueue.length - 1].unpause();
      }
    },
  };
})();
var isSelectableInput = function isSelectableInput2(node) {
  return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
};
var isEscapeEvent = function isEscapeEvent2(e) {
  return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
};
var isTabEvent = function isTabEvent2(e) {
  return e.key === 'Tab' || e.keyCode === 9;
};
var delay = function delay2(fn) {
  return setTimeout(fn, 0);
};
var findIndex = function findIndex2(arr, fn) {
  var idx = -1;
  arr.every(function (value, i) {
    if (fn(value)) {
      idx = i;
      return false;
    }
    return true;
  });
  return idx;
};
var valueOrHandler = function valueOrHandler2(value) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }
  return typeof value === 'function' ? value.apply(void 0, params) : value;
};
var getActualTarget = function getActualTarget2(event) {
  return event.target.shadowRoot && typeof event.composedPath === 'function' ? event.composedPath()[0] : event.target;
};
var createFocusTrap = function createFocusTrap2(elements, userOptions) {
  var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
  var config = _objectSpread2(
    {
      returnFocusOnDeactivate: true,
      escapeDeactivates: true,
      delayInitialFocus: true,
    },
    userOptions,
  );
  var state = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   firstTabbableNode: HTMLElement|null,
    //   lastTabbableNode: HTMLElement|null,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
  };
  var trap;
  var getOption = function getOption2(configOverrideOptions, optionName, configOptionName) {
    return configOverrideOptions && configOverrideOptions[optionName] !== void 0
      ? configOverrideOptions[optionName]
      : config[configOptionName || optionName];
  };
  var findContainerIndex = function findContainerIndex2(element) {
    return state.containerGroups.findIndex(function (_ref) {
      var container = _ref.container,
        tabbableNodes = _ref.tabbableNodes;
      return (
        container.contains(element) || // fall back to explicit tabbable search which will take into consideration any
        //  web components if the `tabbableOptions.getShadowRoot` option was used for
        //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
        //  look inside web components even if open)
        tabbableNodes.find(function (node) {
          return node === element;
        })
      );
    });
  };
  var getNodeForOption = function getNodeForOption2(optionName) {
    var optionValue = config[optionName];
    if (typeof optionValue === 'function') {
      for (
        var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1;
        _key2 < _len2;
        _key2++
      ) {
        params[_key2 - 1] = arguments[_key2];
      }
      optionValue = optionValue.apply(void 0, params);
    }
    if (optionValue === true) {
      optionValue = void 0;
    }
    if (!optionValue) {
      if (optionValue === void 0 || optionValue === false) {
        return optionValue;
      }
      throw new Error('`'.concat(optionName, '` was specified but was not a node, or did not return a node'));
    }
    var node = optionValue;
    if (typeof optionValue === 'string') {
      node = doc.querySelector(optionValue);
      if (!node) {
        throw new Error('`'.concat(optionName, '` as selector refers to no known node'));
      }
    }
    return node;
  };
  var getInitialFocusNode = function getInitialFocusNode2() {
    var node = getNodeForOption('initialFocus');
    if (node === false) {
      return false;
    }
    if (node === void 0) {
      if (findContainerIndex(doc.activeElement) >= 0) {
        node = doc.activeElement;
      } else {
        var firstTabbableGroup = state.tabbableGroups[0];
        var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
        node = firstTabbableNode || getNodeForOption('fallbackFocus');
      }
    }
    if (!node) {
      throw new Error('Your focus-trap needs to have at least one focusable element');
    }
    return node;
  };
  var updateTabbableNodes = function updateTabbableNodes2() {
    state.containerGroups = state.containers.map(function (container) {
      var tabbableNodes = tabbable(container, config.tabbableOptions);
      var focusableNodes = focusable$1(container, config.tabbableOptions);
      return {
        container,
        tabbableNodes,
        focusableNodes,
        firstTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[0] : null,
        lastTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : null,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function nextTabbableNode(node) {
          var forward = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
          var nodeIdx = focusableNodes.findIndex(function (n) {
            return n === node;
          });
          if (nodeIdx < 0) {
            return void 0;
          }
          if (forward) {
            return focusableNodes.slice(nodeIdx + 1).find(function (n) {
              return isTabbable(n, config.tabbableOptions);
            });
          }
          return focusableNodes
            .slice(0, nodeIdx)
            .reverse()
            .find(function (n) {
              return isTabbable(n, config.tabbableOptions);
            });
        },
      };
    });
    state.tabbableGroups = state.containerGroups.filter(function (group) {
      return group.tabbableNodes.length > 0;
    });
    if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus')) {
      throw new Error(
        'Your focus-trap must have at least one container with at least one tabbable node in it at all times',
      );
    }
  };
  var tryFocus = function tryFocus2(node) {
    if (node === false) {
      return;
    }
    if (node === doc.activeElement) {
      return;
    }
    if (!node || !node.focus) {
      tryFocus2(getInitialFocusNode());
      return;
    }
    node.focus({
      preventScroll: !!config.preventScroll,
    });
    state.mostRecentlyFocusedNode = node;
    if (isSelectableInput(node)) {
      node.select();
    }
  };
  var getReturnFocusNode = function getReturnFocusNode2(previousActiveElement) {
    var node = getNodeForOption('setReturnFocus', previousActiveElement);
    return node ? node : node === false ? false : previousActiveElement;
  };
  var checkPointerDown = function checkPointerDown2(e) {
    var target = getActualTarget(e);
    if (findContainerIndex(target) >= 0) {
      return;
    }
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      trap.deactivate({
        // if, on deactivation, we should return focus to the node originally-focused
        //  when the trap was activated (or the configured `setReturnFocus` node),
        //  then assume it's also OK to return focus to the outside node that was
        //  just clicked, causing deactivation, as long as that node is focusable;
        //  if it isn't focusable, then return focus to the original node focused
        //  on activation (or the configured `setReturnFocus` node)
        // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
        //  which will result in the outside click setting focus to the node
        //  that was clicked, whether it's focusable or not; by setting
        //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
        //  on activation (or the configured `setReturnFocus` node)
        returnFocus: config.returnFocusOnDeactivate && !isFocusable$1(target, config.tabbableOptions),
      });
      return;
    }
    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }
    e.preventDefault();
  };
  var checkFocusIn = function checkFocusIn2(e) {
    var target = getActualTarget(e);
    var targetContained = findContainerIndex(target) >= 0;
    if (targetContained || target instanceof Document) {
      if (targetContained) {
        state.mostRecentlyFocusedNode = target;
      }
    } else {
      e.stopImmediatePropagation();
      tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
    }
  };
  var checkTab = function checkTab2(e) {
    var target = getActualTarget(e);
    updateTabbableNodes();
    var destinationNode = null;
    if (state.tabbableGroups.length > 0) {
      var containerIndex = findContainerIndex(target);
      var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : void 0;
      if (containerIndex < 0) {
        if (e.shiftKey) {
          destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
        } else {
          destinationNode = state.tabbableGroups[0].firstTabbableNode;
        }
      } else if (e.shiftKey) {
        var startOfGroupIndex = findIndex(state.tabbableGroups, function (_ref2) {
          var firstTabbableNode = _ref2.firstTabbableNode;
          return target === firstTabbableNode;
        });
        if (
          startOfGroupIndex < 0 &&
          (containerGroup.container === target ||
            (isFocusable$1(target, config.tabbableOptions) &&
              !isTabbable(target, config.tabbableOptions) &&
              !containerGroup.nextTabbableNode(target, false)))
        ) {
          startOfGroupIndex = containerIndex;
        }
        if (startOfGroupIndex >= 0) {
          var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
          var destinationGroup = state.tabbableGroups[destinationGroupIndex];
          destinationNode = destinationGroup.lastTabbableNode;
        }
      } else {
        var lastOfGroupIndex = findIndex(state.tabbableGroups, function (_ref3) {
          var lastTabbableNode = _ref3.lastTabbableNode;
          return target === lastTabbableNode;
        });
        if (
          lastOfGroupIndex < 0 &&
          (containerGroup.container === target ||
            (isFocusable$1(target, config.tabbableOptions) &&
              !isTabbable(target, config.tabbableOptions) &&
              !containerGroup.nextTabbableNode(target)))
        ) {
          lastOfGroupIndex = containerIndex;
        }
        if (lastOfGroupIndex >= 0) {
          var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
          var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
          destinationNode = _destinationGroup.firstTabbableNode;
        }
      }
    } else {
      destinationNode = getNodeForOption('fallbackFocus');
    }
    if (destinationNode) {
      e.preventDefault();
      tryFocus(destinationNode);
    }
  };
  var checkKey = function checkKey2(e) {
    if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
      e.preventDefault();
      trap.deactivate();
      return;
    }
    if (isTabEvent(e)) {
      checkTab(e);
      return;
    }
  };
  var checkClick = function checkClick2(e) {
    var target = getActualTarget(e);
    if (findContainerIndex(target) >= 0) {
      return;
    }
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      return;
    }
    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
  };
  var addListeners = function addListeners2() {
    if (!state.active) {
      return;
    }
    activeFocusTraps.activateTrap(trap);
    state.delayInitialFocusTimer = config.delayInitialFocus
      ? delay(function () {
          tryFocus(getInitialFocusNode());
        })
      : tryFocus(getInitialFocusNode());
    doc.addEventListener('focusin', checkFocusIn, true);
    doc.addEventListener('mousedown', checkPointerDown, {
      capture: true,
      passive: false,
    });
    doc.addEventListener('touchstart', checkPointerDown, {
      capture: true,
      passive: false,
    });
    doc.addEventListener('click', checkClick, {
      capture: true,
      passive: false,
    });
    doc.addEventListener('keydown', checkKey, {
      capture: true,
      passive: false,
    });
    return trap;
  };
  var removeListeners = function removeListeners2() {
    if (!state.active) {
      return;
    }
    doc.removeEventListener('focusin', checkFocusIn, true);
    doc.removeEventListener('mousedown', checkPointerDown, true);
    doc.removeEventListener('touchstart', checkPointerDown, true);
    doc.removeEventListener('click', checkClick, true);
    doc.removeEventListener('keydown', checkKey, true);
    return trap;
  };
  trap = {
    get active() {
      return state.active;
    },
    get paused() {
      return state.paused;
    },
    activate: function activate(activateOptions) {
      if (state.active) {
        return this;
      }
      var onActivate = getOption(activateOptions, 'onActivate');
      var onPostActivate = getOption(activateOptions, 'onPostActivate');
      var checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap');
      if (!checkCanFocusTrap) {
        updateTabbableNodes();
      }
      state.active = true;
      state.paused = false;
      state.nodeFocusedBeforeActivation = doc.activeElement;
      if (onActivate) {
        onActivate();
      }
      var finishActivation = function finishActivation2() {
        if (checkCanFocusTrap) {
          updateTabbableNodes();
        }
        addListeners();
        if (onPostActivate) {
          onPostActivate();
        }
      };
      if (checkCanFocusTrap) {
        checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
        return this;
      }
      finishActivation();
      return this;
    },
    deactivate: function deactivate(deactivateOptions) {
      if (!state.active) {
        return this;
      }
      var options = _objectSpread2(
        {
          onDeactivate: config.onDeactivate,
          onPostDeactivate: config.onPostDeactivate,
          checkCanReturnFocus: config.checkCanReturnFocus,
        },
        deactivateOptions,
      );
      clearTimeout(state.delayInitialFocusTimer);
      state.delayInitialFocusTimer = void 0;
      removeListeners();
      state.active = false;
      state.paused = false;
      activeFocusTraps.deactivateTrap(trap);
      var onDeactivate = getOption(options, 'onDeactivate');
      var onPostDeactivate = getOption(options, 'onPostDeactivate');
      var checkCanReturnFocus = getOption(options, 'checkCanReturnFocus');
      var returnFocus = getOption(options, 'returnFocus', 'returnFocusOnDeactivate');
      if (onDeactivate) {
        onDeactivate();
      }
      var finishDeactivation = function finishDeactivation2() {
        delay(function () {
          if (returnFocus) {
            tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
          }
          if (onPostDeactivate) {
            onPostDeactivate();
          }
        });
      };
      if (returnFocus && checkCanReturnFocus) {
        checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(
          finishDeactivation,
          finishDeactivation,
        );
        return this;
      }
      finishDeactivation();
      return this;
    },
    pause: function pause() {
      if (state.paused || !state.active) {
        return this;
      }
      state.paused = true;
      removeListeners();
      return this;
    },
    unpause: function unpause() {
      if (!state.paused || !state.active) {
        return this;
      }
      state.paused = false;
      updateTabbableNodes();
      addListeners();
      return this;
    },
    updateContainerElements: function updateContainerElements(containerElements) {
      var elementsAsArray = [].concat(containerElements).filter(Boolean);
      state.containers = elementsAsArray.map(function (element) {
        return typeof element === 'string' ? doc.querySelector(element) : element;
      });
      if (state.active) {
        updateTabbableNodes();
      }
      return this;
    },
  };
  trap.updateContainerElements(elements);
  return trap;
};

// packages/focus/src/index.js
function src_default$4(Alpine) {
  let lastFocused;
  let currentFocused;
  window.addEventListener('focusin', () => {
    lastFocused = currentFocused;
    currentFocused = document.activeElement;
  });
  Alpine.magic('focus', (el) => {
    let within = el;
    return {
      __noscroll: false,
      __wrapAround: false,
      within(el2) {
        within = el2;
        return this;
      },
      withoutScrolling() {
        this.__noscroll = true;
        return this;
      },
      noscroll() {
        this.__noscroll = true;
        return this;
      },
      withWrapAround() {
        this.__wrapAround = true;
        return this;
      },
      wrap() {
        return this.withWrapAround();
      },
      focusable(el2) {
        return isFocusable$1(el2);
      },
      previouslyFocused() {
        return lastFocused;
      },
      lastFocused() {
        return lastFocused;
      },
      focused() {
        return currentFocused;
      },
      focusables() {
        if (Array.isArray(within)) return within;
        return focusable$1(within, {displayCheck: 'none'});
      },
      all() {
        return this.focusables();
      },
      isFirst(el2) {
        let els = this.all();
        return els[0] && els[0].isSameNode(el2);
      },
      isLast(el2) {
        let els = this.all();
        return els.length && els.slice(-1)[0].isSameNode(el2);
      },
      getFirst() {
        return this.all()[0];
      },
      getLast() {
        return this.all().slice(-1)[0];
      },
      getNext() {
        let list = this.all();
        let current = document.activeElement;
        if (list.indexOf(current) === -1) return;
        if (this.__wrapAround && list.indexOf(current) === list.length - 1) {
          return list[0];
        }
        return list[list.indexOf(current) + 1];
      },
      getPrevious() {
        let list = this.all();
        let current = document.activeElement;
        if (list.indexOf(current) === -1) return;
        if (this.__wrapAround && list.indexOf(current) === 0) {
          return list.slice(-1)[0];
        }
        return list[list.indexOf(current) - 1];
      },
      first() {
        this.focus(this.getFirst());
      },
      last() {
        this.focus(this.getLast());
      },
      next() {
        this.focus(this.getNext());
      },
      previous() {
        this.focus(this.getPrevious());
      },
      prev() {
        return this.previous();
      },
      focus(el2) {
        if (!el2) return;
        setTimeout(() => {
          if (!el2.hasAttribute('tabindex')) el2.setAttribute('tabindex', '0');
          el2.focus({preventScroll: this.__noscroll});
        });
      },
    };
  });
  Alpine.directive(
    'trap',
    Alpine.skipDuringClone(
      (el, {expression, modifiers}, {effect, evaluateLater, cleanup}) => {
        let evaluator = evaluateLater(expression);
        let oldValue = false;
        let options = {
          escapeDeactivates: false,
          allowOutsideClick: true,
          fallbackFocus: () => el,
        };
        let undoInert = () => {};
        if (modifiers.includes('noautofocus')) {
          options.initialFocus = false;
        } else {
          let autofocusEl = el.querySelector('[autofocus]');
          if (autofocusEl) options.initialFocus = autofocusEl;
        }
        if (modifiers.includes('inert')) {
          options.onPostActivate = () => {
            Alpine.nextTick(() => {
              undoInert = setInert(el);
            });
          };
        }
        let trap = createFocusTrap(el, options);
        let undoDisableScrolling = () => {};
        const releaseFocus = () => {
          undoInert();
          undoInert = () => {};
          undoDisableScrolling();
          undoDisableScrolling = () => {};
          trap.deactivate({
            returnFocus: !modifiers.includes('noreturn'),
          });
        };
        effect(() =>
          evaluator((value) => {
            if (oldValue === value) return;
            if (value && !oldValue) {
              if (modifiers.includes('noscroll')) undoDisableScrolling = disableScrolling();
              setTimeout(() => {
                trap.activate();
              }, 15);
            }
            if (!value && oldValue) {
              releaseFocus();
            }
            oldValue = !!value;
          }),
        );
        cleanup(releaseFocus);
      },
      // When cloning, we only want to add aria-hidden attributes to the
      // DOM and not try to actually trap, as trapping can mess with the
      // live DOM and isn't just isolated to the cloned DOM.
      (el, {expression, modifiers}, {evaluate}) => {
        if (modifiers.includes('inert') && evaluate(expression)) setInert(el);
      },
    ),
  );
}
function setInert(el) {
  let undos = [];
  crawlSiblingsUp(el, (sibling) => {
    let cache = sibling.hasAttribute('aria-hidden');
    sibling.setAttribute('aria-hidden', 'true');
    undos.push(() => cache || sibling.removeAttribute('aria-hidden'));
  });
  return () => {
    while (undos.length) undos.pop()();
  };
}
function crawlSiblingsUp(el, callback) {
  if (el.isSameNode(document.body) || !el.parentNode) return;
  Array.from(el.parentNode.children).forEach((sibling) => {
    if (sibling.isSameNode(el)) {
      crawlSiblingsUp(el.parentNode, callback);
    } else {
      callback(sibling);
    }
  });
}
function disableScrolling() {
  let overflow = document.documentElement.style.overflow;
  let paddingRight = document.documentElement.style.paddingRight;
  let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  document.documentElement.style.overflow = 'hidden';
  document.documentElement.style.paddingRight = `${scrollbarWidth}px`;
  return () => {
    document.documentElement.style.overflow = overflow;
    document.documentElement.style.paddingRight = paddingRight;
  };
}

// packages/focus/builds/module.js
var module_default$4 = src_default$4;
/*! Bundled license information:

tabbable/dist/index.esm.js:
  (*!
  * tabbable 5.3.3
  * @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
  *)

focus-trap/dist/focus-trap.esm.js:
  (*!
  * focus-trap 6.9.4
  * @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
  *)
*/

// packages/morph/src/morph.js
function morph(from, toHtml, options) {
  monkeyPatchDomSetAttributeToAllowAtSymbols();
  let context = createMorphContext(options);
  let toEl = typeof toHtml === 'string' ? createElement$1(toHtml) : toHtml;
  if (window.Alpine && window.Alpine.closestDataStack && !from._x_dataStack) {
    toEl._x_dataStack = window.Alpine.closestDataStack(from);
    toEl._x_dataStack && window.Alpine.cloneNode(from, toEl);
  }
  context.patch(from, toEl);
  return from;
}
function morphBetween(startMarker, endMarker, toHtml, options = {}) {
  monkeyPatchDomSetAttributeToAllowAtSymbols();
  let context = createMorphContext(options);
  let fromContainer = startMarker.parentNode;
  let fromBlock = new Block(startMarker, endMarker);
  let toContainer =
    typeof toHtml === 'string'
      ? (() => {
          let container = document.createElement('div');
          container.insertAdjacentHTML('beforeend', toHtml);
          return container;
        })()
      : toHtml;
  let toStartMarker = document.createComment('[morph-start]');
  let toEndMarker = document.createComment('[morph-end]');
  toContainer.insertBefore(toStartMarker, toContainer.firstChild);
  toContainer.appendChild(toEndMarker);
  let toBlock = new Block(toStartMarker, toEndMarker);
  if (window.Alpine && window.Alpine.closestDataStack) {
    toContainer._x_dataStack = window.Alpine.closestDataStack(fromContainer);
    toContainer._x_dataStack && window.Alpine.cloneNode(fromContainer, toContainer);
  }
  context.patchChildren(fromBlock, toBlock);
}
function createMorphContext(options = {}) {
  let defaultGetKey = (el) => el.getAttribute('key');
  let noop = () => {};
  let context = {
    key: options.key || defaultGetKey,
    lookahead: options.lookahead || false,
    updating: options.updating || noop,
    updated: options.updated || noop,
    removing: options.removing || noop,
    removed: options.removed || noop,
    adding: options.adding || noop,
    added: options.added || noop,
  };
  context.patch = function (from, to) {
    if (context.differentElementNamesTypesOrKeys(from, to)) {
      return context.swapElements(from, to);
    }
    let updateChildrenOnly = false;
    let skipChildren = false;
    let skipUntil = (predicate) => (context.skipUntilCondition = predicate);
    if (
      shouldSkipChildren(
        context.updating,
        () => (skipChildren = true),
        skipUntil,
        from,
        to,
        () => (updateChildrenOnly = true),
      )
    )
      return;
    if (from.nodeType === 1 && window.Alpine) {
      window.Alpine.cloneNode(from, to);
      if (from._x_teleport && to._x_teleport) {
        context.patch(from._x_teleport, to._x_teleport);
      }
    }
    if (textOrComment(to)) {
      context.patchNodeValue(from, to);
      context.updated(from, to);
      return;
    }
    if (!updateChildrenOnly) {
      context.patchAttributes(from, to);
    }
    context.updated(from, to);
    if (!skipChildren) {
      context.patchChildren(from, to);
    }
  };
  context.differentElementNamesTypesOrKeys = function (from, to) {
    return from.nodeType != to.nodeType || from.nodeName != to.nodeName || context.getKey(from) != context.getKey(to);
  };
  context.swapElements = function (from, to) {
    if (shouldSkip(context.removing, from)) return;
    let toCloned = to.cloneNode(true);
    if (shouldSkip(context.adding, toCloned)) return;
    from.replaceWith(toCloned);
    context.removed(from);
    context.added(toCloned);
  };
  context.patchNodeValue = function (from, to) {
    let value = to.nodeValue;
    if (from.nodeValue !== value) {
      from.nodeValue = value;
    }
  };
  context.patchAttributes = function (from, to) {
    if (from._x_transitioning) return;
    if (from._x_isShown && !to._x_isShown) {
      return;
    }
    if (!from._x_isShown && to._x_isShown) {
      return;
    }
    let domAttributes = Array.from(from.attributes);
    let toAttributes = Array.from(to.attributes);
    for (let i = domAttributes.length - 1; i >= 0; i--) {
      let name = domAttributes[i].name;
      if (!to.hasAttribute(name)) {
        from.removeAttribute(name);
      }
    }
    for (let i = toAttributes.length - 1; i >= 0; i--) {
      let name = toAttributes[i].name;
      let value = toAttributes[i].value;
      if (from.getAttribute(name) !== value) {
        from.setAttribute(name, value);
      }
    }
  };
  context.patchChildren = function (from, to) {
    let fromKeys = context.keyToMap(from.children);
    let fromKeyHoldovers = {};
    let currentTo = getFirstNode(to);
    let currentFrom = getFirstNode(from);
    while (currentTo) {
      seedingMatchingId(currentTo, currentFrom);
      let toKey = context.getKey(currentTo);
      let fromKey = context.getKey(currentFrom);
      if (context.skipUntilCondition) {
        let fromDone = !currentFrom || context.skipUntilCondition(currentFrom);
        let toDone = !currentTo || context.skipUntilCondition(currentTo);
        if (fromDone && toDone) {
          context.skipUntilCondition = null;
        } else {
          if (!fromDone) currentFrom = currentFrom && getNextSibling(from, currentFrom);
          if (!toDone) currentTo = currentTo && getNextSibling(to, currentTo);
          continue;
        }
      }
      if (!currentFrom) {
        if (toKey && fromKeyHoldovers[toKey]) {
          let holdover = fromKeyHoldovers[toKey];
          from.appendChild(holdover);
          currentFrom = holdover;
          fromKey = context.getKey(currentFrom);
        } else {
          if (!shouldSkip(context.adding, currentTo)) {
            let clone = currentTo.cloneNode(true);
            from.appendChild(clone);
            context.added(clone);
          }
          currentTo = getNextSibling(to, currentTo);
          continue;
        }
      }
      let isIf = (node) => node && node.nodeType === 8 && node.textContent === '[if BLOCK]><![endif]';
      let isEnd = (node) => node && node.nodeType === 8 && node.textContent === '[if ENDBLOCK]><![endif]';
      if (isIf(currentTo) && isIf(currentFrom)) {
        let nestedIfCount = 0;
        let fromBlockStart = currentFrom;
        while (currentFrom) {
          let next = getNextSibling(from, currentFrom);
          if (isIf(next)) {
            nestedIfCount++;
          } else if (isEnd(next) && nestedIfCount > 0) {
            nestedIfCount--;
          } else if (isEnd(next) && nestedIfCount === 0) {
            currentFrom = next;
            break;
          }
          currentFrom = next;
        }
        let fromBlockEnd = currentFrom;
        nestedIfCount = 0;
        let toBlockStart = currentTo;
        while (currentTo) {
          let next = getNextSibling(to, currentTo);
          if (isIf(next)) {
            nestedIfCount++;
          } else if (isEnd(next) && nestedIfCount > 0) {
            nestedIfCount--;
          } else if (isEnd(next) && nestedIfCount === 0) {
            currentTo = next;
            break;
          }
          currentTo = next;
        }
        let toBlockEnd = currentTo;
        let fromBlock = new Block(fromBlockStart, fromBlockEnd);
        let toBlock = new Block(toBlockStart, toBlockEnd);
        context.patchChildren(fromBlock, toBlock);
        continue;
      }
      if (currentFrom.nodeType === 1 && context.lookahead && !currentFrom.isEqualNode(currentTo)) {
        let nextToElementSibling = getNextSibling(to, currentTo);
        let found = false;
        while (!found && nextToElementSibling) {
          if (nextToElementSibling.nodeType === 1 && currentFrom.isEqualNode(nextToElementSibling)) {
            found = true;
            currentFrom = context.addNodeBefore(from, currentTo, currentFrom);
            fromKey = context.getKey(currentFrom);
          }
          nextToElementSibling = getNextSibling(to, nextToElementSibling);
        }
      }
      if (toKey !== fromKey) {
        if (!toKey && fromKey) {
          fromKeyHoldovers[fromKey] = currentFrom;
          currentFrom = context.addNodeBefore(from, currentTo, currentFrom);
          fromKeyHoldovers[fromKey].remove();
          currentFrom = getNextSibling(from, currentFrom);
          currentTo = getNextSibling(to, currentTo);
          continue;
        }
        if (toKey && !fromKey) {
          if (fromKeys[toKey]) {
            currentFrom.replaceWith(fromKeys[toKey]);
            currentFrom = fromKeys[toKey];
            fromKey = context.getKey(currentFrom);
          }
        }
        if (toKey && fromKey) {
          let fromKeyNode = fromKeys[toKey];
          if (fromKeyNode) {
            fromKeyHoldovers[fromKey] = currentFrom;
            currentFrom.replaceWith(fromKeyNode);
            currentFrom = fromKeyNode;
            fromKey = context.getKey(currentFrom);
          } else {
            fromKeyHoldovers[fromKey] = currentFrom;
            currentFrom = context.addNodeBefore(from, currentTo, currentFrom);
            fromKeyHoldovers[fromKey].remove();
            currentFrom = getNextSibling(from, currentFrom);
            currentTo = getNextSibling(to, currentTo);
            continue;
          }
        }
      }
      let currentFromNext = currentFrom && getNextSibling(from, currentFrom);
      context.patch(currentFrom, currentTo);
      currentTo = currentTo && getNextSibling(to, currentTo);
      currentFrom = currentFromNext;
    }
    let removals = [];
    while (currentFrom) {
      if (!shouldSkip(context.removing, currentFrom)) removals.push(currentFrom);
      currentFrom = getNextSibling(from, currentFrom);
    }
    while (removals.length) {
      let domForRemoval = removals.shift();
      domForRemoval.remove();
      context.removed(domForRemoval);
    }
  };
  context.getKey = function (el) {
    return el && el.nodeType === 1 && context.key(el);
  };
  context.keyToMap = function (els) {
    let map = {};
    for (let el of els) {
      let theKey = context.getKey(el);
      if (theKey) {
        map[theKey] = el;
      }
    }
    return map;
  };
  context.addNodeBefore = function (parent, node, beforeMe) {
    if (!shouldSkip(context.adding, node)) {
      let clone = node.cloneNode(true);
      parent.insertBefore(clone, beforeMe);
      context.added(clone);
      return clone;
    }
    return node;
  };
  return context;
}
morph.step = () => {};
morph.log = () => {};
function shouldSkip(hook, ...args) {
  let skip = false;
  hook(...args, () => (skip = true));
  return skip;
}
function shouldSkipChildren(hook, skipChildren, skipUntil, ...args) {
  let skip = false;
  hook(...args, () => (skip = true), skipChildren, skipUntil);
  return skip;
}
var patched = false;
function createElement$1(html) {
  const template = document.createElement('template');
  template.innerHTML = html;
  return template.content.firstElementChild;
}
function textOrComment(el) {
  return el.nodeType === 3 || el.nodeType === 8;
}
var Block = class {
  constructor(start, end) {
    this.startComment = start;
    this.endComment = end;
  }
  get children() {
    let children = [];
    let currentNode = this.startComment.nextSibling;
    while (currentNode && currentNode !== this.endComment) {
      children.push(currentNode);
      currentNode = currentNode.nextSibling;
    }
    return children;
  }
  appendChild(child) {
    this.endComment.before(child);
  }
  get firstChild() {
    let first = this.startComment.nextSibling;
    if (first === this.endComment) return;
    return first;
  }
  nextNode(reference) {
    let next = reference.nextSibling;
    if (next === this.endComment) return;
    return next;
  }
  insertBefore(newNode, reference) {
    reference.before(newNode);
    return newNode;
  }
};
function getFirstNode(parent) {
  return parent.firstChild;
}
function getNextSibling(parent, reference) {
  let next;
  if (parent instanceof Block) {
    next = parent.nextNode(reference);
  } else {
    next = reference.nextSibling;
  }
  return next;
}
function monkeyPatchDomSetAttributeToAllowAtSymbols() {
  if (patched) return;
  patched = true;
  let original = Element.prototype.setAttribute;
  let hostDiv = document.createElement('div');
  Element.prototype.setAttribute = function newSetAttribute(name, value) {
    if (!name.includes('@')) {
      return original.call(this, name, value);
    }
    hostDiv.innerHTML = `<span ${name}="${value}"></span>`;
    let attr = hostDiv.firstElementChild.getAttributeNode(name);
    hostDiv.firstElementChild.removeAttributeNode(attr);
    this.setAttributeNode(attr);
  };
}
function seedingMatchingId(to, from) {
  let fromId = from && from._x_bindings && from._x_bindings.id;
  if (!fromId) return;
  if (!to.setAttribute) return;
  to.setAttribute('id', fromId);
  to.id = fromId;
}

// packages/morph/src/index.js
function src_default$3(Alpine) {
  Alpine.morph = morph;
  Alpine.morphBetween = morphBetween;
}

// packages/morph/builds/module.js
var module_default$3 = src_default$3;

// packages/intersect/src/index.js
function src_default$2(Alpine) {
  Alpine.directive(
    'intersect',
    Alpine.skipDuringClone((el, {value, expression, modifiers}, {evaluateLater, cleanup}) => {
      let evaluate = evaluateLater(expression);
      let options = {
        rootMargin: getRootMargin(modifiers),
        threshold: getThreshold(modifiers),
      };
      let observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting === (value === 'leave')) return;
          evaluate();
          modifiers.includes('once') && observer.disconnect();
        });
      }, options);
      observer.observe(el);
      cleanup(() => {
        observer.disconnect();
      });
    }),
  );
}
function getThreshold(modifiers) {
  if (modifiers.includes('full')) return 0.99;
  if (modifiers.includes('half')) return 0.5;
  if (!modifiers.includes('threshold')) return 0;
  let threshold = modifiers[modifiers.indexOf('threshold') + 1];
  if (threshold === '100') return 1;
  if (threshold === '0') return 0;
  return Number(`.${threshold}`);
}
function getLengthValue(rawValue) {
  let match = rawValue.match(/^(-?[0-9]+)(px|%)?$/);
  return match ? match[1] + (match[2] || 'px') : void 0;
}
function getRootMargin(modifiers) {
  const key = 'margin';
  const fallback = '0px 0px 0px 0px';
  const index = modifiers.indexOf(key);
  if (index === -1) return fallback;
  let values = [];
  for (let i = 1; i < 5; i++) {
    values.push(getLengthValue(modifiers[index + i] || ''));
  }
  values = values.filter((v) => v !== void 0);
  return values.length ? values.join(' ').trim() : fallback;
}

// packages/intersect/builds/module.js
var module_default$2 = src_default$2;

// packages/persist/src/index.js
function src_default$1(Alpine) {
  let persist = () => {
    let alias;
    let storage;
    try {
      storage = localStorage;
    } catch (e) {
      console.error(e);
      console.warn('Alpine: $persist is using temporary storage since localStorage is unavailable.');
      let dummy = /* @__PURE__ */ new Map();
      storage = {
        getItem: dummy.get.bind(dummy),
        setItem: dummy.set.bind(dummy),
      };
    }
    return Alpine.interceptor(
      (initialValue, getter, setter, path, key) => {
        let lookup = alias || `_x_${path}`;
        let initial = storageHas(lookup, storage) ? storageGet(lookup, storage) : initialValue;
        setter(initial);
        Alpine.effect(() => {
          let value = getter();
          storageSet(lookup, value, storage);
          setter(value);
        });
        return initial;
      },
      (func) => {
        ((func.as = (key) => {
          alias = key;
          return func;
        }),
          (func.using = (target) => {
            storage = target;
            return func;
          }));
      },
    );
  };
  Object.defineProperty(Alpine, '$persist', {get: () => persist()});
  Alpine.magic('persist', persist);
  Alpine.persist = (key, {get, set}, storage = localStorage) => {
    let initial = storageHas(key, storage) ? storageGet(key, storage) : get();
    set(initial);
    Alpine.effect(() => {
      let value = get();
      storageSet(key, value, storage);
      set(value);
    });
  };
}
function storageHas(key, storage) {
  return storage.getItem(key) !== null;
}
function storageGet(key, storage) {
  let value = storage.getItem(key);
  if (value === void 0) return;
  return JSON.parse(value);
}
function storageSet(key, value, storage) {
  storage.setItem(key, JSON.stringify(value));
}

// packages/persist/builds/module.js
var module_default$1 = src_default$1;

// packages/resize/src/index.js
function src_default(Alpine) {
  Alpine.directive(
    'resize',
    Alpine.skipDuringClone((el, {value, expression, modifiers}, {evaluateLater, cleanup}) => {
      let evaluator = evaluateLater(expression);
      let evaluate = (width, height) => {
        evaluator(() => {}, {scope: {$width: width, $height: height}});
      };
      let off = modifiers.includes('document') ? onDocumentResize(evaluate) : onElResize(el, evaluate);
      cleanup(() => off());
    }),
  );
}
function onElResize(el, callback) {
  let observer = new ResizeObserver((entries) => {
    let [width, height] = dimensions(entries);
    callback(width, height);
  });
  observer.observe(el);
  return () => observer.disconnect();
}
var documentResizeObserver;
var documentResizeObserverCallbacks = /* @__PURE__ */ new Set();
function onDocumentResize(callback) {
  documentResizeObserverCallbacks.add(callback);
  if (!documentResizeObserver) {
    documentResizeObserver = new ResizeObserver((entries) => {
      let [width, height] = dimensions(entries);
      documentResizeObserverCallbacks.forEach((i) => i(width, height));
    });
    documentResizeObserver.observe(document.documentElement);
  }
  return () => {
    documentResizeObserverCallbacks.delete(callback);
  };
}
function dimensions(entries) {
  let width, height;
  for (let entry of entries) {
    width = entry.borderBoxSize[0].inlineSize;
    height = entry.borderBoxSize[0].blockSize;
  }
  return [width, height];
}

// packages/resize/builds/module.js
var module_default = src_default;

function isFormDataSubmitterSupported() {
  try {
    new FormData(
      document.createElement('form'),
      // @ts-expect-error if FormData supports the submitter parameter, this will throw
      0,
    );
  } catch (e) {
    return false;
  }
}
function isTouchEvent(e) {
  return e.pointerType === 'touch';
}
function isLeftMouseButton(e) {
  return e.button === 0;
}
function isPopoverApiSupported() {
  return (
    typeof HTMLElement !== 'undefined' &&
    typeof HTMLElement.prototype === 'object' &&
    'popover' in HTMLElement.prototype
  );
}
function isDialogApiSupported() {
  return typeof HTMLDialogElement === 'function';
}
/**
 * Returns an array of section IDs that have or contain an element having the data-cart-api-section attribute.
 * This is used to gather up all the sections that need to be updated when the cart API is called.
 */
function getCartApiSections() {
  return Array.from(
    document.querySelectorAll('.shopify-section:is(:has([data-cart-api-section]),[data-cart-api-section])'),
  ).map((section) => {
    return section.id.split('shopify-section-')[1];
  });
}
// Inspired by https://github.com/remix-run/react-router/blob/9afac15d8cbe30b37d0f9e8b89c9f1e430dfe35a/packages/react-router-dom/dom.ts#L250
function getFormSubmissionInfo(target, submitter) {
  let method;
  let action;
  let formData = undefined;
  let enctype = null;
  let defaultMethod = 'GET';
  if (isFormElement(target)) {
    action = target.action;
    method = target.getAttribute('method') || defaultMethod;
    enctype = target.getAttribute('enctype') || null;
    formData = new FormData(target, submitter || null);
  } else if (
    isButtonElement(target) ||
    (isInputElement(target) && (target.type === 'submit' || target.type === 'image'))
  ) {
    let form = target.form;
    if (form == null) {
      throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
    }
    let attr = target.formAction || form.action;
    action = attr;
    method = target.getAttribute('formmethod') || form.getAttribute('method') || defaultMethod;
    enctype = target.getAttribute('formenctype') || form.getAttribute('enctype') || null;
    // Build a FormData object populated from a form and submitter
    formData = new FormData(form, target);
    // If this browser doesn't support the `FormData(el, submitter)` format,
    // then tack on the submitter value at the end.  This is a lightweight
    // solution that is not 100% spec compliant.  For complete support in older
    // browsers, consider using the `formdata-submitter-polyfill` package
    if (!isFormDataSubmitterSupported()) {
      let {name, type, value} = target;
      if (type === 'image') {
        let prefix = name ? `${name}.` : '';
        formData.append(`${prefix}x`, '0');
        formData.append(`${prefix}y`, '0');
      } else if (name) {
        formData.append(name, value);
      }
    }
  } else if (isHtmlElement(target)) {
    throw new Error(`Cannot submit element that is not <form>, <button>, or ` + `<input type="submit|image">`);
  } else {
    method = defaultMethod;
    action = null;
    enctype = null;
  }
  return {
    action,
    method: method.toUpperCase(),
    formData,
    enctype,
  };
}
/**
 * Make a fetch request with the given form data submission info.
 */
async function submitFormData({action, formData, method, enctype}, init) {
  switch (method) {
    case 'POST':
      if (enctype === 'application/json') {
        return fetch(
          action,
          Object.assign(
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                // Required for quantity checking on the cart endpoints....
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify(serializeFormData(formData)),
            },
            init,
          ),
        );
      } else {
        return fetch(
          action,
          Object.assign(
            {
              method: 'POST',
              body: formData,
              headers: {
                Accept: 'application/javascript',
                // Required for quantity checking on the cart endpoints....
                'X-Requested-With': 'XMLHttpRequest',
              },
            },
            init,
          ),
        );
      }
    case 'GET':
      const url = `${action}?${new URLSearchParams(formData).toString()}`;
      return fetch(
        url,
        Object.assign(
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
          },
          init,
        ),
      );
    default:
      throw new Error(`Unsupported method: ${method}`);
  }
}
function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
// Inspired by https://github.com/remix-run/react-router/blob/9afac15d8cbe30b37d0f9e8b89c9f1e430dfe35a/packages/react-router-dom/dom.ts#L36
function shouldProcessLinkClick(event, target) {
  return (
    event.button === 0 && // Ignore everything but left clicks
    (!target || target === '_self') && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // Ignore clicks with modifier keys
  );
}
// Check if clipboard.writeText() can execute to avoid throwing an error.
// Firefox does not support 'clipboard-write' in the permissions API, so default to true if unsupported.
function isClipboardWriteAllowed() {
  if (navigator.permissions && typeof navigator.permissions.query === 'function') {
    try {
      return navigator.permissions
        .query({name: 'clipboard-write'})
        .then((result) => {
          // Permission denied
          if (result.state === 'denied') return false;
          return result.state === 'granted' || result.state === 'prompt';
        })
        .catch(() => {
          // Permissions API is available but query failed (e.g. not supported for clipboard)
          // Firefox and others: fallback to assume it is allowed, since writeText will throw if not
          return true;
        });
    } catch (_a) {
      // Defensive: if query throws synchronously
      return Promise.resolve(true);
    }
  }
  // permissions API not available at all, assume allowed (since writeText will throw if not)
  return Promise.resolve(true);
}
function isHtmlElement(node) {
  return node != undefined && node != null && typeof node.tagName === 'string' && node.nodeType === Node.ELEMENT_NODE;
}
function isImageElement(node) {
  return isHtmlElement(node) && node.nodeName === 'IMG';
}
function isAnchorElement(node) {
  return isHtmlElement(node) && node.nodeName === 'A';
}
function isFormElement(node) {
  return isHtmlElement(node) && node.nodeName === 'FORM';
}
function isDialogElement(node) {
  return isHtmlElement(node) && node.nodeName === 'DIALOG';
}
function isInputElement(node) {
  return isHtmlElement(node) && node.nodeName === 'INPUT';
}
function isInputRangeElement(node) {
  return isHtmlElement(node) && node.nodeName === 'INPUT' && node.getAttribute('type') == 'range';
}
function isInputNumberElement(node) {
  return isHtmlElement(node) && node.nodeName === 'INPUT' && node.getAttribute('type') == 'number';
}
function isButtonElement(node) {
  return isHtmlElement(node) && node.nodeName === 'BUTTON';
}
function isTemplateElement(node) {
  return isHtmlElement(node) && node.nodeName === 'TEMPLATE';
}
function getWritingDirection(el) {
  return getComputedStyle(el).direction;
}
/**
 * Serializes a FormData object into a JSON object
 * @param formData - The form data to serialize
 * @returns
 */
function serializeFormData(formData) {
  const result = {};
  for (const [key, value] of formData.entries()) {
    // Split the key into parts by brackets
    const parts = key.match(/([^\[\]]+)/g) || [key];
    let current = result;
    // Traverse through all parts except the last one
    for (let i = 0; i < parts.length - 1; i++) {
      const part = parts[i];
      // Create nested object if it doesn't exist
      current[part] = current[part] || {};
      current = current[part];
    }
    // Set the value at the final level
    const lastPart = parts[parts.length - 1];
    current[lastPart] = value;
  }
  return result;
}
/**
 * Checks if a click event is occurring outside of a container element
 * @param event
 * @param container
 * @returns
 */
function isClickingOutside(event, container) {
  // If the event target is not an element, then use it's coordinates to check if it's outside the element
  if (event.target instanceof HTMLDialogElement || !(event.target instanceof Element)) {
    return !isPointWithinElement(event.clientX, event.clientY, container);
  }
  // Using `event.composedPath` tells us whether the element _is or was_ contained in the container
  // when the click event was triggered. This is opposed to e.g. `element.contains(event.target)` which would
  // only check if the element _is_ contained in the container at the time the check is made. This
  // would fail if for instance the contents of the container were changed after the click event was triggered but
  // before the check is made.
  return !event.composedPath().includes(container);
}
/**
 * Checks if a point is within an element
 * @param x - The x coordinate of the point
 * @param y - The y coordinate of the point
 * @param element - The element to check
 * @returns True if the point is within the element, false otherwise
 */
function isPointWithinElement(x, y, element) {
  const {left, right, top, bottom} = element.getBoundingClientRect();
  return x >= left && x <= right && y >= top && y <= bottom;
}

function cache(Alpine) {
  Alpine.store('cache', cacheStore());
  Alpine.directive('cache', ($el, {modifiers, expression}, {Alpine, evaluate}) => {
    var _a;
    if (!isHtmlElement($el)) {
      throw new Error(`Expected HTMLElement but got ${$el}`);
    }
    if ($el.nodeName !== 'SCRIPT') {
      throw new Error('Can only be used on script tags');
    }
    // Do nothing if the script tag is empty
    if (((_a = $el.textContent) === null || _a === void 0 ? void 0 : _a.trim()) == '') {
      return;
    }
    let json;
    try {
      json = JSON.parse($el.textContent || '{}');
    } catch (e) {
      throw new Error(`Could not parse ${$el.textContent} as JSON: ${e}`);
    }
    const resourceName = modifiers[0];
    if (!resourceName) {
      throw new Error('Must specify a store to cache to e.g. x-cache.products');
    }
    const cache = Alpine.store('cache').resources;
    const cacheResource = cache[resourceName];
    if (!cacheResource) {
      throw new Error(`Could not find resource named ${resourceName}. Did you define it in the cache store?`);
    }
    if (expression) {
      const cacheKey = evaluate(expression);
      cacheResource.set(cacheKey, json);
    } else {
      if (isSingletonResource(cacheResource)) {
        cacheResource.set(json);
      } else {
        cacheResource.upsert(json);
      }
    }
  }).before('bind');
  Alpine.magic('cache', () => {
    return Alpine.store('cache').resources;
  });
}
function isSingletonResource(x) {
  if ('isSingleton' in x && x.isSingleton) {
    return true;
  }
  return false;
}
// TODO test me and document me
function buildResource(builder) {
  return {
    records: {},
    set(key, value) {
      this.records[key] = value;
    },
    populate(records) {
      this.records = records;
    },
    upsert(records) {
      this.records = Object.assign(Object.assign({}, this.records), records);
    },
    evict(key) {
      delete this.records[key];
    },
    reset() {
      this.records = {};
    },
    get(key) {
      const result = this.records[key];
      if (!result) {
        return null;
      }
      if (builder) {
        return builder(result);
      }
      return result;
    },
    get isSingleton() {
      return false;
    },
  };
}
// TODO test me and document me
function buildSingletonResource(builder) {
  return {
    record: null,
    set(value) {
      this.record = value;
    },
    evict() {
      this.record = null;
    },
    reset() {
      this.record = null;
    },
    get() {
      const result = this.record;
      if (!result) {
        return null;
      }
      if (builder) {
        return builder(result);
      }
      return result;
    },
    get isSingleton() {
      return true;
    },
  };
}
function cacheStore() {
  return {
    resources: {},
    reset() {
      Object.keys(this.resources).forEach((key) => {
        this.resources[key].reset();
      });
    },
    addResource(key, options) {
      if (options === null || options === void 0 ? void 0 : options.singleton) {
        this.resources[key] = buildSingletonResource(options === null || options === void 0 ? void 0 : options.builder);
      } else {
        this.resources[key] = buildResource(options === null || options === void 0 ? void 0 : options.builder);
      }
    },
  };
}

function isString(x) {
  return typeof x === 'string';
}

function isPlainObject(x) {
  return typeof x === 'object' && x !== null && !Array.isArray(x) && !(x instanceof Date);
}
/**
 * Similar to Object.assign except that it uses property descriptors to copy both enumerable and non-enumerable properties
 * from source objects onto the target object so that getters/setters, etc still work properly
 * @param target
 * @param source
 * @returns
 */
function mergeProperties(target, ...sources) {
  let santizedSources = sources.filter(Boolean).reverse();
  let newObject = Object.defineProperties({}, Object.getOwnPropertyDescriptors(target));
  for (const source of santizedSources) {
    Object.defineProperties(newObject, Object.getOwnPropertyDescriptors(source));
  }
  return newObject;
}
/**
 * Renames a property on an object and deletes the old property, all while preserving the property descriptor (e.g. getters/setters)
 * @param obj
 * @param oldName
 * @param newName
 */
function renameProperty(obj, oldName, newName) {
  const descriptor = Object.getOwnPropertyDescriptor(obj, oldName);
  if (!descriptor) throw new Error(`Property ${String(oldName)} not found on object`);
  Object.defineProperty(obj, newName, descriptor);
  delete obj[oldName];
}
/**
 * Copy a property on an object and deletes the old property, all while preserving the property descriptor (e.g. getters/setters)
 * @param obj - The object to copy the property from
 * @param newObj - The object to copy the property to
 * @param oldName - The name of the property to copy
 * @param optionalNewName - The new name of the property (optional, defaults to oldName)
 */
function copyProperty(obj, newObj, oldName, optionalNewName) {
  const newName = optionalNewName !== null && optionalNewName !== void 0 ? optionalNewName : oldName;
  const descriptor = Object.getOwnPropertyDescriptor(obj, oldName);
  if (!descriptor) throw new Error(`Property ${String(oldName)} not found on object`);
  Object.defineProperty(newObj, newName, descriptor);
}
function trackProperty(obj, key, trackingKey) {
  return new Proxy(obj, {
    set(target, prop, value, receiver) {
      if (prop == key) {
        receiver[trackingKey] = receiver[key];
      }
      return Reflect.set(target, prop, value, receiver);
    },
  });
}

function isFunction(x) {
  return typeof x === 'function';
}

/**
 * Returns the modulo of n and m handling negative numbers correctly
 *
 * e.g.
 * mod(1, 5) = 1
 * mod(7, 5) = 2
 * mod(-1, 5) = 4
 * @param n
 * @param m
 * @returns
 */
function mod(n, m) {
  return ((n % m) + m) % m;
}
/**
 * Returns the value clamped between min and max
 * @param n
 * @param min
 * @param max
 * @returns
 */
function clamp$2(n, min, max) {
  return Math.min(Math.max(n, min), max);
}
/**
 * Emulates how browsers round scroll values which is to the nearest 0 or half integer
 * e.g. 0.1 => 0.0, 0.9 => 0.5..., 0.0 => 0, 1.0 => 1
 */
function toScrollValue(value) {
  return Math.floor(value) + Math.round((value - Math.floor(value)) * 2) / 2;
}
/**
 * Return whether a string is numeric
 * @param value
 * @returns
 */
function isNumeric(value) {
  if (typeof value == 'number') return true;
  return (
    !isNaN(value) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(value))
  ); // ...and ensure strings of whitespace fail
}

var ThemeEditorEvent;
(function (ThemeEditorEvent) {
  ThemeEditorEvent['INSPECTOR_ACTIVATED'] = 'shopify:inspector:activate';
  ThemeEditorEvent['INSPECTOR_DEACTIVATED'] = 'shopify:inspector:deactivate';
  ThemeEditorEvent['SECTION_LOAD'] = 'shopify:section:load';
  ThemeEditorEvent['SECTION_UNLOAD'] = 'shopify:section:unload';
  ThemeEditorEvent['SECTION_SELECT'] = 'shopify:section:select';
  ThemeEditorEvent['SECTION_DESELECT'] = 'shopify:section:deselect';
  ThemeEditorEvent['SECTION_REORDER'] = 'shopify:section:reorder';
  ThemeEditorEvent['BLOCK_SELECT'] = 'shopify:block:select';
  ThemeEditorEvent['BLOCK_DESELECT'] = 'shopify:block:deselect';
})(ThemeEditorEvent || (ThemeEditorEvent = {}));

var ThemeEvent;
(function (ThemeEvent) {
  ThemeEvent[(ThemeEvent['theme:cart:add'] = 0)] = 'theme:cart:add';
  ThemeEvent[(ThemeEvent['theme:cart:update'] = 1)] = 'theme:cart:update';
  ThemeEvent[(ThemeEvent['theme:section:navigate'] = 2)] = 'theme:section:navigate';
  ThemeEvent[(ThemeEvent['theme:section:load'] = 3)] = 'theme:section:load';
  ThemeEvent[(ThemeEvent['theme:section:update'] = 4)] = 'theme:section:update';
})(ThemeEvent || (ThemeEvent = {}));

/**
 * Returns the containing section element of the current element, or the current element if it is a section
 */
function closestSectionEl($el) {
  if (!isHtmlElement($el)) {
    throw new Error(`Expected HTMLElement but got ${$el}`);
  }
  if ($el.classList.contains('shopify-section')) {
    return $el;
  }
  return $el.closest('.shopify-section');
}
function bindAllThemeSections(Alpine, cb) {
  document.addEventListener('alpine:init', () => {
    const sections = document.getElementsByClassName('shopify-section');
    for (const el of sections) {
      if (isHtmlElement(el)) {
        cb(el);
      }
    }
    // Re-bind sections when they are re-loaded by the theme editor
    window.addEventListener(ThemeEditorEvent.SECTION_LOAD, (e) => {
      var _a;
      if ((_a = window.Shopify) === null || _a === void 0 ? void 0 : _a.designMode) {
        const loadedEvent = e;
        const section = document.getElementById(`shopify-section-${loadedEvent.detail.sectionId}`);
        if (section) {
          Alpine.deferMutations();
          cb(section);
          Alpine.flushAndStopDeferringMutations();
        }
      }
    });
  });
}

/**
 * StateMachine: A generic finite state machine implementation.
 *
 * A state machine is a conceptual model used to design systems and applications. It consists of a finite set of states and
 * transitions between those states, often driven by events. State machines are ideal for situations where an application or system
 * can be thought of as having distinct states with well-defined transitions, such as user interfaces, protocols, and life cycles.
 *
 * @template TStates A tuple of string literals representing the possible states.
 * @template TTransitions A mapping of each state to an array of states to which it can transition.
 * @template TState The current state of the machine, must be one of TStates.
 *
 * The `StateMachine` class provides mechanisms to manage states, transitions, and listeners that react to state changes.
 *
 * Usage example:
 *
 * // Define states and transitions
 * const states = ['idle', 'loading', 'success', 'error'] as const;
 * const transitions = {
 *   idle: ['loading'],
 *   loading: ['success', 'error'],
 *   success: ['idle'],
 *   error: ['idle'],
 * };
 *
 * // Create a state machine
 * const machine = new StateMachine('idle', states, transitions);
 *
 * // Listen for state changes
 * machine.on((newState, prevState) => {
 *   console.log(`Transitioned from ${prevState} to ${newState}`);
 * });
 *
 * // Change state
 * machine.state = 'loading';
 *
 * Features:
 * - Strongly typed states and transitions ensure only valid state changes are possible.
 * - Event listeners for state changes, to react to or log transitions.
 * - Custom error handling for invalid transitions.
 *
 * The class manages the current state privately and allows state changes only through the state setter,
 * which checks for valid transitions and notifies listeners.
 */
class StateMachine {
  /**
   * Initializes the state machine with the specified initial state, possible states, and valid transitions.
   *
   * @param initialState The starting state of the state machine.
   * @param states An array of possible states the state machine can be in.
   * @param transitions A record mapping each state to an array of states to which it can transition.
   *
   */
  constructor(initialState, states, transitions) {
    this._prevState = null;
    this.listeners = [];
    this._state = initialState;
    this.states = states;
    this.transitions = transitions;
  }
  /**
   *  Attempts to transition the state machine to a new state. Validates the transition against the defined rules
   *  and, if valid, updates the state and triggers the listeners. Throws an error if the transition is invalid.
   */
  set state(newState) {
    const validTransitions = intersectArrays(this.states, this.transitions[this._state] || []);
    if (validTransitions.includes(newState)) {
      let prevState = this._state;
      this._prevState = prevState;
      this._state = newState;
      this.listeners.forEach((listener) => listener(newState, prevState));
    } else {
      throw new Error(`Invalid transition from ${this._state} to ${newState}`);
    }
  }
  /**
   * Transitions the state machine to a new state, but only temporarily. After the specified timeout, the state will transition to the next state
   * This method is useful for UI interactions that should only be visible for a short period of time, such as a success message after a form submission.
   */
  setTransientState(transientState, nextState, timeout) {
    return new Promise((resolve) => {
      // Transition to the transient state immediately
      this._state = transientState;
      // Then, after a timeout, transition to the next state
      setTimeout(() => {
        this._state = nextState;
        resolve();
      }, timeout);
    });
  }
  /**
   * Returns the current state of the state machine.
   */
  get state() {
    return this._state;
  }
  /**
   * Returns the previous state of the state machine (if this is the initial state it will return null)
   */
  get prevState() {
    return this._prevState;
  }
  /**
   * Registers a new listener function to be called when the state changes.
   * @param listener
   */
  on(listener) {
    this.listeners.push(listener);
  }
  /**
   * Removes a previously registered listener function so that it will no longer be called on state changes.
   * @param listener
   */
  off(listener) {
    const index = this.listeners.indexOf(listener);
    if (index !== -1) {
      this.listeners.splice(index, 1);
    }
  }
}
function intersectArrays(arr1, arr2) {
  const set2 = new Set(arr2);
  return arr1.filter((x) => set2.has(x));
}

const DEFAULT_LIST_STATE_NAME = 'listState';
function listState(Alpine) {
  Alpine.directive('list-state', ($el, {value, expression, modifiers}, {evaluate}) => {
    if (value == 'item') {
      const $data = Alpine.$data($el);
      let scope = `$${DEFAULT_LIST_STATE_NAME}`;
      if (modifiers.includes('for') && modifiers.length >= 2) {
        const forIndex = modifiers.indexOf('for');
        scope = `$${modifiers[forIndex + 1]}`;
      }
      if (!(scope in $data)) {
        throw new Error(
          `x-list-state:item must be used within x-list-state directive. To register an item in a scoped list state, use $myScopeName.register($el)`,
        );
      }
      Alpine.bind($el, {
        'x-data'() {
          return {
            init() {
              $data[scope].register(this.$el);
            },
            destroy() {
              $data[scope].unregister(this.$el);
            },
          };
        },
      });
    } else if (value == null) {
      let options = {};
      let scope = `$${DEFAULT_LIST_STATE_NAME}`;
      if (modifiers.includes('as') && modifiers.length >= 2) {
        const asIndex = modifiers.indexOf('as');
        scope = `$${modifiers[asIndex + 1]}`;
      }
      if (expression) {
        let evalutatedExpression = evaluate(expression === '' ? '{}' : expression);
        if (isPlainObject(evalutatedExpression)) {
          options = evalutatedExpression;
          if (options.scope) {
            scope = `$${options.scope}`;
          }
        }
      }
      let state;
      if (options.multiple || modifiers.includes('multiple')) {
        options = options;
        if (options === null || options === void 0 ? void 0 : options.selectedIndices) {
          if (!(options.selectedIndices instanceof Set)) {
            throw new Error('selectedIndices must be a Set');
          }
        }
        state = buildMultiSelectListState(options);
      } else {
        options = options;
        state = buildSingleSelectListState(options);
      }
      Alpine.addScopeToNode($el, {
        [scope]: Alpine.reactive(state),
      });
    } else {
      throw new Error(`Unknown directive: x-list-state:${value}`);
    }
  }).before('bind');
}
function buildSingleSelectListState(options) {
  let state = {
    previousSelectedIndex: null,
    selectedIndex: null,
    items: new Set(),
    get totalItems() {
      return this.items.size;
    },
    isSelected(index) {
      return this.selectedIndex == index;
    },
    register(el) {
      this.items.add(el);
    },
    unregister(el) {
      this.items.delete(el);
    },
    indexOf(el) {
      return Array.from(this.items).indexOf(el);
    },
    toggle(index) {
      this.selectedIndex == index ? this.deselect(index) : this.select(index);
    },
    select(index) {
      this.selectedIndex = index;
    },
    deselect(index) {
      if (this.selectedIndex == index) {
        this.selectedIndex = null;
      }
    },
  };
  if ('selectedIndex' in options) {
    copyProperty(options, state, 'selectedIndex');
  }
  return state;
}
function buildMultiSelectListState(options) {
  let state = {
    selectedIndices: new Set(),
    items: new Set(),
    get totalItems() {
      return this.items.size;
    },
    isSelected(index) {
      return this.selectedIndices.has(index);
    },
    register(el) {
      this.items.add(el);
    },
    unregister(el) {
      this.items.delete(el);
    },
    indexOf(el) {
      return Array.from(this.items).indexOf(el);
    },
    toggle(index) {
      this.selectedIndices.has(index) ? this.deselect(index) : this.select(index);
    },
    select(index) {
      const selected = this.selectedIndices;
      selected.add(index);
      // Copy to a new set so that reactivity works
      this.selectedIndices = new Set(Array.from(selected));
    },
    deselect(index) {
      const selected = this.selectedIndices;
      selected.delete(index);
      // Copy to a new set so that reactivity works
      this.selectedIndices = new Set(Array.from(selected));
    },
  };
  if ('selectedIndices' in options) {
    copyProperty(options, state, 'selectedIndices');
  }
  return state;
}

/*!
 * tabbable 6.2.0
 * @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
 */
// NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var candidateSelectors = [
  'input:not([inert])',
  'select:not([inert])',
  'textarea:not([inert])',
  'a[href]:not([inert])',
  'button:not([inert])',
  '[tabindex]:not(slot):not([inert])',
  'audio[controls]:not([inert])',
  'video[controls]:not([inert])',
  '[contenteditable]:not([contenteditable="false"]):not([inert])',
  'details>summary:first-of-type:not([inert])',
  'details:not([inert])',
];
var candidateSelector = /* #__PURE__ */ candidateSelectors.join(',');
var NoElement = typeof Element === 'undefined';
var matches = NoElement
  ? function () {}
  : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode =
  !NoElement && Element.prototype.getRootNode
    ? function (element) {
        var _element$getRootNode;
        return element === null || element === void 0
          ? void 0
          : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0
            ? void 0
            : _element$getRootNode.call(element);
      }
    : function (element) {
        return element === null || element === void 0 ? void 0 : element.ownerDocument;
      };

/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */
var isInert = function isInert(node, lookUp) {
  var _node$getAttribute;
  if (lookUp === void 0) {
    lookUp = true;
  }
  // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
  //  JS API property; we have to check the attribute, which can either be empty or 'true';
  //  if it's `null` (not specified) or 'false', it's an active element
  var inertAtt =
    node === null || node === void 0
      ? void 0
      : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0
        ? void 0
        : _node$getAttribute.call(node, 'inert');
  var inert = inertAtt === '' || inertAtt === 'true';

  // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
  //  if it weren't for `matches()` not being a function on shadow roots; the following
  //  code works for any kind of node
  // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
  //  so it likely would not support `:is([inert] *)` either...
  var result = inert || (lookUp && node && isInert(node.parentNode)); // recursive

  return result;
};

/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */
var getCandidates = function getCandidates(el, includeContainer, filter) {
  // even if `includeContainer=false`, we still have to check it for inertness because
  //  if it's inert, all its children are inert
  if (isInert(el)) {
    return [];
  }
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }
  candidates = candidates.filter(filter);
  return candidates;
};

/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */

/**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */

/**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */

/**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */

/**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */
var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);
  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();
    if (isInert(element, false)) {
      // no need to look up since we're drilling down
      // anything inside this container will also be inert
      continue;
    }
    if (element.tagName === 'SLOT') {
      // add shadow dom slot scope (slot itself cannot be focusable)
      var assigned = element.assignedElements();
      var content = assigned.length ? assigned : element.children;
      var nestedCandidates = getCandidatesIteratively(content, true, options);
      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scopeParent: element,
          candidates: nestedCandidates,
        });
      }
    } else {
      // check candidate element
      var validCandidate = matches.call(element, candidateSelector);
      if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      }

      // iterate over shadow content if possible
      var shadowRoot =
        element.shadowRoot ||
        // check for an undisclosed shadow
        (typeof options.getShadowRoot === 'function' && options.getShadowRoot(element));

      // no inert look up because we're already drilling down and checking for inertness
      //  on the way down, so all containers to this root node should have already been
      //  vetted as non-inert
      var validShadowRoot =
        !isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
      if (shadowRoot && validShadowRoot) {
        // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
        //  shadow exists, so look at light dom children as fallback BUT create a scope for any
        //  child candidates found because they're likely slotted elements (elements that are
        //  children of the web component element (which has the shadow), in the light dom, but
        //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
        //  _after_ we return from this recursive call
        var _nestedCandidates = getCandidatesIteratively(
          shadowRoot === true ? element.children : shadowRoot.children,
          true,
          options,
        );
        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scopeParent: element,
            candidates: _nestedCandidates,
          });
        }
      } else {
        // there's not shadow so just dig into the element's (light dom) children
        //  __without__ giving the element special scope treatment
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }
  return candidates;
};
var isInput = function isInput(node) {
  return node.tagName === 'INPUT';
};
var isHiddenInput$1 = function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
};
var isDetailsWithSummary = function isDetailsWithSummary(node) {
  var r =
    node.tagName === 'DETAILS' &&
    Array.prototype.slice.apply(node.children).some(function (child) {
      return child.tagName === 'SUMMARY';
    });
  return r;
};

// determines if a node is ultimately attached to the window's document
var isNodeAttached = function isNodeAttached(node) {
  var _nodeRoot;
  // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
  //  (but NOT _the_ document; see second 'If' comment below for more).
  // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
  //  is attached, and the one we need to check if it's in the document or not (because the
  //  shadow, and all nodes it contains, is never considered in the document since shadows
  //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
  //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
  //  visibility, including all the nodes it contains). The host could be any normal node,
  //  or a custom element (i.e. web component). Either way, that's the one that is considered
  //  part of the document, not the shadow root, nor any of its children (i.e. the node being
  //  tested).
  // To further complicate things, we have to look all the way up until we find a shadow HOST
  //  that is attached (or find none) because the node might be in nested shadows...
  // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
  //  document (per the docs) and while it's a Document-type object, that document does not
  //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
  //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
  //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
  //  node is actually detached.
  // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
  //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
  //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
  //  `ownerDocument` will be `null`, hence the optional chaining on it.
  var nodeRoot = node && getRootNode(node);
  var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;

  // in some cases, a detached node will return itself as the root instead of a document or
  //  shadow root object, in which case, we shouldn't try to look further up the host chain
  var attached = false;
  if (nodeRoot && nodeRoot !== node) {
    var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
    attached = !!(
      ((_nodeRootHost = nodeRootHost) !== null &&
        _nodeRootHost !== void 0 &&
        (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null &&
        _nodeRootHost$ownerDo !== void 0 &&
        _nodeRootHost$ownerDo.contains(nodeRootHost)) ||
      (node !== null &&
        node !== void 0 &&
        (_node$ownerDocument = node.ownerDocument) !== null &&
        _node$ownerDocument !== void 0 &&
        _node$ownerDocument.contains(node))
    );
    while (!attached && nodeRootHost) {
      var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
      // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
      //  which means we need to get the host's host and check if that parent host is contained
      //  in (i.e. attached to) the document
      nodeRoot = getRootNode(nodeRootHost);
      nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
      attached = !!(
        (_nodeRootHost2 = nodeRootHost) !== null &&
        _nodeRootHost2 !== void 0 &&
        (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null &&
        _nodeRootHost2$ownerD !== void 0 &&
        _nodeRootHost2$ownerD.contains(nodeRootHost)
      );
    }
  }
  return attached;
};
var isZeroArea = function isZeroArea(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
    width = _node$getBoundingClie.width,
    height = _node$getBoundingClie.height;
  return width === 0 && height === 0;
};
var isHidden = function isHidden(node, _ref) {
  var displayCheck = _ref.displayCheck,
    getShadowRoot = _ref.getShadowRoot;
  // NOTE: visibility will be `undefined` if node is detached from the document
  //  (see notes about this further down), which means we will consider it visible
  //  (this is legacy behavior from a very long way back)
  // NOTE: we check this regardless of `displayCheck="none"` because this is a
  //  _visibility_ check, not a _display_ check
  if (getComputedStyle(node).visibility === 'hidden') {
    return true;
  }
  var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
  if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
    return true;
  }
  if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
    if (typeof getShadowRoot === 'function') {
      // figure out if we should consider the node to be in an undisclosed shadow and use the
      //  'non-zero-area' fallback
      var originalNode = node;
      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode(node);
        if (
          parentElement &&
          !parentElement.shadowRoot &&
          getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
        ) {
          // node has an undisclosed shadow which means we can only treat it as a black box, so we
          //  fall back to a non-zero-area test
          return isZeroArea(node);
        } else if (node.assignedSlot) {
          // iterate up slot
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          // cross shadow boundary
          node = rootNode.host;
        } else {
          // iterate up normal dom
          node = parentElement;
        }
      }
      node = originalNode;
    }
    // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
    //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
    //  it might be a falsy value, which means shadow DOM support is disabled

    // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
    //  now we can just test to see if it would normally be visible or not, provided it's
    //  attached to the main document.
    // NOTE: We must consider case where node is inside a shadow DOM and given directly to
    //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.

    if (isNodeAttached(node)) {
      // this works wherever the node is: if there's at least one client rect, it's
      //  somehow displayed; it also covers the CSS 'display: contents' case where the
      //  node itself is hidden in place of its contents; and there's no need to search
      //  up the hierarchy either
      return !node.getClientRects().length;
    }

    // Else, the node isn't attached to the document, which means the `getClientRects()`
    //  API will __always__ return zero rects (this can happen, for example, if React
    //  is used to render nodes onto a detached tree, as confirmed in this thread:
    //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
    //
    // It also means that even window.getComputedStyle(node).display will return `undefined`
    //  because styles are only computed for nodes that are in the document.
    //
    // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
    //  somehow. Though it was never stated officially, anyone who has ever used tabbable
    //  APIs on nodes in detached containers has actually implicitly used tabbable in what
    //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
    //  considering __everything__ to be visible because of the innability to determine styles.
    //
    // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
    //  nodes as visible with the 'none' fallback.__
    if (displayCheck !== 'legacy-full') {
      return true; // hidden
    }
    // else, fallback to 'none' mode and consider the node visible
  } else if (displayCheck === 'non-zero-area') {
    // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return isZeroArea(node);
  }

  // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
  //  it's visible
  return false;
};

// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement;
    // check if `node` is contained in a disabled <fieldset>
    while (parentNode) {
      if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
        // look for the first <legend> among the children of the disabled <fieldset>
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);
          // when the first <legend> (in document order) is found
          if (child.tagName === 'LEGEND') {
            // if its parent <fieldset> is not nested in another disabled <fieldset>,
            // return whether `node` is a descendant of its first <legend>
            return matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
          }
        }
        // the disabled <fieldset> containing `node` has no <legend>
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }

  // else, node's tabbable/focusable state should not be affected by a fieldset's
  //  enabled/disabled state
  return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
  if (
    node.disabled ||
    // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    isInert(node) ||
    isHiddenInput$1(node) ||
    isHidden(node, options) ||
    // For a details element with a summary, the summary element gets the focus
    isDetailsWithSummary(node) ||
    isDisabledFromFieldset(node)
  ) {
    return false;
  }
  return true;
};
var focusable = function focusable(container, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([container], options.includeContainer, {
      filter: isNodeMatchingSelectorFocusable.bind(null, options),
      flatten: true,
      getShadowRoot: options.getShadowRoot,
    });
  } else {
    candidates = getCandidates(
      container,
      options.includeContainer,
      isNodeMatchingSelectorFocusable.bind(null, options),
    );
  }
  return candidates;
};
var focusableCandidateSelector = /* #__PURE__ */ candidateSelectors.concat('iframe').join(',');
var isFocusable = function isFocusable(node, options) {
  options = options || {};
  if (!node) {
    throw new Error('No node provided');
  }
  if (matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorFocusable(options, node);
};

/**
 * Adds roving tab pattern on an elements focusable descendants
 *
 * See https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_roving_tabindex for more info about roving tab pattern
 *
 * @example
 *   <div x-roving-tab>
 *     <button>Button 1</button>
 *     <button>Button 2</button>
 *     <button>Button 3</button>
 *   </div>
 * @see https://web.dev/control-focus-with-tabindex/
 */
function rovingTab(Alpine) {
  Alpine.directive('roving-tab', ($el, data, utilities) => {
    if (!isHtmlElement($el)) {
      throw new Error(`Expected HTMLElement but got ${$el}`);
    }
    if (data.value === 'list') {
      handleList$1($el, Alpine);
    } else if (data.value === null) {
      handleRoot$n($el, Alpine, data, utilities);
    } else {
      throw new Error(`Unknown directive: x-roving-tab:${data.value}`);
    }
  }).before('bind');
  Alpine.magic('rovingTab', handleRovingTabMagic(Alpine));
}
function handleRovingTabMagic(Alpine) {
  return function ($el) {
    const $data = Alpine.$data($el);
    return {
      focus(el, options) {
        $data.__rovingTab_focus(el, options);
      },
      setTabbable(el) {
        $data.__rovingTab_setTabbable(el);
      },
      focusNext(options) {
        $data.__rovingTab_focusNext(options);
      },
      focusPrev(options) {
        $data.__rovingTab_focusPrev(options);
      },
      focusFirst(options) {
        $data.__rovingTab_focusFirst(options);
      },
      focusLast(options) {
        $data.__rovingTab_focusLast(options);
      },
    };
  };
}
function handleList$1($el, Alpine) {
  Alpine.bind($el, {
    ['x-data']() {
      return {
        init() {
          this.__rovingTab_listElement = this.$el;
          this.$nextTick(() => {
            this.__rovingTab_listElement.tabIndex = -1;
            // Use Alpine.effect here to re-run the effect when the focusables change
            Alpine.effect(() => {
              this.__rovingTab_setInitialTabIndicies();
            });
          });
        },
      };
    },
    '@keydown': '__rovingTab_onKeyDown',
    '@focusin': '__rovingTab_onFocusIn',
    '@click': '__rovingTab_onClick',
  });
}
function handleRoot$n($el, Alpine, {expression, modifiers}, {evaluate}) {
  const focusables = expression ? () => evaluate(expression) : undefined;
  const direction = modifiers.includes('vertical') ? 'vertical' : 'horizontal';
  const wrap = !modifiers.includes('nowrap');
  Alpine.bind($el, {
    ['x-data']() {
      return rovingTab$1(Alpine, {focusables, direction, wrap});
    },
  });
}
function rovingTab$1(Alpine, options) {
  return {
    __rovingTab_direction: (options === null || options === void 0 ? void 0 : options.direction) || 'horizontal',
    __rovingTab_wrap: options === null || options === void 0 ? void 0 : options.wrap,
    __rovingTab_listElement: null,
    init() {
      this.$nextTick(() => {
        // If no other element is set as the list element, just make it the root
        if (this.__rovingTab_listElement === null) {
          handleList$1(this.$el, Alpine);
        }
      });
    },
    __rovingTab_setInitialTabIndicies() {
      const initialElementTabIndex = this.__rovingTab_getTabbableIndex();
      const initialIndex =
        (options === null || options === void 0 ? void 0 : options.initialIndex) ||
        (initialElementTabIndex >= 0 ? initialElementTabIndex : 0);
      this.__rovingTab_getFocusables().forEach((el, index) => {
        if (index === initialIndex) {
          el.tabIndex = 0;
        } else {
          el.tabIndex = -1;
        }
      });
    },
    __rovingTab_setTabbable(el) {
      // Make all other elements "untabbable"
      for (const focusable of this.__rovingTab_getFocusables()) {
        focusable.setAttribute('tabindex', '-1');
      }
      // Make this element tabbable
      el.setAttribute('tabindex', '0');
    },
    __rovingTab_focus(el, options) {
      this.__rovingTab_setTabbable(el);
      // Wait till next event loop to focus to ensure element is focusable
      setTimeout(() => {
        el.focus(options);
      });
    },
    __rovingTab_focusNext(options) {
      let index = this.__rovingTab_getTabbableIndex();
      const focusableElements = this.__rovingTab_getFocusables();
      if (this.__rovingTab_wrap) {
        index = mod(index + 1, focusableElements.length);
      } else {
        index = Math.min(index + 1, Math.max(focusableElements.length - 1, 0));
      }
      let nextElement = focusableElements[index];
      if (nextElement) this.__rovingTab_focus(nextElement, options);
    },
    __rovingTab_focusPrev(options) {
      let index = this.__rovingTab_getTabbableIndex();
      const focusableElements = this.__rovingTab_getFocusables();
      if (this.__rovingTab_wrap) {
        index = mod(index - 1, focusableElements.length);
      } else {
        index = Math.max(index - 1, 0);
      }
      let prevElement = focusableElements[index];
      if (prevElement) this.__rovingTab_focus(prevElement, options);
    },
    __rovingTab_focusFirst(options) {
      const focusableElements = this.__rovingTab_getFocusables();
      if (focusableElements.length > 0) {
        this.__rovingTab_focus(focusableElements[0], options);
      }
    },
    __rovingTab_focusLast(options) {
      const focusableElements = this.__rovingTab_getFocusables();
      if (focusableElements.length > 0) {
        this.__rovingTab_focus(focusableElements[focusableElements.length - 1], options);
      }
    },
    __rovingTab_getFocusables() {
      if (
        (options === null || options === void 0 ? void 0 : options.focusables) &&
        isFunction(options === null || options === void 0 ? void 0 : options.focusables)
      ) {
        return Array.from(options === null || options === void 0 ? void 0 : options.focusables());
      } else if (
        (options === null || options === void 0 ? void 0 : options.focusables) &&
        Array.isArray(options === null || options === void 0 ? void 0 : options.focusables)
      ) {
        return Array.from(options === null || options === void 0 ? void 0 : options.focusables);
      } else {
        return Array.from(focusable(this.__rovingTab_listElement));
      }
    },
    __rovingTab_getTabbableIndex() {
      return this.__rovingTab_getFocusables().findIndex((e) => e.getAttribute('tabindex') === '0');
    },
    __rovingTab_onKeyDown(e) {
      if (e.target && this.__rovingTab_getFocusables().includes(e.target)) {
        switch (e.key) {
          case 'ArrowRight':
            if (this.__rovingTab_direction == 'horizontal') {
              e.preventDefault();
              e.stopPropagation();
              this.__rovingTab_focusNext();
            }
            break;
          case 'ArrowLeft':
            if (this.__rovingTab_direction == 'horizontal') {
              e.preventDefault();
              e.stopPropagation();
              this.__rovingTab_focusPrev();
            }
            break;
          case 'ArrowDown':
            if (this.__rovingTab_direction == 'vertical') {
              e.preventDefault();
              e.stopPropagation();
              this.__rovingTab_focusNext();
            }
            break;
          case 'ArrowUp':
            if (this.__rovingTab_direction == 'vertical') {
              e.preventDefault();
              e.stopPropagation();
              this.__rovingTab_focusPrev();
            }
            break;
          case 'Home':
            e.preventDefault();
            e.stopPropagation();
            this.__rovingTab_focusFirst();
            break;
          case 'End':
            e.preventDefault();
            e.stopPropagation();
            this.__rovingTab_focusLast();
            break;
        }
      }
    },
    __rovingTab_onClick(e) {
      if (e.target && this.__rovingTab_getFocusables().includes(e.target)) {
        this.__rovingTab_setTabbable(e.target);
      }
    },
    __rovingTab_onFocusIn(e) {
      if (e.target && this.__rovingTab_getFocusables().includes(e.target)) {
        this.__rovingTab_setTabbable(e.target);
      }
    },
  };
}

function isPrintableCharacter(str) {
  var _a;
  return str.length === 1 && ((_a = str.match(/\S/)) === null || _a === void 0 ? void 0 : _a.length) === 1;
}

function focusMatch(Alpine) {
  Alpine.directive('focus-match', ($el, data, utilities) => {
    if (!isHtmlElement($el)) {
      throw new Error(`Expected HTMLElement but got ${$el}`);
    }
    if (data.value === 'list') {
      handleList($el, Alpine, data);
    } else if (data.value === null) {
      handleRoot$m($el, Alpine, data, utilities);
    } else {
      throw new Error(`Unknown directive: x-focus-match:${data.value}`);
    }
  }).before('bind');
  Alpine.magic('focusMatch', handleFocusMatchMagic(Alpine));
}
function handleFocusMatchMagic(Alpine) {
  return function ($el) {
    const $data = Alpine.$data($el);
    return {
      setFocusByFirstCharacter(char) {
        $data.__focusMatch_setFocusByFirstCharacter(char);
      },
    };
  };
}
function handleList($el, Alpine, {modifiers}) {
  Alpine.bind($el, {
    ['x-data']() {
      return {
        init() {
          this.__focusMatch_listElement = this.$el;
        },
      };
    },
  });
}
function handleRoot$m($el, Alpine, {expression}, {evaluate}) {
  const focusables = expression ? () => evaluate(expression) : undefined;
  Alpine.bind($el, {
    ['x-data']() {
      return focusMatch$1({focusables});
    },
    '@keydown': '__focusMatch_onKeyDown',
  });
}
/**
 * Adds the ability to focus an element in a list by typing the first character of the element. Useful in listboxes, menus, etc
 */
function focusMatch$1(options) {
  return {
    __focusMatch_listElement: null,
    init() {
      // By default the root element is the list element
      if (this.__focusMatch_listElement === null) {
        this.__focusMatch_listElement = this.$el;
      }
    },
    __focusMatch_onKeyDown(e) {
      if (isPrintableCharacter(e.key)) {
        this.__focusMatch_setFocusByFirstCharacter(e.key);
      }
    },
    __focusMatch_getFocusables() {
      if (
        (options === null || options === void 0 ? void 0 : options.focusables) &&
        isFunction(options === null || options === void 0 ? void 0 : options.focusables)
      ) {
        return Array.from(options === null || options === void 0 ? void 0 : options.focusables());
      } else if (
        (options === null || options === void 0 ? void 0 : options.focusables) &&
        Array.isArray(options === null || options === void 0 ? void 0 : options.focusables)
      ) {
        return Array.from(options === null || options === void 0 ? void 0 : options.focusables);
      } else {
        return Array.from(focusable(this.__focusMatch_listElement));
      }
    },
    __focusMatch_setFocusByFirstCharacter(char) {
      var _a, _b, _c, _d;
      let start;
      let index;
      let focusIndex = -1;
      let focusable;
      const focusables = this.__focusMatch_getFocusables();
      char = char.toLowerCase();
      if (this.__focusMatch_listElement === null) {
        throw new Error(
          `Expected x-focus-match to be applied to an HTMLElement but got ${this.__focusMatch_listElement}`,
        );
      }
      // Get start index for search based on position of treeitem
      start = focusables.indexOf(this.__focusMatch_listElement) + 1;
      if (start >= focusables.length) {
        start = 0;
      }
      // Check remaining items in the tree
      for (index = start; index < focusables.length; index++) {
        focusable = focusables[index];
        if (
          ((_a = focusable.textContent) === null || _a === void 0 ? void 0 : _a.trim()) !== '' &&
          char === ((_b = focusable.textContent) === null || _b === void 0 ? void 0 : _b.trim()[0].toLowerCase())
        ) {
          focusIndex = index;
          break;
        }
      }
      // If not found in remaining slots, check from beginning
      if (focusIndex === -1) {
        for (index = 0; index < start; index++) {
          focusable = focusables[index];
          if (
            ((_c = focusable.textContent) === null || _c === void 0 ? void 0 : _c.trim()) !== '' &&
            char ===
              ((_d = focusable === null || focusable === void 0 ? void 0 : focusable.textContent) === null ||
              _d === void 0
                ? void 0
                : _d.trim()[0].toLowerCase())
          ) {
            focusIndex = index;
            break;
          }
        }
      }
      // If match was found...
      if (focusIndex > -1) {
        const focusable = focusables[focusIndex];
        if (focusable) {
          // Set [autofocus] attribute to work with other directives like x-trap
          focusable.setAttribute('autofocus', '');
          // Wait till next event loop to focus to ensure element is focusable
          setTimeout(() => {
            // Actually focus element
            focusable.focus();
          });
        }
      }
    },
  };
}

/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */

const sides = ['top', 'right', 'bottom', 'left'];
const alignments = ['start', 'end'];
const placements = /*#__PURE__*/ sides.reduce(
  (acc, side) => acc.concat(side, side + '-' + alignments[0], side + '-' + alignments[1]),
  [],
);
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v) => ({
  x: v,
  y: v,
});
const oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom',
};
const oppositeAlignmentMap = {
  start: 'end',
  end: 'start',
};
function clamp$1(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
  return placement.split('-')[0];
}
function getAlignment(placement) {
  return placement.split('-')[1];
}
function getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}
const yAxisSides = /*#__PURE__*/ new Set(['top', 'bottom']);
function getSideAxis(placement) {
  return yAxisSides.has(getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide =
    alignmentAxis === 'x'
      ? alignment === (rtl ? 'end' : 'start')
        ? 'right'
        : 'left'
      : alignment === 'start'
        ? 'bottom'
        : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [
    getOppositeAlignmentPlacement(placement),
    oppositePlacement,
    getOppositeAlignmentPlacement(oppositePlacement),
  ];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, (alignment) => oppositeAlignmentMap[alignment]);
}
const lrPlacement = ['left', 'right'];
const rlPlacement = ['right', 'left'];
const tbPlacement = ['top', 'bottom'];
const btPlacement = ['bottom', 'top'];
function getSideList(side, isStart, rtl) {
  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rlPlacement : lrPlacement;
      return isStart ? lrPlacement : rlPlacement;
    case 'left':
    case 'right':
      return isStart ? tbPlacement : btPlacement;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === 'start', rtl);
  if (alignment) {
    list = list.map((side) => side + '-' + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, (side) => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding,
  };
}
function getPaddingObject(padding) {
  return typeof padding !== 'number'
    ? expandPaddingObject(padding)
    : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding,
      };
}
function rectToClientRect(rect) {
  const {x, y, width, height} = rect;
  return {
    width,
    height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x,
    y,
  };
}

function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {reference, floating} = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === 'y';
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height,
      };
      break;
    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height,
      };
      break;
    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY,
      };
      break;
    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY,
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y,
      };
  }
  switch (getAlignment(placement)) {
    case 'start':
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case 'end':
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */
const computePosition$1 = async (reference, floating, config) => {
  const {placement = 'bottom', strategy = 'absolute', middleware = [], platform} = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
  let rects = await platform.getElementRects({
    reference,
    floating,
    strategy,
  });
  let {x, y} = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {name, fn} = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset,
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform,
      elements: {
        reference,
        floating,
      },
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data,
      },
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === 'object') {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects =
            reset.rects === true
              ? await platform.getElementRects({
                  reference,
                  floating,
                  strategy,
                })
              : reset.rects;
        }
        ({x, y} = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData,
  };
};

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {x, y, platform, rects, elements, strategy} = state;
  const {
    boundary = 'clippingAncestors',
    rootBoundary = 'viewport',
    elementContext = 'floating',
    altBoundary = false,
    padding = 0,
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === 'floating' ? 'reference' : 'floating';
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(
    await platform.getClippingRect({
      element: (
        (_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null
          ? _await$platform$isEle
          : true
      )
        ? element
        : element.contextElement ||
          (await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating))),
      boundary,
      rootBoundary,
      strategy,
    }),
  );
  const rect =
    elementContext === 'floating'
      ? {
          x,
          y,
          width: rects.floating.width,
          height: rects.floating.height,
        }
      : rects.reference;
  const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
  const offsetScale = (await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)))
    ? (await (platform.getScale == null ? void 0 : platform.getScale(offsetParent))) || {
        x: 1,
        y: 1,
      }
    : {
        x: 1,
        y: 1,
      };
  const elementClientRect = rectToClientRect(
    platform.convertOffsetParentRelativeRectToViewportRelativeRect
      ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
          elements,
          rect,
          offsetParent,
          strategy,
        })
      : rect,
  );
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x,
  };
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow$1 = (options) => ({
  name: 'arrow',
  options,
  async fn(state) {
    const {x, y, placement, rects, platform, elements, middlewareData} = state;
    // Since `element` is required, we don't Partial<> the type.
    const {element, padding = 0} = evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x,
      y,
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform.getDimensions(element);
    const isYAxis = axis === 'y';
    const minProp = isYAxis ? 'top' : 'left';
    const maxProp = isYAxis ? 'bottom' : 'right';
    const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;

    // DOM platform can return `window` as the `offsetParent`.
    if (!clientSize || !(await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;

    // If the padding is large enough that it causes the arrow to no longer be
    // centered, modify the padding so that it is centered.
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min(paddingObject[maxProp], largestPossiblePadding);

    // Make sure the arrow doesn't overflow the floating element if the center
    // point is outside the floating element's bounds.
    const min$1 = minPadding;
    const max = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset = clamp$1(min$1, center, max);

    // If the reference is small enough that the arrow's padding causes it to
    // to point to nothing for an aligned placement, adjust the offset of the
    // floating element itself. To ensure `shift()` continues to take action,
    // a single reset is performed when this is true.
    const shouldAddOffset =
      !middlewareData.arrow &&
      getAlignment(placement) != null &&
      center !== offset &&
      rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? (center < min$1 ? center - min$1 : center - max) : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset,
        centerOffset: center - offset - alignmentOffset,
        ...(shouldAddOffset && {
          alignmentOffset,
        }),
      },
      reset: shouldAddOffset,
    };
  },
});

function getPlacementList(alignment, autoAlignment, allowedPlacements) {
  const allowedPlacementsSortedByAlignment = alignment
    ? [
        ...allowedPlacements.filter((placement) => getAlignment(placement) === alignment),
        ...allowedPlacements.filter((placement) => getAlignment(placement) !== alignment),
      ]
    : allowedPlacements.filter((placement) => getSide(placement) === placement);
  return allowedPlacementsSortedByAlignment.filter((placement) => {
    if (alignment) {
      return (
        getAlignment(placement) === alignment ||
        (autoAlignment ? getOppositeAlignmentPlacement(placement) !== placement : false)
      );
    }
    return true;
  });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const autoPlacement$1 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'autoPlacement',
    options,
    async fn(state) {
      var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
      const {rects, middlewareData, placement, platform, elements} = state;
      const {
        crossAxis = false,
        alignment,
        allowedPlacements = placements,
        autoAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      const placements$1 =
        alignment !== undefined || allowedPlacements === placements
          ? getPlacementList(alignment || null, autoAlignment, allowedPlacements)
          : allowedPlacements;
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const currentIndex =
        ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
      const currentPlacement = placements$1[currentIndex];
      if (currentPlacement == null) {
        return {};
      }
      const alignmentSides = getAlignmentSides(
        currentPlacement,
        rects,
        await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)),
      );

      // Make `computeCoords` start from the right place.
      if (placement !== currentPlacement) {
        return {
          reset: {
            placement: placements$1[0],
          },
        };
      }
      const currentOverflows = [
        overflow[getSide(currentPlacement)],
        overflow[alignmentSides[0]],
        overflow[alignmentSides[1]],
      ];
      const allOverflows = [
        ...(((_middlewareData$autoP2 = middlewareData.autoPlacement) == null
          ? void 0
          : _middlewareData$autoP2.overflows) || []),
        {
          placement: currentPlacement,
          overflows: currentOverflows,
        },
      ];
      const nextPlacement = placements$1[currentIndex + 1];

      // There are more placements to check.
      if (nextPlacement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows,
          },
          reset: {
            placement: nextPlacement,
          },
        };
      }
      const placementsSortedByMostSpace = allOverflows
        .map((d) => {
          const alignment = getAlignment(d.placement);
          return [
            d.placement,
            alignment && crossAxis
              ? // Check along the mainAxis and main crossAxis side.
                d.overflows.slice(0, 2).reduce((acc, v) => acc + v, 0)
              : // Check only the mainAxis.
                d.overflows[0],
            d.overflows,
          ];
        })
        .sort((a, b) => a[1] - b[1]);
      const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d) =>
        d[2]
          .slice(
            0,
            // Aligned placements should not check their opposite crossAxis
            // side.
            getAlignment(d[0]) ? 2 : 3,
          )
          .every((v) => v <= 0),
      );
      const resetPlacement =
        ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) ||
        placementsSortedByMostSpace[0][0];
      if (resetPlacement !== placement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows,
          },
          reset: {
            placement: resetPlacement,
          },
        };
      }
      return {};
    },
  };
};

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip$1 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'flip',
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {placement, middlewareData, rects, initialPlacement, platform, elements} = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = 'bestFit',
        fallbackAxisSideDirection = 'none',
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);

      // If a reset by the arrow was caused due to an alignment offset being
      // added, we should skip any logic now since `flip()` has already done its
      // work.
      // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
      const fallbackPlacements =
        specifiedFallbackPlacements ||
        (isBasePlacement || !flipAlignment
          ? [getOppositePlacement(initialPlacement)]
          : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(
          ...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl),
        );
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData =
        ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [
        ...overflowsData,
        {
          placement,
          overflows,
        },
      ];

      // One or more sides is overflowing.
      if (!overflows.every((side) => side <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex =
          (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          const ignoreCrossAxisOverflow =
            checkCrossAxis === 'alignment' ? initialSideAxis !== getSideAxis(nextPlacement) : false;
          if (
            !ignoreCrossAxisOverflow ||
            // We leave the current main axis only if every placement on that axis
            // overflows the main axis.
            overflowsData.every((d) => (getSideAxis(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true))
          ) {
            // Try next placement and re-run the lifecycle.
            return {
              data: {
                index: nextIndex,
                overflows: overflowsData,
              },
              reset: {
                placement: nextPlacement,
              },
            };
          }
        }

        // First, find the candidates that fit on the mainAxis side of overflow,
        // then find the placement that fits the best on the main crossAxis side.
        let resetPlacement =
          (_overflowsData$filter = overflowsData
            .filter((d) => d.overflows[0] <= 0)
            .sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null
            ? void 0
            : _overflowsData$filter.placement;

        // Otherwise fallback.
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case 'bestFit': {
              var _overflowsData$filter2;
              const placement =
                (_overflowsData$filter2 = overflowsData
                  .filter((d) => {
                    if (hasFallbackAxisSideDirection) {
                      const currentSideAxis = getSideAxis(d.placement);
                      return (
                        currentSideAxis === initialSideAxis ||
                        // Create a bias to the `y` side axis due to horizontal
                        // reading directions favoring greater width.
                        currentSideAxis === 'y'
                      );
                    }
                    return true;
                  })
                  .map((d) => [
                    d.placement,
                    d.overflows.filter((overflow) => overflow > 0).reduce((acc, overflow) => acc + overflow, 0),
                  ])
                  .sort((a, b) => a[1] - b[1])[0]) == null
                  ? void 0
                  : _overflowsData$filter2[0];
              if (placement) {
                resetPlacement = placement;
              }
              break;
            }
            case 'initialPlacement':
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement,
            },
          };
        }
      }
      return {};
    },
  };
};

const originSides = /*#__PURE__*/ new Set(['left', 'top']);

// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.

async function convertValueToCoords(state, options) {
  const {placement, platform, elements} = state;
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === 'y';
  const mainAxisMulti = originSides.has(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);

  // eslint-disable-next-line prefer-const
  let {mainAxis, crossAxis, alignmentAxis} =
    typeof rawValue === 'number'
      ? {
          mainAxis: rawValue,
          crossAxis: 0,
          alignmentAxis: null,
        }
      : {
          mainAxis: rawValue.mainAxis || 0,
          crossAxis: rawValue.crossAxis || 0,
          alignmentAxis: rawValue.alignmentAxis,
        };
  if (alignment && typeof alignmentAxis === 'number') {
    crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical
    ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti,
      }
    : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti,
      };
}

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset$1 = function (options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: 'offset',
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {x, y, placement, middlewareData} = state;
      const diffCoords = await convertValueToCoords(state, options);

      // If the placement is the same and the arrow caused an alignment offset
      // then we don't need to change the positioning coordinates.
      if (
        placement ===
          ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) &&
        (_middlewareData$arrow = middlewareData.arrow) != null &&
        _middlewareData$arrow.alignmentOffset
      ) {
        return {};
      }
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: {
          ...diffCoords,
          placement,
        },
      };
    },
  };
};

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift$1 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'shift',
    options,
    async fn(state) {
      const {x, y, placement} = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: (_ref) => {
            let {x, y} = _ref;
            return {
              x,
              y,
            };
          },
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x,
        y,
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === 'y' ? 'top' : 'left';
        const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
        const min = mainAxisCoord + overflow[minSide];
        const max = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp$1(min, mainAxisCoord, max);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === 'y' ? 'top' : 'left';
        const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
        const min = crossAxisCoord + overflow[minSide];
        const max = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp$1(min, crossAxisCoord, max);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord,
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis,
          },
        },
      };
    },
  };
};

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const size$1 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'size',
    options,
    async fn(state) {
      var _state$middlewareData, _state$middlewareData2;
      const {placement, rects, platform, elements} = state;
      const {apply = () => {}, ...detectOverflowOptions} = evaluate(options, state);
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === 'y';
      const {width, height} = rects.floating;
      let heightSide;
      let widthSide;
      if (side === 'top' || side === 'bottom') {
        heightSide = side;
        widthSide =
          alignment ===
          ((await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating))) ? 'start' : 'end')
            ? 'left'
            : 'right';
      } else {
        widthSide = side;
        heightSide = alignment === 'end' ? 'top' : 'bottom';
      }
      const maximumClippingHeight = height - overflow.top - overflow.bottom;
      const maximumClippingWidth = width - overflow.left - overflow.right;
      const overflowAvailableHeight = min(height - overflow[heightSide], maximumClippingHeight);
      const overflowAvailableWidth = min(width - overflow[widthSide], maximumClippingWidth);
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) {
        availableWidth = maximumClippingWidth;
      }
      if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) {
        availableHeight = maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max(overflow.left, 0);
        const xMax = max(overflow.right, 0);
        const yMin = max(overflow.top, 0);
        const yMax = max(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max(overflow.top, overflow.bottom));
        }
      }
      await apply({
        ...state,
        availableWidth,
        availableHeight,
      });
      const nextDimensions = await platform.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true,
          },
        };
      }
      return {};
    },
  };
};

function hasWindow() {
  return typeof window !== 'undefined';
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || '').toLowerCase();
  }
  // Mocked nodes in testing environments may not be instances of Node. By
  // returning `#document` an infinite loop won't occur.
  // https://github.com/floating-ui/floating-ui/issues/2317
  return '#document';
}
function getWindow(node) {
  var _node$ownerDocument;
  return (
    (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) ||
    window
  );
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null
    ? void 0
    : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement$1(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === 'undefined') {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
const invalidOverflowDisplayValues = /*#__PURE__*/ new Set(['inline', 'contents']);
function isOverflowElement(element) {
  const {overflow, overflowX, overflowY, display} = getComputedStyle$2(element);
  return (
    /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) &&
    !invalidOverflowDisplayValues.has(display)
  );
}
const tableElements = /*#__PURE__*/ new Set(['table', 'td', 'th']);
function isTableElement(element) {
  return tableElements.has(getNodeName(element));
}
const topLayerSelectors = [':popover-open', ':modal'];
function isTopLayer(element) {
  return topLayerSelectors.some((selector) => {
    try {
      return element.matches(selector);
    } catch (_e) {
      return false;
    }
  });
}
const transformProperties = ['transform', 'translate', 'scale', 'rotate', 'perspective'];
const willChangeValues = ['transform', 'translate', 'scale', 'rotate', 'perspective', 'filter'];
const containValues = ['paint', 'layout', 'strict', 'content'];
function isContainingBlock(elementOrCss) {
  const webkit = isWebKit();
  const css = isElement(elementOrCss) ? getComputedStyle$2(elementOrCss) : elementOrCss;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  // https://drafts.csswg.org/css-transforms-2/#individual-transforms
  return (
    transformProperties.some((value) => (css[value] ? css[value] !== 'none' : false)) ||
    (css.containerType ? css.containerType !== 'normal' : false) ||
    (!webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false)) ||
    (!webkit && (css.filter ? css.filter !== 'none' : false)) ||
    willChangeValues.some((value) => (css.willChange || '').includes(value)) ||
    containValues.some((value) => (css.contain || '').includes(value))
  );
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement$1(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === 'undefined' || !CSS.supports) return false;
  return CSS.supports('-webkit-backdrop-filter', 'none');
}
const lastTraversableNodeNames = /*#__PURE__*/ new Set(['html', 'body', '#document']);
function isLastTraversableNode(node) {
  return lastTraversableNodeNames.has(getNodeName(node));
}
function getComputedStyle$2(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop,
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY,
  };
}
function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }
  const result =
    // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot ||
    // DOM Element detected.
    node.parentNode ||
    // ShadowRoot detected.
    (isShadowRoot(node) && node.host) ||
    // Fallback.
    getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement$1(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody =
    scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(
      win,
      win.visualViewport || [],
      isOverflowElement(scrollableAncestor) ? scrollableAncestor : [],
      frameElement && traverseIframes ? getOverflowAncestors(frameElement) : [],
    );
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

function getCssDimensions(element) {
  const css = getComputedStyle$2(element);
  // In testing environments, the `width` and `height` properties are empty
  // strings for SVG elements, returning NaN. Fallback to `0` in this case.
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement$1(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback,
  };
}

function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}

function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement$1(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {width, height, $} = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;

  // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y,
  };
}

const noOffsets = /*#__PURE__*/ createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop,
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || (isFixed && floatingOffsetParent !== getWindow(element))) {
    return false;
  }
  return isFixed;
}

function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent)
    ? getVisualOffsets(domElement)
    : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle$2(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y,
  });
}

// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function getWindowScrollBarX(element, rect) {
  const leftScroll = getNodeScroll(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}

function getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
  if (ignoreScrollbarX === void 0) {
    ignoreScrollbarX = false;
  }
  const htmlRect = documentElement.getBoundingClientRect();
  const x =
    htmlRect.left +
    scroll.scrollLeft -
    (ignoreScrollbarX
      ? 0
      : // RTL <body> scrollbar.
        getWindowScrollBarX(documentElement, htmlRect));
  const y = htmlRect.top + scroll.scrollTop;
  return {
    x,
    y,
  };
}

function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {elements, rect, offsetParent, strategy} = _ref;
  const isFixed = strategy === 'fixed';
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || (topLayer && isFixed)) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0,
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  if (isOffsetParentAnElement || (!isOffsetParentAnElement && !isFixed)) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement$1(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset =
    documentElement && !isOffsetParentAnElement && !isFixed
      ? getHTMLOffset(documentElement, scroll, true)
      : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y,
  };
}

function getClientRects(element) {
  return Array.from(element.getClientRects());
}

// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle$2(body).direction === 'rtl') {
    x += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y,
  };
}

function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || (visualViewportBased && strategy === 'fixed')) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y,
  };
}

const absoluteOrFixed = /*#__PURE__*/ new Set(['absolute', 'fixed']);
// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement$1(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y,
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === 'viewport') {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === 'document') {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height,
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle$2(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}

// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter((el) => isElement(el) && getNodeName(el) !== 'body');
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$2(element).position === 'fixed';
  let currentNode = elementIsFixed ? getParentNode(element) : element;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$2(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === 'fixed') {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed
      ? !currentNodeIsContaining && !currentContainingBlockComputedStyle
      : (!currentNodeIsContaining &&
          computedStyle.position === 'static' &&
          !!currentContainingBlockComputedStyle &&
          absoluteOrFixed.has(currentContainingBlockComputedStyle.position)) ||
        (isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode));
    if (shouldDropCurrentNode) {
      // Drop non-containing blocks.
      result = result.filter((ancestor) => ancestor !== currentNode);
    } else {
      // Record last containing block for next iteration.
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}

// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
  let {element, boundary, rootBoundary, strategy} = _ref;
  const elementClippingAncestors =
    boundary === 'clippingAncestors'
      ? isTopLayer(element)
        ? []
        : getClippingElementAncestors(element, this._c)
      : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce(
    (accRect, clippingAncestor) => {
      const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
      accRect.top = max(rect.top, accRect.top);
      accRect.right = min(rect.right, accRect.right);
      accRect.bottom = min(rect.bottom, accRect.bottom);
      accRect.left = max(rect.left, accRect.left);
      return accRect;
    },
    getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy),
  );
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top,
  };
}

function getDimensions(element) {
  const {width, height} = getCssDimensions(element);
  return {
    width,
    height,
  };
}

function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === 'fixed';
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0,
  };
  const offsets = createCoords(0);

  // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
  // Firefox with layout.scrollbar.side = 3 in about:config to test this.
  function setLeftRTLScrollbarOffset() {
    offsets.x = getWindowScrollBarX(documentElement);
  }
  if (isOffsetParentAnElement || (!isOffsetParentAnElement && !isFixed)) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      setLeftRTLScrollbarOffset();
    }
  }
  if (isFixed && !isOffsetParentAnElement && documentElement) {
    setLeftRTLScrollbarOffset();
  }
  const htmlOffset =
    documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
  const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
  return {
    x,
    y,
    width: rect.width,
    height: rect.height,
  };
}

function isStaticPositioned(element) {
  return getComputedStyle$2(element).position === 'static';
}

function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement$1(element) || getComputedStyle$2(element).position === 'fixed') {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  let rawOffsetParent = element.offsetParent;

  // Firefox returns the <html> element as the offsetParent if it's non-static,
  // while Chrome and Safari return the <body> element. The <body> element must
  // be used to perform the correct calculations even if the <html> element is
  // non-static.
  if (getDocumentElement(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}

// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
  const win = getWindow(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement$1(element)) {
    let svgOffsetParent = getParentNode(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (
    offsetParent &&
    isLastTraversableNode(offsetParent) &&
    isStaticPositioned(offsetParent) &&
    !isContainingBlock(offsetParent)
  ) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}

const getElementRects = async function (data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height,
    },
  };
};

function isRTL(element) {
  return getComputedStyle$2(element).direction === 'rtl';
}

const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL,
};

function rectsAreEqual(a, b) {
  return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}

// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const elementRectForRootMargin = element.getBoundingClientRect();
    const {left, top, width, height} = elementRectForRootMargin;
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + 'px ' + -insetRight + 'px ' + -insetBottom + 'px ' + -insetLeft + 'px';
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1,
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          // If the reference is clipped, the ratio is 0. Throttle the refresh
          // to prevent an infinite loop of updates.
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1000);
        } else {
          refresh(false, ratio);
        }
      }
      if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) {
        // It's possible that even though the ratio is reported as 1, the
        // element is not actually fully within the IntersectionObserver's root
        // area anymore. This can happen under performance constraints. This may
        // be a bug in the browser's IntersectionObserver implementation. To
        // work around this, we compare the element's bounding rect now with
        // what it was at the time we created the IntersectionObserver. If they
        // are not equal then the element moved, so we refresh.
        refresh();
      }
      isFirstUpdate = false;
    }

    // Older browsers don't support a `document` as the root and will throw an
    // error.
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument,
      });
    } catch (_e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}

/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === 'function',
    layoutShift = typeof IntersectionObserver === 'function',
    animationFrame = false,
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors =
    ancestorScroll || ancestorResize
      ? [...(referenceEl ? getOverflowAncestors(referenceEl) : []), ...getOverflowAncestors(floating)]
      : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll &&
      ancestor.addEventListener('scroll', update, {
        passive: true,
      });
    ancestorResize && ancestor.addEventListener('resize', update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref) => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        // Prevent update loops when using the `size` middleware.
        // https://github.com/floating-ui/floating-ui/issues/1740
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener('scroll', update);
      ancestorResize && ancestor.removeEventListener('resize', update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset = offset$1;

/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const autoPlacement = autoPlacement$1;

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift = shift$1;

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip = flip$1;

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const size = size$1;

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = arrow$1;

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */
const computePosition = (reference, floating, options) => {
  // This caches the expensive `getClippingElementAncestors` function so that
  // multiple lifecycle resets re-use the same result. It only lives for a
  // single call. If other functions become expensive, we can add them as well.
  const cache = new Map();
  const mergedOptions = {
    platform,
    ...options,
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache,
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache,
  });
};

var __rest$2 =
  (undefined && undefined.__rest) ||
  function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
      }
    return t;
  };
const DEFAULT_MIN_FIT_HEIGHT = 100; // This is fairly arbitrary but works well for now. We can easily add a `.min.10px` modifier to allow customizing it later if need be
const DEFAULT_MIN_FIT_WIDTH = 0;
const DEFAULT_OFFSET$2 = 20;
const DEFAULT_PADDING = 5;
function float(Alpine) {
  Alpine.directive('float', ($el, {value, modifiers, expression}, {evaluateLater, effect}) => {
    if (!isHtmlElement($el)) {
      throw new Error(`Expected HTMLElement but got ${$el}`);
    }
    if (value == 'arrow') {
      const $data = Alpine.$data($el);
      $data.__float_arrowEl = $el;
      Alpine.bind($el, {
        ':style'() {
          // Dont return styles if the strategy is "css" because the styles are applied via CSS variables
          if (this.__float_strategy == 'css') return {};
          if (this.__float_arrowData == null) return {};
          const side = this.__float_side;
          const {x, y} = this.__float_arrowData;
          const oppositeSide = {
            top: 'bottom',
            right: 'left',
            bottom: 'top',
            left: 'right',
          }[side];
          const rotation = {
            top: '0deg',
            right: '90deg',
            bottom: '180deg',
            left: '-90deg',
          }[oppositeSide];
          return {
            position: 'absolute',
            // Position arrow at the edge of the floating element
            left: x != null ? `${roundByDPR(x || 0)}px` : '',
            top: y != null ? `${roundByDPR(y || 0)}px` : '',
            // Force arrow over to the positioned side
            [side]: '100%',
            // Adjust rotation to point to the target
            transform: `
                rotate(${rotation})
              `,
          };
        },
      });
    } else if (value == null) {
      const getOptions = evaluateLater(expression);
      let initialPlacement = getPlacementModifier(modifiers);
      ensureFlipAndAutoPlacementAreNotUsedTogether(modifiers);
      Alpine.bind($el, {
        'x-data'() {
          return {
            __float_arrowEl: null,
            __float_positionData: null,
            __float_arrowData: null,
            __float_referenceEl: null,
            __float_initialPlacement:
              hasCoverModifier(modifiers) && initialPlacement
                ? getOppositePlacement(initialPlacement)
                : initialPlacement,
            __float_cancelAutoUpdate: null,
            __float_isPositioned: false,
            __float_placement: null,
            __float_alignment: null,
            __float_side: null,
            __float_rootBoundary: 'viewport',
            __float_strategy: getStrategyModifier(modifiers) || 'fixed',
            __float_autoUpdateEnabled: hasAutoUpdateModifier(modifiers),
            __float_initialUpdate: true,
            __float_offset: getOffsetModifier(modifiers) || 0,
            __float_coverEnabled: hasCoverModifier(modifiers),
            __float_autoPlacementEnabled: getAutoPlacementModifier(modifiers) || initialPlacement == undefined,
            __float_flipEnabled: hasFlipModifier(modifiers),
            __float_fitXEnabled: hasFitXModifier(modifiers),
            __float_fitYEnabled: hasFitYModifier(modifiers),
            __float_shiftEnabled: getShiftModifier(modifiers),
            __float_matchSizeEnabled: hasMatchSizeModifier(modifiers),
            __float_padding: getPaddingModifier(modifiers) || 0,
            __float_customMiddleware: [],
            get __float_middleware() {
              let middleware = [offset(this.__float_offset), ...this.__float_customMiddleware];
              if (this.__float_coverEnabled) {
                middleware.push(cover());
              }
              if (this.__float_autoPlacementEnabled == true) {
                middleware.push(
                  autoPlacement({
                    rootBoundary: this.__float_rootBoundary,
                    alignment: this.__float_alignment,
                  }),
                );
              } else if (this.__float_autoPlacementEnabled == 'y') {
                middleware.push(
                  autoPlacement({
                    rootBoundary: this.__float_rootBoundary,
                    alignment: this.__float_alignment,
                    allowedPlacements: ['top', 'bottom'],
                  }),
                );
              } else if (this.__float_autoPlacementEnabled == 'x') {
                middleware.push(
                  autoPlacement({
                    rootBoundary: this.__float_rootBoundary,
                    alignment: this.__float_alignment,
                    allowedPlacements: ['left', 'right'],
                  }),
                );
              }
              if (this.__float_fitYEnabled) {
                middleware.push(
                  fitY(this.__float_strategy, {
                    padding: this.__float_padding,
                    rootBoundary: this.__float_rootBoundary,
                  }),
                );
              }
              if (this.__float_fitXEnabled) {
                middleware.push(
                  fitX(this.__float_strategy, {
                    padding: this.__float_padding,
                    rootBoundary: this.__float_rootBoundary,
                  }),
                );
              }
              if (this.__float_flipEnabled) {
                middleware.push(
                  flip({
                    padding: this.__float_padding,
                    rootBoundary: this.__float_rootBoundary,
                  }),
                );
              }
              if (this.__float_shiftEnabled == true) {
                middleware.push(
                  shift({
                    padding: this.__float_padding,
                    mainAxis: true,
                    crossAxis: false,
                    rootBoundary: this.__float_rootBoundary,
                  }),
                );
              } else if (this.__float_shiftEnabled == 'both') {
                middleware.push(
                  shift({
                    padding: this.__float_padding,
                    mainAxis: true,
                    crossAxis: true,
                    rootBoundary: this.__float_rootBoundary,
                  }),
                );
              } else if (this.__float_shiftEnabled == 'cross') {
                middleware.push(
                  shift({
                    padding: this.__float_padding,
                    mainAxis: false,
                    crossAxis: true,
                    rootBoundary: this.__float_rootBoundary,
                  }),
                );
              }
              if (this.__float_matchSizeEnabled) {
                middleware.push(
                  matchSize(this.__float_strategy, {
                    rootBoundary: this.__float_rootBoundary,
                  }),
                );
              }
              if (this.__float_arrowEl !== null) {
                middleware.push(arrow({element: this.__float_arrowEl}));
              }
              return middleware;
            },
            __float_updatePosition() {
              if (this.__float_referenceEl == null) {
                return;
              }
              computePosition(this.__float_referenceEl, $el, {
                placement: this.__float_initialPlacement,
                strategy: this.__float_strategy == 'absolute' ? 'absolute' : 'fixed',
                middleware: this.__float_middleware,
              }).then((data) => {
                const {placement, middlewareData} = data;
                this.__float_positionData = data;
                this.__float_placement = placement;
                this.__float_alignment = getAlignment(placement) || null;
                this.__float_side = getSide(placement);
                // Arrow positioning logic
                if (middlewareData.arrow && this.__float_arrowEl !== null) {
                  this.__float_arrowData = middlewareData.arrow;
                }
              });
            },
            __float_startAutoUpdate() {
              var _a;
              if (!this.__float_referenceEl) return;
              // Reset any existing floating
              (_a = this.__float_cancelAutoUpdate) === null || _a === void 0 ? void 0 : _a.call(this);
              this.__float_cancelAutoUpdate = autoUpdate(
                this.__float_referenceEl,
                $el,
                this.__float_updatePosition.bind(this),
              );
            },
            __float_getStyles() {
              // If we're not positioned and not floating then reset the styles
              if (this.__float_positionData == null || !this.__float_referenceEl) {
                return {};
              }
              switch (this.__float_strategy) {
                case 'absolute':
                  return {
                    position: 'absolute',
                    left: `${this.__float_positionData.x}px`,
                    top: `${this.__float_positionData.y}px`,
                  };
                case 'transform':
                  return {
                    transform: `translate(${roundByDPR(this.__float_positionData.x)}px, ${roundByDPR(this.__float_positionData.y)}px)`,
                    left: '0',
                    top: '0',
                  };
                case 'transform3d':
                  return {
                    transform: `translate3d(${roundByDPR(this.__float_positionData.x)}px, ${roundByDPR(this.__float_positionData.y)}px, 0)`,
                    left: '0',
                    top: '0',
                  };
                case 'fixed':
                  return {
                    position: 'fixed',
                    left: `${this.__float_positionData.x}px`,
                    top: `${this.__float_positionData.y}px`,
                  };
              }
            },
            init() {
              this.$watch('__float_autoUpdateEnabled', (autoUpdateEnabled) => {
                var _a;
                if (autoUpdateEnabled) {
                  this.__float_startAutoUpdate();
                } else {
                  // If the expression does not result in an html element, reset
                  (_a = this.__float_cancelAutoUpdate) === null || _a === void 0 ? void 0 : _a.call(this);
                }
              });
              this.$watch('__float_positionData', (positionData) => {
                if (this.__float_strategy == 'css') {
                  if (positionData !== null) {
                    const {x, y} = positionData;
                    requestAnimationFrame(() => {
                      var _a, _b;
                      this.$el.style.setProperty('--float-x', `${x}px`);
                      this.$el.style.setProperty('--float-y', `${y}px`);
                      (_a = this.__float_arrowEl) === null || _a === void 0
                        ? void 0
                        : _a.style.setProperty('--float-arrow-x', `${roundByDPR(x || 0)}px`);
                      (_b = this.__float_arrowEl) === null || _b === void 0
                        ? void 0
                        : _b.style.setProperty('--float-arrow-y', `${roundByDPR(y || 0)}px`);
                      this.__float_isPositioned = true;
                    });
                  }
                } else {
                  this.__float_isPositioned = true;
                  Object.assign(this.$el.style, this.__float_getStyles());
                }
              });
              effect(() => {
                getOptions(async (optionsOrRefererenceEl) => {
                  let newReferenceEl = null;
                  let options = {};
                  // Check whether the expression evaluates to an html element or an options object
                  if (optionsOrRefererenceEl != null && optionsOrRefererenceEl != false) {
                    if (isHtmlElement(optionsOrRefererenceEl)) {
                      newReferenceEl = optionsOrRefererenceEl;
                    } else if (isPlainObject(optionsOrRefererenceEl)) {
                      options = optionsOrRefererenceEl;
                      if (options.rootBoundary !== undefined) {
                        this.__float_rootBoundary = options.rootBoundary;
                      }
                      if (options.strategy !== undefined) {
                        this.__float_strategy = options.strategy;
                      }
                      if (options.autoUpdate !== undefined) {
                        this.__float_autoUpdateEnabled = options.autoUpdate;
                      }
                      if (options.offset !== undefined) {
                        this.__float_offset = options.offset;
                      }
                      if (options.cover !== undefined) {
                        this.__float_coverEnabled = options.cover || hasCoverModifier(modifiers) || false;
                      }
                      if (options.autoPlacement !== undefined) {
                        this.__float_autoPlacementEnabled = options.autoPlacement;
                      }
                      if (options.flip !== undefined) {
                        this.__float_flipEnabled = options.flip;
                      }
                      if (options.fitX !== undefined) {
                        this.__float_fitXEnabled = options.fitX;
                      }
                      if (options.fitY !== undefined) {
                        this.__float_fitYEnabled = options.fitY;
                      }
                      if (options.shift !== undefined) {
                        this.__float_shiftEnabled = options.shift;
                      }
                      if (options.matchSize !== undefined) {
                        this.__float_matchSizeEnabled = options.matchSize;
                      }
                      if (options.padding !== undefined) {
                        this.__float_padding = options.padding;
                      }
                      if (options.referenceEl !== undefined) {
                        newReferenceEl = options.referenceEl;
                      }
                      if (options.initialUpdate !== undefined) {
                        this.__float_initialUpdate = options.initialUpdate;
                      }
                    }
                  }
                  // Wait for next tick until arrow element is available and we can calculate the position
                  this.$nextTick(() => {
                    var _a;
                    if (this.__float_referenceEl && !newReferenceEl) {
                      // If the reference el has been removed, cancel any auto updating and reset the position
                      (_a = this.__float_cancelAutoUpdate) === null || _a === void 0 ? void 0 : _a.call(this);
                      this.__float_isPositioned = false;
                    } else if (this.__float_referenceEl != newReferenceEl) {
                      // If a reference el has been provided, set it and update the position
                      this.__float_referenceEl = newReferenceEl;
                      if (this.__float_autoUpdateEnabled) {
                        this.__float_startAutoUpdate();
                      } else if (this.__float_initialUpdate) {
                        this.__float_updatePosition();
                      }
                    }
                  });
                });
              });
            },
            destroy() {
              var _a;
              (_a = this.__float_cancelAutoUpdate) === null || _a === void 0 ? void 0 : _a.call(this);
            },
          };
        },
      });
    } else {
      throw new Error(`Unknown directive: x-float:${value}`);
    }
  }).before('bind');
  Alpine.magic('float', handleFloatMagic(Alpine));
}
function handleFloatMagic(Alpine) {
  return function ($el) {
    const $data = Alpine.$data($el);
    return {
      get referenceEl() {
        return $data.__float_referenceEl;
      },
      set referenceEl(el) {
        $data.__float_referenceEl = el;
      },
      get isPositioned() {
        return $data.__float_isPositioned;
      },
      get placement() {
        return $data.__float_placement;
      },
      get side() {
        return $data.__float_side;
      },
      get alignment() {
        return $data.__float_alignment;
      },
      get matchSizeEnabled() {
        return $data.__float_matchSizeEnabled;
      },
      set matchSizeEnabled(value) {
        $data.__float_matchSizeEnabled = value;
      },
      updatePosition() {
        $data.__float_updatePosition();
      },
      enableAutoUpdate() {
        $data.__float_autoUpdateEnabled = true;
      },
      disableAutoUpdate() {
        $data.__float_autoUpdateEnabled = false;
      },
      get middleware() {
        return $data.__float_customMiddleware;
      },
      set middleware(middleware) {
        $data.__float_customMiddleware = middleware;
      },
    };
  };
}
function getOffsetModifier(modifiers) {
  const offsetModifierIndex = modifiers.findIndex((modifier) => modifier == 'offset');
  const offsetAmountModifier = modifiers[offsetModifierIndex + 1];
  if (offsetModifierIndex === -1) {
    return 0;
  }
  let offsetAmount = DEFAULT_OFFSET$2;
  let match =
    offsetAmountModifier === null || offsetAmountModifier === void 0 ? void 0 : offsetAmountModifier.match(/(-?\d+)px/);
  if (match) {
    offsetAmount = Number(match[1]);
  }
  return Number(offsetAmount);
}
function getPlacementModifier(modifiers) {
  return modifiers.find((modifier) => modifier.match(/^(top|right|bottom|left)(-(start|end))?$/));
}
function hasFlipModifier(modifiers) {
  return modifiers.includes('flip');
}
function getPaddingModifier(modifiers) {
  const paddingModifierIndex = modifiers.findIndex((modifier) => modifier == 'pad');
  const paddingAmountModifier = modifiers[paddingModifierIndex + 1];
  if (paddingModifierIndex === -1) {
    return 0;
  }
  let paddingAmount = DEFAULT_PADDING;
  let match =
    paddingAmountModifier === null || paddingAmountModifier === void 0
      ? void 0
      : paddingAmountModifier.match(/(-?\d+)px/);
  if (match) {
    paddingAmount = Number(match[1]);
  }
  return Number(paddingAmount);
}
function hasCoverModifier(modifiers) {
  return modifiers.includes('cover');
}
function hasFitYModifier(modifiers) {
  return modifiers.includes('fit-y');
}
function hasFitXModifier(modifiers) {
  return modifiers.includes('fit-x');
}
function hasMatchSizeModifier(modifiers) {
  return modifiers.includes('match');
}
function getAutoPlacementModifier(modifiers) {
  if (modifiers.includes('auto')) return true;
  if (modifiers.includes('auto-x')) return 'x';
  if (modifiers.includes('auto-y')) return 'y';
  return false;
}
function getShiftModifier(modifiers) {
  if (modifiers.includes('shift')) return true;
  if (modifiers.includes('shift-cross')) return 'cross';
  if (modifiers.includes('shift-both')) return 'both';
  return false;
}
function hasAutoUpdateModifier(modifiers) {
  return modifiers.includes('update');
}
function getStrategyModifier(modifiers) {
  if (modifiers.includes('css')) return 'css';
  if (modifiers.includes('transform')) return 'transform';
  if (modifiers.includes('transform3d')) return 'transform3d';
  if (modifiers.includes('absolute')) return 'absolute';
}
/**
 * Middleware that adjusts the size of the floating element to match that of the reference in the cross-axis direction
 */
function matchSize(strategy, options) {
  return size(
    Object.assign(
      {
        apply: (_a) => {
          var {rects, elements} = _a,
            other = __rest$2(_a, ['rects', 'elements']);
          const mainAxisPlacement = getAlignmentAxis(other.placement);
          if (mainAxisPlacement === 'x') {
            if (strategy == 'css') {
              elements.floating.style.setProperty('--float-width', `${rects.reference.width}px`);
            } else {
              Object.assign(elements.floating.style, {
                width: `${rects.reference.width}px`,
              });
            }
          } else {
            if (strategy == 'css') {
              elements.floating.style.setProperty('--float-height', `${rects.reference.height}px`);
            } else {
              Object.assign(elements.floating.style, {
                height: `${rects.reference.height}px`,
              });
            }
          }
        },
      },
      options,
    ),
  );
}
/**
 * Middleware that ensures an element fits within the viewport height
 */
function fitY(strategy, options) {
  return size(
    Object.assign(Object.assign({}, options), {
      apply({availableHeight, elements}) {
        var _a;
        const minHeight =
          (_a = options === null || options === void 0 ? void 0 : options.minHeight) !== null && _a !== void 0
            ? _a
            : DEFAULT_MIN_FIT_HEIGHT;
        if (availableHeight >= minHeight) {
          if (strategy == 'css') {
            elements.floating.style.setProperty('--float-max-height', `${availableHeight}px`);
          } else {
            Object.assign(elements.floating.style, {
              maxHeight: `${availableHeight}px`,
            });
          }
        }
      },
    }),
  );
}
/**
 * Middleware that ensures an element fits within the viewport width
 */
function fitX(strategy, options) {
  return size(
    Object.assign(Object.assign({}, options), {
      apply({availableWidth, elements}) {
        var _a;
        const minWidth =
          (_a = options === null || options === void 0 ? void 0 : options.minWidth) !== null && _a !== void 0
            ? _a
            : DEFAULT_MIN_FIT_WIDTH;
        if (availableWidth >= minWidth) {
          if (strategy == 'css') {
            elements.floating.style.setProperty('--float-max-width', `${availableWidth}px`);
          } else {
            Object.assign(elements.floating.style, {
              maxWidth: `${availableWidth}px`,
            });
          }
        }
      },
    }),
  );
}
/**
 * Middleware which offsets the floating element to cover the reference element (i.e. align top edge of floating element with top edge of reference element, etc.)
 */
function cover() {
  const middleware = offset((state) => {
    const axis = getSideAxis(state.placement);
    let offset = 0;
    if (axis === 'x') {
      offset = -state.rects.reference.width;
    } else if (axis === 'y') {
      offset = -state.rects.reference.height;
    }
    return offset;
  });
  return middleware;
}
function ensureFlipAndAutoPlacementAreNotUsedTogether(modifiers) {
  if (hasFlipModifier(modifiers) && getAutoPlacementModifier(modifiers)) {
    throw new Error(
      `The \`flip\` and \`auto\` modifiers cannot be used together. Use either \`auto\` or \`flip\`. See https://floating-ui.com/docs/autoPlacement#conflict-with-flip`,
    );
  }
}
function roundByDPR(value) {
  const dpr = window.devicePixelRatio || 1;
  return Math.round(value * dpr) / dpr;
}

const DEFAULT_MAX_REPEAT_TIME_IN_MS = 1500;
/**
 * Allow repeatedly triggering an action while the mouse is held down or while element is being touched
 *
 * e.g.
 *
 * <button x-hold.250ms="console.log('clicked')">Hold me down</button>
 */
function hold(Alpine) {
  Alpine.directive('hold', ($el, {modifiers, expression}, {evaluate}) => {
    if (!isHtmlElement($el)) {
      throw new Error(`Expected HTMLElement but got ${$el}`);
    }
    let firstModifier = modifiers[0] || '';
    let time = isNumeric(firstModifier.split('ms')[0]) ? Number(firstModifier.split('ms')[0]) : 25;
    let maxModifierIndex = modifiers.indexOf('max');
    let maxValueModifier = modifiers[maxModifierIndex + 1];
    let maxTime = isNumeric(
      maxValueModifier === null || maxValueModifier === void 0 ? void 0 : maxValueModifier.split('ms')[0],
    )
      ? Number(maxValueModifier.split('ms')[0])
      : DEFAULT_MAX_REPEAT_TIME_IN_MS;
    Alpine.bind($el, {
      ['x-data']() {
        return {
          __intervalId: undefined,
          __onPointerDown(e) {
            var _a;
            if (isHtmlElement(e.target)) {
              if ((_a = e.target) === null || _a === void 0 ? void 0 : _a.hasPointerCapture(e.pointerId)) {
                e.target.releasePointerCapture(e.pointerId);
              }
            }
            let repeats = 0;
            this.__intervalId = window.setInterval(() => {
              evaluate(expression);
              repeats += 1;
              if (repeats * time >= maxTime) {
                // Automatically stop the intervals after a certain amount of time
                // in case somehow the pointerup event is not triggered or there is some
                // other bug that causes the interval to not be cleared
                window.clearInterval(this.__intervalId);
              }
            }, time);
          },
          __onPointerUp(_e) {
            window.clearInterval(this.__intervalId);
          },
          __onPointerLeave(_e) {
            window.clearInterval(this.__intervalId);
          },
          destroy() {
            window.clearInterval(this.__intervalId);
          },
        };
      },
      '@pointerdown': '__onPointerDown',
      '@pointerup.window': '__onPointerUp',
      '@pointerleave': '__onPointerLeave',
    });
  }).before('bind');
}

/**
 * Monitors a container element to check if any of the start/end/top/right/bottom/left boundary elements are overflowing using IntersectionObserver
 *
 * @example
 *
 * <div class="w-10 overflow-x-auto" x-overflow x-overflow:viewport>
 *   <div>Left: <span x-text="$overflow.left"></span></div>
 *   <div class="w-[1000px]">
 *     <div x-overflow:start class="absolute inset-0 start-auto h-full w-[1px]">
 *     Child
 *     <div x-overflow:end class="absolute inset-0 end-auto h-full w-[1px]">
 *   </div>
 *   <div>Right: <span x-text="$overflow.right"></span></div>
 * </div>
 */
function overflow(Alpine) {
  Alpine.directive('overflow', ($el, {value}, {Alpine, evaluate}) => {
    let threshold = 0.1;
    if (!isHtmlElement($el)) {
      throw new Error(`Expected HTMLElement but got ${$el}`);
    }
    // TODO when x-overflow:foo elements are destroyed, unset their value so we can use this with e.g. multi carousels per x-overflow
    if (value == 'viewport') {
      Alpine.bind($el, {
        'x-init': '__overflow_viewportEl = $el',
      });
    } else if (value == null) {
      Alpine.bind($el, {
        ['x-data']() {
          return {
            __overflow_intersectionObserver: null,
            __overflow_intersectionEntries: [],
            __overflow_viewportEl: null,
            __overflow_boundaryEls: new WeakMap(),
            __overflow_targetEl: null,
            __overflow_overflows: {},
            init() {
              this.$nextTick(() => {
                if (!this.__overflow_viewportEl) {
                  this.__overflow_viewportEl = $el;
                }
                this.__overflow_intersectionObserver = new IntersectionObserver(
                  this.__overflow_onIntersect.bind(this),
                  {
                    root: this.__overflow_viewportEl,
                    rootMargin: '0px',
                    threshold: [0, threshold, 1.0 - threshold, 1.0],
                  },
                );
              });
            },
            __overflow_registerBoundary(name, el) {
              if (this.__overflow_boundaryEls.has(el)) return;
              this.__overflow_boundaryEls.set(el, name);
              this.__overflow_overflows[name] = false;
              this.$nextTick(() => {
                this.__overflow_intersectionObserver.observe(el);
              });
            },
            __overflow_unregisterBoundary(el) {
              var _a, _b;
              if (!this.__overflow_boundaryEls.has(el)) return;
              const name = this.__overflow_boundaryEls.get(el);
              this.__overflow_boundaryEls.delete(el);
              (_a = this.__overflow_overflows) === null || _a === void 0 ? true : delete _a[name];
              (_b = this.__overflow_intersectionObserver) === null || _b === void 0 ? void 0 : _b.unobserve(el);
            },
            __overflow_onIntersect(entries) {
              this.__overflow_intersectionEntries = entries;
              // When the intersection observer fires, check if any of the boundary elements are intersecting
              // and if so, mark them as overflowing
              for (const entry of entries) {
                if (this.__overflow_boundaryEls.has(entry.target)) {
                  const name = this.__overflow_boundaryEls.get(entry.target);
                  let isOverflowing = false;
                  if (entry.intersectionRatio < 1.0 - threshold) {
                    isOverflowing = true;
                  } else {
                    isOverflowing = false;
                  }
                  // Need to create a new object for reactive effects to fire
                  this.__overflow_overflows = Object.assign(Object.assign({}, this.__overflow_overflows), {
                    [name]: isOverflowing,
                  });
                }
              }
              evaluate(() => {}, {scope: {$entries: entries}, params: [entries]});
            },
            destroy() {
              var _a;
              (_a = this.__overflow_intersectionObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
            },
          };
        },
      });
    } else {
      let $data = Alpine.$data($el);
      if ($data.__overflow_registerBoundary === undefined) {
        throw new Error(`Cannot use $overflow directive without x-overflow directive`);
      }
      // Handle x-overflow:foo directives so users can register named boundaries for overflow detection
      Alpine.bind($el, {
        'x-data'() {
          return {
            init() {
              this.$nextTick(() => {
                this.__overflow_registerBoundary(value, $el);
              });
            },
            destroy() {
              this.__overflow_unregisterBoundary($el);
            },
          };
        },
      });
    }
  }).before('bind');
  Alpine.magic('overflow', (el) => {
    let $data = Alpine.$data(el);
    return mergeProperties(
      {
        registerBoundary(name, el) {
          if ($data.__overflow_registerBoundary === undefined) {
            throw new Error(`Cannot use $overflow directive without x-overflow directive`);
          }
          $data.__overflow_registerBoundary(name, el);
        },
      },
      $data.__overflow_overflows || {},
    );
  });
}

/**
 * Manages the state and transformation of pan session data.
 */
class PanSession {
  /**
   * Creates an instance of PanSession.
   * @param {Object} options - Configuration options for the pan session.
   * @param {number} [options.panX=0] - Initial horizontal pan position.
   * @param {number} [options.panY=0] - Initial vertical pan position.
   */
  constructor(options) {
    this._startPanX = 0;
    this._startPanY = 0;
    this._lastPanX = 0;
    this._lastPanY = 0;
    this._panVelocityX = 0; // px/s
    this._panVelocityY = 0; // px/s
    this._updatedAt = 0;
    this._startPanX = (options === null || options === void 0 ? void 0 : options.startPanX) || 0;
    this._startPanY = (options === null || options === void 0 ? void 0 : options.startPanY) || 0;
    this._lastPanX =
      (options === null || options === void 0 ? void 0 : options.lastPanX) ||
      (options === null || options === void 0 ? void 0 : options.startPanX) ||
      0;
    this._lastPanY =
      (options === null || options === void 0 ? void 0 : options.lastPanY) ||
      (options === null || options === void 0 ? void 0 : options.lastPanY) ||
      0;
    this._updatedAt = (options === null || options === void 0 ? void 0 : options.updatedAt) || Date.now();
  }
  /**
   * Updates the pan session with new coordinates and calculates velocity.
   * @param {number} x - The new horizontal pan position.
   * @param {number} y - The new vertical pan position.
   * @param {number} [currentTime=Date.now()] - The current timestamp.
   */
  update(x, y, currentTime = Date.now()) {
    const lastUpdatedAt = this._updatedAt;
    const panDeltaX = x - this._lastPanX;
    const panDeltaY = y - this._lastPanY;
    const deltaTInS = (currentTime - lastUpdatedAt) / 1000;
    const newPanSession = new PanSession({
      startPanX: this._startPanX,
      startPanY: this._startPanY,
      lastPanX: x,
      lastPanY: y,
      updatedAt: currentTime,
    });
    if (deltaTInS > 0.0) {
      newPanSession._panVelocityX = Math.round(panDeltaX / deltaTInS);
      newPanSession._panVelocityY = Math.round(panDeltaY / deltaTInS);
    }
    return newPanSession;
  }
  /**
   * Serializes the current state of the pan session to a JSON object.
   * @returns {PanSessionJSON} The JSON representation of the pan session.
   */
  toJSON() {
    return {
      lastPanX: this.lastPanX,
      lastPanY: this.lastPanY,
      panVelocityX: this.panVelocityX,
      panVelocityY: this.panVelocityY,
    };
  }
  /** The last recorded horizontal pan position. */
  get lastPanX() {
    return this._lastPanX;
  }
  /** The last recorded vertical pan position. */
  get lastPanY() {
    return this._lastPanY;
  }
  get startPanX() {
    return this._startPanX;
  }
  get startPanY() {
    return this._startPanY;
  }
  /** The current horizontal pan velocity (px/s). */
  get panVelocityX() {
    return this._panVelocityX;
  }
  /** The current vertical pan velocity (px/s). */
  get panVelocityY() {
    return this._panVelocityY;
  }
  /** The total horizontal distance moved from the start pan position. */
  get panDeltaX() {
    return this._lastPanX - this._startPanX;
  }
  /** The total vertical distance moved from the start pan position. */
  get panDeltaY() {
    return this._lastPanY - this._startPanY;
  }
}

/**
 * Detect a "pan" gesture on an element, e.g. a user clicks / touches, moves their pointer/finger, then stops clicking / lifts finger up
 *
 * When a pan is detected a "panstart" event will be dispatched, followed by a "panmove" event for each move, and then a "panend" event when the pan is complete
 *
 * @example
 *
 * const pannableEl = document.querySelector('...')
 * new PanGestureRecognizer(pannableEl)
 *
 * pannableEl.addEventListener('panstart', () => {})
 * pannableEl.addEventListener('panmove', () => {})
 * pannableEl.addEventListener('panend', () => {})
 */
const PAN_THRESHOLD = 5; // pixels - minimum movement to start panning
class PanGestureRecognizer {
  constructor(targetElement) {
    this.isPanning = false;
    this.__panSession = null;
    this.__initialPointerX = 0;
    this.__initialPointerY = 0;
    this._onPointerDown = (e) => {
      if (!isLeftMouseButton(e)) return;
      if (isTouchEvent(e)) return;
      // Store initial position to calculate movement distance
      this.__initialPointerX = e.pageX;
      this.__initialPointerY = e.pageY;
      this.target.addEventListener('pointermove', this._onPointerMove);
      this.target.addEventListener('pointerup', this._onPointerUp);
      this.target.addEventListener('pointercancel', this._onPointerCancel);
      this.target.addEventListener('pointerleave', this._onPointerLeave);
      this.target.addEventListener('click', this._onClick);
    };
    this._onPointerMove = (e) => {
      // Calculate distance moved from initial pointer down position
      const deltaX = Math.abs(e.pageX - this.__initialPointerX);
      const deltaY = Math.abs(e.pageY - this.__initialPointerY);
      const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
      if (!this.isPanning) {
        // Only start panning if movement exceeds threshold
        if (distance < PAN_THRESHOLD) {
          return;
        }
        // Now we know it's a pan gesture - prevent default dragging behavior
        e.preventDefault();
        this.isPanning = true;
        this.__panSession = new PanSession({
          startPanX: this.__initialPointerX,
          startPanY: this.__initialPointerY,
        });
        this._dispatchPanStart(e);
        // Capture pointer events so we can continue panning even if the mouse is moved outside of the target element
        this.target.setPointerCapture(e.pointerId);
      } else {
        // Prevent default dragging behavior during pan
        e.preventDefault();
        this.__panSession = this.__panSession.update(e.pageX, e.pageY);
      }
      this._update(e);
    };
    this._onPointerUp = (e) => {
      this.target.removeEventListener('pointerup', this._onPointerUp);
      this.target.removeEventListener('pointermove', this._onPointerMove);
      this.target.removeEventListener('pointercancel', this._onPointerCancel);
      this.target.removeEventListener('pointerleave', this._onPointerLeave);
      if (this.isPanning) {
        e.stopPropagation();
        this.target.releasePointerCapture(e.pointerId);
        this._dispatchPanEnd(e);
        this._update.cancel();
      }
      // Wait for the event to be processed before resetting the pan state so that we can still cancel the click event
      setTimeout(() => {
        this.isPanning = false;
      });
    };
    this._onPointerCancel = (e) => {
      this._onPointerUp(e);
    };
    this._onPointerLeave = (e) => {
      this._onPointerUp(e);
    };
    this._onClick = (e) => {
      if (this.isPanning) {
        e.preventDefault();
        e.stopPropagation();
      }
    };
    this._update = frameThrottle((e) => {
      this._dispatchPanMove(e);
    });
    this.target = targetElement;
    this.target.addEventListener('pointerdown', this._onPointerDown);
  }
  destroy() {
    this.target.removeEventListener('pointerdown', this._onPointerDown);
    this.target.removeEventListener('pointermove', this._onPointerMove);
    this.target.removeEventListener('pointerup', this._onPointerUp);
    this.target.removeEventListener('pointercancel', this._onPointerCancel);
    this.target.removeEventListener('pointerleave', this._onPointerLeave);
    this.target.removeEventListener('click', this._onClick);
    this._update.cancel();
  }
  _dispatchPanStart(e) {
    this.target.dispatchEvent(
      new CustomEvent('panstart', {detail: {originalEvent: e, panSession: this.__panSession}, bubbles: true}),
    );
  }
  _dispatchPanMove(e) {
    this.target.dispatchEvent(
      new CustomEvent('panmove', {detail: {originalEvent: e, panSession: this.__panSession}, bubbles: true}),
    );
  }
  _dispatchPanEnd(e) {
    this.target.dispatchEvent(
      new CustomEvent('panend', {detail: {originalEvent: e, panSession: this.__panSession}, bubbles: true}),
    );
  }
}
function frameThrottle(fn) {
  let frameId = null;
  const callback = (...args) => {
    if (frameId) return;
    frameId = requestAnimationFrame(() => {
      fn(...args);
      frameId = null;
    });
  };
  callback.cancel = () => {
    if (frameId) {
      cancelAnimationFrame(frameId);
      frameId = null;
    }
  };
  return callback;
}

function scrollList(Alpine) {
  Alpine.directive('scroll-list', ($el, data, utilities) => {
    if (!isHtmlElement($el)) {
      throw new Error(`Expected HTMLElement but got ${$el}`);
    }
    if (data.value === 'viewport') {
      handleViewport$2($el, Alpine);
    } else if (data.value === 'scroller') {
      handleScroller($el, Alpine);
    } else if (data.value === 'item') {
      handleItem$1($el, Alpine);
    } else if (data.value === 'next') {
      handleNextButton$2($el, Alpine);
    } else if (data.value === 'prev') {
      handlePrevButton$2($el, Alpine);
    } else if (data.value === null) {
      handleRoot$l($el, Alpine, data);
    } else {
      throw new Error(`Unknown directive: x-scroll-list:${data.value}`);
    }
  }).before('bind');
  Alpine.magic('scrollList', handleScrollListMagic(Alpine));
}
function handleViewport$2($el, Alpine) {
  Alpine.bind($el, {
    ':id': "$id('scrollList')",
    'x-overflow:viewport': '',
    ['x-data']() {
      return {
        init() {
          this.$data.__viewportElement = this.$el;
        },
      };
    },
  });
}
function handleScroller($el, Alpine) {
  Alpine.bind($el, {
    ['x-data']() {
      return {
        init() {
          this.$data.__scrollContainerElement = this.$el;
        },
      };
    },
  });
}
function handleItem$1($el, Alpine) {
  Alpine.bind($el, {
    'x-data'() {
      return {
        init() {
          this.$data.__items.add(this.$el);
          this.$nextTick(() => {
            var _a, _b;
            (_a = this.$data.__visibleItemsIntersectionObserver) === null || _a === void 0
              ? void 0
              : _a.observe(this.$el);
            (_b = this.$data.__centeredItemIntersectionObserver) === null || _b === void 0
              ? void 0
              : _b.observe(this.$el);
          });
        },
        destroy() {
          var _a, _b;
          (_a = this.$data.__visibleItemsIntersectionObserver) === null || _a === void 0
            ? void 0
            : _a.unobserve(this.$el);
          (_b = this.$data.__centeredItemIntersectionObserver) === null || _b === void 0
            ? void 0
            : _b.unobserve(this.$el);
          this.$data.__items.delete(this.$el);
        },
      };
    },
  });
}
function handleNextButton$2($el, Alpine) {
  Alpine.bind($el, {
    '@click': '$scrollList.next()',
  });
}
function handlePrevButton$2($el, Alpine) {
  Alpine.bind($el, {
    '@click': '$scrollList.prev()',
  });
}
function handleRoot$l($el, Alpine, {modifiers}, _utilities) {
  let isVertical = modifiers.includes('vertical');
  Alpine.bind($el, {
    ['x-data']() {
      const data = {
        __viewportElement: null,
        __scrollContainerElement: null,
        __isScrolling: false,
        __centeredIndex: 0,
        __items: new Set(),
        __visibleIndices: null,
        __visibleItemsIntersectionObserver: null,
        __centeredItemIntersectionObserver: null,
        __firstBoundaryElement: null,
        __lastBoundaryElement: null,
        __itemsMutationObserver: null,
        __abortController: new AbortController(),
        init() {
          this.$nextTick(() => {
            // Watch for items becoming fully intersecting the viewport or not
            this.__visibleItemsIntersectionObserver = new IntersectionObserver(this.__onIntersect.bind(this), {
              root: this.__viewportElement,
              threshold: 0.99,
            });
            // Watch for the item that is currently centered in the viewport. Useful in "single item" type carousels
            this.__centeredItemIntersectionObserver = new IntersectionObserver(this.__onIntersectCenter.bind(this), {
              root: this.__viewportElement,
              // places the detection area in the center from top to bottom (or left to right when vertical) of the container so that it can detect images with all kind of heights(or widths when vertical)
              rootMargin: isVertical ? '-50% 0% -50% 99%' : '0% -50% 99% -50%',
              threshold: 0.0,
            });
            this.__setupScrollListener();
            this.__setupItemsMutationObserver();
            this.__updateOverflowBoundaries();
          });
        },
        destroy() {
          var _a, _b, _c;
          (_a = this.__visibleItemsIntersectionObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
          (_b = this.__centeredItemIntersectionObserver) === null || _b === void 0 ? void 0 : _b.disconnect();
          (_c = this.__itemsMutationObserver) === null || _c === void 0 ? void 0 : _c.disconnect();
          this.__abortController.abort();
          // Unregister overflow boundaries
          const overflowData = this.$data;
          if (overflowData.__overflow_unregisterBoundary) {
            if (this.__firstBoundaryElement) {
              overflowData.__overflow_unregisterBoundary(this.__firstBoundaryElement);
            }
            if (this.__lastBoundaryElement) {
              overflowData.__overflow_unregisterBoundary(this.__lastBoundaryElement);
            }
          }
        },
        __indexOf(item) {
          return Array.from(this.__items).indexOf(item);
        },
        __scrollToItem(index, options = {behavior: 'smooth'}) {
          var _a, _b;
          const item = Array.from(this.__items)[index];
          if (item) {
            if (isVertical) {
              (_a = this.__scrollContainerElement) === null || _a === void 0
                ? void 0
                : _a.scrollTo({
                    left: 0,
                    top: getTargetScrollTop(
                      item,
                      this.__scrollContainerElement,
                      (options === null || options === void 0 ? void 0 : options.align) || 'start',
                    ),
                    behavior: (options === null || options === void 0 ? void 0 : options.behavior) || 'smooth',
                  });
            } else {
              (_b = this.__scrollContainerElement) === null || _b === void 0
                ? void 0
                : _b.scrollTo({
                    left: getTargetScrollLeft(
                      item,
                      this.__scrollContainerElement,
                      (options === null || options === void 0 ? void 0 : options.align) || 'start',
                    ),
                    top: 0,
                    behavior: (options === null || options === void 0 ? void 0 : options.behavior) || 'smooth',
                  });
            }
          }
        },
        __scrollToNextItem() {
          var _a;
          const sortedVisibleIndices = Array.from(
            (_a = this.__visibleIndices) !== null && _a !== void 0 ? _a : new Set(),
          ).sort();
          const lastVisibleIndex = sortedVisibleIndices[sortedVisibleIndices.length - 1];
          if (lastVisibleIndex === undefined) {
            return;
          }
          const firstNonVisibleIndex = Math.min(lastVisibleIndex + 1, this.__totalItems - 1);
          if (firstNonVisibleIndex === lastVisibleIndex) {
            return;
          }
          this.__scrollToItem(firstNonVisibleIndex, {align: 'start'});
        },
        __scrollToPrevItem() {
          var _a;
          const sortedVisibleIndices = Array.from(
            (_a = this.__visibleIndices) !== null && _a !== void 0 ? _a : new Set(),
          ).sort();
          const firstVisibleIndex = sortedVisibleIndices[0];
          if (firstVisibleIndex === undefined) {
            return;
          }
          const lastNonVisibleIndex = Math.max(firstVisibleIndex - 1, 0);
          if (lastNonVisibleIndex === firstVisibleIndex) {
            return;
          }
          this.__scrollToItem(lastNonVisibleIndex, {align: 'end'});
        },
        __onIntersect(entries) {
          if (this.__visibleIndices === null) this.__visibleIndices = new Set();
          entries.forEach((entry) => {
            var _a, _b;
            const itemIndex = this.$data.__indexOf(entry.target);
            if (entry.isIntersecting) {
              (_a = this.__visibleIndices) === null || _a === void 0 ? void 0 : _a.add(itemIndex);
            } else {
              (_b = this.__visibleIndices) === null || _b === void 0 ? void 0 : _b.delete(itemIndex);
            }
          });
        },
        __onIntersectCenter(entries) {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const intersectingIndex = this.$data.__indexOf(entry.target);
              this.__centeredIndex = intersectingIndex;
            }
          });
        },
        __setupScrollListener() {
          var _a;
          (_a = this.__scrollContainerElement) === null || _a === void 0
            ? void 0
            : _a.addEventListener(
                'scroll',
                () => {
                  if (!this.__isScrolling) {
                    this.__isScrolling = true;
                    this.__setupScrollEndListener();
                  }
                },
                {once: true, passive: true, signal: this.__abortController.signal},
              );
        },
        __setupScrollEndListener() {
          var _a;
          (_a = this.__scrollContainerElement) === null || _a === void 0
            ? void 0
            : _a.addEventListener(
                'scrollend',
                () => {
                  this.__isScrolling = false;
                  this.__setupScrollListener();
                },
                {once: true, signal: this.__abortController.signal},
              );
        },
        __setupItemsMutationObserver() {
          if (!this.__scrollContainerElement) return;
          this.__itemsMutationObserver = new MutationObserver(() => {
            this.__updateOverflowBoundaries();
          });
          this.__itemsMutationObserver.observe(this.__scrollContainerElement, {
            childList: true,
            subtree: true,
          });
        },
        __updateOverflowBoundaries() {
          if (!this.$overflow) return;
          const overflowData = this.$data;
          if (!overflowData.__overflow_registerBoundary || !overflowData.__overflow_unregisterBoundary) return;
          const itemsArray = Array.from(this.__items);
          const firstItem = itemsArray[0] || null;
          const lastItem = itemsArray[itemsArray.length - 1] || null;
          if (firstItem == lastItem) return;
          // Unregister old boundaries if they changed
          if (this.__firstBoundaryElement && this.__firstBoundaryElement !== firstItem) {
            overflowData.__overflow_unregisterBoundary(this.__firstBoundaryElement);
            this.__firstBoundaryElement = null;
          }
          if (this.__lastBoundaryElement && this.__lastBoundaryElement !== lastItem) {
            overflowData.__overflow_unregisterBoundary(this.__lastBoundaryElement);
            this.__lastBoundaryElement = null;
          }
          // Register new boundaries
          if (firstItem && this.__firstBoundaryElement !== firstItem) {
            overflowData.__overflow_registerBoundary('start', firstItem);
            this.__firstBoundaryElement = firstItem;
          }
          if (lastItem && this.__lastBoundaryElement !== lastItem) {
            overflowData.__overflow_registerBoundary('end', lastItem);
            this.__lastBoundaryElement = lastItem;
          }
        },
        get __totalItems() {
          return Array.from(this.__items).length;
        },
      };
      return data;
    },
    'x-id': "['scrollList']",
    'x-overflow': '',
    'x-scroll-list:viewport': '',
    'x-scroll-list:scroller': '',
  });
}
function handleScrollListMagic(Alpine) {
  return function ($el) {
    let $data = Alpine.$data($el);
    return {
      get isScrolling() {
        return $data.__isScrolling;
      },
      get items() {
        if (!$data.__items) return null;
        return Array.from($data.__items);
      },
      get visibleIndices() {
        if (!$data.__visibleIndices) return null;
        return Array.from($data.__visibleIndices);
      },
      get centeredIndex() {
        return $data.__centeredIndex;
      },
      set centeredIndex(value) {
        $data.__centeredIndex = value;
        $data.__scrollToItem(value);
      },
      scrollTo(index, options) {
        $data.__scrollToItem(index, options);
      },
      next() {
        $data.__scrollToNextItem();
      },
      prev() {
        $data.__scrollToPrevItem();
      },
    };
  };
}
function getTargetScrollTop(item, container, align) {
  switch (align) {
    case 'start':
      return item.offsetTop;
    case 'center':
      return item.offsetTop + item.offsetHeight / 2 - container.offsetHeight / 2;
    case 'end':
      return item.offsetTop + item.offsetHeight - container.offsetHeight;
  }
}
function getTargetScrollLeft(item, container, align) {
  switch (align) {
    case 'start':
      return item.offsetLeft;
    case 'center':
      return item.offsetLeft + item.offsetWidth / 2 - container.offsetWidth / 2;
    case 'end':
      return item.offsetLeft + item.offsetWidth - container.offsetWidth;
  }
}

function addUniqueItem(arr, item) {
  if (arr.indexOf(item) === -1) arr.push(item);
}
function removeItem(arr, item) {
  const index = arr.indexOf(item);
  if (index > -1) arr.splice(index, 1);
}

const clamp = (min, max, v) => {
  if (v > max) return max;
  if (v < min) return min;
  return v;
};

function formatErrorMessage(message, errorCode) {
  return errorCode
    ? `${message}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${errorCode}`
    : message;
}

let warning = () => {};
let invariant = () => {};
if (process.env.NODE_ENV !== 'production') {
  warning = (check, message, errorCode) => {
    if (!check && typeof console !== 'undefined') {
      console.warn(formatErrorMessage(message, errorCode));
    }
  };
  invariant = (check, message, errorCode) => {
    if (!check) {
      throw new Error(formatErrorMessage(message, errorCode));
    }
  };
}

const MotionGlobalConfig = {};

/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */
const isNumericalString = (v) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);

function isObject(value) {
  return typeof value === 'object' && value !== null;
}

/**
 * Check if the value is a zero value string like "0px" or "0%"
 */
const isZeroValueString = (v) => /^0[^.\s]+$/u.test(v);

/*#__NO_SIDE_EFFECTS__*/
function memo(callback) {
  let result;
  return () => {
    if (result === undefined) result = callback();
    return result;
  };
}

/*#__NO_SIDE_EFFECTS__*/
const noop = (any) => any;

/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */
const combineFunctions = (a, b) => (v) => b(a(v));
const pipe = (...transformers) => transformers.reduce(combineFunctions);

/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/
/*#__NO_SIDE_EFFECTS__*/
const progress = (from, to, value) => {
  const toFromDifference = to - from;
  return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

class SubscriptionManager {
  constructor() {
    this.subscriptions = [];
  }
  add(handler) {
    addUniqueItem(this.subscriptions, handler);
    return () => removeItem(this.subscriptions, handler);
  }
  notify(a, b, c) {
    const numSubscriptions = this.subscriptions.length;
    if (!numSubscriptions) return;
    if (numSubscriptions === 1) {
      /**
       * If there's only a single handler we can just call it without invoking a loop.
       */
      this.subscriptions[0](a, b, c);
    } else {
      for (let i = 0; i < numSubscriptions; i++) {
        /**
         * Check whether the handler exists before firing as it's possible
         * the subscriptions were modified during this loop running.
         */
        const handler = this.subscriptions[i];
        handler && handler(a, b, c);
      }
    }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}

/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */
/*#__NO_SIDE_EFFECTS__*/
const secondsToMilliseconds = (seconds) => seconds * 1000;
/*#__NO_SIDE_EFFECTS__*/
const millisecondsToSeconds = (milliseconds) => milliseconds / 1000;

/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/
function velocityPerSecond(velocity, frameDuration) {
  return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

const warned = new Set();
function warnOnce(condition, message, errorCode) {
  if (condition || warned.has(message)) return;
  console.warn(formatErrorMessage(message, errorCode));
  warned.add(message);
}

const wrap = (min, max, v) => {
  const rangeSize = max - min;
  return ((((v - min) % rangeSize) + rangeSize) % rangeSize) + min;
};

/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE

  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticeably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/
// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const calcBezier = (t, a1, a2) => (((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const subdivisionPrecision = 0.0000001;
const subdivisionMaxIterations = 12;
function binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
  let currentX;
  let currentT;
  let i = 0;
  do {
    currentT = lowerBound + (upperBound - lowerBound) / 2.0;
    currentX = calcBezier(currentT, mX1, mX2) - x;
    if (currentX > 0.0) {
      upperBound = currentT;
    } else {
      lowerBound = currentT;
    }
  } while (Math.abs(currentX) > subdivisionPrecision && ++i < subdivisionMaxIterations);
  return currentT;
}
function cubicBezier(mX1, mY1, mX2, mY2) {
  // If this is a linear gradient, return linear easing
  if (mX1 === mY1 && mX2 === mY2) return noop;
  const getTForX = (aX) => binarySubdivide(aX, 0, 1, mX1, mX2);
  // If animation is at start/end, return t without easing
  return (t) => (t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2));
}

// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const mirrorEasing = (easing) => (p) => (p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2);

// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const reverseEasing = (easing) => (p) => 1 - easing(1 - p);

const backOut = /*@__PURE__*/ cubicBezier(0.33, 1.53, 0.69, 0.99);
const backIn = /*@__PURE__*/ reverseEasing(backOut);
const backInOut = /*@__PURE__*/ mirrorEasing(backIn);

const anticipate = (p) => ((p *= 2) < 1 ? 0.5 * backIn(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1))));

const circIn = (p) => 1 - Math.sin(Math.acos(p));
const circOut = reverseEasing(circIn);
const circInOut = mirrorEasing(circIn);

const easeIn = /*@__PURE__*/ cubicBezier(0.42, 0, 1, 1);
const easeOut = /*@__PURE__*/ cubicBezier(0, 0, 0.58, 1);
const easeInOut = /*@__PURE__*/ cubicBezier(0.42, 0, 0.58, 1);

const isEasingArray = (ease) => {
  return Array.isArray(ease) && typeof ease[0] !== 'number';
};

function getEasingForSegment(easing, i) {
  return isEasingArray(easing) ? easing[wrap(0, easing.length, i)] : easing;
}

const isBezierDefinition = (easing) => Array.isArray(easing) && typeof easing[0] === 'number';

const easingLookup = {
  linear: noop,
  easeIn,
  easeInOut,
  easeOut,
  circIn,
  circInOut,
  circOut,
  backIn,
  backInOut,
  backOut,
  anticipate,
};
const isValidEasing = (easing) => {
  return typeof easing === 'string';
};
const easingDefinitionToFunction = (definition) => {
  if (isBezierDefinition(definition)) {
    // If cubic bezier definition, create bezier curve
    invariant(
      definition.length === 4,
      `Cubic bezier arrays must contain four numerical values.`,
      'cubic-bezier-length',
    );
    const [x1, y1, x2, y2] = definition;
    return cubicBezier(x1, y1, x2, y2);
  } else if (isValidEasing(definition)) {
    // Else lookup from table
    invariant(easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`, 'invalid-easing-type');
    return easingLookup[definition];
  }
  return definition;
};

const stepsOrder = [
  'setup', // Compute
  'read', // Read
  'resolveKeyframes', // Write/Read/Write/Read
  'preUpdate', // Compute
  'update', // Compute
  'preRender', // Compute
  'render', // Write
  'postRender', // Compute
];

const statsBuffer = {
  value: null,
  addProjectionMetrics: null,
};

function createRenderStep(runNextFrame, stepName) {
  /**
   * We create and reuse two queues, one to queue jobs for the current frame
   * and one for the next. We reuse to avoid triggering GC after x frames.
   */
  let thisFrame = new Set();
  let nextFrame = new Set();
  /**
   * Track whether we're currently processing jobs in this step. This way
   * we can decide whether to schedule new jobs for this frame or next.
   */
  let isProcessing = false;
  let flushNextFrame = false;
  /**
   * A set of processes which were marked keepAlive when scheduled.
   */
  const toKeepAlive = new WeakSet();
  let latestFrameData = {
    delta: 0.0,
    timestamp: 0.0,
    isProcessing: false,
  };
  let numCalls = 0;
  function triggerCallback(callback) {
    if (toKeepAlive.has(callback)) {
      step.schedule(callback);
      runNextFrame();
    }
    numCalls++;
    callback(latestFrameData);
  }
  const step = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (callback, keepAlive = false, immediate = false) => {
      const addToCurrentFrame = immediate && isProcessing;
      const queue = addToCurrentFrame ? thisFrame : nextFrame;
      if (keepAlive) toKeepAlive.add(callback);
      if (!queue.has(callback)) queue.add(callback);
      return callback;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (callback) => {
      nextFrame.delete(callback);
      toKeepAlive.delete(callback);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (frameData) => {
      latestFrameData = frameData;
      /**
       * If we're already processing we've probably been triggered by a flushSync
       * inside an existing process. Instead of executing, mark flushNextFrame
       * as true and ensure we flush the following frame at the end of this one.
       */
      if (isProcessing) {
        flushNextFrame = true;
        return;
      }
      isProcessing = true;
      [thisFrame, nextFrame] = [nextFrame, thisFrame];
      // Execute this frame
      thisFrame.forEach(triggerCallback);
      /**
       * If we're recording stats then
       */
      if (stepName && statsBuffer.value) {
        statsBuffer.value.frameloop[stepName].push(numCalls);
      }
      numCalls = 0;
      // Clear the frame so no callbacks remain. This is to avoid
      // memory leaks should this render step not run for a while.
      thisFrame.clear();
      isProcessing = false;
      if (flushNextFrame) {
        flushNextFrame = false;
        step.process(frameData);
      }
    },
  };
  return step;
}

const maxElapsed$1 = 40;
function createRenderBatcher(scheduleNextBatch, allowKeepAlive) {
  let runNextFrame = false;
  let useDefaultElapsed = true;
  const state = {
    delta: 0.0,
    timestamp: 0.0,
    isProcessing: false,
  };
  const flagRunNextFrame = () => (runNextFrame = true);
  const steps = stepsOrder.reduce((acc, key) => {
    acc[key] = createRenderStep(flagRunNextFrame, allowKeepAlive ? key : undefined);
    return acc;
  }, {});
  const {setup, read, resolveKeyframes, preUpdate, update, preRender, render, postRender} = steps;
  const processBatch = () => {
    const timestamp = MotionGlobalConfig.useManualTiming ? state.timestamp : performance.now();
    runNextFrame = false;
    if (!MotionGlobalConfig.useManualTiming) {
      state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, maxElapsed$1), 1);
    }
    state.timestamp = timestamp;
    state.isProcessing = true;
    // Unrolled render loop for better per-frame performance
    setup.process(state);
    read.process(state);
    resolveKeyframes.process(state);
    preUpdate.process(state);
    update.process(state);
    preRender.process(state);
    render.process(state);
    postRender.process(state);
    state.isProcessing = false;
    if (runNextFrame && allowKeepAlive) {
      useDefaultElapsed = false;
      scheduleNextBatch(processBatch);
    }
  };
  const wake = () => {
    runNextFrame = true;
    useDefaultElapsed = true;
    if (!state.isProcessing) {
      scheduleNextBatch(processBatch);
    }
  };
  const schedule = stepsOrder.reduce((acc, key) => {
    const step = steps[key];
    acc[key] = (process, keepAlive = false, immediate = false) => {
      if (!runNextFrame) wake();
      return step.schedule(process, keepAlive, immediate);
    };
    return acc;
  }, {});
  const cancel = (process) => {
    for (let i = 0; i < stepsOrder.length; i++) {
      steps[stepsOrder[i]].cancel(process);
    }
  };
  return {schedule, cancel, state, steps};
}

const {
  schedule: frame,
  cancel: cancelFrame,
  state: frameData,
  steps: frameSteps,
} = /* @__PURE__ */ createRenderBatcher(
  typeof requestAnimationFrame !== 'undefined' ? requestAnimationFrame : noop,
  true,
);

let now;
function clearTime() {
  now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */
const time = {
  now: () => {
    if (now === undefined) {
      time.set(frameData.isProcessing || MotionGlobalConfig.useManualTiming ? frameData.timestamp : performance.now());
    }
    return now;
  },
  set: (newTime) => {
    now = newTime;
    queueMicrotask(clearTime);
  },
};

const checkStringStartsWith = (token) => (key) => typeof key === 'string' && key.startsWith(token);
const isCSSVariableName = /*@__PURE__*/ checkStringStartsWith('--');
const startsAsVariableToken = /*@__PURE__*/ checkStringStartsWith('var(--');
const isCSSVariableToken = (value) => {
  const startsWithToken = startsAsVariableToken(value);
  if (!startsWithToken) return false;
  // Ensure any comments are stripped from the value as this can harm performance of the regex.
  return singleCssVariableRegex.test(value.split('/*')[0].trim());
};
const singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;

const number = {
  test: (v) => typeof v === 'number',
  parse: parseFloat,
  transform: (v) => v,
};
const alpha = {
  ...number,
  transform: (v) => clamp(0, 1, v),
};
const scale = {
  ...number,
  default: 1,
};

// If this number is a decimal, make it just five decimal places
// to avoid exponents
const sanitize = (v) => Math.round(v * 100000) / 100000;

const floatRegex = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;

function isNullish(v) {
  return v == null;
}

const singleColorRegex =
  /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;

/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */
const isColorString = (type, testProp) => (v) => {
  return Boolean(
    (typeof v === 'string' && singleColorRegex.test(v) && v.startsWith(type)) ||
    (testProp && !isNullish(v) && Object.prototype.hasOwnProperty.call(v, testProp)),
  );
};
const splitColor = (aName, bName, cName) => (v) => {
  if (typeof v !== 'string') return v;
  const [a, b, c, alpha] = v.match(floatRegex);
  return {
    [aName]: parseFloat(a),
    [bName]: parseFloat(b),
    [cName]: parseFloat(c),
    alpha: alpha !== undefined ? parseFloat(alpha) : 1,
  };
};

const clampRgbUnit = (v) => clamp(0, 255, v);
const rgbUnit = {
  ...number,
  transform: (v) => Math.round(clampRgbUnit(v)),
};
const rgba = {
  test: /*@__PURE__*/ isColorString('rgb', 'red'),
  parse: /*@__PURE__*/ splitColor('red', 'green', 'blue'),
  transform: ({red, green, blue, alpha: alpha$1 = 1}) =>
    'rgba(' +
    rgbUnit.transform(red) +
    ', ' +
    rgbUnit.transform(green) +
    ', ' +
    rgbUnit.transform(blue) +
    ', ' +
    sanitize(alpha.transform(alpha$1)) +
    ')',
};

function parseHex(v) {
  let r = '';
  let g = '';
  let b = '';
  let a = '';
  // If we have 6 characters, ie #FF0000
  if (v.length > 5) {
    r = v.substring(1, 3);
    g = v.substring(3, 5);
    b = v.substring(5, 7);
    a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
  } else {
    r = v.substring(1, 2);
    g = v.substring(2, 3);
    b = v.substring(3, 4);
    a = v.substring(4, 5);
    r += r;
    g += g;
    b += b;
    a += a;
  }
  return {
    red: parseInt(r, 16),
    green: parseInt(g, 16),
    blue: parseInt(b, 16),
    alpha: a ? parseInt(a, 16) / 255 : 1,
  };
}
const hex = {
  test: /*@__PURE__*/ isColorString('#'),
  parse: parseHex,
  transform: rgba.transform,
};

/*#__NO_SIDE_EFFECTS__*/
const createUnitType = (unit) => ({
  test: (v) => typeof v === 'string' && v.endsWith(unit) && v.split(' ').length === 1,
  parse: parseFloat,
  transform: (v) => `${v}${unit}`,
});
const degrees = /*@__PURE__*/ createUnitType('deg');
const percent = /*@__PURE__*/ createUnitType('%');
const px = /*@__PURE__*/ createUnitType('px');
const vh = /*@__PURE__*/ createUnitType('vh');
const vw = /*@__PURE__*/ createUnitType('vw');
const progressPercentage = /*@__PURE__*/ (() => ({
  ...percent,
  parse: (v) => percent.parse(v) / 100,
  transform: (v) => percent.transform(v * 100),
}))();

const hsla = {
  test: /*@__PURE__*/ isColorString('hsl', 'hue'),
  parse: /*@__PURE__*/ splitColor('hue', 'saturation', 'lightness'),
  transform: ({hue, saturation, lightness, alpha: alpha$1 = 1}) => {
    return (
      'hsla(' +
      Math.round(hue) +
      ', ' +
      percent.transform(sanitize(saturation)) +
      ', ' +
      percent.transform(sanitize(lightness)) +
      ', ' +
      sanitize(alpha.transform(alpha$1)) +
      ')'
    );
  },
};

const color = {
  test: (v) => rgba.test(v) || hex.test(v) || hsla.test(v),
  parse: (v) => {
    if (rgba.test(v)) {
      return rgba.parse(v);
    } else if (hsla.test(v)) {
      return hsla.parse(v);
    } else {
      return hex.parse(v);
    }
  },
  transform: (v) => {
    return typeof v === 'string' ? v : v.hasOwnProperty('red') ? rgba.transform(v) : hsla.transform(v);
  },
  getAnimatableNone: (v) => {
    const parsed = color.parse(v);
    parsed.alpha = 0;
    return color.transform(parsed);
  },
};

const colorRegex =
  /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;

function test(v) {
  return (
    isNaN(v) && typeof v === 'string' && (v.match(floatRegex)?.length || 0) + (v.match(colorRegex)?.length || 0) > 0
  );
}
const NUMBER_TOKEN = 'number';
const COLOR_TOKEN = 'color';
const VAR_TOKEN = 'var';
const VAR_FUNCTION_TOKEN = 'var(';
const SPLIT_TOKEN = '${}';
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const complexRegex =
  /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function analyseComplexValue(value) {
  const originalValue = value.toString();
  const values = [];
  const indexes = {
    color: [],
    number: [],
    var: [],
  };
  const types = [];
  let i = 0;
  const tokenised = originalValue.replace(complexRegex, (parsedValue) => {
    if (color.test(parsedValue)) {
      indexes.color.push(i);
      types.push(COLOR_TOKEN);
      values.push(color.parse(parsedValue));
    } else if (parsedValue.startsWith(VAR_FUNCTION_TOKEN)) {
      indexes.var.push(i);
      types.push(VAR_TOKEN);
      values.push(parsedValue);
    } else {
      indexes.number.push(i);
      types.push(NUMBER_TOKEN);
      values.push(parseFloat(parsedValue));
    }
    ++i;
    return SPLIT_TOKEN;
  });
  const split = tokenised.split(SPLIT_TOKEN);
  return {values, split, indexes, types};
}
function parseComplexValue(v) {
  return analyseComplexValue(v).values;
}
function createTransformer(source) {
  const {split, types} = analyseComplexValue(source);
  const numSections = split.length;
  return (v) => {
    let output = '';
    for (let i = 0; i < numSections; i++) {
      output += split[i];
      if (v[i] !== undefined) {
        const type = types[i];
        if (type === NUMBER_TOKEN) {
          output += sanitize(v[i]);
        } else if (type === COLOR_TOKEN) {
          output += color.transform(v[i]);
        } else {
          output += v[i];
        }
      }
    }
    return output;
  };
}
const convertNumbersToZero = (v) => (typeof v === 'number' ? 0 : color.test(v) ? color.getAnimatableNone(v) : v);
function getAnimatableNone$1(v) {
  const parsed = parseComplexValue(v);
  const transformer = createTransformer(v);
  return transformer(parsed.map(convertNumbersToZero));
}
const complex = {
  test,
  parse: parseComplexValue,
  createTransformer,
  getAnimatableNone: getAnimatableNone$1,
};

// Adapted from https://gist.github.com/mjackson/5311256
function hueToRgb(p, q, t) {
  if (t < 0) t += 1;
  if (t > 1) t -= 1;
  if (t < 1 / 6) return p + (q - p) * 6 * t;
  if (t < 1 / 2) return q;
  if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}
function hslaToRgba({hue, saturation, lightness, alpha}) {
  hue /= 360;
  saturation /= 100;
  lightness /= 100;
  let red = 0;
  let green = 0;
  let blue = 0;
  if (!saturation) {
    red = green = blue = lightness;
  } else {
    const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
    const p = 2 * lightness - q;
    red = hueToRgb(p, q, hue + 1 / 3);
    green = hueToRgb(p, q, hue);
    blue = hueToRgb(p, q, hue - 1 / 3);
  }
  return {
    red: Math.round(red * 255),
    green: Math.round(green * 255),
    blue: Math.round(blue * 255),
    alpha,
  };
}

function mixImmediate(a, b) {
  return (p) => (p > 0 ? b : a);
}

/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/
const mixNumber$1 = (from, to, progress) => {
  return from + (to - from) * progress;
};

// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const mixLinearColor = (from, to, v) => {
  const fromExpo = from * from;
  const expo = v * (to * to - fromExpo) + fromExpo;
  return expo < 0 ? 0 : Math.sqrt(expo);
};
const colorTypes = [hex, rgba, hsla];
const getColorType = (v) => colorTypes.find((type) => type.test(v));
function asRGBA(color) {
  const type = getColorType(color);
  warning(
    Boolean(type),
    `'${color}' is not an animatable color. Use the equivalent color code instead.`,
    'color-not-animatable',
  );
  if (!Boolean(type)) return false;
  let model = type.parse(color);
  if (type === hsla) {
    // TODO Remove this cast - needed since Motion's stricter typing
    model = hslaToRgba(model);
  }
  return model;
}
const mixColor = (from, to) => {
  const fromRGBA = asRGBA(from);
  const toRGBA = asRGBA(to);
  if (!fromRGBA || !toRGBA) {
    return mixImmediate(from, to);
  }
  const blended = {...fromRGBA};
  return (v) => {
    blended.red = mixLinearColor(fromRGBA.red, toRGBA.red, v);
    blended.green = mixLinearColor(fromRGBA.green, toRGBA.green, v);
    blended.blue = mixLinearColor(fromRGBA.blue, toRGBA.blue, v);
    blended.alpha = mixNumber$1(fromRGBA.alpha, toRGBA.alpha, v);
    return rgba.transform(blended);
  };
};

const invisibleValues = new Set(['none', 'hidden']);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */
function mixVisibility(origin, target) {
  if (invisibleValues.has(origin)) {
    return (p) => (p <= 0 ? origin : target);
  } else {
    return (p) => (p >= 1 ? target : origin);
  }
}

function mixNumber(a, b) {
  return (p) => mixNumber$1(a, b, p);
}
function getMixer(a) {
  if (typeof a === 'number') {
    return mixNumber;
  } else if (typeof a === 'string') {
    return isCSSVariableToken(a) ? mixImmediate : color.test(a) ? mixColor : mixComplex;
  } else if (Array.isArray(a)) {
    return mixArray;
  } else if (typeof a === 'object') {
    return color.test(a) ? mixColor : mixObject;
  }
  return mixImmediate;
}
function mixArray(a, b) {
  const output = [...a];
  const numValues = output.length;
  const blendValue = a.map((v, i) => getMixer(v)(v, b[i]));
  return (p) => {
    for (let i = 0; i < numValues; i++) {
      output[i] = blendValue[i](p);
    }
    return output;
  };
}
function mixObject(a, b) {
  const output = {...a, ...b};
  const blendValue = {};
  for (const key in output) {
    if (a[key] !== undefined && b[key] !== undefined) {
      blendValue[key] = getMixer(a[key])(a[key], b[key]);
    }
  }
  return (v) => {
    for (const key in blendValue) {
      output[key] = blendValue[key](v);
    }
    return output;
  };
}
function matchOrder(origin, target) {
  const orderedOrigin = [];
  const pointers = {color: 0, var: 0, number: 0};
  for (let i = 0; i < target.values.length; i++) {
    const type = target.types[i];
    const originIndex = origin.indexes[type][pointers[type]];
    const originValue = origin.values[originIndex] ?? 0;
    orderedOrigin[i] = originValue;
    pointers[type]++;
  }
  return orderedOrigin;
}
const mixComplex = (origin, target) => {
  const template = complex.createTransformer(target);
  const originStats = analyseComplexValue(origin);
  const targetStats = analyseComplexValue(target);
  const canInterpolate =
    originStats.indexes.var.length === targetStats.indexes.var.length &&
    originStats.indexes.color.length === targetStats.indexes.color.length &&
    originStats.indexes.number.length >= targetStats.indexes.number.length;
  if (canInterpolate) {
    if (
      (invisibleValues.has(origin) && !targetStats.values.length) ||
      (invisibleValues.has(target) && !originStats.values.length)
    ) {
      return mixVisibility(origin, target);
    }
    return pipe(mixArray(matchOrder(originStats, targetStats), targetStats.values), template);
  } else {
    warning(
      true,
      `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`,
      'complex-values-different',
    );
    return mixImmediate(origin, target);
  }
};

function mix(from, to, p) {
  if (typeof from === 'number' && typeof to === 'number' && typeof p === 'number') {
    return mixNumber$1(from, to, p);
  }
  const mixer = getMixer(from);
  return mixer(from, to);
}

const frameloopDriver = (update) => {
  const passTimestamp = ({timestamp}) => update(timestamp);
  return {
    start: (keepAlive = true) => frame.update(passTimestamp, keepAlive),
    stop: () => cancelFrame(passTimestamp),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => (frameData.isProcessing ? frameData.timestamp : time.now()),
  };
};

const generateLinearEasing = (
  easing,
  duration, // as milliseconds
  resolution = 10, // as milliseconds
) => {
  let points = '';
  const numPoints = Math.max(Math.round(duration / resolution), 2);
  for (let i = 0; i < numPoints; i++) {
    points += Math.round(easing(i / (numPoints - 1)) * 10000) / 10000 + ', ';
  }
  return `linear(${points.substring(0, points.length - 2)})`;
};

/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */
const maxGeneratorDuration = 20000;
function calcGeneratorDuration(generator) {
  let duration = 0;
  const timeStep = 50;
  let state = generator.next(duration);
  while (!state.done && duration < maxGeneratorDuration) {
    duration += timeStep;
    state = generator.next(duration);
  }
  return duration >= maxGeneratorDuration ? Infinity : duration;
}

/**
 * Create a progress => progress easing function from a generator.
 */
function createGeneratorEasing(options, scale = 100, createGenerator) {
  const generator = createGenerator({...options, keyframes: [0, scale]});
  const duration = Math.min(calcGeneratorDuration(generator), maxGeneratorDuration);
  return {
    type: 'keyframes',
    ease: (progress) => {
      return generator.next(duration * progress).value / scale;
    },
    duration: millisecondsToSeconds(duration),
  };
}

const velocitySampleDuration = 5; // ms
function calcGeneratorVelocity(resolveValue, t, current) {
  const prevT = Math.max(t - velocitySampleDuration, 0);
  return velocityPerSecond(current - resolveValue(prevT), t - prevT);
}

const springDefaults = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1.0,
  velocity: 0.0,
  // Default duration/bounce-based options
  duration: 800, // in ms
  bounce: 0.3,
  visualDuration: 0.3, // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2,
  },
  restDelta: {
    granular: 0.005,
    default: 0.5,
  },
  // Limits
  minDuration: 0.01, // in seconds
  maxDuration: 10.0, // in seconds
  minDamping: 0.05,
  maxDamping: 1,
};

const safeMin = 0.001;
function findSpring({
  duration = springDefaults.duration,
  bounce = springDefaults.bounce,
  velocity = springDefaults.velocity,
  mass = springDefaults.mass,
}) {
  let envelope;
  let derivative;
  warning(
    duration <= secondsToMilliseconds(springDefaults.maxDuration),
    'Spring duration must be 10 seconds or less',
    'spring-duration-limit',
  );
  let dampingRatio = 1 - bounce;
  /**
   * Restrict dampingRatio and duration to within acceptable ranges.
   */
  dampingRatio = clamp(springDefaults.minDamping, springDefaults.maxDamping, dampingRatio);
  duration = clamp(springDefaults.minDuration, springDefaults.maxDuration, millisecondsToSeconds(duration));
  if (dampingRatio < 1) {
    /**
     * Underdamped spring
     */
    envelope = (undampedFreq) => {
      const exponentialDecay = undampedFreq * dampingRatio;
      const delta = exponentialDecay * duration;
      const a = exponentialDecay - velocity;
      const b = calcAngularFreq(undampedFreq, dampingRatio);
      const c = Math.exp(-delta);
      return safeMin - (a / b) * c;
    };
    derivative = (undampedFreq) => {
      const exponentialDecay = undampedFreq * dampingRatio;
      const delta = exponentialDecay * duration;
      const d = delta * velocity + velocity;
      const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
      const f = Math.exp(-delta);
      const g = calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
      const factor = -envelope(undampedFreq) + safeMin > 0 ? -1 : 1;
      return (factor * ((d - e) * f)) / g;
    };
  } else {
    /**
     * Critically-damped spring
     */
    envelope = (undampedFreq) => {
      const a = Math.exp(-undampedFreq * duration);
      const b = (undampedFreq - velocity) * duration + 1;
      return -safeMin + a * b;
    };
    derivative = (undampedFreq) => {
      const a = Math.exp(-undampedFreq * duration);
      const b = (velocity - undampedFreq) * (duration * duration);
      return a * b;
    };
  }
  const initialGuess = 5 / duration;
  const undampedFreq = approximateRoot(envelope, derivative, initialGuess);
  duration = secondsToMilliseconds(duration);
  if (isNaN(undampedFreq)) {
    return {
      stiffness: springDefaults.stiffness,
      damping: springDefaults.damping,
      duration,
    };
  } else {
    const stiffness = Math.pow(undampedFreq, 2) * mass;
    return {
      stiffness,
      damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
      duration,
    };
  }
}
const rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
  let result = initialGuess;
  for (let i = 1; i < rootIterations; i++) {
    result = result - envelope(result) / derivative(result);
  }
  return result;
}
function calcAngularFreq(undampedFreq, dampingRatio) {
  return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

const durationKeys = ['duration', 'bounce'];
const physicsKeys = ['stiffness', 'damping', 'mass'];
function isSpringType(options, keys) {
  return keys.some((key) => options[key] !== undefined);
}
function getSpringOptions(options) {
  let springOptions = {
    velocity: springDefaults.velocity,
    stiffness: springDefaults.stiffness,
    damping: springDefaults.damping,
    mass: springDefaults.mass,
    isResolvedFromDuration: false,
    ...options,
  };
  // stiffness/damping/mass overrides duration/bounce
  if (!isSpringType(options, physicsKeys) && isSpringType(options, durationKeys)) {
    if (options.visualDuration) {
      const visualDuration = options.visualDuration;
      const root = (2 * Math.PI) / (visualDuration * 1.2);
      const stiffness = root * root;
      const damping = 2 * clamp(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
      springOptions = {
        ...springOptions,
        mass: springDefaults.mass,
        stiffness,
        damping,
      };
    } else {
      const derived = findSpring(options);
      springOptions = {
        ...springOptions,
        ...derived,
        mass: springDefaults.mass,
      };
      springOptions.isResolvedFromDuration = true;
    }
  }
  return springOptions;
}
function spring(optionsOrVisualDuration = springDefaults.visualDuration, bounce = springDefaults.bounce) {
  const options =
    typeof optionsOrVisualDuration !== 'object'
      ? {
          visualDuration: optionsOrVisualDuration,
          keyframes: [0, 1],
          bounce,
        }
      : optionsOrVisualDuration;
  let {restSpeed, restDelta} = options;
  const origin = options.keyframes[0];
  const target = options.keyframes[options.keyframes.length - 1];
  /**
   * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
   * to reduce GC during animation.
   */
  const state = {done: false, value: origin};
  const {stiffness, damping, mass, duration, velocity, isResolvedFromDuration} = getSpringOptions({
    ...options,
    velocity: -millisecondsToSeconds(options.velocity || 0),
  });
  const initialVelocity = velocity || 0.0;
  const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
  const initialDelta = target - origin;
  const undampedAngularFreq = millisecondsToSeconds(Math.sqrt(stiffness / mass));
  /**
   * If we're working on a granular scale, use smaller defaults for determining
   * when the spring is finished.
   *
   * These defaults have been selected emprically based on what strikes a good
   * ratio between feeling good and finishing as soon as changes are imperceptible.
   */
  const isGranularScale = Math.abs(initialDelta) < 5;
  restSpeed || (restSpeed = isGranularScale ? springDefaults.restSpeed.granular : springDefaults.restSpeed.default);
  restDelta || (restDelta = isGranularScale ? springDefaults.restDelta.granular : springDefaults.restDelta.default);
  let resolveSpring;
  if (dampingRatio < 1) {
    const angularFreq = calcAngularFreq(undampedAngularFreq, dampingRatio);
    // Underdamped spring
    resolveSpring = (t) => {
      const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
      return (
        target -
        envelope *
          (((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq) *
            Math.sin(angularFreq * t) +
            initialDelta * Math.cos(angularFreq * t))
      );
    };
  } else if (dampingRatio === 1) {
    // Critically damped spring
    resolveSpring = (t) =>
      target -
      Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
  } else {
    // Overdamped spring
    const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
    resolveSpring = (t) => {
      const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
      // When performing sinh or cosh values can hit Infinity so we cap them here
      const freqForT = Math.min(dampedAngularFreq * t, 300);
      return (
        target -
        (envelope *
          ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) +
            dampedAngularFreq * initialDelta * Math.cosh(freqForT))) /
          dampedAngularFreq
      );
    };
  }
  const generator = {
    calculatedDuration: isResolvedFromDuration ? duration || null : null,
    next: (t) => {
      const current = resolveSpring(t);
      if (!isResolvedFromDuration) {
        let currentVelocity = t === 0 ? initialVelocity : 0.0;
        /**
         * We only need to calculate velocity for under-damped springs
         * as over- and critically-damped springs can't overshoot, so
         * checking only for displacement is enough.
         */
        if (dampingRatio < 1) {
          currentVelocity =
            t === 0 ? secondsToMilliseconds(initialVelocity) : calcGeneratorVelocity(resolveSpring, t, current);
        }
        const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
        const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
        state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
      } else {
        state.done = t >= duration;
      }
      state.value = state.done ? target : current;
      return state;
    },
    toString: () => {
      const calculatedDuration = Math.min(calcGeneratorDuration(generator), maxGeneratorDuration);
      const easing = generateLinearEasing(
        (progress) => generator.next(calculatedDuration * progress).value,
        calculatedDuration,
        30,
      );
      return calculatedDuration + 'ms ' + easing;
    },
    toTransition: () => {},
  };
  return generator;
}
spring.applyToOptions = (options) => {
  const generatorOptions = createGeneratorEasing(options, 100, spring);
  options.ease = generatorOptions.ease;
  options.duration = secondsToMilliseconds(generatorOptions.duration);
  options.type = 'keyframes';
  return options;
};

function inertia({
  keyframes,
  velocity = 0.0,
  power = 0.8,
  timeConstant = 325,
  bounceDamping = 10,
  bounceStiffness = 500,
  modifyTarget,
  min,
  max,
  restDelta = 0.5,
  restSpeed,
}) {
  const origin = keyframes[0];
  const state = {
    done: false,
    value: origin,
  };
  const isOutOfBounds = (v) => (min !== undefined && v < min) || (max !== undefined && v > max);
  const nearestBoundary = (v) => {
    if (min === undefined) return max;
    if (max === undefined) return min;
    return Math.abs(min - v) < Math.abs(max - v) ? min : max;
  };
  let amplitude = power * velocity;
  const ideal = origin + amplitude;
  const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
  /**
   * If the target has changed we need to re-calculate the amplitude, otherwise
   * the animation will start from the wrong position.
   */
  if (target !== ideal) amplitude = target - origin;
  const calcDelta = (t) => -amplitude * Math.exp(-t / timeConstant);
  const calcLatest = (t) => target + calcDelta(t);
  const applyFriction = (t) => {
    const delta = calcDelta(t);
    const latest = calcLatest(t);
    state.done = Math.abs(delta) <= restDelta;
    state.value = state.done ? target : latest;
  };
  /**
   * Ideally this would resolve for t in a stateless way, we could
   * do that by always precalculating the animation but as we know
   * this will be done anyway we can assume that spring will
   * be discovered during that.
   */
  let timeReachedBoundary;
  let spring$1;
  const checkCatchBoundary = (t) => {
    if (!isOutOfBounds(state.value)) return;
    timeReachedBoundary = t;
    spring$1 = spring({
      keyframes: [state.value, nearestBoundary(state.value)],
      velocity: calcGeneratorVelocity(calcLatest, t, state.value), // TODO: This should be passing * 1000
      damping: bounceDamping,
      stiffness: bounceStiffness,
      restDelta,
      restSpeed,
    });
  };
  checkCatchBoundary(0);
  return {
    calculatedDuration: null,
    next: (t) => {
      /**
       * We need to resolve the friction to figure out if we need a
       * spring but we don't want to do this twice per frame. So here
       * we flag if we updated for this frame and later if we did
       * we can skip doing it again.
       */
      let hasUpdatedFrame = false;
      if (!spring$1 && timeReachedBoundary === undefined) {
        hasUpdatedFrame = true;
        applyFriction(t);
        checkCatchBoundary(t);
      }
      /**
       * If we have a spring and the provided t is beyond the moment the friction
       * animation crossed the min/max boundary, use the spring.
       */
      if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) {
        return spring$1.next(t - timeReachedBoundary);
      } else {
        !hasUpdatedFrame && applyFriction(t);
        return state;
      }
    },
  };
}

function createMixers(output, ease, customMixer) {
  const mixers = [];
  const mixerFactory = customMixer || MotionGlobalConfig.mix || mix;
  const numMixers = output.length - 1;
  for (let i = 0; i < numMixers; i++) {
    let mixer = mixerFactory(output[i], output[i + 1]);
    if (ease) {
      const easingFunction = Array.isArray(ease) ? ease[i] || noop : ease;
      mixer = pipe(easingFunction, mixer);
    }
    mixers.push(mixer);
  }
  return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revisit this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */
function interpolate(input, output, {clamp: isClamp = true, ease, mixer} = {}) {
  const inputLength = input.length;
  invariant(inputLength === output.length, 'Both input and output ranges must be the same length', 'range-length');
  /**
   * If we're only provided a single input, we can just make a function
   * that returns the output.
   */
  if (inputLength === 1) return () => output[0];
  if (inputLength === 2 && output[0] === output[1]) return () => output[1];
  const isZeroDeltaRange = input[0] === input[1];
  // If input runs highest -> lowest, reverse both arrays
  if (input[0] > input[inputLength - 1]) {
    input = [...input].reverse();
    output = [...output].reverse();
  }
  const mixers = createMixers(output, ease, mixer);
  const numMixers = mixers.length;
  const interpolator = (v) => {
    if (isZeroDeltaRange && v < input[0]) return output[0];
    let i = 0;
    if (numMixers > 1) {
      for (; i < input.length - 2; i++) {
        if (v < input[i + 1]) break;
      }
    }
    const progressInRange = progress(input[i], input[i + 1], v);
    return mixers[i](progressInRange);
  };
  return isClamp ? (v) => interpolator(clamp(input[0], input[inputLength - 1], v)) : interpolator;
}

function fillOffset(offset, remaining) {
  const min = offset[offset.length - 1];
  for (let i = 1; i <= remaining; i++) {
    const offsetProgress = progress(0, remaining, i);
    offset.push(mixNumber$1(min, 1, offsetProgress));
  }
}

function defaultOffset$1(arr) {
  const offset = [0];
  fillOffset(offset, arr.length - 1);
  return offset;
}

function convertOffsetToTimes(offset, duration) {
  return offset.map((o) => o * duration);
}

function defaultEasing(values, easing) {
  return values.map(() => easing || easeInOut).splice(0, values.length - 1);
}
function keyframes({duration = 300, keyframes: keyframeValues, times, ease = 'easeInOut'}) {
  /**
   * Easing functions can be externally defined as strings. Here we convert them
   * into actual functions.
   */
  const easingFunctions = isEasingArray(ease) ? ease.map(easingDefinitionToFunction) : easingDefinitionToFunction(ease);
  /**
   * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
   * to reduce GC during animation.
   */
  const state = {
    done: false,
    value: keyframeValues[0],
  };
  /**
   * Create a times array based on the provided 0-1 offsets
   */
  const absoluteTimes = convertOffsetToTimes(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : defaultOffset$1(keyframeValues),
    duration,
  );
  const mapTimeToKeyframe = interpolate(absoluteTimes, keyframeValues, {
    ease: Array.isArray(easingFunctions) ? easingFunctions : defaultEasing(keyframeValues, easingFunctions),
  });
  return {
    calculatedDuration: duration,
    next: (t) => {
      state.value = mapTimeToKeyframe(t);
      state.done = t >= duration;
      return state;
    },
  };
}

const isNotNull$1 = (value) => value !== null;
function getFinalKeyframe$1(keyframes, {repeat, repeatType = 'loop'}, finalKeyframe, speed = 1) {
  const resolvedKeyframes = keyframes.filter(isNotNull$1);
  const useFirstKeyframe = speed < 0 || (repeat && repeatType !== 'loop' && repeat % 2 === 1);
  const index = useFirstKeyframe ? 0 : resolvedKeyframes.length - 1;
  return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}

const transitionTypeMap = {
  decay: inertia,
  inertia,
  tween: keyframes,
  keyframes: keyframes,
  spring,
};
function replaceTransitionType(transition) {
  if (typeof transition.type === 'string') {
    transition.type = transitionTypeMap[transition.type];
  }
}

class WithPromise {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((resolve) => {
      this.resolve = resolve;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(onResolve, onReject) {
    return this.finished.then(onResolve, onReject);
  }
}

const percentToProgress = (percent) => percent / 100;
class JSAnimation extends WithPromise {
  constructor(options) {
    super();
    this.state = 'idle';
    this.startTime = null;
    this.isStopped = false;
    /**
     * The current time of the animation.
     */
    this.currentTime = 0;
    /**
     * The time at which the animation was paused.
     */
    this.holdTime = null;
    /**
     * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
     */
    this.playbackSpeed = 1;
    /**
     * This method is bound to the instance to fix a pattern where
     * animation.stop is returned as a reference from a useEffect.
     */
    this.stop = () => {
      const {motionValue} = this.options;
      if (motionValue && motionValue.updatedAt !== time.now()) {
        this.tick(time.now());
      }
      this.isStopped = true;
      if (this.state === 'idle') return;
      this.teardown();
      this.options.onStop?.();
    };
    this.options = options;
    this.initAnimation();
    this.play();
    if (options.autoplay === false) this.pause();
  }
  initAnimation() {
    const {options} = this;
    replaceTransitionType(options);
    const {type = keyframes, repeat = 0, repeatDelay = 0, repeatType, velocity = 0} = options;
    let {keyframes: keyframes$1} = options;
    const generatorFactory = type || keyframes;
    if (process.env.NODE_ENV !== 'production' && generatorFactory !== keyframes) {
      invariant(
        keyframes$1.length <= 2,
        `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${keyframes$1}`,
        'spring-two-frames',
      );
    }
    if (generatorFactory !== keyframes && typeof keyframes$1[0] !== 'number') {
      this.mixKeyframes = pipe(percentToProgress, mix(keyframes$1[0], keyframes$1[1]));
      keyframes$1 = [0, 100];
    }
    const generator = generatorFactory({...options, keyframes: keyframes$1});
    /**
     * If we have a mirror repeat type we need to create a second generator that outputs the
     * mirrored (not reversed) animation and later ping pong between the two generators.
     */
    if (repeatType === 'mirror') {
      this.mirroredGenerator = generatorFactory({
        ...options,
        keyframes: [...keyframes$1].reverse(),
        velocity: -velocity,
      });
    }
    /**
     * If duration is undefined and we have repeat options,
     * we need to calculate a duration from the generator.
     *
     * We set it to the generator itself to cache the duration.
     * Any timeline resolver will need to have already precalculated
     * the duration by this step.
     */
    if (generator.calculatedDuration === null) {
      generator.calculatedDuration = calcGeneratorDuration(generator);
    }
    const {calculatedDuration} = generator;
    this.calculatedDuration = calculatedDuration;
    this.resolvedDuration = calculatedDuration + repeatDelay;
    this.totalDuration = this.resolvedDuration * (repeat + 1) - repeatDelay;
    this.generator = generator;
  }
  updateTime(timestamp) {
    const animationTime = Math.round(timestamp - this.startTime) * this.playbackSpeed;
    // Update currentTime
    if (this.holdTime !== null) {
      this.currentTime = this.holdTime;
    } else {
      // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
      // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
      // example.
      this.currentTime = animationTime;
    }
  }
  tick(timestamp, sample = false) {
    const {generator, totalDuration, mixKeyframes, mirroredGenerator, resolvedDuration, calculatedDuration} = this;
    if (this.startTime === null) return generator.next(0);
    const {delay = 0, keyframes, repeat, repeatType, repeatDelay, type, onUpdate, finalKeyframe} = this.options;
    /**
     * requestAnimationFrame timestamps can come through as lower than
     * the startTime as set by performance.now(). Here we prevent this,
     * though in the future it could be possible to make setting startTime
     * a pending operation that gets resolved here.
     */
    if (this.speed > 0) {
      this.startTime = Math.min(this.startTime, timestamp);
    } else if (this.speed < 0) {
      this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
    }
    if (sample) {
      this.currentTime = timestamp;
    } else {
      this.updateTime(timestamp);
    }
    // Rebase on delay
    const timeWithoutDelay = this.currentTime - delay * (this.playbackSpeed >= 0 ? 1 : -1);
    const isInDelayPhase = this.playbackSpeed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
    this.currentTime = Math.max(timeWithoutDelay, 0);
    // If this animation has finished, set the current time  to the total duration.
    if (this.state === 'finished' && this.holdTime === null) {
      this.currentTime = totalDuration;
    }
    let elapsed = this.currentTime;
    let frameGenerator = generator;
    if (repeat) {
      /**
       * Get the current progress (0-1) of the animation. If t is >
       * than duration we'll get values like 2.5 (midway through the
       * third iteration)
       */
      const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
      /**
       * Get the current iteration (0 indexed). For instance the floor of
       * 2.5 is 2.
       */
      let currentIteration = Math.floor(progress);
      /**
       * Get the current progress of the iteration by taking the remainder
       * so 2.5 is 0.5 through iteration 2
       */
      let iterationProgress = progress % 1.0;
      /**
       * If iteration progress is 1 we count that as the end
       * of the previous iteration.
       */
      if (!iterationProgress && progress >= 1) {
        iterationProgress = 1;
      }
      iterationProgress === 1 && currentIteration--;
      currentIteration = Math.min(currentIteration, repeat + 1);
      /**
       * Reverse progress if we're not running in "normal" direction
       */
      const isOddIteration = Boolean(currentIteration % 2);
      if (isOddIteration) {
        if (repeatType === 'reverse') {
          iterationProgress = 1 - iterationProgress;
          if (repeatDelay) {
            iterationProgress -= repeatDelay / resolvedDuration;
          }
        } else if (repeatType === 'mirror') {
          frameGenerator = mirroredGenerator;
        }
      }
      elapsed = clamp(0, 1, iterationProgress) * resolvedDuration;
    }
    /**
     * If we're in negative time, set state as the initial keyframe.
     * This prevents delay: x, duration: 0 animations from finishing
     * instantly.
     */
    const state = isInDelayPhase ? {done: false, value: keyframes[0]} : frameGenerator.next(elapsed);
    if (mixKeyframes) {
      state.value = mixKeyframes(state.value);
    }
    let {done} = state;
    if (!isInDelayPhase && calculatedDuration !== null) {
      done = this.playbackSpeed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
    }
    const isAnimationFinished =
      this.holdTime === null && (this.state === 'finished' || (this.state === 'running' && done));
    // TODO: The exception for inertia could be cleaner here
    if (isAnimationFinished && type !== inertia) {
      state.value = getFinalKeyframe$1(keyframes, this.options, finalKeyframe, this.speed);
    }
    if (onUpdate) {
      onUpdate(state.value);
    }
    if (isAnimationFinished) {
      this.finish();
    }
    return state;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(resolve, reject) {
    return this.finished.then(resolve, reject);
  }
  get duration() {
    return millisecondsToSeconds(this.calculatedDuration);
  }
  get iterationDuration() {
    const {delay = 0} = this.options || {};
    return this.duration + millisecondsToSeconds(delay);
  }
  get time() {
    return millisecondsToSeconds(this.currentTime);
  }
  set time(newTime) {
    newTime = secondsToMilliseconds(newTime);
    this.currentTime = newTime;
    if (this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0) {
      this.holdTime = newTime;
    } else if (this.driver) {
      this.startTime = this.driver.now() - newTime / this.playbackSpeed;
    }
    this.driver?.start(false);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(newSpeed) {
    this.updateTime(time.now());
    const hasChanged = this.playbackSpeed !== newSpeed;
    this.playbackSpeed = newSpeed;
    if (hasChanged) {
      this.time = millisecondsToSeconds(this.currentTime);
    }
  }
  play() {
    if (this.isStopped) return;
    const {driver = frameloopDriver, startTime} = this.options;
    if (!this.driver) {
      this.driver = driver((timestamp) => this.tick(timestamp));
    }
    this.options.onPlay?.();
    const now = this.driver.now();
    if (this.state === 'finished') {
      this.updateFinished();
      this.startTime = now;
    } else if (this.holdTime !== null) {
      this.startTime = now - this.holdTime;
    } else if (!this.startTime) {
      this.startTime = startTime ?? now;
    }
    if (this.state === 'finished' && this.speed < 0) {
      this.startTime += this.calculatedDuration;
    }
    this.holdTime = null;
    /**
     * Set playState to running only after we've used it in
     * the previous logic.
     */
    this.state = 'running';
    this.driver.start();
  }
  pause() {
    this.state = 'paused';
    this.updateTime(time.now());
    this.holdTime = this.currentTime;
  }
  complete() {
    if (this.state !== 'running') {
      this.play();
    }
    this.state = 'finished';
    this.holdTime = null;
  }
  finish() {
    this.notifyFinished();
    this.teardown();
    this.state = 'finished';
    this.options.onComplete?.();
  }
  cancel() {
    this.holdTime = null;
    this.startTime = 0;
    this.tick(0);
    this.teardown();
    this.options.onCancel?.();
  }
  teardown() {
    this.state = 'idle';
    this.stopDriver();
    this.startTime = this.holdTime = null;
  }
  stopDriver() {
    if (!this.driver) return;
    this.driver.stop();
    this.driver = undefined;
  }
  sample(sampleTime) {
    this.startTime = 0;
    return this.tick(sampleTime, true);
  }
  attachTimeline(timeline) {
    if (this.options.allowFlatten) {
      this.options.type = 'keyframes';
      this.options.ease = 'linear';
      this.initAnimation();
    }
    this.driver?.stop();
    return timeline.observe(this);
  }
}

function fillWildcards(keyframes) {
  for (let i = 1; i < keyframes.length; i++) {
    keyframes[i] ?? (keyframes[i] = keyframes[i - 1]);
  }
}

const radToDeg = (rad) => (rad * 180) / Math.PI;
const rotate = (v) => {
  const angle = radToDeg(Math.atan2(v[1], v[0]));
  return rebaseAngle(angle);
};
const matrix2dParsers = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (v) => (Math.abs(v[0]) + Math.abs(v[3])) / 2,
  rotate,
  rotateZ: rotate,
  skewX: (v) => radToDeg(Math.atan(v[1])),
  skewY: (v) => radToDeg(Math.atan(v[2])),
  skew: (v) => (Math.abs(v[1]) + Math.abs(v[2])) / 2,
};
const rebaseAngle = (angle) => {
  angle = angle % 360;
  if (angle < 0) angle += 360;
  return angle;
};
const rotateZ = rotate;
const scaleX = (v) => Math.sqrt(v[0] * v[0] + v[1] * v[1]);
const scaleY = (v) => Math.sqrt(v[4] * v[4] + v[5] * v[5]);
const matrix3dParsers = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX,
  scaleY,
  scale: (v) => (scaleX(v) + scaleY(v)) / 2,
  rotateX: (v) => rebaseAngle(radToDeg(Math.atan2(v[6], v[5]))),
  rotateY: (v) => rebaseAngle(radToDeg(Math.atan2(-v[2], v[0]))),
  rotateZ,
  rotate: rotateZ,
  skewX: (v) => radToDeg(Math.atan(v[4])),
  skewY: (v) => radToDeg(Math.atan(v[1])),
  skew: (v) => (Math.abs(v[1]) + Math.abs(v[4])) / 2,
};
function defaultTransformValue(name) {
  return name.includes('scale') ? 1 : 0;
}
function parseValueFromTransform(transform, name) {
  if (!transform || transform === 'none') {
    return defaultTransformValue(name);
  }
  const matrix3dMatch = transform.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let parsers;
  let match;
  if (matrix3dMatch) {
    parsers = matrix3dParsers;
    match = matrix3dMatch;
  } else {
    const matrix2dMatch = transform.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    parsers = matrix2dParsers;
    match = matrix2dMatch;
  }
  if (!match) {
    return defaultTransformValue(name);
  }
  const valueParser = parsers[name];
  const values = match[1].split(',').map(convertTransformToNumber);
  return typeof valueParser === 'function' ? valueParser(values) : values[valueParser];
}
const readTransformValue = (instance, name) => {
  const {transform = 'none'} = getComputedStyle(instance);
  return parseValueFromTransform(transform, name);
};
function convertTransformToNumber(value) {
  return parseFloat(value.trim());
}

/**
 * Generate a list of every possible transform key.
 */
const transformPropOrder = [
  'transformPerspective',
  'x',
  'y',
  'z',
  'translateX',
  'translateY',
  'translateZ',
  'scale',
  'scaleX',
  'scaleY',
  'rotate',
  'rotateX',
  'rotateY',
  'rotateZ',
  'skew',
  'skewX',
  'skewY',
];
/**
 * A quick lookup for transform props.
 */
const transformProps = /*@__PURE__*/ (() => new Set(transformPropOrder))();

const isNumOrPxType = (v) => v === number || v === px;
const transformKeys = new Set(['x', 'y', 'z']);
const nonTranslationalTransformKeys = transformPropOrder.filter((key) => !transformKeys.has(key));
function removeNonTranslationalTransform(visualElement) {
  const removedTransforms = [];
  nonTranslationalTransformKeys.forEach((key) => {
    const value = visualElement.getValue(key);
    if (value !== undefined) {
      removedTransforms.push([key, value.get()]);
      value.set(key.startsWith('scale') ? 1 : 0);
    }
  });
  return removedTransforms;
}
const positionalValues = {
  // Dimensions
  width: ({x}, {paddingLeft = '0', paddingRight = '0'}) =>
    x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
  height: ({y}, {paddingTop = '0', paddingBottom = '0'}) =>
    y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
  top: (_bbox, {top}) => parseFloat(top),
  left: (_bbox, {left}) => parseFloat(left),
  bottom: ({y}, {top}) => parseFloat(top) + (y.max - y.min),
  right: ({x}, {left}) => parseFloat(left) + (x.max - x.min),
  // Transform
  x: (_bbox, {transform}) => parseValueFromTransform(transform, 'x'),
  y: (_bbox, {transform}) => parseValueFromTransform(transform, 'y'),
};
// Alias translate longform names
positionalValues.translateX = positionalValues.x;
positionalValues.translateY = positionalValues.y;

const toResolve = new Set();
let isScheduled = false;
let anyNeedsMeasurement = false;
let isForced = false;
function measureAllKeyframes() {
  if (anyNeedsMeasurement) {
    const resolversToMeasure = Array.from(toResolve).filter((resolver) => resolver.needsMeasurement);
    const elementsToMeasure = new Set(resolversToMeasure.map((resolver) => resolver.element));
    const transformsToRestore = new Map();
    /**
     * Write pass
     * If we're measuring elements we want to remove bounding box-changing transforms.
     */
    elementsToMeasure.forEach((element) => {
      const removedTransforms = removeNonTranslationalTransform(element);
      if (!removedTransforms.length) return;
      transformsToRestore.set(element, removedTransforms);
      element.render();
    });
    // Read
    resolversToMeasure.forEach((resolver) => resolver.measureInitialState());
    // Write
    elementsToMeasure.forEach((element) => {
      element.render();
      const restore = transformsToRestore.get(element);
      if (restore) {
        restore.forEach(([key, value]) => {
          element.getValue(key)?.set(value);
        });
      }
    });
    // Read
    resolversToMeasure.forEach((resolver) => resolver.measureEndState());
    // Write
    resolversToMeasure.forEach((resolver) => {
      if (resolver.suspendedScrollY !== undefined) {
        window.scrollTo(0, resolver.suspendedScrollY);
      }
    });
  }
  anyNeedsMeasurement = false;
  isScheduled = false;
  toResolve.forEach((resolver) => resolver.complete(isForced));
  toResolve.clear();
}
function readAllKeyframes() {
  toResolve.forEach((resolver) => {
    resolver.readKeyframes();
    if (resolver.needsMeasurement) {
      anyNeedsMeasurement = true;
    }
  });
}
function flushKeyframeResolvers() {
  isForced = true;
  readAllKeyframes();
  measureAllKeyframes();
  isForced = false;
}
class KeyframeResolver {
  constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false) {
    this.state = 'pending';
    /**
     * Track whether this resolver is async. If it is, it'll be added to the
     * resolver queue and flushed in the next frame. Resolvers that aren't going
     * to trigger read/write thrashing don't need to be async.
     */
    this.isAsync = false;
    /**
     * Track whether this resolver needs to perform a measurement
     * to resolve its keyframes.
     */
    this.needsMeasurement = false;
    this.unresolvedKeyframes = [...unresolvedKeyframes];
    this.onComplete = onComplete;
    this.name = name;
    this.motionValue = motionValue;
    this.element = element;
    this.isAsync = isAsync;
  }
  scheduleResolve() {
    this.state = 'scheduled';
    if (this.isAsync) {
      toResolve.add(this);
      if (!isScheduled) {
        isScheduled = true;
        frame.read(readAllKeyframes);
        frame.resolveKeyframes(measureAllKeyframes);
      }
    } else {
      this.readKeyframes();
      this.complete();
    }
  }
  readKeyframes() {
    const {unresolvedKeyframes, name, element, motionValue} = this;
    // If initial keyframe is null we need to read it from the DOM
    if (unresolvedKeyframes[0] === null) {
      const currentValue = motionValue?.get();
      // TODO: This doesn't work if the final keyframe is a wildcard
      const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
      if (currentValue !== undefined) {
        unresolvedKeyframes[0] = currentValue;
      } else if (element && name) {
        const valueAsRead = element.readValue(name, finalKeyframe);
        if (valueAsRead !== undefined && valueAsRead !== null) {
          unresolvedKeyframes[0] = valueAsRead;
        }
      }
      if (unresolvedKeyframes[0] === undefined) {
        unresolvedKeyframes[0] = finalKeyframe;
      }
      if (motionValue && currentValue === undefined) {
        motionValue.set(unresolvedKeyframes[0]);
      }
    }
    fillWildcards(unresolvedKeyframes);
  }
  setFinalKeyframe() {}
  measureInitialState() {}
  renderEndStyles() {}
  measureEndState() {}
  complete(isForcedComplete = false) {
    this.state = 'complete';
    this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, isForcedComplete);
    toResolve.delete(this);
  }
  cancel() {
    if (this.state === 'scheduled') {
      toResolve.delete(this);
      this.state = 'pending';
    }
  }
  resume() {
    if (this.state === 'pending') this.scheduleResolve();
  }
}

const isCSSVar = (name) => name.startsWith('--');

function setStyle(element, name, value) {
  isCSSVar(name) ? element.style.setProperty(name, value) : (element.style[name] = value);
}

const supportsScrollTimeline = /* @__PURE__ */ memo(() => window.ScrollTimeline !== undefined);

/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */
const supportsFlags = {};

function memoSupports(callback, supportsFlag) {
  const memoized = memo(callback);
  return () => supportsFlags[supportsFlag] ?? memoized();
}

const supportsLinearEasing = /*@__PURE__*/ memoSupports(() => {
  try {
    document.createElement('div').animate({opacity: 0}, {easing: 'linear(0, 1)'});
  } catch (e) {
    return false;
  }
  return true;
}, 'linearEasing');

const cubicBezierAsString = ([a, b, c, d]) => `cubic-bezier(${a}, ${b}, ${c}, ${d})`;

const supportedWaapiEasing = {
  linear: 'linear',
  ease: 'ease',
  easeIn: 'ease-in',
  easeOut: 'ease-out',
  easeInOut: 'ease-in-out',
  circIn: /*@__PURE__*/ cubicBezierAsString([0, 0.65, 0.55, 1]),
  circOut: /*@__PURE__*/ cubicBezierAsString([0.55, 0, 1, 0.45]),
  backIn: /*@__PURE__*/ cubicBezierAsString([0.31, 0.01, 0.66, -0.59]),
  backOut: /*@__PURE__*/ cubicBezierAsString([0.33, 1.53, 0.69, 0.99]),
};

function mapEasingToNativeEasing(easing, duration) {
  if (!easing) {
    return undefined;
  } else if (typeof easing === 'function') {
    return supportsLinearEasing() ? generateLinearEasing(easing, duration) : 'ease-out';
  } else if (isBezierDefinition(easing)) {
    return cubicBezierAsString(easing);
  } else if (Array.isArray(easing)) {
    return easing.map(
      (segmentEasing) => mapEasingToNativeEasing(segmentEasing, duration) || supportedWaapiEasing.easeOut,
    );
  } else {
    return supportedWaapiEasing[easing];
  }
}

function startWaapiAnimation(
  element,
  valueName,
  keyframes,
  {delay = 0, duration = 300, repeat = 0, repeatType = 'loop', ease = 'easeOut', times} = {},
  pseudoElement = undefined,
) {
  const keyframeOptions = {
    [valueName]: keyframes,
  };
  if (times) keyframeOptions.offset = times;
  const easing = mapEasingToNativeEasing(ease, duration);
  /**
   * If this is an easing array, apply to keyframes, not animation as a whole
   */
  if (Array.isArray(easing)) keyframeOptions.easing = easing;
  const options = {
    delay,
    duration,
    easing: !Array.isArray(easing) ? easing : 'linear',
    fill: 'both',
    iterations: repeat + 1,
    direction: repeatType === 'reverse' ? 'alternate' : 'normal',
  };
  if (pseudoElement) options.pseudoElement = pseudoElement;
  const animation = element.animate(keyframeOptions, options);
  return animation;
}

function isGenerator(type) {
  return typeof type === 'function' && 'applyToOptions' in type;
}

function applyGeneratorOptions({type, ...options}) {
  if (isGenerator(type) && supportsLinearEasing()) {
    return type.applyToOptions(options);
  } else {
    options.duration ?? (options.duration = 300);
    options.ease ?? (options.ease = 'easeOut');
  }
  return options;
}

/**
 * NativeAnimation implements AnimationPlaybackControls for the browser's Web Animations API.
 */
class NativeAnimation extends WithPromise {
  constructor(options) {
    super();
    this.finishedTime = null;
    this.isStopped = false;
    if (!options) return;
    const {element, name, keyframes, pseudoElement, allowFlatten = false, finalKeyframe, onComplete} = options;
    this.isPseudoElement = Boolean(pseudoElement);
    this.allowFlatten = allowFlatten;
    this.options = options;
    invariant(typeof options.type !== 'string', `Mini animate() doesn't support "type" as a string.`, 'mini-spring');
    const transition = applyGeneratorOptions(options);
    this.animation = startWaapiAnimation(element, name, keyframes, transition, pseudoElement);
    if (transition.autoplay === false) {
      this.animation.pause();
    }
    this.animation.onfinish = () => {
      this.finishedTime = this.time;
      if (!pseudoElement) {
        const keyframe = getFinalKeyframe$1(keyframes, this.options, finalKeyframe, this.speed);
        if (this.updateMotionValue) {
          this.updateMotionValue(keyframe);
        } else {
          /**
           * If we can, we want to commit the final style as set by the user,
           * rather than the computed keyframe value supplied by the animation.
           */
          setStyle(element, name, keyframe);
        }
        this.animation.cancel();
      }
      onComplete?.();
      this.notifyFinished();
    };
  }
  play() {
    if (this.isStopped) return;
    this.animation.play();
    if (this.state === 'finished') {
      this.updateFinished();
    }
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.finish?.();
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch (e) {}
  }
  stop() {
    if (this.isStopped) return;
    this.isStopped = true;
    const {state} = this;
    if (state === 'idle' || state === 'finished') {
      return;
    }
    if (this.updateMotionValue) {
      this.updateMotionValue();
    } else {
      this.commitStyles();
    }
    if (!this.isPseudoElement) this.cancel();
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    if (!this.isPseudoElement) {
      this.animation.commitStyles?.();
    }
  }
  get duration() {
    const duration = this.animation.effect?.getComputedTiming?.().duration || 0;
    return millisecondsToSeconds(Number(duration));
  }
  get iterationDuration() {
    const {delay = 0} = this.options || {};
    return this.duration + millisecondsToSeconds(delay);
  }
  get time() {
    return millisecondsToSeconds(Number(this.animation.currentTime) || 0);
  }
  set time(newTime) {
    this.finishedTime = null;
    this.animation.currentTime = secondsToMilliseconds(newTime);
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(newSpeed) {
    // Allow backwards playback after finishing
    if (newSpeed < 0) this.finishedTime = null;
    this.animation.playbackRate = newSpeed;
  }
  get state() {
    return this.finishedTime !== null ? 'finished' : this.animation.playState;
  }
  get startTime() {
    return Number(this.animation.startTime);
  }
  set startTime(newStartTime) {
    this.animation.startTime = newStartTime;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({timeline, observe}) {
    if (this.allowFlatten) {
      this.animation.effect?.updateTiming({easing: 'linear'});
    }
    this.animation.onfinish = null;
    if (timeline && supportsScrollTimeline()) {
      this.animation.timeline = timeline;
      return noop;
    } else {
      return observe(this);
    }
  }
}

const unsupportedEasingFunctions = {
  anticipate,
  backInOut,
  circInOut,
};
function isUnsupportedEase(key) {
  return key in unsupportedEasingFunctions;
}
function replaceStringEasing(transition) {
  if (typeof transition.ease === 'string' && isUnsupportedEase(transition.ease)) {
    transition.ease = unsupportedEasingFunctions[transition.ease];
  }
}

/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */
const sampleDelta = 10; //ms
class NativeAnimationExtended extends NativeAnimation {
  constructor(options) {
    /**
     * The base NativeAnimation function only supports a subset
     * of Motion easings, and WAAPI also only supports some
     * easing functions via string/cubic-bezier definitions.
     *
     * This function replaces those unsupported easing functions
     * with a JS easing function. This will later get compiled
     * to a linear() easing function.
     */
    replaceStringEasing(options);
    /**
     * Ensure we replace the transition type with a generator function
     * before passing to WAAPI.
     *
     * TODO: Does this have a better home? It could be shared with
     * JSAnimation.
     */
    replaceTransitionType(options);
    super(options);
    if (options.startTime) {
      this.startTime = options.startTime;
    }
    this.options = options;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read commited styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(value) {
    const {motionValue, onUpdate, onComplete, element, ...options} = this.options;
    if (!motionValue) return;
    if (value !== undefined) {
      motionValue.set(value);
      return;
    }
    const sampleAnimation = new JSAnimation({
      ...options,
      autoplay: false,
    });
    const sampleTime = secondsToMilliseconds(this.finishedTime ?? this.time);
    motionValue.setWithVelocity(
      sampleAnimation.sample(sampleTime - sampleDelta).value,
      sampleAnimation.sample(sampleTime).value,
      sampleDelta,
    );
    sampleAnimation.stop();
  }
}

/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */
const isAnimatable = (value, name) => {
  // If the list of keys that might be non-animatable grows, replace with Set
  if (name === 'zIndex') return false;
  // If it's a number or a keyframes array, we can animate it. We might at some point
  // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
  // but for now lets leave it like this for performance reasons
  if (typeof value === 'number' || Array.isArray(value)) return true;
  if (
    typeof value === 'string' && // It's animatable if we have a string
    (complex.test(value) || value === '0') && // And it contains numbers and/or colors
    !value.startsWith('url(') // Unless it starts with "url("
  ) {
    return true;
  }
  return false;
};

function hasKeyframesChanged(keyframes) {
  const current = keyframes[0];
  if (keyframes.length === 1) return true;
  for (let i = 0; i < keyframes.length; i++) {
    if (keyframes[i] !== current) return true;
  }
}
function canAnimate(keyframes, name, type, velocity) {
  /**
   * Check if we're able to animate between the start and end keyframes,
   * and throw a warning if we're attempting to animate between one that's
   * animatable and another that isn't.
   */
  const originKeyframe = keyframes[0];
  if (originKeyframe === null) return false;
  /**
   * These aren't traditionally animatable but we do support them.
   * In future we could look into making this more generic or replacing
   * this function with mix() === mixImmediate
   */
  if (name === 'display' || name === 'visibility') return true;
  const targetKeyframe = keyframes[keyframes.length - 1];
  const isOriginAnimatable = isAnimatable(originKeyframe, name);
  const isTargetAnimatable = isAnimatable(targetKeyframe, name);
  warning(
    isOriginAnimatable === isTargetAnimatable,
    `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". "${isOriginAnimatable ? targetKeyframe : originKeyframe}" is not an animatable value.`,
    'value-not-animatable',
  );
  // Always skip if any of these are true
  if (!isOriginAnimatable || !isTargetAnimatable) {
    return false;
  }
  return hasKeyframesChanged(keyframes) || ((type === 'spring' || isGenerator(type)) && velocity);
}

function makeAnimationInstant(options) {
  options.duration = 0;
  options.type = 'keyframes';
}

/**
 * A list of values that can be hardware-accelerated.
 */
const acceleratedValues = new Set([
  'opacity',
  'clipPath',
  'filter',
  'transform',
  // TODO: Could be re-enabled now we have support for linear() easing
  // "background-color"
]);
const supportsWaapi = /*@__PURE__*/ memo(() => Object.hasOwnProperty.call(Element.prototype, 'animate'));
function supportsBrowserAnimation(options) {
  const {motionValue, name, repeatDelay, repeatType, damping, type} = options;
  const subject = motionValue?.owner?.current;
  /**
   * We use this check instead of isHTMLElement() because we explicitly
   * **don't** want elements in different timing contexts (i.e. popups)
   * to be accelerated, as it's not possible to sync these animations
   * properly with those driven from the main window frameloop.
   */
  if (!(subject instanceof HTMLElement)) {
    return false;
  }
  const {onUpdate, transformTemplate} = motionValue.owner.getProps();
  return (
    supportsWaapi() &&
    name &&
    acceleratedValues.has(name) &&
    (name !== 'transform' || !transformTemplate) &&
    /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !onUpdate &&
    !repeatDelay &&
    repeatType !== 'mirror' &&
    damping !== 0 &&
    type !== 'inertia'
  );
}

/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */
const MAX_RESOLVE_DELAY = 40;
class AsyncMotionValueAnimation extends WithPromise {
  constructor({
    autoplay = true,
    delay = 0,
    type = 'keyframes',
    repeat = 0,
    repeatDelay = 0,
    repeatType = 'loop',
    keyframes,
    name,
    motionValue,
    element,
    ...options
  }) {
    super();
    /**
     * Bound to support return animation.stop pattern
     */
    this.stop = () => {
      if (this._animation) {
        this._animation.stop();
        this.stopTimeline?.();
      }
      this.keyframeResolver?.cancel();
    };
    this.createdAt = time.now();
    const optionsWithDefaults = {
      autoplay,
      delay,
      type,
      repeat,
      repeatDelay,
      repeatType,
      name,
      motionValue,
      element,
      ...options,
    };
    const KeyframeResolver$1 = element?.KeyframeResolver || KeyframeResolver;
    this.keyframeResolver = new KeyframeResolver$1(
      keyframes,
      (resolvedKeyframes, finalKeyframe, forced) =>
        this.onKeyframesResolved(resolvedKeyframes, finalKeyframe, optionsWithDefaults, !forced),
      name,
      motionValue,
      element,
    );
    this.keyframeResolver?.scheduleResolve();
  }
  onKeyframesResolved(keyframes, finalKeyframe, options, sync) {
    this.keyframeResolver = undefined;
    const {name, type, velocity, delay, isHandoff, onUpdate} = options;
    this.resolvedAt = time.now();
    /**
     * If we can't animate this value with the resolved keyframes
     * then we should complete it immediately.
     */
    if (!canAnimate(keyframes, name, type, velocity)) {
      if (MotionGlobalConfig.instantAnimations || !delay) {
        onUpdate?.(getFinalKeyframe$1(keyframes, options, finalKeyframe));
      }
      keyframes[0] = keyframes[keyframes.length - 1];
      makeAnimationInstant(options);
      options.repeat = 0;
    }
    /**
     * Resolve startTime for the animation.
     *
     * This method uses the createdAt and resolvedAt to calculate the
     * animation startTime. *Ideally*, we would use the createdAt time as t=0
     * as the following frame would then be the first frame of the animation in
     * progress, which would feel snappier.
     *
     * However, if there's a delay (main thread work) between the creation of
     * the animation and the first commited frame, we prefer to use resolvedAt
     * to avoid a sudden jump into the animation.
     */
    const startTime = sync
      ? !this.resolvedAt
        ? this.createdAt
        : this.resolvedAt - this.createdAt > MAX_RESOLVE_DELAY
          ? this.resolvedAt
          : this.createdAt
      : undefined;
    const resolvedOptions = {
      startTime,
      finalKeyframe,
      ...options,
      keyframes,
    };
    /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */
    const animation =
      !isHandoff && supportsBrowserAnimation(resolvedOptions)
        ? new NativeAnimationExtended({
            ...resolvedOptions,
            element: resolvedOptions.motionValue.owner.current,
          })
        : new JSAnimation(resolvedOptions);
    animation.finished.then(() => this.notifyFinished()).catch(noop);
    if (this.pendingTimeline) {
      this.stopTimeline = animation.attachTimeline(this.pendingTimeline);
      this.pendingTimeline = undefined;
    }
    this._animation = animation;
  }
  get finished() {
    if (!this._animation) {
      return this._finished;
    } else {
      return this.animation.finished;
    }
  }
  then(onResolve, _onReject) {
    return this.finished.finally(onResolve).then(() => {});
  }
  get animation() {
    if (!this._animation) {
      this.keyframeResolver?.resume();
      flushKeyframeResolvers();
    }
    return this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get iterationDuration() {
    return this.animation.iterationDuration;
  }
  get time() {
    return this.animation.time;
  }
  set time(newTime) {
    this.animation.time = newTime;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(newSpeed) {
    this.animation.speed = newSpeed;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(timeline) {
    if (this._animation) {
      this.stopTimeline = this.animation.attachTimeline(timeline);
    } else {
      this.pendingTimeline = timeline;
    }
    return () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    if (this._animation) {
      this.animation.cancel();
    }
    this.keyframeResolver?.cancel();
  }
}

class GroupAnimation {
  constructor(animations) {
    // Bound to accomadate common `return animation.stop` pattern
    this.stop = () => this.runAll('stop');
    this.animations = animations.filter(Boolean);
  }
  get finished() {
    return Promise.all(this.animations.map((animation) => animation.finished));
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(propName) {
    return this.animations[0][propName];
  }
  setAll(propName, newValue) {
    for (let i = 0; i < this.animations.length; i++) {
      this.animations[i][propName] = newValue;
    }
  }
  attachTimeline(timeline) {
    const subscriptions = this.animations.map((animation) => animation.attachTimeline(timeline));
    return () => {
      subscriptions.forEach((cancel, i) => {
        cancel && cancel();
        this.animations[i].stop();
      });
    };
  }
  get time() {
    return this.getAll('time');
  }
  set time(time) {
    this.setAll('time', time);
  }
  get speed() {
    return this.getAll('speed');
  }
  set speed(speed) {
    this.setAll('speed', speed);
  }
  get state() {
    return this.getAll('state');
  }
  get startTime() {
    return this.getAll('startTime');
  }
  get duration() {
    return getMax(this.animations, 'duration');
  }
  get iterationDuration() {
    return getMax(this.animations, 'iterationDuration');
  }
  runAll(methodName) {
    this.animations.forEach((controls) => controls[methodName]());
  }
  play() {
    this.runAll('play');
  }
  pause() {
    this.runAll('pause');
  }
  cancel() {
    this.runAll('cancel');
  }
  complete() {
    this.runAll('complete');
  }
}
function getMax(animations, propName) {
  let max = 0;
  for (let i = 0; i < animations.length; i++) {
    const value = animations[i][propName];
    if (value !== null && value > max) {
      max = value;
    }
  }
  return max;
}

class GroupAnimationWithThen extends GroupAnimation {
  then(onResolve, _onReject) {
    return this.finished.finally(onResolve).then(() => {});
  }
}

class NativeAnimationWrapper extends NativeAnimation {
  constructor(animation) {
    super();
    this.animation = animation;
    animation.onfinish = () => {
      this.finishedTime = this.time;
      this.notifyFinished();
    };
  }
}

/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */
const splitCSSVariableRegex =
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function parseCSSVariable(current) {
  const match = splitCSSVariableRegex.exec(current);
  if (!match) return [,];
  const [, token1, token2, fallback] = match;
  return [`--${token1 ?? token2}`, fallback];
}
const maxDepth = 4;
function getVariableValue(current, element, depth = 1) {
  invariant(
    depth <= maxDepth,
    `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`,
    'max-css-var-depth',
  );
  const [token, fallback] = parseCSSVariable(current);
  // No CSS variable detected
  if (!token) return;
  // Attempt to read this CSS variable off the element
  const resolved = window.getComputedStyle(element).getPropertyValue(token);
  if (resolved) {
    const trimmed = resolved.trim();
    return isNumericalString(trimmed) ? parseFloat(trimmed) : trimmed;
  }
  return isCSSVariableToken(fallback) ? getVariableValue(fallback, element, depth + 1) : fallback;
}

function getValueTransition$1(transition, key) {
  return transition?.[key] ?? transition?.['default'] ?? transition;
}

const positionalKeys = new Set(['width', 'height', 'top', 'left', 'right', 'bottom', ...transformPropOrder]);

/**
 * ValueType for "auto"
 */
const auto = {
  test: (v) => v === 'auto',
  parse: (v) => v,
};

/**
 * Tests a provided value against a ValueType
 */
const testValueType = (v) => (type) => type.test(v);

/**
 * A list of value types commonly used for dimensions
 */
const dimensionValueTypes = [number, px, percent, degrees, vw, vh, auto];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */
const findDimensionValueType = (v) => dimensionValueTypes.find(testValueType(v));

function isNone(value) {
  if (typeof value === 'number') {
    return value === 0;
  } else if (value !== null) {
    return value === 'none' || value === '0' || isZeroValueString(value);
  } else {
    return true;
  }
}

/**
 * Properties that should default to 1 or 100%
 */
const maxDefaults = new Set(['brightness', 'contrast', 'saturate', 'opacity']);
function applyDefaultFilter(v) {
  const [name, value] = v.slice(0, -1).split('(');
  if (name === 'drop-shadow') return v;
  const [number] = value.match(floatRegex) || [];
  if (!number) return v;
  const unit = value.replace(number, '');
  let defaultValue = maxDefaults.has(name) ? 1 : 0;
  if (number !== value) defaultValue *= 100;
  return name + '(' + defaultValue + unit + ')';
}
const functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const filter = {
  ...complex,
  getAnimatableNone: (v) => {
    const functions = v.match(functionRegex);
    return functions ? functions.map(applyDefaultFilter).join(' ') : v;
  },
};

const int = {
  ...number,
  transform: Math.round,
};

const transformValueTypes = {
  rotate: degrees,
  rotateX: degrees,
  rotateY: degrees,
  rotateZ: degrees,
  scale,
  scaleX: scale,
  scaleY: scale,
  scaleZ: scale,
  skew: degrees,
  skewX: degrees,
  skewY: degrees,
  distance: px,
  translateX: px,
  translateY: px,
  translateZ: px,
  x: px,
  y: px,
  z: px,
  perspective: px,
  transformPerspective: px,
  opacity: alpha,
  originX: progressPercentage,
  originY: progressPercentage,
  originZ: px,
};

const numberValueTypes = {
  // Border props
  borderWidth: px,
  borderTopWidth: px,
  borderRightWidth: px,
  borderBottomWidth: px,
  borderLeftWidth: px,
  borderRadius: px,
  radius: px,
  borderTopLeftRadius: px,
  borderTopRightRadius: px,
  borderBottomRightRadius: px,
  borderBottomLeftRadius: px,
  // Positioning props
  width: px,
  maxWidth: px,
  height: px,
  maxHeight: px,
  top: px,
  right: px,
  bottom: px,
  left: px,
  // Spacing props
  padding: px,
  paddingTop: px,
  paddingRight: px,
  paddingBottom: px,
  paddingLeft: px,
  margin: px,
  marginTop: px,
  marginRight: px,
  marginBottom: px,
  marginLeft: px,
  // Misc
  backgroundPositionX: px,
  backgroundPositionY: px,
  ...transformValueTypes,
  zIndex: int,
  // SVG
  fillOpacity: alpha,
  strokeOpacity: alpha,
  numOctaves: int,
};

/**
 * A map of default value types for common values
 */
const defaultValueTypes = {
  ...numberValueTypes,
  // Color props
  color,
  backgroundColor: color,
  outlineColor: color,
  fill: color,
  stroke: color,
  // Border props
  borderColor: color,
  borderTopColor: color,
  borderRightColor: color,
  borderBottomColor: color,
  borderLeftColor: color,
  filter,
  WebkitFilter: filter,
};
/**
 * Gets the default ValueType for the provided value key
 */
const getDefaultValueType = (key) => defaultValueTypes[key];

function getAnimatableNone(key, value) {
  let defaultValueType = getDefaultValueType(key);
  if (defaultValueType !== filter) defaultValueType = complex;
  // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
  return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}

/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */
const invalidTemplates = new Set(['auto', 'none', '0']);
function makeNoneKeyframesAnimatable(unresolvedKeyframes, noneKeyframeIndexes, name) {
  let i = 0;
  let animatableTemplate = undefined;
  while (i < unresolvedKeyframes.length && !animatableTemplate) {
    const keyframe = unresolvedKeyframes[i];
    if (
      typeof keyframe === 'string' &&
      !invalidTemplates.has(keyframe) &&
      analyseComplexValue(keyframe).values.length
    ) {
      animatableTemplate = unresolvedKeyframes[i];
    }
    i++;
  }
  if (animatableTemplate && name) {
    for (const noneIndex of noneKeyframeIndexes) {
      unresolvedKeyframes[noneIndex] = getAnimatableNone(name, animatableTemplate);
    }
  }
}

class DOMKeyframesResolver extends KeyframeResolver {
  constructor(unresolvedKeyframes, onComplete, name, motionValue, element) {
    super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
  }
  readKeyframes() {
    const {unresolvedKeyframes, element, name} = this;
    if (!element || !element.current) return;
    super.readKeyframes();
    /**
     * If any keyframe is a CSS variable, we need to find its value by sampling the element
     */
    for (let i = 0; i < unresolvedKeyframes.length; i++) {
      let keyframe = unresolvedKeyframes[i];
      if (typeof keyframe === 'string') {
        keyframe = keyframe.trim();
        if (isCSSVariableToken(keyframe)) {
          const resolved = getVariableValue(keyframe, element.current);
          if (resolved !== undefined) {
            unresolvedKeyframes[i] = resolved;
          }
          if (i === unresolvedKeyframes.length - 1) {
            this.finalKeyframe = keyframe;
          }
        }
      }
    }
    /**
     * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
     * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
     * have a far bigger performance impact.
     */
    this.resolveNoneKeyframes();
    /**
     * Check to see if unit type has changed. If so schedule jobs that will
     * temporarily set styles to the destination keyframes.
     * Skip if we have more than two keyframes or this isn't a positional value.
     * TODO: We can throw if there are multiple keyframes and the value type changes.
     */
    if (!positionalKeys.has(name) || unresolvedKeyframes.length !== 2) {
      return;
    }
    const [origin, target] = unresolvedKeyframes;
    const originType = findDimensionValueType(origin);
    const targetType = findDimensionValueType(target);
    /**
     * Either we don't recognise these value types or we can animate between them.
     */
    if (originType === targetType) return;
    /**
     * If both values are numbers or pixels, we can animate between them by
     * converting them to numbers.
     */
    if (isNumOrPxType(originType) && isNumOrPxType(targetType)) {
      for (let i = 0; i < unresolvedKeyframes.length; i++) {
        const value = unresolvedKeyframes[i];
        if (typeof value === 'string') {
          unresolvedKeyframes[i] = parseFloat(value);
        }
      }
    } else if (positionalValues[name]) {
      /**
       * Else, the only way to resolve this is by measuring the element.
       */
      this.needsMeasurement = true;
    }
  }
  resolveNoneKeyframes() {
    const {unresolvedKeyframes, name} = this;
    const noneKeyframeIndexes = [];
    for (let i = 0; i < unresolvedKeyframes.length; i++) {
      if (unresolvedKeyframes[i] === null || isNone(unresolvedKeyframes[i])) {
        noneKeyframeIndexes.push(i);
      }
    }
    if (noneKeyframeIndexes.length) {
      makeNoneKeyframesAnimatable(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
  }
  measureInitialState() {
    const {element, unresolvedKeyframes, name} = this;
    if (!element || !element.current) return;
    if (name === 'height') {
      this.suspendedScrollY = window.pageYOffset;
    }
    this.measuredOrigin = positionalValues[name](
      element.measureViewportBox(),
      window.getComputedStyle(element.current),
    );
    unresolvedKeyframes[0] = this.measuredOrigin;
    // Set final key frame to measure after next render
    const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
    if (measureKeyframe !== undefined) {
      element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
  }
  measureEndState() {
    const {element, name, unresolvedKeyframes} = this;
    if (!element || !element.current) return;
    const value = element.getValue(name);
    value && value.jump(this.measuredOrigin, false);
    const finalKeyframeIndex = unresolvedKeyframes.length - 1;
    const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
    unresolvedKeyframes[finalKeyframeIndex] = positionalValues[name](
      element.measureViewportBox(),
      window.getComputedStyle(element.current),
    );
    if (finalKeyframe !== null && this.finalKeyframe === undefined) {
      this.finalKeyframe = finalKeyframe;
    }
    // If we removed transform values, reapply them before the next render
    if (this.removedTransforms?.length) {
      this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue]) => {
        element.getValue(unsetTransformName).set(unsetTransformValue);
      });
    }
    this.resolveNoneKeyframes();
  }
}

function camelToDash$1(str) {
  return str.replace(/([A-Z])/g, (match) => `-${match.toLowerCase()}`);
}

function resolveElements(elementOrSelector, scope, selectorCache) {
  if (elementOrSelector instanceof EventTarget) {
    return [elementOrSelector];
  } else if (typeof elementOrSelector === 'string') {
    let root = document;
    const elements = selectorCache?.[elementOrSelector] ?? root.querySelectorAll(elementOrSelector);
    return elements ? Array.from(elements) : [];
  }
  return Array.from(elementOrSelector);
}

function createSelectorEffect(subjectEffect) {
  return (subject, values) => {
    const elements = resolveElements(subject);
    const subscriptions = [];
    for (const element of elements) {
      const remove = subjectEffect(element, values);
      subscriptions.push(remove);
    }
    return () => {
      for (const remove of subscriptions) remove();
    };
  };
}

/**
 * Provided a value and a ValueType, returns the value as that value type.
 */
const getValueAsType = (value, type) => {
  return type && typeof value === 'number' ? type.transform(value) : value;
};

class MotionValueState {
  constructor() {
    this.latest = {};
    this.values = new Map();
  }
  set(name, value, render, computed, useDefaultValueType = true) {
    const existingValue = this.values.get(name);
    if (existingValue) {
      existingValue.onRemove();
    }
    const onChange = () => {
      const v = value.get();
      if (useDefaultValueType) {
        this.latest[name] = getValueAsType(v, numberValueTypes[name]);
      } else {
        this.latest[name] = v;
      }
      render && frame.render(render);
    };
    onChange();
    const cancelOnChange = value.on('change', onChange);
    computed && value.addDependent(computed);
    const remove = () => {
      cancelOnChange();
      render && cancelFrame(render);
      this.values.delete(name);
      computed && value.removeDependent(computed);
    };
    this.values.set(name, {value, onRemove: remove});
    return remove;
  }
  get(name) {
    return this.values.get(name)?.value;
  }
  destroy() {
    for (const value of this.values.values()) {
      value.onRemove();
    }
  }
}

function createEffect(addValue) {
  const stateCache = new WeakMap();
  const subscriptions = [];
  return (subject, values) => {
    const state = stateCache.get(subject) ?? new MotionValueState();
    stateCache.set(subject, state);
    for (const key in values) {
      const value = values[key];
      const remove = addValue(subject, state, key, value);
      subscriptions.push(remove);
    }
    return () => {
      for (const cancel of subscriptions) cancel();
    };
  };
}

function canSetAsProperty(element, name) {
  if (!(name in element)) return false;
  const descriptor =
    Object.getOwnPropertyDescriptor(Object.getPrototypeOf(element), name) ||
    Object.getOwnPropertyDescriptor(element, name);
  // Check if it has a setter
  return descriptor && typeof descriptor.set === 'function';
}
const addAttrValue = (element, state, key, value) => {
  const isProp = canSetAsProperty(element, key);
  const name = isProp ? key : key.startsWith('data') || key.startsWith('aria') ? camelToDash$1(key) : key;
  /**
   * Set attribute directly via property if available
   */
  const render = isProp
    ? () => {
        element[name] = state.latest[key];
      }
    : () => {
        const v = state.latest[key];
        if (v === null || v === undefined) {
          element.removeAttribute(name);
        } else {
          element.setAttribute(name, String(v));
        }
      };
  return state.set(key, value, render);
};
const attrEffect = /*@__PURE__*/ createSelectorEffect(/*@__PURE__*/ createEffect(addAttrValue));

const propEffect = /*@__PURE__*/ createEffect((subject, state, key, value) => {
  return state.set(
    key,
    value,
    () => {
      subject[key] = state.latest[key];
    },
    undefined,
    false,
  );
});

/**
 * Checks if an element is an HTML element in a way
 * that works across iframes
 */
function isHTMLElement(element) {
  return isObject(element) && 'offsetHeight' in element;
}

/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */
const MAX_VELOCITY_DELTA = 30;
const isFloat = (value) => {
  return !isNaN(parseFloat(value));
};
const collectMotionValues = {
  current: undefined,
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */
class MotionValue {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(init, options = {}) {
    /**
     * Tracks whether this value can output a velocity. Currently this is only true
     * if the value is numerical, but we might be able to widen the scope here and support
     * other value types.
     *
     * @internal
     */
    this.canTrackVelocity = null;
    /**
     * An object containing a SubscriptionManager for each active event.
     */
    this.events = {};
    this.updateAndNotify = (v) => {
      const currentTime = time.now();
      /**
       * If we're updating the value during another frame or eventloop
       * than the previous frame, then the we set the previous frame value
       * to current.
       */
      if (this.updatedAt !== currentTime) {
        this.setPrevFrameValue();
      }
      this.prev = this.current;
      this.setCurrent(v);
      // Update update subscribers
      if (this.current !== this.prev) {
        this.events.change?.notify(this.current);
        if (this.dependents) {
          for (const dependent of this.dependents) {
            dependent.dirty();
          }
        }
      }
    };
    this.hasAnimated = false;
    this.setCurrent(init);
    this.owner = options.owner;
  }
  setCurrent(current) {
    this.current = current;
    this.updatedAt = time.now();
    if (this.canTrackVelocity === null && current !== undefined) {
      this.canTrackVelocity = isFloat(this.current);
    }
  }
  setPrevFrameValue(prevFrameValue = this.current) {
    this.prevFrameValue = prevFrameValue;
    this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(subscription) {
    if (process.env.NODE_ENV !== 'production') {
      warnOnce(false, `value.onChange(callback) is deprecated. Switch to value.on("change", callback).`);
    }
    return this.on('change', subscription);
  }
  on(eventName, callback) {
    if (!this.events[eventName]) {
      this.events[eventName] = new SubscriptionManager();
    }
    const unsubscribe = this.events[eventName].add(callback);
    if (eventName === 'change') {
      return () => {
        unsubscribe();
        /**
         * If we have no more change listeners by the start
         * of the next frame, stop active animations.
         */
        frame.read(() => {
          if (!this.events.change.getSize()) {
            this.stop();
          }
        });
      };
    }
    return unsubscribe;
  }
  clearListeners() {
    for (const eventManagers in this.events) {
      this.events[eventManagers].clear();
    }
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(passiveEffect, stopPassiveEffect) {
    this.passiveEffect = passiveEffect;
    this.stopPassiveEffect = stopPassiveEffect;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(v) {
    if (!this.passiveEffect) {
      this.updateAndNotify(v);
    } else {
      this.passiveEffect(v, this.updateAndNotify);
    }
  }
  setWithVelocity(prev, current, delta) {
    this.set(current);
    this.prev = undefined;
    this.prevFrameValue = prev;
    this.prevUpdatedAt = this.updatedAt - delta;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(v, endAnimation = true) {
    this.updateAndNotify(v);
    this.prev = v;
    this.prevUpdatedAt = this.prevFrameValue = undefined;
    endAnimation && this.stop();
    if (this.stopPassiveEffect) this.stopPassiveEffect();
  }
  dirty() {
    this.events.change?.notify(this.current);
  }
  addDependent(dependent) {
    if (!this.dependents) {
      this.dependents = new Set();
    }
    this.dependents.add(dependent);
  }
  removeDependent(dependent) {
    if (this.dependents) {
      this.dependents.delete(dependent);
    }
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    if (collectMotionValues.current) {
      collectMotionValues.current.push(this);
    }
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const currentTime = time.now();
    if (
      !this.canTrackVelocity ||
      this.prevFrameValue === undefined ||
      currentTime - this.updatedAt > MAX_VELOCITY_DELTA
    ) {
      return 0;
    }
    const delta = Math.min(this.updatedAt - this.prevUpdatedAt, MAX_VELOCITY_DELTA);
    // Casts because of parseFloat's poor typing
    return velocityPerSecond(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(startAnimation) {
    this.stop();
    return new Promise((resolve) => {
      this.hasAnimated = true;
      this.animation = startAnimation(resolve);
      if (this.events.animationStart) {
        this.events.animationStart.notify();
      }
    }).then(() => {
      if (this.events.animationComplete) {
        this.events.animationComplete.notify();
      }
      this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    if (this.animation) {
      this.animation.stop();
      if (this.events.animationCancel) {
        this.events.animationCancel.notify();
      }
    }
    this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.dependents?.clear();
    this.events.destroy?.notify();
    this.clearListeners();
    this.stop();
    if (this.stopPassiveEffect) {
      this.stopPassiveEffect();
    }
  }
}
function motionValue(init, options) {
  return new MotionValue(init, options);
}

const translateAlias$1 = {
  x: 'translateX',
  y: 'translateY',
  z: 'translateZ',
  transformPerspective: 'perspective',
};
function buildTransform$1(state) {
  let transform = '';
  let transformIsDefault = true;
  /**
   * Loop over all possible transforms in order, adding the ones that
   * are present to the transform string.
   */
  for (let i = 0; i < transformPropOrder.length; i++) {
    const key = transformPropOrder[i];
    const value = state.latest[key];
    if (value === undefined) continue;
    let valueIsDefault = true;
    if (typeof value === 'number') {
      valueIsDefault = value === (key.startsWith('scale') ? 1 : 0);
    } else {
      valueIsDefault = parseFloat(value) === 0;
    }
    if (!valueIsDefault) {
      transformIsDefault = false;
      const transformName = translateAlias$1[key] || key;
      const valueToRender = state.latest[key];
      transform += `${transformName}(${valueToRender}) `;
    }
  }
  return transformIsDefault ? 'none' : transform.trim();
}

const originProps = new Set(['originX', 'originY', 'originZ']);
const addStyleValue = (element, state, key, value) => {
  let render = undefined;
  let computed = undefined;
  if (transformProps.has(key)) {
    if (!state.get('transform')) {
      // If this is an HTML element, we need to set the transform-box to fill-box
      // to normalise the transform relative to the element's bounding box
      if (!isHTMLElement(element) && !state.get('transformBox')) {
        addStyleValue(element, state, 'transformBox', new MotionValue('fill-box'));
      }
      state.set('transform', new MotionValue('none'), () => {
        element.style.transform = buildTransform$1(state);
      });
    }
    computed = state.get('transform');
  } else if (originProps.has(key)) {
    if (!state.get('transformOrigin')) {
      state.set('transformOrigin', new MotionValue(''), () => {
        const originX = state.latest.originX ?? '50%';
        const originY = state.latest.originY ?? '50%';
        const originZ = state.latest.originZ ?? 0;
        element.style.transformOrigin = `${originX} ${originY} ${originZ}`;
      });
    }
    computed = state.get('transformOrigin');
  } else if (isCSSVar(key)) {
    render = () => {
      element.style.setProperty(key, state.latest[key]);
    };
  } else {
    render = () => {
      element.style[key] = state.latest[key];
    };
  }
  return state.set(key, value, render, computed);
};
const styleEffect = /*@__PURE__*/ createSelectorEffect(/*@__PURE__*/ createEffect(addStyleValue));

const toPx = px.transform;
function addSVGPathValue(element, state, key, value) {
  frame.render(() => element.setAttribute('pathLength', '1'));
  if (key === 'pathOffset') {
    return state.set(key, value, () => element.setAttribute('stroke-dashoffset', toPx(-state.latest[key])));
  } else {
    if (!state.get('stroke-dasharray')) {
      state.set('stroke-dasharray', new MotionValue('1 1'), () => {
        const {pathLength = 1, pathSpacing} = state.latest;
        element.setAttribute('stroke-dasharray', `${toPx(pathLength)} ${toPx(pathSpacing ?? 1 - Number(pathLength))}`);
      });
    }
    return state.set(key, value, undefined, state.get('stroke-dasharray'));
  }
}
const addSVGValue = (element, state, key, value) => {
  if (key.startsWith('path')) {
    return addSVGPathValue(element, state, key, value);
  } else if (key.startsWith('attr')) {
    return addAttrValue(element, state, convertAttrKey(key), value);
  }
  const handler = key in element.style ? addStyleValue : addAttrValue;
  return handler(element, state, key, value);
};
const svgEffect = /*@__PURE__*/ createSelectorEffect(/*@__PURE__*/ createEffect(addSVGValue));
function convertAttrKey(key) {
  return key.replace(/^attr([A-Z])/, (_, firstChar) => firstChar.toLowerCase());
}

const {schedule: microtask, cancel: cancelMicrotask} = /* @__PURE__ */ createRenderBatcher(queueMicrotask, false);

/**
 * Checks if an element is an SVG element in a way
 * that works across iframes
 */
function isSVGElement(element) {
  return isObject(element) && 'ownerSVGElement' in element;
}

const resizeHandlers = new WeakMap();
let observer;
const getSize = (borderBoxAxis, svgAxis, htmlAxis) => (target, borderBoxSize) => {
  if (borderBoxSize && borderBoxSize[0]) {
    return borderBoxSize[0][borderBoxAxis + 'Size'];
  } else if (isSVGElement(target) && 'getBBox' in target) {
    return target.getBBox()[svgAxis];
  } else {
    return target[htmlAxis];
  }
};
const getWidth = /*@__PURE__*/ getSize('inline', 'width', 'offsetWidth');
const getHeight = /*@__PURE__*/ getSize('block', 'height', 'offsetHeight');
function notifyTarget({target, borderBoxSize}) {
  resizeHandlers.get(target)?.forEach((handler) => {
    handler(target, {
      get width() {
        return getWidth(target, borderBoxSize);
      },
      get height() {
        return getHeight(target, borderBoxSize);
      },
    });
  });
}
function notifyAll(entries) {
  entries.forEach(notifyTarget);
}
function createResizeObserver() {
  if (typeof ResizeObserver === 'undefined') return;
  observer = new ResizeObserver(notifyAll);
}
function resizeElement(target, handler) {
  if (!observer) createResizeObserver();
  const elements = resolveElements(target);
  elements.forEach((element) => {
    let elementHandlers = resizeHandlers.get(element);
    if (!elementHandlers) {
      elementHandlers = new Set();
      resizeHandlers.set(element, elementHandlers);
    }
    elementHandlers.add(handler);
    observer?.observe(element);
  });
  return () => {
    elements.forEach((element) => {
      const elementHandlers = resizeHandlers.get(element);
      elementHandlers?.delete(handler);
      if (!elementHandlers?.size) {
        observer?.unobserve(element);
      }
    });
  };
}

const windowCallbacks = new Set();
let windowResizeHandler;
function createWindowResizeHandler() {
  windowResizeHandler = () => {
    const info = {
      get width() {
        return window.innerWidth;
      },
      get height() {
        return window.innerHeight;
      },
    };
    windowCallbacks.forEach((callback) => callback(info));
  };
  window.addEventListener('resize', windowResizeHandler);
}
function resizeWindow(callback) {
  windowCallbacks.add(callback);
  if (!windowResizeHandler) createWindowResizeHandler();
  return () => {
    windowCallbacks.delete(callback);
    if (!windowCallbacks.size && typeof windowResizeHandler === 'function') {
      window.removeEventListener('resize', windowResizeHandler);
      windowResizeHandler = undefined;
    }
  };
}

function resize(a, b) {
  return typeof a === 'function' ? resizeWindow(a) : resizeElement(a, b);
}

function observeTimeline(update, timeline) {
  let prevProgress;
  const onFrame = () => {
    const {currentTime} = timeline;
    const percentage = currentTime === null ? 0 : currentTime.value;
    const progress = percentage / 100;
    if (prevProgress !== progress) {
      update(progress);
    }
    prevProgress = progress;
  };
  frame.preUpdate(onFrame, true);
  return () => cancelFrame(onFrame);
}

/**
 * Checks if an element is specifically an SVGSVGElement (the root SVG element)
 * in a way that works across iframes
 */
function isSVGSVGElement(element) {
  return isSVGElement(element) && element.tagName === 'svg';
}

function getOriginIndex(from, total) {
  if (from === 'first') {
    return 0;
  } else {
    const lastIndex = total - 1;
    return from === 'last' ? lastIndex : lastIndex / 2;
  }
}
function stagger(duration = 0.1, {startDelay = 0, from = 0, ease} = {}) {
  return (i, total) => {
    const fromIndex = typeof from === 'number' ? from : getOriginIndex(from, total);
    const distance = Math.abs(fromIndex - i);
    let delay = duration * distance;
    if (ease) {
      const maxDelay = total * duration;
      const easingFunction = easingDefinitionToFunction(ease);
      delay = easingFunction(delay / maxDelay) * maxDelay;
    }
    return startDelay + delay;
  };
}

function transform(...args) {
  const useImmediate = !Array.isArray(args[0]);
  const argOffset = useImmediate ? 0 : -1;
  const inputValue = args[0 + argOffset];
  const inputRange = args[1 + argOffset];
  const outputRange = args[2 + argOffset];
  const options = args[3 + argOffset];
  const interpolator = interpolate(inputRange, outputRange, options);
  return useImmediate ? interpolator(inputValue) : interpolator;
}

function subscribeValue(inputValues, outputValue, getLatest) {
  const update = () => outputValue.set(getLatest());
  const scheduleUpdate = () => frame.preRender(update, false, true);
  const subscriptions = inputValues.map((v) => v.on('change', scheduleUpdate));
  outputValue.on('destroy', () => {
    subscriptions.forEach((unsubscribe) => unsubscribe());
    cancelFrame(update);
  });
}

/**
 * Create a `MotionValue` that transforms the output of other `MotionValue`s by
 * passing their latest values through a transform function.
 *
 * Whenever a `MotionValue` referred to in the provided function is updated,
 * it will be re-evaluated.
 *
 * ```jsx
 * const x = motionValue(0)
 * const y = transformValue(() => x.get() * 2) // double x
 * ```
 *
 * @param transformer - A transform function. This function must be pure with no side-effects or conditional statements.
 * @returns `MotionValue`
 *
 * @public
 */
function transformValue(transform) {
  const collectedValues = [];
  /**
   * Open session of collectMotionValues. Any MotionValue that calls get()
   * inside transform will be saved into this array.
   */
  collectMotionValues.current = collectedValues;
  const initialValue = transform();
  collectMotionValues.current = undefined;
  const value = motionValue(initialValue);
  subscribeValue(collectedValues, value, transform);
  return value;
}

/**
 * Create a `MotionValue` that maps the output of another `MotionValue` by
 * mapping it from one range of values into another.
 *
 * @remarks
 *
 * Given an input range of `[-200, -100, 100, 200]` and an output range of
 * `[0, 1, 1, 0]`, the returned `MotionValue` will:
 *
 * - When provided a value between `-200` and `-100`, will return a value between `0` and  `1`.
 * - When provided a value between `-100` and `100`, will return `1`.
 * - When provided a value between `100` and `200`, will return a value between `1` and  `0`
 *
 * The input range must be a linear series of numbers. The output range
 * can be any value type supported by Motion: numbers, colors, shadows, etc.
 *
 * Every value in the output range must be of the same type and in the same format.
 *
 * ```jsx
 * const x = motionValue(0)
 * const xRange = [-200, -100, 100, 200]
 * const opacityRange = [0, 1, 1, 0]
 * const opacity = mapValue(x, xRange, opacityRange)
 * ```
 *
 * @param inputValue - `MotionValue`
 * @param inputRange - A linear series of numbers (either all increasing or decreasing)
 * @param outputRange - A series of numbers, colors or strings. Must be the same length as `inputRange`.
 * @param options -
 *
 *  - clamp: boolean. Clamp values to within the given range. Defaults to `true`
 *  - ease: EasingFunction[]. Easing functions to use on the interpolations between each value in the input and output ranges. If provided as an array, the array must be one item shorter than the input and output ranges, as the easings apply to the transition between each.
 *
 * @returns `MotionValue`
 *
 * @public
 */
function mapValue(inputValue, inputRange, outputRange, options) {
  const map = transform(inputRange, outputRange, options);
  return transformValue(() => map(inputValue.get()));
}

const isMotionValue = (value) => Boolean(value && value.getVelocity);

/**
 * Create a `MotionValue` that animates to its latest value using a spring.
 * Can either be a value or track another `MotionValue`.
 *
 * ```jsx
 * const x = motionValue(0)
 * const y = transformValue(() => x.get() * 2) // double x
 * ```
 *
 * @param transformer - A transform function. This function must be pure with no side-effects or conditional statements.
 * @returns `MotionValue`
 *
 * @public
 */
function springValue(source, options) {
  const initialValue = isMotionValue(source) ? source.get() : source;
  const value = motionValue(initialValue);
  attachSpring(value, source, options);
  return value;
}
function attachSpring(value, source, options) {
  const initialValue = value.get();
  let activeAnimation = null;
  let latestValue = initialValue;
  let latestSetter;
  const unit = typeof initialValue === 'string' ? initialValue.replace(/[\d.-]/g, '') : undefined;
  const stopAnimation = () => {
    if (activeAnimation) {
      activeAnimation.stop();
      activeAnimation = null;
    }
  };
  const startAnimation = () => {
    stopAnimation();
    activeAnimation = new JSAnimation({
      keyframes: [asNumber(value.get()), asNumber(latestValue)],
      velocity: value.getVelocity(),
      type: 'spring',
      restDelta: 0.001,
      restSpeed: 0.01,
      ...options,
      onUpdate: latestSetter,
    });
  };
  value.attach((v, set) => {
    latestValue = v;
    latestSetter = (latest) => set(parseValue(latest, unit));
    frame.postRender(startAnimation);
  }, stopAnimation);
  if (isMotionValue(source)) {
    const removeSourceOnChange = source.on('change', (v) => value.set(parseValue(v, unit)));
    const removeValueOnDestroy = value.on('destroy', removeSourceOnChange);
    return () => {
      removeSourceOnChange();
      removeValueOnDestroy();
    };
  }
  return stopAnimation;
}
function parseValue(v, unit) {
  return unit ? v + unit : v;
}
function asNumber(v) {
  return typeof v === 'number' ? v : parseFloat(v);
}

/**
 * A list of all ValueTypes
 */
const valueTypes = [...dimensionValueTypes, color, complex];
/**
 * Tests a value against the list of ValueTypes
 */
const findValueType = (v) => valueTypes.find(testValueType(v));

function chooseLayerType(valueName) {
  if (valueName === 'layout') return 'group';
  if (valueName === 'enter' || valueName === 'new') return 'new';
  if (valueName === 'exit' || valueName === 'old') return 'old';
  return 'group';
}

let pendingRules = {};
let style = null;
const css = {
  set: (selector, values) => {
    pendingRules[selector] = values;
  },
  commit: () => {
    if (!style) {
      style = document.createElement('style');
      style.id = 'motion-view';
    }
    let cssText = '';
    for (const selector in pendingRules) {
      const rule = pendingRules[selector];
      cssText += `${selector} {\n`;
      for (const [property, value] of Object.entries(rule)) {
        cssText += `  ${property}: ${value};\n`;
      }
      cssText += '}\n';
    }
    style.textContent = cssText;
    document.head.appendChild(style);
    pendingRules = {};
  },
  remove: () => {
    if (style && style.parentElement) {
      style.parentElement.removeChild(style);
    }
  },
};

function getViewAnimationLayerInfo(pseudoElement) {
  const match = pseudoElement.match(/::view-transition-(old|new|group|image-pair)\((.*?)\)/);
  if (!match) return null;
  return {layer: match[2], type: match[1]};
}

function filterViewAnimations(animation) {
  const {effect} = animation;
  if (!effect) return false;
  return effect.target === document.documentElement && effect.pseudoElement?.startsWith('::view-transition');
}
function getViewAnimations() {
  return document.getAnimations().filter(filterViewAnimations);
}

function hasTarget(target, targets) {
  return targets.has(target) && Object.keys(targets.get(target)).length > 0;
}

const definitionNames = ['layout', 'enter', 'exit', 'new', 'old'];
function startViewAnimation(builder) {
  const {update, targets, options: defaultOptions} = builder;
  if (!document.startViewTransition) {
    return new Promise(async (resolve) => {
      await update();
      resolve(new GroupAnimation([]));
    });
  }
  // TODO: Go over existing targets and ensure they all have ids
  /**
   * If we don't have any animations defined for the root target,
   * remove it from being captured.
   */
  if (!hasTarget('root', targets)) {
    css.set(':root', {
      'view-transition-name': 'none',
    });
  }
  /**
   * Set the timing curve to linear for all view transition layers.
   * This gets baked into the keyframes, which can't be changed
   * without breaking the generated animation.
   *
   * This allows us to set easing via updateTiming - which can be changed.
   */
  css.set('::view-transition-group(*), ::view-transition-old(*), ::view-transition-new(*)', {
    'animation-timing-function': 'linear !important',
  });
  css.commit(); // Write
  const transition = document.startViewTransition(async () => {
    await update();
    // TODO: Go over new targets and ensure they all have ids
  });
  transition.finished.finally(() => {
    css.remove(); // Write
  });
  return new Promise((resolve) => {
    transition.ready.then(() => {
      const generatedViewAnimations = getViewAnimations();
      const animations = [];
      /**
       * Create animations for each of our explicitly-defined subjects.
       */
      targets.forEach((definition, target) => {
        // TODO: If target is not "root", resolve elements
        // and iterate over each
        for (const key of definitionNames) {
          if (!definition[key]) continue;
          const {keyframes, options} = definition[key];
          for (let [valueName, valueKeyframes] of Object.entries(keyframes)) {
            if (!valueKeyframes) continue;
            const valueOptions = {
              ...getValueTransition$1(defaultOptions, valueName),
              ...getValueTransition$1(options, valueName),
            };
            const type = chooseLayerType(key);
            /**
             * If this is an opacity animation, and keyframes are not an array,
             * we need to convert them into an array and set an initial value.
             */
            if (valueName === 'opacity' && !Array.isArray(valueKeyframes)) {
              const initialValue = type === 'new' ? 0 : 1;
              valueKeyframes = [initialValue, valueKeyframes];
            }
            /**
             * Resolve stagger function if provided.
             */
            if (typeof valueOptions.delay === 'function') {
              valueOptions.delay = valueOptions.delay(0, 1);
            }
            valueOptions.duration && (valueOptions.duration = secondsToMilliseconds(valueOptions.duration));
            valueOptions.delay && (valueOptions.delay = secondsToMilliseconds(valueOptions.delay));
            const animation = new NativeAnimation({
              ...valueOptions,
              element: document.documentElement,
              name: valueName,
              pseudoElement: `::view-transition-${type}(${target})`,
              keyframes: valueKeyframes,
            });
            animations.push(animation);
          }
        }
      });
      /**
       * Handle browser generated animations
       */
      for (const animation of generatedViewAnimations) {
        if (animation.playState === 'finished') continue;
        const {effect} = animation;
        if (!effect || !(effect instanceof KeyframeEffect)) continue;
        const {pseudoElement} = effect;
        if (!pseudoElement) continue;
        const name = getViewAnimationLayerInfo(pseudoElement);
        if (!name) continue;
        const targetDefinition = targets.get(name.layer);
        if (!targetDefinition) {
          /**
           * If transition name is group then update the timing of the animation
           * whereas if it's old or new then we could possibly replace it using
           * the above method.
           */
          const transitionName = name.type === 'group' ? 'layout' : '';
          let animationTransition = {
            ...getValueTransition$1(defaultOptions, transitionName),
          };
          animationTransition.duration &&
            (animationTransition.duration = secondsToMilliseconds(animationTransition.duration));
          animationTransition = applyGeneratorOptions(animationTransition);
          const easing = mapEasingToNativeEasing(animationTransition.ease, animationTransition.duration);
          effect.updateTiming({
            delay: secondsToMilliseconds(animationTransition.delay ?? 0),
            duration: animationTransition.duration,
            easing,
          });
          animations.push(new NativeAnimationWrapper(animation));
        } else if (
          hasOpacity(targetDefinition, 'enter') &&
          hasOpacity(targetDefinition, 'exit') &&
          effect.getKeyframes().some((keyframe) => keyframe.mixBlendMode)
        ) {
          animations.push(new NativeAnimationWrapper(animation));
        } else {
          animation.cancel();
        }
      }
      resolve(new GroupAnimation(animations));
    });
  });
}
function hasOpacity(target, key) {
  return target?.[key]?.keyframes.opacity;
}

let builders = [];
let current = null;
function next() {
  current = null;
  const [nextBuilder] = builders;
  if (nextBuilder) start(nextBuilder);
}
function start(builder) {
  removeItem(builders, builder);
  current = builder;
  startViewAnimation(builder).then((animation) => {
    builder.notifyReady(animation);
    animation.finished.finally(next);
  });
}
function processQueue() {
  /**
   * Iterate backwards over the builders array. We can ignore the
   * "wait" animations. If we have an interrupting animation in the
   * queue then we need to batch all preceeding animations into it.
   * Currently this only batches the update functions but will also
   * need to batch the targets.
   */
  for (let i = builders.length - 1; i >= 0; i--) {
    const builder = builders[i];
    const {interrupt} = builder.options;
    if (interrupt === 'immediate') {
      const batchedUpdates = builders.slice(0, i + 1).map((b) => b.update);
      const remaining = builders.slice(i + 1);
      builder.update = () => {
        batchedUpdates.forEach((update) => update());
      };
      // Put the current builder at the front, followed by any "wait" builders
      builders = [builder, ...remaining];
      break;
    }
  }
  if (!current || builders[0]?.options.interrupt === 'immediate') {
    next();
  }
}
function addToQueue(builder) {
  builders.push(builder);
  microtask.render(processQueue);
}

class ViewTransitionBuilder {
  constructor(update, options = {}) {
    this.currentSubject = 'root';
    this.targets = new Map();
    this.notifyReady = noop;
    this.readyPromise = new Promise((resolve) => {
      this.notifyReady = resolve;
    });
    this.update = update;
    this.options = {
      interrupt: 'wait',
      ...options,
    };
    addToQueue(this);
  }
  get(subject) {
    this.currentSubject = subject;
    return this;
  }
  layout(keyframes, options) {
    this.updateTarget('layout', keyframes, options);
    return this;
  }
  new(keyframes, options) {
    this.updateTarget('new', keyframes, options);
    return this;
  }
  old(keyframes, options) {
    this.updateTarget('old', keyframes, options);
    return this;
  }
  enter(keyframes, options) {
    this.updateTarget('enter', keyframes, options);
    return this;
  }
  exit(keyframes, options) {
    this.updateTarget('exit', keyframes, options);
    return this;
  }
  crossfade(options) {
    this.updateTarget('enter', {opacity: 1}, options);
    this.updateTarget('exit', {opacity: 0}, options);
    return this;
  }
  updateTarget(target, keyframes, options = {}) {
    const {currentSubject, targets} = this;
    if (!targets.has(currentSubject)) {
      targets.set(currentSubject, {});
    }
    const targetData = targets.get(currentSubject);
    targetData[target] = {keyframes, options};
  }
  then(resolve, reject) {
    return this.readyPromise.then(resolve, reject);
  }
}
function animateView(update, defaultOptions = {}) {
  return new ViewTransitionBuilder(update, defaultOptions);
}

function isDOMKeyframes(keyframes) {
  return typeof keyframes === 'object' && !Array.isArray(keyframes);
}

function resolveSubjects(subject, keyframes, scope, selectorCache) {
  if (typeof subject === 'string' && isDOMKeyframes(keyframes)) {
    return resolveElements(subject, scope, selectorCache);
  } else if (subject instanceof NodeList) {
    return Array.from(subject);
  } else if (Array.isArray(subject)) {
    return subject;
  } else {
    return [subject];
  }
}

function calculateRepeatDuration(duration, repeat, _repeatDelay) {
  return duration * (repeat + 1);
}

/**
 * Given a absolute or relative time definition and current/prev time state of the sequence,
 * calculate an absolute time for the next keyframes.
 */
function calcNextTime(current, next, prev, labels) {
  if (typeof next === 'number') {
    return next;
  } else if (next.startsWith('-') || next.startsWith('+')) {
    return Math.max(0, current + parseFloat(next));
  } else if (next === '<') {
    return prev;
  } else if (next.startsWith('<')) {
    return Math.max(0, prev + parseFloat(next.slice(1)));
  } else {
    return labels.get(next) ?? current;
  }
}

function eraseKeyframes(sequence, startTime, endTime) {
  for (let i = 0; i < sequence.length; i++) {
    const keyframe = sequence[i];
    if (keyframe.at > startTime && keyframe.at < endTime) {
      removeItem(sequence, keyframe);
      // If we remove this item we have to push the pointer back one
      i--;
    }
  }
}
function addKeyframes(sequence, keyframes, easing, offset, startTime, endTime) {
  /**
   * Erase every existing value between currentTime and targetTime,
   * this will essentially splice this timeline into any currently
   * defined ones.
   */
  eraseKeyframes(sequence, startTime, endTime);
  for (let i = 0; i < keyframes.length; i++) {
    sequence.push({
      value: keyframes[i],
      at: mixNumber$1(startTime, endTime, offset[i]),
      easing: getEasingForSegment(easing, i),
    });
  }
}

/**
 * Take an array of times that represent repeated keyframes. For instance
 * if we have original times of [0, 0.5, 1] then our repeated times will
 * be [0, 0.5, 1, 1, 1.5, 2]. Loop over the times and scale them back
 * down to a 0-1 scale.
 */
function normalizeTimes(times, repeat) {
  for (let i = 0; i < times.length; i++) {
    times[i] = times[i] / (repeat + 1);
  }
}

function compareByTime(a, b) {
  if (a.at === b.at) {
    if (a.value === null) return 1;
    if (b.value === null) return -1;
    return 0;
  } else {
    return a.at - b.at;
  }
}

const defaultSegmentEasing = 'easeInOut';
const MAX_REPEAT = 20;
function createAnimationsFromSequence(
  sequence,
  {defaultTransition = {}, ...sequenceTransition} = {},
  scope,
  generators,
) {
  const defaultDuration = defaultTransition.duration || 0.3;
  const animationDefinitions = new Map();
  const sequences = new Map();
  const elementCache = {};
  const timeLabels = new Map();
  let prevTime = 0;
  let currentTime = 0;
  let totalDuration = 0;
  /**
   * Build the timeline by mapping over the sequence array and converting
   * the definitions into keyframes and offsets with absolute time values.
   * These will later get converted into relative offsets in a second pass.
   */
  for (let i = 0; i < sequence.length; i++) {
    const segment = sequence[i];
    /**
     * If this is a timeline label, mark it and skip the rest of this iteration.
     */
    if (typeof segment === 'string') {
      timeLabels.set(segment, currentTime);
      continue;
    } else if (!Array.isArray(segment)) {
      timeLabels.set(segment.name, calcNextTime(currentTime, segment.at, prevTime, timeLabels));
      continue;
    }
    let [subject, keyframes, transition = {}] = segment;
    /**
     * If a relative or absolute time value has been specified we need to resolve
     * it in relation to the currentTime.
     */
    if (transition.at !== undefined) {
      currentTime = calcNextTime(currentTime, transition.at, prevTime, timeLabels);
    }
    /**
     * Keep track of the maximum duration in this definition. This will be
     * applied to currentTime once the definition has been parsed.
     */
    let maxDuration = 0;
    const resolveValueSequence = (
      valueKeyframes,
      valueTransition,
      valueSequence,
      elementIndex = 0,
      numSubjects = 0,
    ) => {
      const valueKeyframesAsList = keyframesAsList(valueKeyframes);
      const {
        delay = 0,
        times = defaultOffset$1(valueKeyframesAsList),
        type = 'keyframes',
        repeat,
        repeatType,
        repeatDelay = 0,
        ...remainingTransition
      } = valueTransition;
      let {ease = defaultTransition.ease || 'easeOut', duration} = valueTransition;
      /**
       * Resolve stagger() if defined.
       */
      const calculatedDelay = typeof delay === 'function' ? delay(elementIndex, numSubjects) : delay;
      /**
       * If this animation should and can use a spring, generate a spring easing function.
       */
      const numKeyframes = valueKeyframesAsList.length;
      const createGenerator = isGenerator(type) ? type : generators?.[type || 'keyframes'];
      if (numKeyframes <= 2 && createGenerator) {
        /**
         * As we're creating an easing function from a spring,
         * ideally we want to generate it using the real distance
         * between the two keyframes. However this isn't always
         * possible - in these situations we use 0-100.
         */
        let absoluteDelta = 100;
        if (numKeyframes === 2 && isNumberKeyframesArray(valueKeyframesAsList)) {
          const delta = valueKeyframesAsList[1] - valueKeyframesAsList[0];
          absoluteDelta = Math.abs(delta);
        }
        const springTransition = {...remainingTransition};
        if (duration !== undefined) {
          springTransition.duration = secondsToMilliseconds(duration);
        }
        const springEasing = createGeneratorEasing(springTransition, absoluteDelta, createGenerator);
        ease = springEasing.ease;
        duration = springEasing.duration;
      }
      duration ?? (duration = defaultDuration);
      const startTime = currentTime + calculatedDelay;
      /**
       * If there's only one time offset of 0, fill in a second with length 1
       */
      if (times.length === 1 && times[0] === 0) {
        times[1] = 1;
      }
      /**
       * Fill out if offset if fewer offsets than keyframes
       */
      const remainder = times.length - valueKeyframesAsList.length;
      remainder > 0 && fillOffset(times, remainder);
      /**
       * If only one value has been set, ie [1], push a null to the start of
       * the keyframe array. This will let us mark a keyframe at this point
       * that will later be hydrated with the previous value.
       */
      valueKeyframesAsList.length === 1 && valueKeyframesAsList.unshift(null);
      /**
       * Handle repeat options
       */
      if (repeat) {
        invariant(repeat < MAX_REPEAT, 'Repeat count too high, must be less than 20', 'repeat-count-high');
        duration = calculateRepeatDuration(duration, repeat);
        const originalKeyframes = [...valueKeyframesAsList];
        const originalTimes = [...times];
        ease = Array.isArray(ease) ? [...ease] : [ease];
        const originalEase = [...ease];
        for (let repeatIndex = 0; repeatIndex < repeat; repeatIndex++) {
          valueKeyframesAsList.push(...originalKeyframes);
          for (let keyframeIndex = 0; keyframeIndex < originalKeyframes.length; keyframeIndex++) {
            times.push(originalTimes[keyframeIndex] + (repeatIndex + 1));
            ease.push(keyframeIndex === 0 ? 'linear' : getEasingForSegment(originalEase, keyframeIndex - 1));
          }
        }
        normalizeTimes(times, repeat);
      }
      const targetTime = startTime + duration;
      /**
       * Add keyframes, mapping offsets to absolute time.
       */
      addKeyframes(valueSequence, valueKeyframesAsList, ease, times, startTime, targetTime);
      maxDuration = Math.max(calculatedDelay + duration, maxDuration);
      totalDuration = Math.max(targetTime, totalDuration);
    };
    if (isMotionValue(subject)) {
      const subjectSequence = getSubjectSequence(subject, sequences);
      resolveValueSequence(keyframes, transition, getValueSequence('default', subjectSequence));
    } else {
      const subjects = resolveSubjects(subject, keyframes, scope, elementCache);
      const numSubjects = subjects.length;
      /**
       * For every element in this segment, process the defined values.
       */
      for (let subjectIndex = 0; subjectIndex < numSubjects; subjectIndex++) {
        /**
         * Cast necessary, but we know these are of this type
         */
        keyframes = keyframes;
        transition = transition;
        const thisSubject = subjects[subjectIndex];
        const subjectSequence = getSubjectSequence(thisSubject, sequences);
        for (const key in keyframes) {
          resolveValueSequence(
            keyframes[key],
            getValueTransition(transition, key),
            getValueSequence(key, subjectSequence),
            subjectIndex,
            numSubjects,
          );
        }
      }
    }
    prevTime = currentTime;
    currentTime += maxDuration;
  }
  /**
   * For every element and value combination create a new animation.
   */
  sequences.forEach((valueSequences, element) => {
    for (const key in valueSequences) {
      const valueSequence = valueSequences[key];
      /**
       * Arrange all the keyframes in ascending time order.
       */
      valueSequence.sort(compareByTime);
      const keyframes = [];
      const valueOffset = [];
      const valueEasing = [];
      /**
       * For each keyframe, translate absolute times into
       * relative offsets based on the total duration of the timeline.
       */
      for (let i = 0; i < valueSequence.length; i++) {
        const {at, value, easing} = valueSequence[i];
        keyframes.push(value);
        valueOffset.push(progress(0, totalDuration, at));
        valueEasing.push(easing || 'easeOut');
      }
      /**
       * If the first keyframe doesn't land on offset: 0
       * provide one by duplicating the initial keyframe. This ensures
       * it snaps to the first keyframe when the animation starts.
       */
      if (valueOffset[0] !== 0) {
        valueOffset.unshift(0);
        keyframes.unshift(keyframes[0]);
        valueEasing.unshift(defaultSegmentEasing);
      }
      /**
       * If the last keyframe doesn't land on offset: 1
       * provide one with a null wildcard value. This will ensure it
       * stays static until the end of the animation.
       */
      if (valueOffset[valueOffset.length - 1] !== 1) {
        valueOffset.push(1);
        keyframes.push(null);
      }
      if (!animationDefinitions.has(element)) {
        animationDefinitions.set(element, {
          keyframes: {},
          transition: {},
        });
      }
      const definition = animationDefinitions.get(element);
      definition.keyframes[key] = keyframes;
      definition.transition[key] = {
        ...defaultTransition,
        duration: totalDuration,
        ease: valueEasing,
        times: valueOffset,
        ...sequenceTransition,
      };
    }
  });
  return animationDefinitions;
}
function getSubjectSequence(subject, sequences) {
  !sequences.has(subject) && sequences.set(subject, {});
  return sequences.get(subject);
}
function getValueSequence(name, sequences) {
  if (!sequences[name]) sequences[name] = [];
  return sequences[name];
}
function keyframesAsList(keyframes) {
  return Array.isArray(keyframes) ? keyframes : [keyframes];
}
function getValueTransition(transition, key) {
  return transition && transition[key]
    ? {
        ...transition,
        ...transition[key],
      }
    : {...transition};
}
const isNumber = (keyframe) => typeof keyframe === 'number';
const isNumberKeyframesArray = (keyframes) => keyframes.every(isNumber);

const visualElementStore = new WeakMap();

const isKeyframesTarget = (v) => {
  return Array.isArray(v);
};

function getValueState(visualElement) {
  const state = [{}, {}];
  visualElement?.values.forEach((value, key) => {
    state[0][key] = value.get();
    state[1][key] = value.getVelocity();
  });
  return state;
}
function resolveVariantFromProps(props, definition, custom, visualElement) {
  /**
   * If the variant definition is a function, resolve.
   */
  if (typeof definition === 'function') {
    const [current, velocity] = getValueState(visualElement);
    definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
  }
  /**
   * If the variant definition is a variant label, or
   * the function returned a variant label, resolve.
   */
  if (typeof definition === 'string') {
    definition = props.variants && props.variants[definition];
  }
  /**
   * At this point we've resolved both functions and variant labels,
   * but the resolved variant label might itself have been a function.
   * If so, resolve. This can only have returned a valid target object.
   */
  if (typeof definition === 'function') {
    const [current, velocity] = getValueState(visualElement);
    definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
  }
  return definition;
}

function resolveVariant(visualElement, definition, custom) {
  const props = visualElement.getProps();
  return resolveVariantFromProps(props, definition, props.custom, visualElement);
}

/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */
function setMotionValue(visualElement, key, value) {
  if (visualElement.hasValue(key)) {
    visualElement.getValue(key).set(value);
  } else {
    visualElement.addValue(key, motionValue(value));
  }
}
function resolveFinalValueInKeyframes(v) {
  // TODO maybe throw if v.length - 1 is placeholder token?
  return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
}
function setTarget(visualElement, definition) {
  const resolved = resolveVariant(visualElement, definition);
  let {transitionEnd = {}, transition = {}, ...target} = resolved || {};
  target = {...target, ...transitionEnd};
  for (const key in target) {
    const value = resolveFinalValueInKeyframes(target[key]);
    setMotionValue(visualElement, key, value);
  }
}

function isWillChangeMotionValue(value) {
  return Boolean(isMotionValue(value) && value.add);
}

function addValueToWillChange(visualElement, key) {
  const willChange = visualElement.getValue('willChange');
  /**
   * It could be that a user has set willChange to a regular MotionValue,
   * in which case we can't add the value to it.
   */
  if (isWillChangeMotionValue(willChange)) {
    return willChange.add(key);
  } else if (!willChange && MotionGlobalConfig.WillChange) {
    const newWillChange = new MotionGlobalConfig.WillChange('auto');
    visualElement.addValue('willChange', newWillChange);
    newWillChange.add(key);
  }
}

/**
 * Convert camelCase to dash-case properties.
 */
const camelToDash = (str) => str.replace(/([a-z])([A-Z])/gu, '$1-$2').toLowerCase();

const optimizedAppearDataId = 'framerAppearId';
const optimizedAppearDataAttribute = 'data-' + camelToDash(optimizedAppearDataId);

function getOptimisedAppearId(visualElement) {
  return visualElement.props[optimizedAppearDataAttribute];
}

const isNotNull = (value) => value !== null;
function getFinalKeyframe(keyframes, {repeat, repeatType = 'loop'}, finalKeyframe) {
  const resolvedKeyframes = keyframes.filter(isNotNull);
  const index = repeat && repeatType !== 'loop' && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
  return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}

const underDampedSpring = {
  type: 'spring',
  stiffness: 500,
  damping: 25,
  restSpeed: 10,
};
const criticallyDampedSpring = (target) => ({
  type: 'spring',
  stiffness: 550,
  damping: target === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10,
});
const keyframesTransition = {
  type: 'keyframes',
  duration: 0.8,
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */
const ease = {
  type: 'keyframes',
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3,
};
const getDefaultTransition = (valueKey, {keyframes}) => {
  if (keyframes.length > 2) {
    return keyframesTransition;
  } else if (transformProps.has(valueKey)) {
    return valueKey.startsWith('scale') ? criticallyDampedSpring(keyframes[1]) : underDampedSpring;
  }
  return ease;
};

/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */
function isTransitionDefined({
  when,
  delay: _delay,
  delayChildren,
  staggerChildren,
  staggerDirection,
  repeat,
  repeatType,
  repeatDelay,
  from,
  elapsed,
  ...transition
}) {
  return !!Object.keys(transition).length;
}

const animateMotionValue =
  (name, value, target, transition = {}, element, isHandoff) =>
  (onComplete) => {
    const valueTransition = getValueTransition$1(transition, name) || {};
    /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */
    const delay = valueTransition.delay || transition.delay || 0;
    /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */
    let {elapsed = 0} = transition;
    elapsed = elapsed - secondsToMilliseconds(delay);
    const options = {
      keyframes: Array.isArray(target) ? target : [null, target],
      ease: 'easeOut',
      velocity: value.getVelocity(),
      ...valueTransition,
      delay: -elapsed,
      onUpdate: (v) => {
        value.set(v);
        valueTransition.onUpdate && valueTransition.onUpdate(v);
      },
      onComplete: () => {
        onComplete();
        valueTransition.onComplete && valueTransition.onComplete();
      },
      name,
      motionValue: value,
      element: isHandoff ? undefined : element,
    };
    /**
     * If there's no transition defined for this value, we can generate
     * unique transition settings for this value.
     */
    if (!isTransitionDefined(valueTransition)) {
      Object.assign(options, getDefaultTransition(name, options));
    }
    /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */
    options.duration && (options.duration = secondsToMilliseconds(options.duration));
    options.repeatDelay && (options.repeatDelay = secondsToMilliseconds(options.repeatDelay));
    /**
     * Support deprecated way to set initial value. Prefer keyframe syntax.
     */
    if (options.from !== undefined) {
      options.keyframes[0] = options.from;
    }
    let shouldSkip = false;
    if (options.type === false || (options.duration === 0 && !options.repeatDelay)) {
      makeAnimationInstant(options);
      if (options.delay === 0) {
        shouldSkip = true;
      }
    }
    if (MotionGlobalConfig.instantAnimations || MotionGlobalConfig.skipAnimations) {
      shouldSkip = true;
      makeAnimationInstant(options);
      options.delay = 0;
    }
    /**
     * If the transition type or easing has been explicitly set by the user
     * then we don't want to allow flattening the animation.
     */
    options.allowFlatten = !valueTransition.type && !valueTransition.ease;
    /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */
    if (shouldSkip && !isHandoff && value.get() !== undefined) {
      const finalKeyframe = getFinalKeyframe(options.keyframes, valueTransition);
      if (finalKeyframe !== undefined) {
        frame.update(() => {
          options.onUpdate(finalKeyframe);
          options.onComplete();
        });
        return;
      }
    }
    return valueTransition.isSync ? new JSAnimation(options) : new AsyncMotionValueAnimation(options);
  };

/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */
function shouldBlockAnimation({protectedKeys, needsAnimating}, key) {
  const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
  needsAnimating[key] = false;
  return shouldBlock;
}
function animateTarget(visualElement, targetAndTransition, {delay = 0, transitionOverride, type} = {}) {
  let {transition = visualElement.getDefaultTransition(), transitionEnd, ...target} = targetAndTransition;
  if (transitionOverride) transition = transitionOverride;
  const animations = [];
  const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
  for (const key in target) {
    const value = visualElement.getValue(key, visualElement.latestValues[key] ?? null);
    const valueTarget = target[key];
    if (valueTarget === undefined || (animationTypeState && shouldBlockAnimation(animationTypeState, key))) {
      continue;
    }
    const valueTransition = {
      delay,
      ...getValueTransition$1(transition || {}, key),
    };
    /**
     * If the value is already at the defined target, skip the animation.
     */
    const currentValue = value.get();
    if (
      currentValue !== undefined &&
      !value.isAnimating &&
      !Array.isArray(valueTarget) &&
      valueTarget === currentValue &&
      !valueTransition.velocity
    ) {
      continue;
    }
    /**
     * If this is the first time a value is being animated, check
     * to see if we're handling off from an existing animation.
     */
    let isHandoff = false;
    if (window.MotionHandoffAnimation) {
      const appearId = getOptimisedAppearId(visualElement);
      if (appearId) {
        const startTime = window.MotionHandoffAnimation(appearId, key, frame);
        if (startTime !== null) {
          valueTransition.startTime = startTime;
          isHandoff = true;
        }
      }
    }
    addValueToWillChange(visualElement, key);
    value.start(
      animateMotionValue(
        key,
        value,
        valueTarget,
        visualElement.shouldReduceMotion && positionalKeys.has(key) ? {type: false} : valueTransition,
        visualElement,
        isHandoff,
      ),
    );
    const animation = value.animation;
    if (animation) {
      animations.push(animation);
    }
  }
  if (transitionEnd) {
    Promise.all(animations).then(() => {
      frame.update(() => {
        transitionEnd && setTarget(visualElement, transitionEnd);
      });
    });
  }
  return animations;
}

/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */
function convertBoundingBoxToBox({top, left, right, bottom}) {
  return {
    x: {min: left, max: right},
    y: {min: top, max: bottom},
  };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */
function transformBoxPoints(point, transformPoint) {
  if (!transformPoint) return point;
  const topLeft = transformPoint({x: point.left, y: point.top});
  const bottomRight = transformPoint({x: point.right, y: point.bottom});
  return {
    top: topLeft.y,
    left: topLeft.x,
    bottom: bottomRight.y,
    right: bottomRight.x,
  };
}

function measureViewportBox(instance, transformPoint) {
  return convertBoundingBoxToBox(transformBoxPoints(instance.getBoundingClientRect(), transformPoint));
}

const featureProps = {
  animation: ['animate', 'variants', 'whileHover', 'whileTap', 'exit', 'whileInView', 'whileFocus', 'whileDrag'],
  exit: ['exit'],
  drag: ['drag', 'dragControls'],
  focus: ['whileFocus'],
  hover: ['whileHover', 'onHoverStart', 'onHoverEnd'],
  tap: ['whileTap', 'onTap', 'onTapStart', 'onTapCancel'],
  pan: ['onPan', 'onPanStart', 'onPanSessionStart', 'onPanEnd'],
  inView: ['whileInView', 'onViewportEnter', 'onViewportLeave'],
  layout: ['layout', 'layoutId'],
};
const featureDefinitions = {};
for (const key in featureProps) {
  featureDefinitions[key] = {
    isEnabled: (props) => featureProps[key].some((name) => !!props[name]),
  };
}

const createAxis = () => ({min: 0, max: 0});
const createBox = () => ({
  x: createAxis(),
  y: createAxis(),
});

const isBrowser = typeof window !== 'undefined';

// Does this device prefer reduced motion? Returns `null` server-side.
const prefersReducedMotion = {current: null};
const hasReducedMotionListener = {current: false};

function initPrefersReducedMotion() {
  hasReducedMotionListener.current = true;
  if (!isBrowser) return;
  if (window.matchMedia) {
    const motionMediaQuery = window.matchMedia('(prefers-reduced-motion)');
    const setReducedMotionPreferences = () => (prefersReducedMotion.current = motionMediaQuery.matches);
    motionMediaQuery.addEventListener('change', setReducedMotionPreferences);
    setReducedMotionPreferences();
  } else {
    prefersReducedMotion.current = false;
  }
}

function isAnimationControls(v) {
  return v !== null && typeof v === 'object' && typeof v.start === 'function';
}

/**
 * Decides if the supplied variable is variant label
 */
function isVariantLabel(v) {
  return typeof v === 'string' || Array.isArray(v);
}

const variantPriorityOrder = ['animate', 'whileInView', 'whileFocus', 'whileHover', 'whileTap', 'whileDrag', 'exit'];
const variantProps = ['initial', ...variantPriorityOrder];

function isControllingVariants(props) {
  return isAnimationControls(props.animate) || variantProps.some((name) => isVariantLabel(props[name]));
}
function isVariantNode(props) {
  return Boolean(isControllingVariants(props) || props.variants);
}

function updateMotionValuesFromProps(element, next, prev) {
  for (const key in next) {
    const nextValue = next[key];
    const prevValue = prev[key];
    if (isMotionValue(nextValue)) {
      /**
       * If this is a motion value found in props or style, we want to add it
       * to our visual element's motion value map.
       */
      element.addValue(key, nextValue);
    } else if (isMotionValue(prevValue)) {
      /**
       * If we're swapping from a motion value to a static value,
       * create a new motion value from that
       */
      element.addValue(key, motionValue(nextValue, {owner: element}));
    } else if (prevValue !== nextValue) {
      /**
       * If this is a flat value that has changed, update the motion value
       * or create one if it doesn't exist. We only want to do this if we're
       * not handling the value with our animation state.
       */
      if (element.hasValue(key)) {
        const existingValue = element.getValue(key);
        if (existingValue.liveStyle === true) {
          existingValue.jump(nextValue);
        } else if (!existingValue.hasAnimated) {
          existingValue.set(nextValue);
        }
      } else {
        const latestValue = element.getStaticValue(key);
        element.addValue(key, motionValue(latestValue !== undefined ? latestValue : nextValue, {owner: element}));
      }
    }
  }
  // Handle removed values
  for (const key in prev) {
    if (next[key] === undefined) element.removeValue(key);
  }
  return next;
}

const propEventHandlers = [
  'AnimationStart',
  'AnimationComplete',
  'Update',
  'BeforeLayoutMeasure',
  'LayoutMeasure',
  'LayoutAnimationStart',
  'LayoutAnimationComplete',
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */
class VisualElement {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
    return {};
  }
  constructor({parent, props, presenceContext, reducedMotionConfig, blockInitialAnimation, visualState}, options = {}) {
    /**
     * A reference to the current underlying Instance, e.g. a HTMLElement
     * or Three.Mesh etc.
     */
    this.current = null;
    /**
     * A set containing references to this VisualElement's children.
     */
    this.children = new Set();
    /**
     * Determine what role this visual element should take in the variant tree.
     */
    this.isVariantNode = false;
    this.isControllingVariants = false;
    /**
     * Decides whether this VisualElement should animate in reduced motion
     * mode.
     *
     * TODO: This is currently set on every individual VisualElement but feels
     * like it could be set globally.
     */
    this.shouldReduceMotion = null;
    /**
     * A map of all motion values attached to this visual element. Motion
     * values are source of truth for any given animated value. A motion
     * value might be provided externally by the component via props.
     */
    this.values = new Map();
    this.KeyframeResolver = KeyframeResolver;
    /**
     * Cleanup functions for active features (hover/tap/exit etc)
     */
    this.features = {};
    /**
     * A map of every subscription that binds the provided or generated
     * motion values onChange listeners to this visual element.
     */
    this.valueSubscriptions = new Map();
    /**
     * A reference to the previously-provided motion values as returned
     * from scrapeMotionValuesFromProps. We use the keys in here to determine
     * if any motion values need to be removed after props are updated.
     */
    this.prevMotionValues = {};
    /**
     * An object containing a SubscriptionManager for each active event.
     */
    this.events = {};
    /**
     * An object containing an unsubscribe function for each prop event subscription.
     * For example, every "Update" event can have multiple subscribers via
     * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
     */
    this.propEventSubscriptions = {};
    this.notifyUpdate = () => this.notify('Update', this.latestValues);
    this.render = () => {
      if (!this.current) return;
      this.triggerBuild();
      this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
    };
    this.renderScheduledAt = 0.0;
    this.scheduleRender = () => {
      const now = time.now();
      if (this.renderScheduledAt < now) {
        this.renderScheduledAt = now;
        frame.render(this.render, false, true);
      }
    };
    const {latestValues, renderState} = visualState;
    this.latestValues = latestValues;
    this.baseTarget = {...latestValues};
    this.initialValues = props.initial ? {...latestValues} : {};
    this.renderState = renderState;
    this.parent = parent;
    this.props = props;
    this.presenceContext = presenceContext;
    this.depth = parent ? parent.depth + 1 : 0;
    this.reducedMotionConfig = reducedMotionConfig;
    this.options = options;
    this.blockInitialAnimation = Boolean(blockInitialAnimation);
    this.isControllingVariants = isControllingVariants(props);
    this.isVariantNode = isVariantNode(props);
    if (this.isVariantNode) {
      this.variantChildren = new Set();
    }
    this.manuallyAnimateOnMount = Boolean(parent && parent.current);
    /**
     * Any motion values that are provided to the element when created
     * aren't yet bound to the element, as this would technically be impure.
     * However, we iterate through the motion values and set them to the
     * initial values for this component.
     *
     * TODO: This is impure and we should look at changing this to run on mount.
     * Doing so will break some tests but this isn't necessarily a breaking change,
     * more a reflection of the test.
     */
    const {willChange, ...initialMotionValues} = this.scrapeMotionValuesFromProps(props, {}, this);
    for (const key in initialMotionValues) {
      const value = initialMotionValues[key];
      if (latestValues[key] !== undefined && isMotionValue(value)) {
        value.set(latestValues[key]);
      }
    }
  }
  mount(instance) {
    this.current = instance;
    visualElementStore.set(instance, this);
    if (this.projection && !this.projection.instance) {
      this.projection.mount(instance);
    }
    if (this.parent && this.isVariantNode && !this.isControllingVariants) {
      this.removeFromVariantTree = this.parent.addVariantChild(this);
    }
    this.values.forEach((value, key) => this.bindToMotionValue(key, value));
    if (!hasReducedMotionListener.current) {
      initPrefersReducedMotion();
    }
    this.shouldReduceMotion =
      this.reducedMotionConfig === 'never'
        ? false
        : this.reducedMotionConfig === 'always'
          ? true
          : prefersReducedMotion.current;
    if (process.env.NODE_ENV !== 'production') {
      warnOnce(
        this.shouldReduceMotion !== true,
        'You have Reduced Motion enabled on your device. Animations may not appear as expected.',
        'reduced-motion-disabled',
      );
    }
    this.parent?.addChild(this);
    this.update(this.props, this.presenceContext);
  }
  unmount() {
    this.projection && this.projection.unmount();
    cancelFrame(this.notifyUpdate);
    cancelFrame(this.render);
    this.valueSubscriptions.forEach((remove) => remove());
    this.valueSubscriptions.clear();
    this.removeFromVariantTree && this.removeFromVariantTree();
    this.parent?.removeChild(this);
    for (const key in this.events) {
      this.events[key].clear();
    }
    for (const key in this.features) {
      const feature = this.features[key];
      if (feature) {
        feature.unmount();
        feature.isMounted = false;
      }
    }
    this.current = null;
  }
  addChild(child) {
    this.children.add(child);
    this.enteringChildren ?? (this.enteringChildren = new Set());
    this.enteringChildren.add(child);
  }
  removeChild(child) {
    this.children.delete(child);
    this.enteringChildren && this.enteringChildren.delete(child);
  }
  bindToMotionValue(key, value) {
    if (this.valueSubscriptions.has(key)) {
      this.valueSubscriptions.get(key)();
    }
    const valueIsTransform = transformProps.has(key);
    if (valueIsTransform && this.onBindTransform) {
      this.onBindTransform();
    }
    const removeOnChange = value.on('change', (latestValue) => {
      this.latestValues[key] = latestValue;
      this.props.onUpdate && frame.preRender(this.notifyUpdate);
      if (valueIsTransform && this.projection) {
        this.projection.isTransformDirty = true;
      }
      this.scheduleRender();
    });
    let removeSyncCheck;
    if (window.MotionCheckAppearSync) {
      removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
    }
    this.valueSubscriptions.set(key, () => {
      removeOnChange();
      if (removeSyncCheck) removeSyncCheck();
      if (value.owner) value.stop();
    });
  }
  sortNodePosition(other) {
    /**
     * If these nodes aren't even of the same type we can't compare their depth.
     */
    if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) {
      return 0;
    }
    return this.sortInstanceNodePosition(this.current, other.current);
  }
  updateFeatures() {
    let key = 'animation';
    for (key in featureDefinitions) {
      const featureDefinition = featureDefinitions[key];
      if (!featureDefinition) continue;
      const {isEnabled, Feature: FeatureConstructor} = featureDefinition;
      /**
       * If this feature is enabled but not active, make a new instance.
       */
      if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) {
        this.features[key] = new FeatureConstructor(this);
      }
      /**
       * If we have a feature, mount or update it.
       */
      if (this.features[key]) {
        const feature = this.features[key];
        if (feature.isMounted) {
          feature.update();
        } else {
          feature.mount();
          feature.isMounted = true;
        }
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : createBox();
  }
  getStaticValue(key) {
    return this.latestValues[key];
  }
  setStaticValue(key, value) {
    this.latestValues[key] = value;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(props, presenceContext) {
    if (props.transformTemplate || this.props.transformTemplate) {
      this.scheduleRender();
    }
    this.prevProps = this.props;
    this.props = props;
    this.prevPresenceContext = this.presenceContext;
    this.presenceContext = presenceContext;
    /**
     * Update prop event handlers ie onAnimationStart, onAnimationComplete
     */
    for (let i = 0; i < propEventHandlers.length; i++) {
      const key = propEventHandlers[i];
      if (this.propEventSubscriptions[key]) {
        this.propEventSubscriptions[key]();
        delete this.propEventSubscriptions[key];
      }
      const listenerName = 'on' + key;
      const listener = props[listenerName];
      if (listener) {
        this.propEventSubscriptions[key] = this.on(key, listener);
      }
    }
    this.prevMotionValues = updateMotionValuesFromProps(
      this,
      this.scrapeMotionValuesFromProps(props, this.prevProps, this),
      this.prevMotionValues,
    );
    if (this.handleChildMotionValue) {
      this.handleChildMotionValue();
    }
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(name) {
    return this.props.variants ? this.props.variants[name] : undefined;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(child) {
    const closestVariantNode = this.getClosestVariantNode();
    if (closestVariantNode) {
      closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
      return () => closestVariantNode.variantChildren.delete(child);
    }
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(key, value) {
    // Remove existing value if it exists
    const existingValue = this.values.get(key);
    if (value !== existingValue) {
      if (existingValue) this.removeValue(key);
      this.bindToMotionValue(key, value);
      this.values.set(key, value);
      this.latestValues[key] = value.get();
    }
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(key) {
    this.values.delete(key);
    const unsubscribe = this.valueSubscriptions.get(key);
    if (unsubscribe) {
      unsubscribe();
      this.valueSubscriptions.delete(key);
    }
    delete this.latestValues[key];
    this.removeValueFromRenderState(key, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(key) {
    return this.values.has(key);
  }
  getValue(key, defaultValue) {
    if (this.props.values && this.props.values[key]) {
      return this.props.values[key];
    }
    let value = this.values.get(key);
    if (value === undefined && defaultValue !== undefined) {
      value = motionValue(defaultValue === null ? undefined : defaultValue, {owner: this});
      this.addValue(key, value);
    }
    return value;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(key, target) {
    let value =
      this.latestValues[key] !== undefined || !this.current
        ? this.latestValues[key]
        : (this.getBaseTargetFromProps(this.props, key) ?? this.readValueFromInstance(this.current, key, this.options));
    if (value !== undefined && value !== null) {
      if (typeof value === 'string' && (isNumericalString(value) || isZeroValueString(value))) {
        // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
      } else if (!findValueType(value) && complex.test(target)) {
        value = getAnimatableNone(key, target);
      }
      this.setBaseTarget(key, isMotionValue(value) ? value.get() : value);
    }
    return isMotionValue(value) ? value.get() : value;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(key, value) {
    this.baseTarget[key] = value;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(key) {
    const {initial} = this.props;
    let valueFromInitial;
    if (typeof initial === 'string' || typeof initial === 'object') {
      const variant = resolveVariantFromProps(this.props, initial, this.presenceContext?.custom);
      if (variant) {
        valueFromInitial = variant[key];
      }
    }
    /**
     * If this value still exists in the current initial variant, read that.
     */
    if (initial && valueFromInitial !== undefined) {
      return valueFromInitial;
    }
    /**
     * Alternatively, if this VisualElement config has defined a getBaseTarget
     * so we can read the value from an alternative source, try that.
     */
    const target = this.getBaseTargetFromProps(this.props, key);
    if (target !== undefined && !isMotionValue(target)) return target;
    /**
     * If the value was initially defined on initial, but it doesn't any more,
     * return undefined. Otherwise return the value as initially read from the DOM.
     */
    return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
  }
  on(eventName, callback) {
    if (!this.events[eventName]) {
      this.events[eventName] = new SubscriptionManager();
    }
    return this.events[eventName].add(callback);
  }
  notify(eventName, ...args) {
    if (this.events[eventName]) {
      this.events[eventName].notify(...args);
    }
  }
  scheduleRenderMicrotask() {
    microtask.render(this.render);
  }
}

class DOMVisualElement extends VisualElement {
  constructor() {
    super(...arguments);
    this.KeyframeResolver = DOMKeyframesResolver;
  }
  sortInstanceNodePosition(a, b) {
    /**
     * compareDocumentPosition returns a bitmask, by using the bitwise &
     * we're returning true if 2 in that bitmask is set to true. 2 is set
     * to true if b preceeds a.
     */
    return a.compareDocumentPosition(b) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(props, key) {
    return props.style ? props.style[key] : undefined;
  }
  removeValueFromRenderState(key, {vars, style}) {
    delete vars[key];
    delete style[key];
  }
  handleChildMotionValue() {
    if (this.childSubscription) {
      this.childSubscription();
      delete this.childSubscription;
    }
    const {children} = this.props;
    if (isMotionValue(children)) {
      this.childSubscription = children.on('change', (latest) => {
        if (this.current) {
          this.current.textContent = `${latest}`;
        }
      });
    }
  }
}

const translateAlias = {
  x: 'translateX',
  y: 'translateY',
  z: 'translateZ',
  transformPerspective: 'perspective',
};
const numTransforms = transformPropOrder.length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */
function buildTransform(latestValues, transform, transformTemplate) {
  // The transform string we're going to build into.
  let transformString = '';
  let transformIsDefault = true;
  /**
   * Loop over all possible transforms in order, adding the ones that
   * are present to the transform string.
   */
  for (let i = 0; i < numTransforms; i++) {
    const key = transformPropOrder[i];
    const value = latestValues[key];
    if (value === undefined) continue;
    let valueIsDefault = true;
    if (typeof value === 'number') {
      valueIsDefault = value === (key.startsWith('scale') ? 1 : 0);
    } else {
      valueIsDefault = parseFloat(value) === 0;
    }
    if (!valueIsDefault || transformTemplate) {
      const valueAsType = getValueAsType(value, numberValueTypes[key]);
      if (!valueIsDefault) {
        transformIsDefault = false;
        const transformName = translateAlias[key] || key;
        transformString += `${transformName}(${valueAsType}) `;
      }
      if (transformTemplate) {
        transform[key] = valueAsType;
      }
    }
  }
  transformString = transformString.trim();
  // If we have a custom `transform` template, pass our transform values and
  // generated transformString to that before returning
  if (transformTemplate) {
    transformString = transformTemplate(transform, transformIsDefault ? '' : transformString);
  } else if (transformIsDefault) {
    transformString = 'none';
  }
  return transformString;
}

function buildHTMLStyles(state, latestValues, transformTemplate) {
  const {style, vars, transformOrigin} = state;
  // Track whether we encounter any transform or transformOrigin values.
  let hasTransform = false;
  let hasTransformOrigin = false;
  /**
   * Loop over all our latest animated values and decide whether to handle them
   * as a style or CSS variable.
   *
   * Transforms and transform origins are kept separately for further processing.
   */
  for (const key in latestValues) {
    const value = latestValues[key];
    if (transformProps.has(key)) {
      // If this is a transform, flag to enable further transform processing
      hasTransform = true;
      continue;
    } else if (isCSSVariableName(key)) {
      vars[key] = value;
      continue;
    } else {
      // Convert the value to its default value type, ie 0 -> "0px"
      const valueAsType = getValueAsType(value, numberValueTypes[key]);
      if (key.startsWith('origin')) {
        // If this is a transform origin, flag and enable further transform-origin processing
        hasTransformOrigin = true;
        transformOrigin[key] = valueAsType;
      } else {
        style[key] = valueAsType;
      }
    }
  }
  if (!latestValues.transform) {
    if (hasTransform || transformTemplate) {
      style.transform = buildTransform(latestValues, state.transform, transformTemplate);
    } else if (style.transform) {
      /**
       * If we have previously created a transform but currently don't have any,
       * reset transform style to none.
       */
      style.transform = 'none';
    }
  }
  /**
   * Build a transformOrigin style. Uses the same defaults as the browser for
   * undefined origins.
   */
  if (hasTransformOrigin) {
    const {originX = '50%', originY = '50%', originZ = 0} = transformOrigin;
    style.transformOrigin = `${originX} ${originY} ${originZ}`;
  }
}

function renderHTML(element, {style, vars}, styleProp, projection) {
  const elementStyle = element.style;
  let key;
  for (key in style) {
    // CSSStyleDeclaration has [index: number]: string; in the types, so we use that as key type.
    elementStyle[key] = style[key];
  }
  // Write projection styles directly to element style
  projection?.applyProjectionStyles(elementStyle, styleProp);
  for (key in vars) {
    // Loop over any CSS variables and assign those.
    // They can only be assigned using `setProperty`.
    elementStyle.setProperty(key, vars[key]);
  }
}

const scaleCorrectors = {};

function isForcedMotionValue(key, {layout, layoutId}) {
  return (
    transformProps.has(key) ||
    key.startsWith('origin') ||
    ((layout || layoutId !== undefined) && (!!scaleCorrectors[key] || key === 'opacity'))
  );
}

function scrapeMotionValuesFromProps$1(props, prevProps, visualElement) {
  const {style} = props;
  const newValues = {};
  for (const key in style) {
    if (
      isMotionValue(style[key]) ||
      (prevProps.style && isMotionValue(prevProps.style[key])) ||
      isForcedMotionValue(key, props) ||
      visualElement?.getValue(key)?.liveStyle !== undefined
    ) {
      newValues[key] = style[key];
    }
  }
  return newValues;
}

function getComputedStyle$1(element) {
  return window.getComputedStyle(element);
}
class HTMLVisualElement extends DOMVisualElement {
  constructor() {
    super(...arguments);
    this.type = 'html';
    this.renderInstance = renderHTML;
  }
  readValueFromInstance(instance, key) {
    if (transformProps.has(key)) {
      return this.projection?.isProjecting ? defaultTransformValue(key) : readTransformValue(instance, key);
    } else {
      const computedStyle = getComputedStyle$1(instance);
      const value = (isCSSVariableName(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
      return typeof value === 'string' ? value.trim() : value;
    }
  }
  measureInstanceViewportBox(instance, {transformPagePoint}) {
    return measureViewportBox(instance, transformPagePoint);
  }
  build(renderState, latestValues, props) {
    buildHTMLStyles(renderState, latestValues, props.transformTemplate);
  }
  scrapeMotionValuesFromProps(props, prevProps, visualElement) {
    return scrapeMotionValuesFromProps$1(props, prevProps, visualElement);
  }
}

function isObjectKey(key, object) {
  return key in object;
}
class ObjectVisualElement extends VisualElement {
  constructor() {
    super(...arguments);
    this.type = 'object';
  }
  readValueFromInstance(instance, key) {
    if (isObjectKey(key, instance)) {
      const value = instance[key];
      if (typeof value === 'string' || typeof value === 'number') {
        return value;
      }
    }
    return undefined;
  }
  getBaseTargetFromProps() {
    return undefined;
  }
  removeValueFromRenderState(key, renderState) {
    delete renderState.output[key];
  }
  measureInstanceViewportBox() {
    return createBox();
  }
  build(renderState, latestValues) {
    Object.assign(renderState.output, latestValues);
  }
  renderInstance(instance, {output}) {
    Object.assign(instance, output);
  }
  sortInstanceNodePosition() {
    return 0;
  }
}

const dashKeys = {
  offset: 'stroke-dashoffset',
  array: 'stroke-dasharray',
};
const camelKeys = {
  offset: 'strokeDashoffset',
  array: 'strokeDasharray',
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */
function buildSVGPath(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
  // Normalise path length by setting SVG attribute pathLength to 1
  attrs.pathLength = 1;
  // We use dash case when setting attributes directly to the DOM node and camel case
  // when defining props on a React component.
  const keys = useDashCase ? dashKeys : camelKeys;
  // Build the dash offset
  attrs[keys.offset] = px.transform(-offset);
  // Build the dash array
  const pathLength = px.transform(length);
  const pathSpacing = px.transform(spacing);
  attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}

/**
 * Build SVG visual attributes, like cx and style.transform
 */
function buildSVGAttrs(
  state,
  {
    attrX,
    attrY,
    attrScale,
    pathLength,
    pathSpacing = 1,
    pathOffset = 0,
    // This is object creation, which we try to avoid per-frame.
    ...latest
  },
  isSVGTag,
  transformTemplate,
  styleProp,
) {
  buildHTMLStyles(state, latest, transformTemplate);
  /**
   * For svg tags we just want to make sure viewBox is animatable and treat all the styles
   * as normal HTML tags.
   */
  if (isSVGTag) {
    if (state.style.viewBox) {
      state.attrs.viewBox = state.style.viewBox;
    }
    return;
  }
  state.attrs = state.style;
  state.style = {};
  const {attrs, style} = state;
  /**
   * However, we apply transforms as CSS transforms.
   * So if we detect a transform, transformOrigin we take it from attrs and copy it into style.
   */
  if (attrs.transform) {
    style.transform = attrs.transform;
    delete attrs.transform;
  }
  if (style.transform || attrs.transformOrigin) {
    style.transformOrigin = attrs.transformOrigin ?? '50% 50%';
    delete attrs.transformOrigin;
  }
  if (style.transform) {
    /**
     * SVG's element transform-origin uses its own median as a reference.
     * Therefore, transformBox becomes a fill-box
     */
    style.transformBox = styleProp?.transformBox ?? 'fill-box';
    delete attrs.transformBox;
  }
  // Render attrX/attrY/attrScale as attributes
  if (attrX !== undefined) attrs.x = attrX;
  if (attrY !== undefined) attrs.y = attrY;
  if (attrScale !== undefined) attrs.scale = attrScale;
  // Build SVG path if one has been defined
  if (pathLength !== undefined) {
    buildSVGPath(attrs, pathLength, pathSpacing, pathOffset, false);
  }
}

/**
 * A set of attribute names that are always read/written as camel case.
 */
const camelCaseAttributes = new Set([
  'baseFrequency',
  'diffuseConstant',
  'kernelMatrix',
  'kernelUnitLength',
  'keySplines',
  'keyTimes',
  'limitingConeAngle',
  'markerHeight',
  'markerWidth',
  'numOctaves',
  'targetX',
  'targetY',
  'surfaceScale',
  'specularConstant',
  'specularExponent',
  'stdDeviation',
  'tableValues',
  'viewBox',
  'gradientTransform',
  'pathLength',
  'startOffset',
  'textLength',
  'lengthAdjust',
]);

const isSVGTag = (tag) => typeof tag === 'string' && tag.toLowerCase() === 'svg';

function renderSVG(element, renderState, _styleProp, projection) {
  renderHTML(element, renderState, undefined, projection);
  for (const key in renderState.attrs) {
    element.setAttribute(!camelCaseAttributes.has(key) ? camelToDash(key) : key, renderState.attrs[key]);
  }
}

function scrapeMotionValuesFromProps(props, prevProps, visualElement) {
  const newValues = scrapeMotionValuesFromProps$1(props, prevProps, visualElement);
  for (const key in props) {
    if (isMotionValue(props[key]) || isMotionValue(prevProps[key])) {
      const targetKey =
        transformPropOrder.indexOf(key) !== -1 ? 'attr' + key.charAt(0).toUpperCase() + key.substring(1) : key;
      newValues[targetKey] = props[key];
    }
  }
  return newValues;
}

class SVGVisualElement extends DOMVisualElement {
  constructor() {
    super(...arguments);
    this.type = 'svg';
    this.isSVGTag = false;
    this.measureInstanceViewportBox = createBox;
  }
  getBaseTargetFromProps(props, key) {
    return props[key];
  }
  readValueFromInstance(instance, key) {
    if (transformProps.has(key)) {
      const defaultType = getDefaultValueType(key);
      return defaultType ? defaultType.default || 0 : 0;
    }
    key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
    return instance.getAttribute(key);
  }
  scrapeMotionValuesFromProps(props, prevProps, visualElement) {
    return scrapeMotionValuesFromProps(props, prevProps, visualElement);
  }
  build(renderState, latestValues, props) {
    buildSVGAttrs(renderState, latestValues, this.isSVGTag, props.transformTemplate, props.style);
  }
  renderInstance(instance, renderState, styleProp, projection) {
    renderSVG(instance, renderState, styleProp, projection);
  }
  mount(instance) {
    this.isSVGTag = isSVGTag(instance.tagName);
    super.mount(instance);
  }
}

function createDOMVisualElement(element) {
  const options = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        transform: {},
        transformOrigin: {},
        style: {},
        vars: {},
        attrs: {},
      },
      latestValues: {},
    },
  };
  const node =
    isSVGElement(element) && !isSVGSVGElement(element) ? new SVGVisualElement(options) : new HTMLVisualElement(options);
  node.mount(element);
  visualElementStore.set(element, node);
}
function createObjectVisualElement(subject) {
  const options = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        output: {},
      },
      latestValues: {},
    },
  };
  const node = new ObjectVisualElement(options);
  node.mount(subject);
  visualElementStore.set(subject, node);
}

function animateSingleValue(value, keyframes, options) {
  const motionValue$1 = isMotionValue(value) ? value : motionValue(value);
  motionValue$1.start(animateMotionValue('', motionValue$1, keyframes, options));
  return motionValue$1.animation;
}

function isSingleValue(subject, keyframes) {
  return (
    isMotionValue(subject) || typeof subject === 'number' || (typeof subject === 'string' && !isDOMKeyframes(keyframes))
  );
}
/**
 * Implementation
 */
function animateSubject(subject, keyframes, options, scope) {
  const animations = [];
  if (isSingleValue(subject, keyframes)) {
    animations.push(
      animateSingleValue(
        subject,
        isDOMKeyframes(keyframes) ? keyframes.default || keyframes : keyframes,
        options ? options.default || options : options,
      ),
    );
  } else {
    const subjects = resolveSubjects(subject, keyframes, scope);
    const numSubjects = subjects.length;
    invariant(Boolean(numSubjects), 'No valid elements provided.', 'no-valid-elements');
    for (let i = 0; i < numSubjects; i++) {
      const thisSubject = subjects[i];
      invariant(
        thisSubject !== null,
        "You're trying to perform an animation on null. Ensure that selectors are correctly finding elements and refs are correctly hydrated.",
        'animate-null',
      );
      const createVisualElement = thisSubject instanceof Element ? createDOMVisualElement : createObjectVisualElement;
      if (!visualElementStore.has(thisSubject)) {
        createVisualElement(thisSubject);
      }
      const visualElement = visualElementStore.get(thisSubject);
      const transition = {...options};
      /**
       * Resolve stagger function if provided.
       */
      if ('delay' in transition && typeof transition.delay === 'function') {
        transition.delay = transition.delay(i, numSubjects);
      }
      animations.push(...animateTarget(visualElement, {...keyframes, transition}, {}));
    }
  }
  return animations;
}

function animateSequence(sequence, options, scope) {
  const animations = [];
  const animationDefinitions = createAnimationsFromSequence(sequence, options, scope, {spring});
  animationDefinitions.forEach(({keyframes, transition}, subject) => {
    animations.push(...animateSubject(subject, keyframes, transition));
  });
  return animations;
}

function isSequence(value) {
  return Array.isArray(value) && value.some(Array.isArray);
}
/**
 * Creates an animation function that is optionally scoped
 * to a specific element.
 */
function createScopedAnimate(scope) {
  /**
   * Implementation
   */
  function scopedAnimate(subjectOrSequence, optionsOrKeyframes, options) {
    let animations = [];
    let animationOnComplete;
    if (isSequence(subjectOrSequence)) {
      animations = animateSequence(subjectOrSequence, optionsOrKeyframes, scope);
    } else {
      // Extract top-level onComplete so it doesn't get applied per-value
      const {onComplete, ...rest} = options || {};
      if (typeof onComplete === 'function') {
        animationOnComplete = onComplete;
      }
      animations = animateSubject(subjectOrSequence, optionsOrKeyframes, rest, scope);
    }
    const animation = new GroupAnimationWithThen(animations);
    if (animationOnComplete) {
      animation.finished.then(animationOnComplete);
    }
    return animation;
  }
  return scopedAnimate;
}
const animate = createScopedAnimate();

/**
 * A time in milliseconds, beyond which we consider the scroll velocity to be 0.
 */
const maxElapsed = 50;
const createAxisInfo = () => ({
  current: 0,
  offset: [],
  progress: 0,
  scrollLength: 0,
  targetOffset: 0,
  targetLength: 0,
  containerLength: 0,
  velocity: 0,
});
const createScrollInfo = () => ({
  time: 0,
  x: createAxisInfo(),
  y: createAxisInfo(),
});
const keys = {
  x: {
    length: 'Width',
    position: 'Left',
  },
  y: {
    length: 'Height',
    position: 'Top',
  },
};
function updateAxisInfo(element, axisName, info, time) {
  const axis = info[axisName];
  const {length, position} = keys[axisName];
  const prev = axis.current;
  const prevTime = info.time;
  axis.current = element[`scroll${position}`];
  axis.scrollLength = element[`scroll${length}`] - element[`client${length}`];
  axis.offset.length = 0;
  axis.offset[0] = 0;
  axis.offset[1] = axis.scrollLength;
  axis.progress = progress(0, axis.scrollLength, axis.current);
  const elapsed = time - prevTime;
  axis.velocity = elapsed > maxElapsed ? 0 : velocityPerSecond(axis.current - prev, elapsed);
}
function updateScrollInfo(element, info, time) {
  updateAxisInfo(element, 'x', info, time);
  updateAxisInfo(element, 'y', info, time);
  info.time = time;
}

function calcInset(element, container) {
  const inset = {x: 0, y: 0};
  let current = element;
  while (current && current !== container) {
    if (isHTMLElement(current)) {
      inset.x += current.offsetLeft;
      inset.y += current.offsetTop;
      current = current.offsetParent;
    } else if (current.tagName === 'svg') {
      /**
       * This isn't an ideal approach to measuring the offset of <svg /> tags.
       * It would be preferable, given they behave like HTMLElements in most ways
       * to use offsetLeft/Top. But these don't exist on <svg />. Likewise we
       * can't use .getBBox() like most SVG elements as these provide the offset
       * relative to the SVG itself, which for <svg /> is usually 0x0.
       */
      const svgBoundingBox = current.getBoundingClientRect();
      current = current.parentElement;
      const parentBoundingBox = current.getBoundingClientRect();
      inset.x += svgBoundingBox.left - parentBoundingBox.left;
      inset.y += svgBoundingBox.top - parentBoundingBox.top;
    } else if (current instanceof SVGGraphicsElement) {
      const {x, y} = current.getBBox();
      inset.x += x;
      inset.y += y;
      let svg = null;
      let parent = current.parentNode;
      while (!svg) {
        if (parent.tagName === 'svg') {
          svg = parent;
        }
        parent = current.parentNode;
      }
      current = svg;
    } else {
      break;
    }
  }
  return inset;
}

const namedEdges = {
  start: 0,
  center: 0.5,
  end: 1,
};
function resolveEdge(edge, length, inset = 0) {
  let delta = 0;
  /**
   * If we have this edge defined as a preset, replace the definition
   * with the numerical value.
   */
  if (edge in namedEdges) {
    edge = namedEdges[edge];
  }
  /**
   * Handle unit values
   */
  if (typeof edge === 'string') {
    const asNumber = parseFloat(edge);
    if (edge.endsWith('px')) {
      delta = asNumber;
    } else if (edge.endsWith('%')) {
      edge = asNumber / 100;
    } else if (edge.endsWith('vw')) {
      delta = (asNumber / 100) * document.documentElement.clientWidth;
    } else if (edge.endsWith('vh')) {
      delta = (asNumber / 100) * document.documentElement.clientHeight;
    } else {
      edge = asNumber;
    }
  }
  /**
   * If the edge is defined as a number, handle as a progress value.
   */
  if (typeof edge === 'number') {
    delta = length * edge;
  }
  return inset + delta;
}

const defaultOffset = [0, 0];
function resolveOffset(offset, containerLength, targetLength, targetInset) {
  let offsetDefinition = Array.isArray(offset) ? offset : defaultOffset;
  let targetPoint = 0;
  let containerPoint = 0;
  if (typeof offset === 'number') {
    /**
     * If we're provided offset: [0, 0.5, 1] then each number x should become
     * [x, x], so we default to the behaviour of mapping 0 => 0 of both target
     * and container etc.
     */
    offsetDefinition = [offset, offset];
  } else if (typeof offset === 'string') {
    offset = offset.trim();
    if (offset.includes(' ')) {
      offsetDefinition = offset.split(' ');
    } else {
      /**
       * If we're provided a definition like "100px" then we want to apply
       * that only to the top of the target point, leaving the container at 0.
       * Whereas a named offset like "end" should be applied to both.
       */
      offsetDefinition = [offset, namedEdges[offset] ? offset : `0`];
    }
  }
  targetPoint = resolveEdge(offsetDefinition[0], targetLength, targetInset);
  containerPoint = resolveEdge(offsetDefinition[1], containerLength);
  return targetPoint - containerPoint;
}

const ScrollOffset = {
  Enter: [
    [0, 1],
    [1, 1],
  ],
  Exit: [
    [0, 0],
    [1, 0],
  ],
  Any: [
    [1, 0],
    [0, 1],
  ],
  All: [
    [0, 0],
    [1, 1],
  ],
};

const point = {x: 0, y: 0};
function getTargetSize(target) {
  return 'getBBox' in target && target.tagName !== 'svg'
    ? target.getBBox()
    : {width: target.clientWidth, height: target.clientHeight};
}
function resolveOffsets(container, info, options) {
  const {offset: offsetDefinition = ScrollOffset.All} = options;
  const {target = container, axis = 'y'} = options;
  const lengthLabel = axis === 'y' ? 'height' : 'width';
  const inset = target !== container ? calcInset(target, container) : point;
  /**
   * Measure the target and container. If they're the same thing then we
   * use the container's scrollWidth/Height as the target, from there
   * all other calculations can remain the same.
   */
  const targetSize =
    target === container ? {width: container.scrollWidth, height: container.scrollHeight} : getTargetSize(target);
  const containerSize = {
    width: container.clientWidth,
    height: container.clientHeight,
  };
  /**
   * Reset the length of the resolved offset array rather than creating a new one.
   * TODO: More reusable data structures for targetSize/containerSize would also be good.
   */
  info[axis].offset.length = 0;
  /**
   * Populate the offset array by resolving the user's offset definition into
   * a list of pixel scroll offets.
   */
  let hasChanged = !info[axis].interpolate;
  const numOffsets = offsetDefinition.length;
  for (let i = 0; i < numOffsets; i++) {
    const offset = resolveOffset(offsetDefinition[i], containerSize[lengthLabel], targetSize[lengthLabel], inset[axis]);
    if (!hasChanged && offset !== info[axis].interpolatorOffsets[i]) {
      hasChanged = true;
    }
    info[axis].offset[i] = offset;
  }
  /**
   * If the pixel scroll offsets have changed, create a new interpolator function
   * to map scroll value into a progress.
   */
  if (hasChanged) {
    info[axis].interpolate = interpolate(info[axis].offset, defaultOffset$1(offsetDefinition), {clamp: false});
    info[axis].interpolatorOffsets = [...info[axis].offset];
  }
  info[axis].progress = clamp(0, 1, info[axis].interpolate(info[axis].current));
}

function measure(container, target = container, info) {
  /**
   * Find inset of target within scrollable container
   */
  info.x.targetOffset = 0;
  info.y.targetOffset = 0;
  if (target !== container) {
    let node = target;
    while (node && node !== container) {
      info.x.targetOffset += node.offsetLeft;
      info.y.targetOffset += node.offsetTop;
      node = node.offsetParent;
    }
  }
  info.x.targetLength = target === container ? target.scrollWidth : target.clientWidth;
  info.y.targetLength = target === container ? target.scrollHeight : target.clientHeight;
  info.x.containerLength = container.clientWidth;
  info.y.containerLength = container.clientHeight;
  /**
   * In development mode ensure scroll containers aren't position: static as this makes
   * it difficult to measure their relative positions.
   */
  if (process.env.NODE_ENV !== 'production') {
    if (container && target && target !== container) {
      warnOnce(
        getComputedStyle(container).position !== 'static',
        "Please ensure that the container has a non-static position, like 'relative', 'fixed', or 'absolute' to ensure scroll offset is calculated correctly.",
      );
    }
  }
}
function createOnScrollHandler(element, onScroll, info, options = {}) {
  return {
    measure: (time) => {
      measure(element, options.target, info);
      updateScrollInfo(element, info, time);
      if (options.offset || options.target) {
        resolveOffsets(element, info, options);
      }
    },
    notify: () => onScroll(info),
  };
}

const scrollListeners = new WeakMap();
const resizeListeners = new WeakMap();
const onScrollHandlers = new WeakMap();
const getEventTarget = (element) => (element === document.scrollingElement ? window : element);
function scrollInfo(onScroll, {container = document.scrollingElement, ...options} = {}) {
  if (!container) return noop;
  let containerHandlers = onScrollHandlers.get(container);
  /**
   * Get the onScroll handlers for this container.
   * If one isn't found, create a new one.
   */
  if (!containerHandlers) {
    containerHandlers = new Set();
    onScrollHandlers.set(container, containerHandlers);
  }
  /**
   * Create a new onScroll handler for the provided callback.
   */
  const info = createScrollInfo();
  const containerHandler = createOnScrollHandler(container, onScroll, info, options);
  containerHandlers.add(containerHandler);
  /**
   * Check if there's a scroll event listener for this container.
   * If not, create one.
   */
  if (!scrollListeners.has(container)) {
    const measureAll = () => {
      for (const handler of containerHandlers) {
        handler.measure(frameData.timestamp);
      }
      frame.preUpdate(notifyAll);
    };
    const notifyAll = () => {
      for (const handler of containerHandlers) {
        handler.notify();
      }
    };
    const listener = () => frame.read(measureAll);
    scrollListeners.set(container, listener);
    const target = getEventTarget(container);
    window.addEventListener('resize', listener, {passive: true});
    if (container !== document.documentElement) {
      resizeListeners.set(container, resize(container, listener));
    }
    target.addEventListener('scroll', listener, {passive: true});
    listener();
  }
  const listener = scrollListeners.get(container);
  frame.read(listener, false, true);
  return () => {
    cancelFrame(listener);
    /**
     * Check if we even have any handlers for this container.
     */
    const currentHandlers = onScrollHandlers.get(container);
    if (!currentHandlers) return;
    currentHandlers.delete(containerHandler);
    if (currentHandlers.size) return;
    /**
     * If no more handlers, remove the scroll listener too.
     */
    const scrollListener = scrollListeners.get(container);
    scrollListeners.delete(container);
    if (scrollListener) {
      getEventTarget(container).removeEventListener('scroll', scrollListener);
      resizeListeners.get(container)?.();
      window.removeEventListener('resize', scrollListener);
    }
  };
}

const timelineCache = new Map();
function scrollTimelineFallback(options) {
  const currentTime = {value: 0};
  const cancel = scrollInfo((info) => {
    currentTime.value = info[options.axis].progress * 100;
  }, options);
  return {currentTime, cancel};
}
function getTimeline({source, container, ...options}) {
  const {axis} = options;
  if (source) container = source;
  const containerCache = timelineCache.get(container) ?? new Map();
  timelineCache.set(container, containerCache);
  const targetKey = options.target ?? 'self';
  const targetCache = containerCache.get(targetKey) ?? {};
  const axisKey = axis + (options.offset ?? []).join(',');
  if (!targetCache[axisKey]) {
    targetCache[axisKey] =
      !options.target && supportsScrollTimeline()
        ? new ScrollTimeline({source: container, axis})
        : scrollTimelineFallback({container, ...options});
  }
  return targetCache[axisKey];
}

function attachToAnimation(animation, options) {
  const timeline = getTimeline(options);
  return animation.attachTimeline({
    timeline: options.target ? undefined : timeline,
    observe: (valueAnimation) => {
      valueAnimation.pause();
      return observeTimeline((progress) => {
        valueAnimation.time = valueAnimation.iterationDuration * progress;
      }, timeline);
    },
  });
}

/**
 * If the onScroll function has two arguments, it's expecting
 * more specific information about the scroll from scrollInfo.
 */
function isOnScrollWithInfo(onScroll) {
  return onScroll.length === 2;
}
function attachToFunction(onScroll, options) {
  if (isOnScrollWithInfo(onScroll)) {
    return scrollInfo((info) => {
      onScroll(info[options.axis].progress, info);
    }, options);
  } else {
    return observeTimeline(onScroll, getTimeline(options));
  }
}

function scroll(onScroll, {axis = 'y', container = document.scrollingElement, ...options} = {}) {
  if (!container) return noop;
  const optionsWithDefaults = {axis, container, ...options};
  return typeof onScroll === 'function'
    ? attachToFunction(onScroll, optionsWithDefaults)
    : attachToAnimation(onScroll, optionsWithDefaults);
}

const thresholds = {
  some: 0,
  all: 1,
};
function inView(elementOrSelector, onStart, {root, margin: rootMargin, amount = 'some'} = {}) {
  const elements = resolveElements(elementOrSelector);
  const activeIntersections = new WeakMap();
  const onIntersectionChange = (entries) => {
    entries.forEach((entry) => {
      const onEnd = activeIntersections.get(entry.target);
      /**
       * If there's no change to the intersection, we don't need to
       * do anything here.
       */
      if (entry.isIntersecting === Boolean(onEnd)) return;
      if (entry.isIntersecting) {
        const newOnEnd = onStart(entry.target, entry);
        if (typeof newOnEnd === 'function') {
          activeIntersections.set(entry.target, newOnEnd);
        } else {
          observer.unobserve(entry.target);
        }
      } else if (typeof onEnd === 'function') {
        onEnd(entry);
        activeIntersections.delete(entry.target);
      }
    });
  };
  const observer = new IntersectionObserver(onIntersectionChange, {
    root,
    rootMargin,
    threshold: typeof amount === 'number' ? amount : thresholds[amount],
  });
  elements.forEach((element) => observer.observe(element));
  return () => observer.disconnect();
}

const isTouchDevice = () => window.matchMedia('(pointer: coarse)').matches;
/**
 * Enhances an element to allow for iOS-like horizontal/vertical "panning" on desktop
 * with a momentum effect, utilizing mouse drag gestures. The directive is part of a larger suite
 * that enables complex scrolling behaviors including snap-to-grid and independent
 * element movement within a scrollable track.
 *
 * Notes:
 * - Requires method-ui 'scroll-snap' plugin
 *
 * Performance Notes:
 * - It may be neccesary to use `-webkit-transform: translate3d(0,0,0);` on carousel items that contain images
 * in order to prevent jank while scrolling if you're using loading="lazy" on those images
 *
 * Directives:
 *  - x-carousel:viewport: Defines the scrollable viewport area.
 *  - x-carousel:track: Marks an element as the scrollable track containing slide items.
 *  - x-carousel:scroller: Designates an element as a scrollContainer, which moves with user interaction.
 *
 * Usage:
 *
 * 1. Basic Horizontal Carousel:
 * <div x-carousel:viewport>
 *   <div x-carousel:track class="flex ...">
 *     <!-- Slide items here -->
 *   </div>
 * </div>
 *
 * Key Features:
 * - Desktop optimized: Specifically designed for mouse-based interaction on desktop environments.
 * - Momentum scrolling: Implements inertia for a natural sliding experience with mouse dragging.
 * - Snap points support: Works with CSS scroll-snap to align slides on stop.
 * - Independent element sliding: Allows elements to move separately within the track.
 *
 * Implementation Details:
 * The directive utilizes several internal utilities to manage mouse drag gestures,
 * scrolling behavior, and snap-to-grid logic. It leverages Alpine.js reactivity
 * to update the UI state based on user interaction and scrolling position.
 *
 * Note: This directive should be used in conjunction with Alpine.js and assumes
 * the presence of specific CSS classes for styling (e.g., `overflow-hidden`, `flex`).
 * The behavior is designed for non-touch, mouse-driven environments and disables touch-specific interactions.
 */
function carousel(Alpine) {
  Alpine.directive('carousel', ($el, data, utilities) => {
    if (!isHtmlElement($el)) {
      throw new Error(`Expected HTMLElement but got ${$el}`);
    }
    if (data.value === 'viewport') {
      handleViewport$1($el, Alpine);
    } else if (data.value === 'track') {
      handleTrack($el, Alpine, data);
    } else if (data.value === 'item') {
      handleItem($el, Alpine);
    } else if (data.value === 'next') {
      handleNextButton$1($el, Alpine);
    } else if (data.value === 'prev') {
      handlePrevButton$1($el, Alpine);
    } else if (data.value === null) {
      handleRoot$k($el, Alpine);
    } else {
      throw new Error(`Unknown directive: x-carousel:${data.value}`);
    }
  }).before('bind');
  Alpine.magic('carousel', handleCarouselMagic(Alpine));
}
/**
 * Binds a track component to an HTML element with Alpine.js.
 * This component handles moving a set of elements together in a performant way in a carousel UI.
 */
function handleTrack($el, Alpine, data, _utilities) {
  const shouldAutoRegisterItems = data.modifiers.includes('autoregister');
  Alpine.bind($el, {
    'x-scroll-list:scroller': '',
    ['x-data']() {
      return {
        __mutationObserver: null,
        init() {
          this.$data.__carouselTrackEl = this.$el;
          if (shouldAutoRegisterItems) {
            // Automatically register initial children as x-carousel:item's
            Array.from($el.children).forEach((child) => {
              if (isTemplateElement(child)) return;
              handleItem(child, Alpine);
            });
            // Watch for new children being added to the track
            this.__mutationObserver = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                  for (const node of mutation.addedNodes) {
                    if (isTemplateElement(node)) continue;
                    handleItem(node, Alpine);
                  }
                }
                if (mutation.type === 'childList') {
                  this.$nextTick(() => {
                    this.$data.__updateBounds();
                  });
                }
              });
            });
            this.__mutationObserver.observe($el, {
              childList: true,
              subtree: false,
            });
          }
        },
        destroy() {
          var _a;
          (_a = this.__mutationObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
        },
      };
    },
  });
}
/**
 * Binds a viewport component to an HTML element with Alpine.js.
 * This component deals with the gestures and the viewport bounds for the carousel.
 *
 * @param {HTMLElement} $el - The element to bind the viewport component to.
 */
function handleViewport$1($el, Alpine) {
  Alpine.bind($el, {
    ':id': "$id('carousel')",
    'x-scroll-list:viewport': '',
    ['x-data']() {
      return {
        init() {
          this.$data.__viewportEl = this.$el;
          // Don't watch for pan events if on a touch device since they have native panning for scrollable elements
          if (!isTouchDevice()) {
            this.$data.__gestureRecognizer = new PanGestureRecognizer(this.$el);
          }
        },
        destroy() {
          var _a;
          (_a = this.__gestureRecognizer) === null || _a === void 0 ? void 0 : _a.destroy();
        },
      };
    },
    '@panstart'() {
      if (!this.$data.__isEnabled) return;
      if (this.$data.__state === 'animating') return;
      this.$data.__panSession = this.$event.detail.panSession;
      this.$data.__beginPan();
      this.$data.__state = 'panning';
    },
    '@panmove'() {
      if (!this.$data.__isEnabled) return;
      if (this.$data.__state === 'animating') return;
      this.$data.__panSession = this.$event.detail.panSession;
      if (this.$data.__state === 'panning') {
        this.$data.__continuePan();
      } else {
        this.$data.__beginPan();
        this.$data.__state = 'panning';
      }
    },
    '@panend'() {
      if (!this.$data.__isEnabled) return;
      if (this.$data.__state === 'animating') return;
      this.$data.__panSession = this.$event.detail.panSession;
      this.$data.__endPan();
    },
  });
}
function handleItem($el, Alpine) {
  Alpine.bind($el, {
    'x-scroll-list:item': '',
    ':role': '$el.getAttribute("role") || "group"',
    'aria-roledescription': 'slide',
    // Prevent dragging images and links which interfere with the carousel pan gesture
    '@dragstart': '$event.preventDefault()',
  });
}
function handleNextButton$1($el, Alpine) {
  Alpine.bind($el, {
    'x-scroll-list:next': '',
  });
}
function handlePrevButton$1($el, Alpine) {
  Alpine.bind($el, {
    'x-scroll-list:prev': '',
  });
}
/**
 * Binds a root carousel component to an HTML element with Alpine.js.
 * This component controls the overall state and interactions of a carousel UI.
 *
 * @param {HTMLElement} $el - The element to bind the root component to.
 */
function handleRoot$k($el, Alpine) {
  Alpine.bind($el, {
    'x-scroll-list': '',
    ['x-data']() {
      return {
        __animation: null,
        __maxScrollLeft: 0,
        __state: 'initial',
        __scrollWidth: 0,
        __viewportWidth: 0,
        __panSession: null,
        __initialScrollLeft: null,
        __carouselTrackEl: null,
        __viewportEl: null,
        __gestureRecognizer: null,
        init() {
          this.$watch('$scrollList.isScrolling', (isScrolling) => {
            this.__state = isScrolling ? 'scrolling' : 'initial';
          });
          this.$nextTick(() => {
            this.$watch('$carousel.visibleIndices', (visibleIndices, prevVisibleIndices) => {
              if (this.__state !== 'initial') return;
              if (
                (visibleIndices === null || visibleIndices === void 0 ? void 0 : visibleIndices.length) ===
                (prevVisibleIndices === null || prevVisibleIndices === void 0 ? void 0 : prevVisibleIndices.length)
              )
                return;
            });
          });
        },
        destroy() {
          var _a;
          (_a = this.__animation) === null || _a === void 0 ? void 0 : _a.cancel();
        },
        __beginPan() {
          Alpine.stopObservingMutations();
          this.$data.__initialScrollLeft = this.__carouselTrackEl.scrollLeft;
          const panSession = this.$data.__panSession;
          const panDeltaXFromInitialScrollLeft = panSession.panDeltaX - this.$data.__initialScrollLeft;
          window.requestAnimationFrame(() => {
            this.__carouselTrackEl.style.overflow = 'visible';
            this.__carouselTrackEl.style.transform = `translate3d(${panDeltaXFromInitialScrollLeft}px, 0px, 0)`;
            this.__carouselTrackEl.style.willChange = 'transform';
            this.__maxScrollLeft = this.$data.__scrollWidth - this.$data.__viewportWidth;
          });
        },
        __continuePan() {
          const panSession = this.$data.__panSession;
          const panDeltaXFromInitialScrollLeft = panSession.panDeltaX - this.$data.__initialScrollLeft;
          this.__carouselTrackEl.style.transform = `translate3d(${panDeltaXFromInitialScrollLeft}px, 0px, 0)`;
        },
        __endPan() {
          this.__animateToScrollLeft();
        },
        async __animateToScrollLeft() {
          this.__state = 'animating';
          const panSession = this.$data.__panSession;
          const calculatedFinalScrollLeft = toScrollValue(this.$data.__initialScrollLeft - panSession.panDeltaX);
          const power = 0.6;
          const velocity = panSession.panVelocityX;
          // The extra distance that will be scrolled in the track due to the inertia animation
          const amplitude = power * velocity;
          const direction = getWritingDirection(this.$el);
          const scrollLeftAfterAnimation =
            direction == 'rtl'
              ? clamp$2(toScrollValue(calculatedFinalScrollLeft - amplitude), -this.__maxScrollLeft, 0)
              : clamp$2(toScrollValue(calculatedFinalScrollLeft - amplitude), 0, this.__maxScrollLeft);
          // Apply the final scroll position that would be reached with the current animation
          // in order to figure out where the closest snap point is
          this.__carouselTrackEl.style.overflow = 'auto';
          this.__carouselTrackEl.scrollLeft = scrollLeftAfterAnimation;
          this.__carouselTrackEl.style.transform = `translate3d(0px, 0px, 0)`;
          window.requestAnimationFrame(async () => {
            // Now, figure out where the closest snap point is
            const snappedScrollLeft = this.__carouselTrackEl.scrollLeft;
            this.__carouselTrackEl.style.overflow = 'visible';
            // Apply a transform to "reset" the scroll position to where it was when the pan ended
            this.__carouselTrackEl.style.transform = `translate3d(${-calculatedFinalScrollLeft}px, 0px, 0)`;
            // Animate the scroll position to the closest snap point
            this.__animation = animate(
              this.__carouselTrackEl,
              {x: [-calculatedFinalScrollLeft, -snappedScrollLeft]},
              {
                type: 'spring',
                stiffness: 120,
                damping: 15,
                velocity: panSession.panVelocityX,
              },
            );
            await this.__animation.finished;
            this.__jumpToScrollLeft(snappedScrollLeft);
          });
        },
        __jumpToScrollLeft(scrollLeft) {
          // Finally, remove the transform and restore the scroll position
          this.__carouselTrackEl.style.overflow = 'auto';
          this.__carouselTrackEl.scrollLeft = scrollLeft;
          this.__carouselTrackEl.style.transform = '';
          this.__carouselTrackEl.style.willChange = '';
          this.__animation = null;
          this.__state = 'initial';
          Alpine.startObservingMutations();
        },
        get __isScrollable() {
          if (this.__carouselTrackEl == null) return false;
          if (this.__viewportEl == null) return false;
          return this.__scrollWidth > this.__viewportWidth;
        },
        get __isEnabled() {
          return this.$carousel.items.length > 1 && this.__isScrollable;
        },
        __updateBounds() {
          var _a, _b;
          if (this.__carouselTrackEl == null) return;
          if (this.__viewportEl == null) return;
          this.__scrollWidth = (_a = this.__carouselTrackEl) === null || _a === void 0 ? void 0 : _a.scrollWidth;
          this.__viewportWidth =
            (_b = this.__viewportEl) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().width;
        },
      };
    },
    'x-id': "['carousel']",
    'x-resize': '__updateBounds',
    'x-resize.document': '__updateBounds',
    ':role': '$el.getAttribute("role") || "region"',
    'aria-roledescription': 'carousel',
  });
}
function handleCarouselMagic(Alpine) {
  return function ($el) {
    let $data = Alpine.$data($el);
    return mergeProperties(
      {},
      {
        get state() {
          return $data.__state;
        },
        get isPanning() {
          return $data.__state == 'panning';
        },
        get isEnabled() {
          return $data.__isEnabled;
        },
      },
      handleScrollListMagic(Alpine)($el),
    );
  };
}

function isReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/**
 *
 * Add parallax effect on an element based on the scroll position of its root.
 *
 * @example
 *
 * <div
 *   class="relative flex justify-center items-center overflow-hidden h-[200px]"
 *   x-parallax
 * >
 *   <div
 *     class="absolute flex justify-center items-center min-h-full w-full h-[180%] text-white"
 *     x-parallax:background
 *   >
 *     Parallax child
 *   </div>
 * </div>
 */
function parallax(Alpine) {
  Alpine.directive('parallax', ($el, data, {cleanup, effect, evaluate}) => {
    if (!isHtmlElement($el)) {
      throw new Error(`Expected HTMLElement but got ${$el}`);
    }
    if (data.value === 'background') {
      handleBackground($el, Alpine, data);
    } else if (data.value === 'child') {
      // DEPRECATED: for backwards compatibility
      handleBackground($el, Alpine, data);
    } else if (data.value === 'element') {
      handleElement$1($el, Alpine, data);
    } else if (data.value === null) {
      handleRoot$j($el, Alpine);
    } else {
      throw new Error(`Unknown directive: x-parallax:${data.value}`);
    }
  }).before('bind');
}
function handleBackground($el, Alpine, data) {
  const reverse = data.modifiers.includes('reverse');
  Alpine.bind($el, {
    ['x-data']() {
      return {
        __parallaxBackground_initialRender: true,
        __parallaxBackground_motionCancelFn: null,
        __parallaxBackground_styleEffect: null,
        __parallaxBackground_cancelInView: null,
        __parallaxBackground_bounds: [0, 0, 0],
        __parallaxBackground_scrollValue: motionValue(0),
        init() {
          if (isReducedMotion()) {
            // Skip parallax effect if user prefers reduced motion
            return;
          }
          if (!this.$data.__rootEl) {
            return;
          }
          this.__parallaxBackground_cancelInView = inView(
            $el,
            () => {
              this.$nextTick(() => {
                const {top: rootTop, bottom: rootBottom} = this.$data.__rootEl.getBoundingClientRect();
                const {top: elTop, bottom: elBottom} = $el.getBoundingClientRect();
                const topDiff = rootTop - elTop;
                const bottomDiff = elBottom - rootBottom;
                if (topDiff <= 0 && bottomDiff <= 0) {
                  if (process.env.NODE_ENV === 'development') {
                    console.warn(
                      'Incorrect child element sizing / alignment. The child parallax element must be taller than its container and initially aligned to the top/bottom of the container so that the image has room to move as the page scrolls',
                    );
                  }
                  return;
                }
                this.__parallaxBackground_bounds = [-bottomDiff, 0, topDiff];
                this.__parallaxBackground_setupScroll();
              });
            },
            {amount: 0},
          );
        },
        __parallaxBackground_setupScroll() {
          const scrollToY = transform(reverse ? [1, 0, -1] : [-1, 0, 1], this.__parallaxBackground_bounds);
          // Keep track of initial scroll progress to avoid a jump when the element is initially rendered
          let initialProgress = 0;
          this.__parallaxBackground_motionCancelFn = scroll(
            (progress) => {
              if (this.__parallaxBackground_initialRender && progress != 0) {
                initialProgress = progress;
                this.__parallaxBackground_initialRender = false;
              } else {
                // Subtract the initial progress to avoid a jump when the element is initially rendered
                this.__parallaxBackground_scrollValue.set(progress - initialProgress);
              }
            },
            {
              target: this.$data.__rootEl,
              offset: ['start end', 'end start'],
            },
          );
          Alpine.mutateDom(() => {
            this.__parallaxBackground_styleEffect = styleEffect($el, {
              y: transformValue(() => scrollToY(this.__parallaxBackground_scrollValue.get())),
            });
          });
        },
        destroy() {
          var _a, _b, _c;
          (_a = this.__parallaxBackground_cancelInView) === null || _a === void 0 ? void 0 : _a.call(this);
          this.__parallaxBackground_cancelInView = null;
          (_b = this.__parallaxBackground_styleEffect) === null || _b === void 0 ? void 0 : _b.call(this);
          this.__parallaxBackground_styleEffect = null;
          (_c = this.__parallaxBackground_motionCancelFn) === null || _c === void 0 ? void 0 : _c.call(this);
          this.__parallaxBackground_motionCancelFn = null;
        },
      };
    },
  });
}
function handleElement$1($el, Alpine, data) {
  let parallaxDistance = 10;
  let parallaxUnit = 'px';
  if (data.modifiers.includes('distance')) {
    const rawValue = data.modifiers[data.modifiers.indexOf('distance') + 1];
    // Support x-parallax:element.200px which will move the element up or down by 200px
    let pxMatch = rawValue.match(/(-?[0-9]+)px/);
    if (pxMatch) {
      parallaxDistance = Number(pxMatch[1]);
      parallaxUnit = 'px';
    }
    let percentageMatch = rawValue.match(/(-?[0-9]+)%/);
    if (percentageMatch) {
      parallaxDistance = Number(percentageMatch[1]);
      parallaxUnit = '%';
    }
  }
  Alpine.bind($el, {
    ['x-data']() {
      return {
        __parallaxElement_initialRender: true,
        __parallaxElement_motionCancelFn: null,
        __parallaxElement_styleEffect: null,
        __parallaxElement_cancelInView: null,
        __parallaxElement_scrollValue: motionValue(0),
        init() {
          if (isReducedMotion()) {
            // Skip parallax effect if user prefers reduced motion
            return;
          }
          this.__parallaxElement_cancelInView = inView(
            $el,
            () => {
              this.$nextTick(() => {
                this.__parallaxElement_setupScroll();
              });
            },
            {amount: 0},
          );
        },
        __parallaxElement_setupScroll() {
          const root = this.$data.__rootEl;
          if (!root) return;
          const scrollToY = transform([0, 1], [`0${parallaxUnit}`, `${parallaxDistance}${parallaxUnit}`]);
          let initialProgress = 0;
          this.__parallaxElement_motionCancelFn = scroll(
            (progress) => {
              if (this.__parallaxElement_initialRender && progress != 0) {
                initialProgress = progress;
                this.__parallaxElement_initialRender = false;
              } else {
                // Subtract the initial progress to avoid a jump when the element is initially rendered
                this.__parallaxElement_scrollValue.set(progress - initialProgress);
              }
            },
            {
              target: root,
              offset: ['start end', 'end start'],
            },
          );
          Alpine.mutateDom(() => {
            this.__parallaxElement_styleEffect = styleEffect($el, {
              y: transformValue(() => scrollToY(this.__parallaxElement_scrollValue.get())),
            });
          });
        },
        destroy() {
          var _a, _b, _c;
          (_a = this.__parallaxElement_cancelInView) === null || _a === void 0 ? void 0 : _a.call(this);
          this.__parallaxElement_cancelInView = null;
          (_b = this.__parallaxElement_motionCancelFn) === null || _b === void 0 ? void 0 : _b.call(this);
          (_c = this.__parallaxElement_styleEffect) === null || _c === void 0 ? void 0 : _c.call(this);
          this.__parallaxElement_styleEffect = null;
          this.__parallaxElement_motionCancelFn = null;
        },
      };
    },
  });
}
function handleRoot$j($el, Alpine) {
  Alpine.bind($el, {
    ['x-data']() {
      return {
        __rootEl: $el,
      };
    },
  });
}

/**
 * Enables the creation of disclosure components, commonly known as accordions or collapsible sections.
 * A disclosure component typically consists of a button that controls the visibility of an
 * associated content area.
 *
 * Note: requires method-ui 'animations' plugin
 *
 * See https://www.w3.org/WAI/ARIA/apg/patterns/disclosure/ for more information about disclosures
 *
 * Usage:
 * - x-disclosure - Applied to the root element of a disclosure component. It can optionally accept an expression that
 *   2-way binds to the internal isExpanded state of the disclosure e.g. `x-disclosure="isExpanded"`. If no expression is provided, the disclosure is closed by default
 *   If your disclosure is _not_ animated, use the .noanimate modifier to prevent the disclosure from waiting for animations to complete before transitioning to expanded and vice versa.
 * - x-disclosure:button - Marks an element as the button that toggles the visibility of the
 *   disclosure content. This element is typically a button or a similar interactive element.
 * - `data-skip-animation-wait` - Add this attribute to elements when you don't want to wait for their animations to complete before state transitions.
 *
 * @example
 *
 * <div x-disclosure>
 *   <button x-disclosure:button>Open SESAME</button>
 *   <div x-disclosure:panel>
 *     <p>Hello world</p>
 *   </div>
 * </div>
 *
 * @example Initially expanded
 *
 * <div x-disclosure="true">
 *   <button x-disclosure:button>Open SESAME</button>
 *   <div x-disclosure:panel>
 *     <p>Hello world</p>
 *   </div>
 * </div>
 *
 * or
 *
 * <div x-disclosure="{ isExpanded: true }">
 *   <button x-disclosure:button>Open SESAME</button>
 *   <div x-disclosure:panel>
 *     <p>Hello world</p>
 *   </div>
 * </div>
 *
 * @example Bound to external state
 *
 * <div x-data="{isExpandedExternal: true}">
 *   <div x-show="isExpandedExternal">Im open!</div>
 *
 *   <div x-disclosure="{
 *     get isExpanded() {
 *       return this.isExpandedExternal
 *     },
 *     set isExpanded(value) {
 *       this.isExpandedExternal = value
 *     }
 *   }">
 *     <button x-disclosure:button>Open SESAME</button>
 *     <div x-disclosure:panel>
 *       <p>Hello world</p>
 *     </div>
 *   </div>
 * </div>
 *
 * The '$disclosure' magic property provides an API for managing the state of the disclosure
 * component, including checking its open/closed status and programmatically toggling its state.
 *
 * ## Disclosure Groups
 *
 * Disclosure groups are a collection of disclosures that are managed as a single accordion.
 * This is useful for creating multi-step forms or other UI elements that require the disclosure
 * of multiple sections.
 *
 * @example
 *
 * <div x-disclosure-group>
 *   <div x-disclosure
 *     <button x-disclosure:button>Open SESAME 1</button>
 *     <div x-disclosure:panel>
 *       <p>Hello world 1</p>
 *     </div>
 *   </div>
 *  <div x-disclosure>
 *     <button x-disclosure:button>Open SESAME 2</button>
 *     <div x-disclosure:panel>
 *       <p>Hello world 2</p>
 *     </div>
 *   </div>
 * </div>
 *
 * The '$disclosureGroup' magic property provides an API for managing the state of the disclosure group,
 * including checking the expanded index and programmatically toggling the state of the disclosures.
 *
 */
function disclosure(Alpine) {
  Alpine.directive('disclosure', ($el, data, utilities) => {
    if (data.value === 'panel') {
      handlePanel$3($el, Alpine);
    } else if (data.value === 'button') {
      handleButton$6($el, Alpine);
    } else if (data.value === null) {
      handleRoot$i($el, Alpine, data, utilities);
    } else {
      throw new Error(`Unknown directive: x-disclosure:${data.value}`);
    }
  }).before('bind');
  Alpine.directive('disclosure-group', ($el, data, utilities) => {
    if (data.value === null) {
      handleDisclosureGroup($el, Alpine, data, utilities);
    } else {
      throw new Error(`Unknown directive: x-disclosure-group:${data.value}`);
    }
  }).before('bind');
  Alpine.magic('disclosure', handleDisclosureMagic(Alpine));
  Alpine.magic('disclosureGroup', handleDisclosureGroupMagic(Alpine));
}
function handleDisclosureMagic(Alpine) {
  return function ($el) {
    const $data = Alpine.$data($el);
    return {
      get isExpanded() {
        var _a;
        return (_a = $data.__disclosure_state) === null || _a === void 0 ? void 0 : _a.isExpanded;
      },
      set isExpanded(value) {
        if (!$data.__disclosure_state) return;
        $data.__disclosure_state.isExpanded = value;
      },
      get isCollapsed() {
        var _a;
        return (_a = $data.__disclosure_state) === null || _a === void 0 ? void 0 : _a.isCollapsed;
      },
      get isInGroup() {
        return $data.__disclosure_isInGroup;
      },
      get groupIndex() {
        return $data.__disclosure_groupIndex;
      },
      toggle() {
        var _a;
        (_a = $data.__disclosure_state) === null || _a === void 0 ? void 0 : _a.toggle();
      },
      expand() {
        var _a;
        (_a = $data.__disclosure_state) === null || _a === void 0 ? void 0 : _a.expand();
      },
      collapse() {
        var _a;
        (_a = $data.__disclosure_state) === null || _a === void 0 ? void 0 : _a.collapse();
      },
      waitForAnimations() {
        return $data.__disclosure_waitForAnimations();
      },
    };
  };
}
function handleDisclosureGroupMagic(Alpine) {
  return function ($el) {
    const $data = Alpine.$data($el);
    return $data.__disclosure_group_state || {};
  };
}
function handlePanel$3($el, Alpine) {
  if (!$el._x_doShow) {
    $el._x_doShow = () => {};
  }
  if (!$el._x_doHide) {
    $el._x_doHide = () => {};
  }
  Alpine.bind($el, {
    ':id': `$el.id || $id('disclosure-panel')`,
    role: 'group',
    'x-show': '$disclosure.isExpanded',
    'x-init'() {
      this.__disclosure_contentEl = this.$el;
      // TODO investigate hooking into Alpine's el._x_doShow / el._x_doHide hooks instead of this
      const addHidden = () => {
        Alpine.mutateDom(() => {
          // TODO add support for `hidden="until-found"`
          this.$el.setAttribute('hidden', '');
          this.$el.style.setProperty('display', 'none');
        });
      };
      const removeHidden = () => {
        Alpine.mutateDom(() => {
          this.$el.removeAttribute('hidden');
          this.$el.style.removeProperty('display');
        });
      };
      // Set initial hidden state
      if (this.__disclosure_state.isExpanded) {
        removeHidden();
      } else {
        addHidden();
      }
      this.$watch('__disclosure_state.isExpanded', async (isExpanded) => {
        if (isExpanded) {
          removeHidden();
        } else {
          if (this.__disclosure_animated) {
            await this.__disclosure_waitForAnimations();
            // If the disclosure re-expanded before the animation completed, don't hide it
            if (this.__disclosure_state.isExpanded) return;
            addHidden();
          } else {
            addHidden();
          }
        }
      });
    },
    ':aria-labelledby': '__disclosure_buttonEl?.id',
    'data-morph-children-only': '',
  });
}
function handleButton$6($el, Alpine) {
  Alpine.bind($el, {
    role: 'button',
    ':id': `$el.id || $id('disclosure-button')`,
    'x-init': '__disclosure_buttonEl = $el',
    '@click.stop.prevent': '$disclosure.toggle()',
    ':aria-controls': '__disclosure_contentEl?.id',
    ':aria-expanded': '$disclosure.isExpanded',
  });
}
function handleDisclosureGroup($el, Alpine, {expression, modifiers}, {evaluate}) {
  let options = evaluate(expression === '' ? '{}' : expression);
  if (options !== undefined && options !== null && !isPlainObject(options)) {
    throw new Error(`options must be an object, but got ${options}`);
  }
  let state;
  if (options.multiple || modifiers.includes('multiple')) {
    state = buildMultiSelectDisclosureGroupState(options);
  } else {
    state = buildSingleSelectDisclosureGroupState(options);
  }
  Alpine.bind($el, {
    ['x-data']() {
      return {
        __disclosure_group_state: state,
      };
    },
  });
}
function handleRoot$i($el, Alpine, {modifiers, expression}, {evaluate}) {
  const $data = Alpine.$data($el);
  const isInDisclosureGroup = !!$data.__disclosure_group_state;
  // Track the depth of the disclosure group so that we can exclude the children of a grouped disclosure from also having their state controlled by the group state
  let groupDepth = $data.__disclosure_groupDepth;
  if (isInDisclosureGroup) {
    if (groupDepth === undefined || groupDepth === null) {
      groupDepth = 0;
    }
    groupDepth++;
  }
  const isDirectChildOfDisclosureGroup = isInDisclosureGroup && groupDepth === 1;
  const animated = !modifiers.includes('noanimate');
  const expand = modifiers.includes('expand');
  let options = {};
  // Evaluate the x-disclosure expression to get the initial expanded state of the disclosure (e.g. true or false)
  if (expression) {
    let evalutatedExpression = evaluate(expression === '' ? '{}' : expression);
    if (evalutatedExpression === true || evalutatedExpression === false) {
      options.isExpanded = evalutatedExpression;
    } else if (isPlainObject(evalutatedExpression)) {
      options = evalutatedExpression;
    }
  } else {
    // If there's no expression, but the .expand modifier is used, the disclosure is expanded by default
    if (expand) {
      options.isExpanded = true;
    }
  }
  let state = buildDisclosureState(options);
  // If a x-disclosure is the child of a x-disclosure-group its 'isExpanded' state is derived from the group's expanded state instead of having its own state
  // This allows us to close disclosure when another one in the group is opened
  // For clarity: the groupDepth check here ensures that e.g. if you have a popup inside of a tab
  // that opening or closing the popup doesn't affect the state of the tabs (i.e the disclosure group)
  if (isDirectChildOfDisclosureGroup) {
    state = buildDisclosureState({
      get isExpanded() {
        var _a, _b;
        const index =
          (_b = (_a = $data.__disclosure_group_state).indexOf) === null || _b === void 0 ? void 0 : _b.call(_a, $el);
        const isExpanded = $data.__disclosure_group_state.isExpanded(index);
        return isExpanded;
      },
      set isExpanded(value) {
        var _a, _b;
        const index =
          (_b = (_a = $data.__disclosure_group_state).indexOf) === null || _b === void 0 ? void 0 : _b.call(_a, $el);
        if (value) {
          $data.__disclosure_group_state.expand(index);
        } else {
          $data.__disclosure_group_state.collapse(index);
        }
      },
    });
  }
  Alpine.bind($el, {
    ':id': `$el.id || $id('disclosure')`,
    ['x-data']() {
      return {
        __disclosure_buttonEl: null,
        __disclosure_contentEl: null,
        __disclosure_state: state,
        __disclosure_animated: animated,
        __disclosure_groupDepth: groupDepth,
        init() {
          this.$watch('__disclosure_state.isExpanded', (isExpanded) => {
            this.$dispatch(isExpanded ? 'expand' : 'collapse');
          });
          if (isDirectChildOfDisclosureGroup) {
            // Register this element with the disclosure group so we can keep track of it's index
            this.$data.__disclosure_group_state.register(this.$el);
            if (options.isExpanded) {
              this.__disclosure_state.expand();
            }
          }
        },
        destroy() {
          if (isDirectChildOfDisclosureGroup) {
            this.$data.__disclosure_group_state.unregister(this.$el);
          }
        },
        async __disclosure_waitForAnimations() {
          return await this.$waitForAnimations({
            subtree: true,
            target: this.__disclosure_contentEl,
          });
        },
        get __disclosure_isInGroup() {
          return isInDisclosureGroup;
        },
        get __disclosure_groupIndex() {
          var _a, _b;
          if (!this.__disclosure_isInGroup) return null;
          return (_b = (_a = $data.__disclosure_group_state).indexOf) === null || _b === void 0
            ? void 0
            : _b.call(_a, this.$el);
        },
      };
    },
    ['x-id']: "['disclosure', 'disclosure-panel', 'disclosure-button']",
  });
}
function buildDisclosureState(options) {
  var _a;
  let state = {
    isExpanded:
      (_a = options === null || options === void 0 ? void 0 : options.isExpanded) !== null && _a !== void 0
        ? _a
        : false,
    expand() {
      this.isExpanded = true;
    },
    collapse() {
      this.isExpanded = false;
    },
    toggle() {
      this.isExpanded = !this.isExpanded;
    },
    get isCollapsed() {
      return !this.isExpanded;
    },
  };
  if ((options === null || options === void 0 ? void 0 : options.isExpanded) !== undefined) {
    const isExpandedDescriptor = Object.getOwnPropertyDescriptor(options, 'isExpanded');
    Object.defineProperty(state, 'isExpanded', isExpandedDescriptor);
  }
  return state;
}
function buildSingleSelectDisclosureGroupState(options) {
  var _a;
  let state = {
    expandedIndex:
      (_a = options === null || options === void 0 ? void 0 : options.initiallyExpandedIndex) !== null && _a !== void 0
        ? _a
        : null,
    items: new Set(),
    isExpanded(index) {
      return this.expandedIndex === index;
    },
    register(el) {
      this.items.add(el);
    },
    unregister(el) {
      this.items.delete(el);
    },
    indexOf(el) {
      return Array.from(this.items).indexOf(el);
    },
    toggle(index) {
      this.expandedIndex === index ? this.collapse(index) : this.expand(index);
    },
    expand(index) {
      this.expandedIndex = index;
    },
    collapse(index) {
      if (this.expandedIndex === index) {
        this.expandedIndex = null;
      }
    },
  };
  if (options && 'expandedIndex' in options) {
    copyProperty(options, state, 'expandedIndex');
  }
  return state;
}
function buildMultiSelectDisclosureGroupState(options) {
  var _a;
  let state = {
    expandedIndices:
      (_a = options === null || options === void 0 ? void 0 : options.initiallyExpandedIndices) !== null &&
      _a !== void 0
        ? _a
        : new Set(),
    items: new Set(),
    isExpanded(index) {
      return this.expandedIndices.has(index);
    },
    register(el) {
      this.items.add(el);
    },
    unregister(el) {
      this.items.delete(el);
    },
    indexOf(el) {
      return Array.from(this.items).indexOf(el);
    },
    toggle(index) {
      this.expandedIndices.has(index) ? this.collapse(index) : this.expand(index);
    },
    expand(index) {
      const expanded = this.expandedIndices;
      expanded.add(index);
      // Copy to a new set so that reactivity works
      this.expandedIndices = new Set(Array.from(expanded));
    },
    collapse(index) {
      const expanded = this.expandedIndices;
      expanded.delete(index);
      // Copy to a new set so that reactivity works
      this.expandedIndices = new Set(Array.from(expanded));
    },
  };
  if (options && 'expandedIndices' in options) {
    copyProperty(options, state, 'expandedIndices');
  }
  return state;
}

/**
 * Enables the creation of modal or non-modal dialog components using native <dialog> elements
 * The 'dialog' directive provides an intuitive way to define dialog content, close buttons, and modal behavior.
 *
 * Usage:
 * - x-dialog - The root element of the dialog, initializing the  dialog functionality and adding a data context for child directives. Use the 'modal' modifier (x-dialog.modal) to make the dialog modal.
 * - x-dialog:dialog - The <dialog> element
 * - x-dialog:content - The element that holds the content of the dialog. Clicking outside of this element will close the dialog.
 * - x-dialog:button - Attaches to a button or element that will open the dialog when clicked.
 * - x-dialog:close - Attaches to a button or element that will close the dialog when clicked.
 *
 * The '$dialog' magic property is an extension of '$disclosure' and provides state management
 * and control functions for the dialog, ensuring proper open/close behavior and accessibility
 * compliance.
 *
 * @example
 *
 * <div x-data="{ isMyDialogOpen: false }">
 *   <dialog x-dialog="{ isOpen: isMyDialogOpen }" class="closed:hidden backdrop:bg-black/50">
 *     I am dialog content!
 *     <button x-dialog:close>Close</button>
 *   </dialog>
 * </div>
 */
function dialog(Alpine) {
  Alpine.directive('dialog', ($el, data, utilities) => {
    if (!isHtmlElement($el)) {
      throw new Error(`Expected HTMLElement but got ${$el}`);
    }
    if (data.value === 'panel');
    else if (data.value === 'button') {
      handleButton$5($el, Alpine);
    } else if (data.value === 'close') {
      handleCloseButton($el, Alpine);
    } else if (data.value === 'backdrop') {
      handleBackdrop($el, Alpine);
    } else if (data.value === 'dialog') {
      if (!isDialogElement($el)) throw new Error('x-dialog must be used on a <dialog> element');
      handleDialog($el, Alpine, data);
    } else if (data.value === 'content') {
      handleContent($el, Alpine);
    } else if (data.value === null) {
      handleRoot$h($el, Alpine, data, utilities);
    } else {
      throw new Error(`Unknown directive: x-dialog:${data.value}`);
    }
  }).before('bind');
  Alpine.magic('dialog', handleDialogMagic(Alpine));
}
function handleDialogMagic(Alpine) {
  return function ($el) {
    const $data = Alpine.$data($el);
    return {
      get isOpen() {
        var _a;
        return (_a = $data.__disclosure_state) === null || _a === void 0 ? void 0 : _a.isExpanded;
      },
      set isOpen(value) {
        if (!$data.__disclosure_state) return;
        $data.__disclosure_state.isExpanded = value;
      },
      open() {
        var _a;
        (_a = $data.__disclosure_state) === null || _a === void 0 ? void 0 : _a.expand();
      },
      close() {
        var _a;
        (_a = $data.__disclosure_state) === null || _a === void 0 ? void 0 : _a.collapse();
      },
    };
  };
}
function handleBackdrop($el, Alpine) {
  Alpine.bind($el, {
    'x-show': '$dialog.isOpen',
    '@click': '$dialog.close()',
  });
}
function handleButton$5($el, Alpine) {
  Alpine.bind($el, {
    'x-disclosure:button': '',
    'aria-haspopup': 'dialog',
  });
}
function handleCloseButton($el, Alpine) {
  Alpine.bind($el, {
    '@click': '$dialog.close()',
  });
}
function handleDialog($el, Alpine, {modifiers}) {
  const $data = Alpine.$data($el);
  Alpine.bind($el, {
    // Close the dialog on when native close or cancel events fired on element for whatever reason
    '@close.stop.prevent': '$dialog.close()',
    '@cancel.stop.prevent': '$dialog.close()',
    // Close when clicking outside of the dialog panel i.e. the backdrop
    '@click'() {
      if (isClickingOutside(this.$event, $data.__dialog_contentEl || $el)) {
        this.$dialog.close();
      }
    },
    'x-init'() {
      this.__dialog_dialogEl = $el;
      // If the user chose to use :open and @close instead of x-model then bind internal state to the DOM
      if (Alpine.bound($el, 'open') !== undefined) {
        this.$dialog.isOpen = Alpine.bound($el, 'open', false);
      }
    },
    'x-disclosure:panel': '',
    // Override role="group" which is the default for x-disclosure:panel
    role: 'dialog',
    '@keydown.escape.window': '$data.__dialog_isModal && $dialog.close()',
  });
}
function handleContent($el, Alpine) {
  Alpine.bind($el, {
    'x-init'() {
      this.__dialog_contentEl = $el;
    },
  });
}
function handleRoot$h($el, Alpine, {expression, modifiers}, {evaluate}) {
  const disclosureModifiers = modifiers.filter((modifier) => ['open', 'noanimate'].includes(modifier));
  let options = evaluate(expression === '' ? '{}' : expression);
  const modal = modifiers.includes('modal');
  const noautofocus = modifiers.includes('noautofocus');
  Alpine.bind($el, {
    [`x-disclosure.${disclosureModifiers.join('.')}`]() {
      if (isPlainObject(options)) {
        // Rename isOpen property to isExpanded which is what the disclosure expects
        if ('isOpen' in options) {
          renameProperty(options, 'isOpen', 'isExpanded');
        }
        if ('isInitiallyOpen' in options) {
          renameProperty(options, 'isInitiallyOpen', 'isInitiallyExpanded');
        }
      }
      return options;
    },
    ['x-data']() {
      return {
        __dialog_isModal: modal || false,
        __dialog_dialogEl: null,
        __dialog_contentEl: null,
        __dialog_autofocus: !noautofocus,
        async __dialog_showDialog() {
          var _a, _b, _c, _d;
          if (!isDialogApiSupported()) return;
          let autofocusEl = null;
          if (this.__dialog_autofocus) {
            // Allow the dialog panel to be focused once the dialog is opened
            if (this.__dialog_dialogEl) {
              autofocusEl = this.$focus
                .within(this.__dialog_dialogEl)
                .focusables()
                .find((el) => el.autofocus);
              // Remove autofocus until animation complete to avoid breaking any transitions/animations
              autofocusEl === null || autofocusEl === void 0 ? void 0 : autofocusEl.removeAttribute('autofocus');
            }
          }
          if (this.__dialog_isModal) {
            (_a = this.__dialog_dialogEl) === null || _a === void 0 ? void 0 : _a.showModal();
          } else {
            (_b = this.__dialog_dialogEl) === null || _b === void 0 ? void 0 : _b.show();
          }
          await this.$disclosure.waitForAnimations();
          // Remove inert attribute if it exists
          if ((_c = this.__dialog_dialogEl) === null || _c === void 0 ? void 0 : _c.hasAttribute('inert')) {
            Alpine.mutateDom(() => {
              var _a;
              (_a = this.__dialog_dialogEl) === null || _a === void 0 ? void 0 : _a.removeAttribute('inert');
            });
          }
          if (!this.$dialog.isOpen) return;
          if (this.__dialog_autofocus) {
            if (autofocusEl) {
              autofocusEl.focus({preventScroll: true});
              // Add autofocus back to the element to ensure it is focused
              autofocusEl.setAttribute('autofocus', '');
            } else {
              (_d = this.$focus.within(this.__dialog_dialogEl).getFirst()) === null || _d === void 0
                ? void 0
                : _d.focus({preventScroll: true});
            }
          }
        },
        async __dialog_closeDialog() {
          var _a, _b;
          if (!isDialogApiSupported()) return;
          // Wait until animations have completed before hiding the dialog to avoid
          // layout shifting when dialog / top-layer styles are removed
          await this.$disclosure.waitForAnimations();
          // Ensure dialog hasn't been reopened
          if (this.$dialog.isOpen) return;
          if ((_a = this.__dialog_dialogEl) === null || _a === void 0 ? void 0 : _a.open) {
            (_b = this.__dialog_dialogEl) === null || _b === void 0 ? void 0 : _b.close();
          }
          // Set inert after animations have completed so that the dialog is inert when next opened
          window.requestAnimationFrame(() => {
            Alpine.mutateDom(() => {
              var _a;
              (_a = this.__dialog_dialogEl) === null || _a === void 0 ? void 0 : _a.setAttribute('inert', '');
            });
          });
        },
        init() {
          this.$nextTick(() => {
            if (this.$dialog.isOpen) {
              this.__dialog_showDialog();
            } else {
              this.__dialog_closeDialog();
            }
            this.$watch('$dialog.isOpen', async (isOpen) => {
              this.$nextTick(() => {
                if (isOpen) {
                  this.__dialog_showDialog();
                } else {
                  this.__dialog_closeDialog();
                }
              });
            });
          });
        },
      };
    },
    'x-id': "['dialog']",
  });
}

/**
 * Plugin allowing the creation of popup elements. Popups are small overlays that open on demand, typically used to display
 * additional information, provide interactive content, or act as dropdown menus.
 *
 * Usage:
 * - x-popup - Applied to the root element of the popup, initializing the  popup functionality and adding a data context for child directives
 * - x-popup:popup - Specifies the actual popup element, which is displayed when the popup is active.
 * - x-popup:target - Specifies the target element that triggers the popup. Interaction with
 *   this element (e.g., click or hover) will control the display of the popup content.
 * - x-popup:float-reference - Optional directive that specifies the element that the popup should float itself in relation to (by default is the x-popup:target)
 * - x-popup:button - Adds the necessary attributes to an element to toggle the popup when clicked
 *
 * The '$popup' magic property provides an API for managing the popup's state, including
 * opening, closing, and querying its visibility. It allows for programmatic control over the
 * popup component.
 *
 * @example
 *
 * <div x-popup>
 *   <button x-popup:target x-popup:button>Toggle Popup</button>
 *   <div x-cloak x-popup:popup>
 *     I'm a popup!
 *   </div>
 * </div>
 *
 * Note: Add .nofloat modifier (e.g. x-popup:popup.nofloat) to disable floating behavior if you want to position the popup manually.
 */
function popup(Alpine) {
  Alpine.directive('popup', ($el, data, utilities) => {
    if (!isHtmlElement($el)) {
      throw new Error(`Expected HTMLElement but got ${$el}`);
    }
    if (data.value === 'popup') {
      handlePopup($el, Alpine, data, utilities);
    } else if (data.value === 'target') {
      handleTarget$1($el, Alpine);
    } else if (data.value === 'float-reference') {
      handleFloatReference($el, Alpine);
    } else if (data.value == 'arrow') {
      handleArrow$2($el, Alpine);
    } else if (data.value === 'button') {
      handleButton$4($el, Alpine);
    } else if (data.value === null) {
      handleRoot$g($el, Alpine, data, utilities);
    } else {
      throw new Error(`Unknown directive: x-popup:${data.value}`);
    }
  }).before('bind');
  Alpine.magic('popup', handlePopupMagic(Alpine));
}
function handlePopupMagic(Alpine) {
  return function ($el) {
    const $data = Alpine.$data($el);
    return mergeProperties(
      {},
      {
        get isOpen() {
          var _a;
          return (_a = $data.__disclosure_state) === null || _a === void 0 ? void 0 : _a.isExpanded;
        },
        set isOpen(value) {
          if (!$data.__disclosure_state) return;
          $data.__disclosure_state.isExpanded = value;
        },
        open() {
          var _a;
          (_a = $data.__disclosure_state) === null || _a === void 0 ? void 0 : _a.expand();
        },
        close() {
          var _a;
          (_a = $data.__disclosure_state) === null || _a === void 0 ? void 0 : _a.collapse();
        },
        get targetEl() {
          return $data.__popup_targetEl;
        },
        get popupEl() {
          return $data.__popup_popupEl;
        },
        get floatReferenceEl() {
          return $data.__popup_floatReferenceEl;
        },
        set floatReferenceEl(el) {
          $data.__popup_floatReferenceEl = el;
        },
      },
      handleFloatMagic(Alpine)($el),
    );
  };
}
function handleButton$4($el, Alpine) {
  Alpine.bind($el, {
    'x-disclosure:button': '',
    'x-popup:target': '',
    'aria-haspopup': 'true',
  });
}
function handleFloatReference($el, Alpine) {
  Alpine.bind($el, {
    'x-init': '__popup_floatReferenceEl = $el',
  });
}
function handleTarget$1($el, Alpine) {
  Alpine.bind($el, {
    ':id': `$el.id || $id('popup-target')`,
    'x-init': '__popup_targetEl = $el',
    ':aria-expanded': '$popup.isOpen',
    ':aria-controls': '__popup_popupEl?.id',
  });
}
function handlePopup($el, Alpine, {modifiers, expression}, {evaluate}) {
  // Allow disabling x-float
  let shouldFloat = modifiers.includes('nofloat') ? false : true;
  modifiers.includes('update');
  let floatModifiers = modifiers.join('.') || 'bottom.auto';
  const floatOptions = expression ? evaluate(expression) : {};
  const shouldAutoClose = Alpine.$data($el).__popup_autoclose;
  Alpine.bind(
    $el,
    Object.assign(
      Object.assign(
        Object.assign(
          {
            'x-disclosure:panel': '',
            'x-data'() {
              return {
                init() {
                  this.$data.__popup_popupEl = $el;
                  if (shouldFloat) {
                    // TODO investigate hooking into Alpine's el._x_doShow / el._x_doHide hooks to enable / disable floating
                    if (this.$popup.isOpen) {
                      this.__popup_enableFloating();
                    }
                    this.$watch('$popup.isOpen', (isOpen) => {
                      if (isOpen) {
                        this.__popup_enableFloating();
                      } else {
                        this.__popup_disableFloating();
                      }
                    });
                  }
                },
                __popup_enableFloating() {
                  // Wait until next tick to enable auto update to ensure that the float reference el exists and any other dom updates have been made
                  this.$nextTick(() => {
                    this.$float.referenceEl = this.$data.__popup_floatReferenceEl || this.$data.__popup_targetEl;
                    this.$float.enableAutoUpdate();
                  });
                },
                __popup_disableFloating() {
                  var _a, _b;
                  (_b = (_a = this.$float).disableAutoUpdate) === null || _b === void 0 ? void 0 : _b.call(_a);
                },
              };
            },
          },
          shouldFloat
            ? {
                [`x-float.${floatModifiers}`]() {
                  return Object.assign(Object.assign({}, floatOptions), {autoUpdate: false, initialUpdate: false});
                },
              }
            : {},
        ),
        {':tabindex': '-1'},
      ),
      shouldAutoClose
        ? {
            '@keydown.escape.stop.prevent': `
            if (!$popup.isOpen) return

            $popup.close()

            if (__popup_returnFocusAfterClose) {
              await $disclosure.waitForAnimations()
              __popup_targetEl?.focus()
            }
          `,
            '@mousedown.outside': `
            if (!$popup.isOpen) return
            if (!__popup_autoclose) return
            if (__popup_popupEl?.contains($event.target)) return
            if (__popup_targetEl?.contains($event.target)) return
            $popup.close()
          `,
            '@focusin.window': `
            if (!$popup.isOpen) return
            if (!__popup_autoclose) return
            if (__popup_popupEl?.contains($event.target)) return
            if (__popup_targetEl?.contains($event.target)) return
            $popup.close()
          `,
          }
        : {},
    ),
  );
}
function handleArrow$2($el, Alpine) {
  Alpine.bind($el, {
    'x-float:arrow': '',
  });
}
function handleRoot$g($el, Alpine, {modifiers, expression}, {evaluate}) {
  let options = evaluate(expression === '' ? '{}' : expression);
  const disclosureModifiers = modifiers.filter((modifier) => ['open', 'noanimate'].includes(modifier));
  // Prevent popup from returning focus to the target element after closing
  const returnFocusAfterClose = !modifiers.includes('noreturn');
  // Prevent automatically closing the popup when clicking outside of it
  const autoclose = !modifiers.includes('noclose');
  Alpine.bind($el, {
    [`x-disclosure.${disclosureModifiers.join('.')}`]() {
      if (isPlainObject(options)) {
        // Rename isOpen property to isExpanded which is what the disclosure expects
        if ('isOpen' in options) {
          renameProperty(options, 'isOpen', 'isExpanded');
        }
        if ('isInitiallyOpen' in options) {
          renameProperty(options, 'isInitiallyOpen', 'isInitiallyExpanded');
        }
      }
      return options;
    },
    ['x-id']: "['popup', 'popup-target']",
    'x-data'() {
      return {
        __popup_returnFocusAfterClose: returnFocusAfterClose,
        __popup_autoclose: autoclose,
        __popup_targetEl: null,
        __popup_floatReferenceEl: null,
        __popup_popupEl: null,
        __popup_rootEl: $el,
      };
    },
  });
}

const selectors$1 = {
  listbox: '[role="listbox"]',
  listboxOption: '[role="option"]',
  enabledListboxOption: '[role="option"]:not([aria-disabled=true])',
};
/**
 * Enables the creation and management of accessible listbox components, following ARIA practices.
 * The 'listbox' directive and '$listbox' magic property provide functionality for managing listbox
 * options, selection state, and keyboard interactions.
 *
 * See https://www.w3.org/WAI/ARIA/apg/patterns/listbox/ for more information about listboxes
 *
 * Note:
 * - Requires method-ui 'roving-tab' plugin
 * - Requires method-ui 'focus-match' plugin
 *
 * Usage:
 * - x-listbox (on <ul>, <ol>, or <div>) - Transforms the element into an Alpine.js-managed listbox.
 * - x-listbox:display - Binds to an element to display the selected value of the listbox.
 * - x-listbox:hidden-input   - Binds to an input element to store the selected value of the listbox.
 * - x-listbox:options - Defines the container for the listbox options.
 * - x-listbox:option  - Assigns to each listbox option, handling selection and keyboard navigation.
 *
 * The '$listbox' magic property provides an API for managing the listbox state, including methods
 * like 'select', 'deselect', and properties like 'selectedValue'
 *
 * @example
 *
 * <div x-listbox>
 *   <input type="hidden" name="my-input" x-listbox:hidden-input></span>
 *   <span x-listbox:display></span>
 *   <ul x-listbox:options>
 *     <li x-listbox:option="1">Option 1</li>
 *     <li x-listbox:option="2">Option 2</li>
 *     <li x-listbox:option="3">Option 3</li>
 *   </ul>
 * </div>
 */
function listbox(Alpine) {
  Alpine.directive('listbox', ($el, data, utilities) => {
    if (!isHtmlElement($el)) {
      throw new Error(`Expected HTMLElement but got ${$el}`);
    }
    if (data.value === 'display') {
      handleDisplay$1($el, Alpine);
    } else if (data.value === 'hidden-input') {
      handleHiddenInput$1($el, Alpine);
    } else if (data.value === 'options') {
      handleOptions$2($el, Alpine);
    } else if (data.value === 'option') {
      handleOption$2($el, Alpine);
    } else if (data.value === null) {
      handleRoot$f($el, Alpine);
    } else {
      throw new Error(`Unknown directive: x-listbox:${data.value}`);
    }
  }).before('bind');
  Alpine.magic('listbox', handleListboxMagic(Alpine));
  Alpine.magic('listboxOption', handleListboxOptionMagic(Alpine));
}
function handleListboxMagic(Alpine) {
  return function ($el) {
    const $data = Alpine.$data($el);
    // TODO figure out a way to not have to manually bind these methods to the component like this
    return {
      isSelected(value) {
        return $data.__listbox_isSelected(value);
      },
      select(value, dispatch) {
        return $data.__listbox_select(value, dispatch);
      },
      deselect() {
        return $data.__listbox_deselect();
      },
      get selectedValue() {
        return $data.__listbox_selectedValue;
      },
      get options() {
        return $data.__listbox_options;
      },
      get enabledOptions() {
        return $data.__listbox_enabledOptions;
      },
    };
  };
}
function handleListboxOptionMagic(Alpine) {
  return function ($el) {
    const $data = Alpine.$data($el);
    return {
      get isSelected() {
        return $data.__listboxOption_isSelected;
      },
      get isDisabled() {
        return $data.__listboxOption_isDisabled;
      },
      select(options) {
        return $data.__listboxOption_select(options);
      },
    };
  };
}
function handleOptions$2($el, Alpine) {
  Alpine.bind($el, {
    'x-init'() {
      this.__listbox_optionsEl = $el;
    },
    'x-roving-tab:list': ``,
    ':id': `$el.id || $id('listbox-options')`,
    ':role': "'listbox'",
    ':tabindex': '-1',
    ':aria-labelledby': '__listbox_displayValue?.id',
  });
}
function handleOption$2($el, Alpine) {
  Alpine.bind($el, {
    ['x-data']() {
      return {
        __listboxOption_isDisabled: false,
        init() {
          this.__listboxOption_isDisabled = Boolean(Alpine.extractProp(this.$el, 'aria-disabled', false));
          this.$nextTick(() => {
            if (this.__listboxOption_isSelected && !this.__listboxOption_isDisabled) {
              this.$rovingTab.setTabbable(this.$el);
            } else if (this.__listboxOption_isDisabled) {
              this.$el.setAttribute('tabindex', '-1');
            }
          });
          this.$watch('__listboxOption_isDisabled', (isDisabled) => {
            if (isDisabled) {
              this.$el.setAttribute('tabindex', '-1');
            }
          });
        },
        __listboxOption_select(options) {
          if (
            (options === null || options === void 0 ? void 0 : options.disabled) !== true &&
            this.__listboxOption_isDisabled
          )
            return;
          this.$data.__listbox_select(
            this.$el.getAttribute('value'),
            options === null || options === void 0 ? void 0 : options.dispatch,
          );
        },
        get __listboxOption_isSelected() {
          return this.$data.__listbox_isSelected(this.$el.getAttribute('value'));
        },
      };
    },
    ':role': "'option'",
    ':aria-selected': '__listboxOption_isSelected',
    ':aria-disabled': '__listboxOption_isDisabled',
    '@click'() {
      if (this.$el.getAttribute('value') == null) return;
      this.$event.stopPropagation();
      this.$event.preventDefault();
      this.__listboxOption_select();
    },
    '@keydown.enter'() {
      if (this.$el.getAttribute('value') == null) return;
      this.$event.stopPropagation();
      this.$event.preventDefault();
      this.__listboxOption_select();
    },
    '@keydown.space'() {
      if (this.$el.getAttribute('value') == null) return;
      this.$event.stopPropagation();
      this.$event.preventDefault();
      this.__listboxOption_select();
    },
  });
}
function handleHiddenInput$1($el, Alpine) {
  Alpine.bind($el, {
    'x-init': `__listbox_hiddenInputEl = $el`,
    'x-model.fill': '$data.__listbox_selectedValue',
    'x-modelable': '$data.__listbox_selectedValue',
  });
}
function handleDisplay$1($el, Alpine) {
  Alpine.bind($el, {
    'x-init'() {
      this.__listbox_displayValue = $el;
    },
    'x-effect'() {
      var _a;
      if (this.__listbox_options.length == 0) return;
      if (this.__listbox_selectedOption) {
        const clonedSelectedOption =
          (_a = this.__listbox_selectedOption) === null || _a === void 0 ? void 0 : _a.cloneNode(true);
        if (clonedSelectedOption) {
          this.$el.replaceChildren(...clonedSelectedOption.childNodes);
        }
      } else {
        // If there's no selected option, clear out the display value
        this.$el.replaceChildren();
      }
    },
    ':id': `$el.id || $id('listbox-display')`,
  });
}
function handleRoot$f($el, Alpine) {
  Alpine.bind($el, {
    'x-id': "['listbox', 'listbox-options', 'listbox-display']",
    'x-roving-tab.vertical.nowrap': `__listbox_enabledOptions`,
    ':id': `$el.id || $id('listbox')`,
    ['x-data']() {
      return listbox$1();
    },
  });
}
function listbox$1() {
  return {
    __listbox_displayValue: null,
    __listbox_optionsEl: null,
    __listbox_hiddenInputEl: null,
    __listbox_selectedValue: null,
    get __listbox_selectedOption() {
      var _a;
      return (
        ((_a = this.__listbox_optionsEl) === null || _a === void 0
          ? void 0
          : _a.querySelector(`[value="${escapeValue(this.__listbox_selectedValue) || ''}"]`)) || null
      );
    },
    __listbox_select(value, dispatch = true) {
      this.__listbox_selectedValue = value;
      if (dispatch) {
        // Usage of next tick here ensures that the event is being dispatched _after_ the hidden input value has changed so that select integrates properly with forms
        this.$nextTick(() => {
          this.$dispatch('change', value);
          this.$dispatch('input', value);
        });
      }
    },
    __listbox_deselect() {
      this.__listbox_selectedValue = null;
    },
    __listbox_isSelected(value) {
      return this.__listbox_selectedValue === value;
    },
    get __listbox_options() {
      var _a;
      return (
        ((_a = this.__listbox_optionsEl) === null || _a === void 0
          ? void 0
          : _a.querySelectorAll(selectors$1.listboxOption)) || []
      );
    },
    get __listbox_enabledOptions() {
      var _a;
      return (
        ((_a = this.__listbox_optionsEl) === null || _a === void 0
          ? void 0
          : _a.querySelectorAll(selectors$1.enabledListboxOption)) || []
      );
    },
  };
}
function escapeValue(value) {
  if (!isString(value)) return null;
  return value === null || value === void 0 ? void 0 : value.replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, '\\$&');
}

/**
 * IMPORTANT: once custom-styled HTML selects have broad support we'll likely burn this in fire and just use that.
 *
 * Enable the creation and management of accessible select-only selects which provide an interface for selecting an
 * item from a list.

 * See https://www.w3.org/WAI/ARIA/apg/patterns/select/examples/select-select-only/ for more information about selects:
 * Partly inspired by https://react-spectrum.adobe.com/react-aria/Select.html
 *
 * Notes:
 * - Requires method-ui 'listbox' plugin
 * - Requires method-ui 'popover' plugin
 *
 * Usage:
 * - x-select - Applied to the root element of the select, initializing the select functionality and adding a data context for child directives
 * - x-select:button  - Binds to an input element to store the selected value of the select.
 * - x-select:options - Defines the container for the select options.
 * - x-select:option  - Assigns to each select option, handling selection and keyboard navigation. The children of the option will be rendered as the selected value of the select when it is closed.
 * - x-select:panel - Specifies the element that acts as the popup content for the select.
 * - x-select:target  - Indicates the target element for the popup, typically the input element.
 * - x-select:display - Renders the selected value of the select when it is closed
 *
 * The '$select' magic property merges the functionalities of '$listbox' and '$popup', providing
 * a comprehensive API for managing the select state, including selection, popup visibility, and
 * keyboard interactions.
 *
 * Usage with <label> elements:
 * x-select may be used in conjunction with HTML <label> elements using the `for` attribute.
 *
 * e.g.
 *
 * <label for="my-select">My Select</label>
 * <div x-select>
 *   <button x-select:button id="my-select">My Select</button>
 *   ...
 * </div>
 *
 * This will cause x-select to find the <label> element with the matching `for` attribute, add an id attribute
 * to the label element (if it does not already have one), and then add that to the generated aria-labelledby
 * attribute on the button
 * */
function select(Alpine) {
  Alpine.directive('select', ($el, data) => {
    if (!isHtmlElement($el)) {
      throw new Error(`Expected HTMLElement but got ${$el}`);
    }
    if (data.value === 'label') {
      handleLabel($el, Alpine);
    } else if (data.value === 'button') {
      handleButton$3($el, Alpine);
    } else if (data.value === 'hidden-input') {
      handleHiddenInput($el, Alpine);
    } else if (data.value === 'display') {
      handleDisplay($el, Alpine);
    } else if (data.value === 'options') {
      handleOptions$1($el, Alpine);
    } else if (data.value === 'option') {
      handleOption$1($el, Alpine, data);
    } else if (data.value === 'panel') {
      handlePanel$2($el, Alpine, data);
    } else if (data.value === null) {
      handleRoot$e($el, Alpine, data);
    } else {
      throw new Error(`Unknown directive: x-select:${data.value}`);
    }
  }).before('bind');
  Alpine.magic('select', handleSelectMagic(Alpine));
}
function handleSelectMagic(Alpine) {
  return function ($el) {
    return mergeProperties({}, handleListboxMagic(Alpine)($el), handlePopupMagic(Alpine)($el));
  };
}
function handleButton$3($el, Alpine) {
  Alpine.bind($el, {
    ['x-data']() {
      return {
        __select_onKeyDown(e) {
          if (isPrintableCharacter(e.key)) {
            this.$select.open();
            this.$nextTick(() => {
              this.$focusMatch.setFocusByFirstCharacter(e.key);
            });
          }
        },
      };
    },
    'x-init': '__select_buttonEl = $el',
    'x-popover:button': '',
    ':tabindex': '0',
    ':id': "$el.id || $id('select-button')",
    ':aria-labelledby': "[__select_displayEl?.id || $el.id, __select_labelEl?.id].filter(Boolean).join(' ')",
    ':aria-controls': '__listbox_optionsEl?.id',
    'aria-haspopup': 'listbox',
    '@keydown.down.stop.prevent': '$popup.open()',
    '@keydown': '__select_onKeyDown',
  });
}
function handleHiddenInput($el, Alpine) {
  Alpine.bind($el, {
    'x-listbox:hidden-input': '',
  });
}
function handleDisplay($el, Alpine) {
  Alpine.bind($el, {
    'x-init': '__select_displayEl = $el',
    'x-listbox:display': '',
  });
}
function handleLabel($el, Alpine) {
  Alpine.bind($el, {
    'x-init': '__select_labelEl = $el',
    ':id': "$el.id || $id('select-label')",
  });
}
function handlePanel$2($el, Alpine, data) {
  Alpine.bind(
    $el,
    Object.assign(
      Object.assign(
        {},
        data.modifiers.length
          ? {
              [`x-popover:panel.${data.modifiers.join('.')}`]: '',
            }
          : {
              [`x-popover:panel.bottom-start.flip.match.update.shift.fit-y.pad.5px`]: '',
            },
      ),
      {
        // Unset aria-labelledby as we want the listbox to be the thing that is labelled
        ':aria-labelledby': 'null',
        'x-init': '__select_panelEl = $el',
      },
    ),
  );
}
function handleOptions$1($el, Alpine) {
  Alpine.bind($el, {
    'x-init': '__select_optionsEl = $el',
    'x-listbox:options': '',
    'x-focus-match:list': ``,
    ':aria-labelledby': '__select_labelEl?.id || __select_buttonEl?.id',
    tabindex: '-1',
  });
}
function handleOption$1($el, Alpine, {expression}) {
  Alpine.bind($el, {
    'x-listbox:option': expression,
  });
}
function handleRoot$e($el, Alpine, {modifiers, expression}) {
  Alpine.bind($el, {
    [`x-popover.${modifiers.join('.')}`]: expression || '',
    'x-listbox': '',
    'x-focus-match': `$listbox.enabledOptions`,
    ':aria-labelledby': 'null',
    'x-id': "['select-button', 'select-label']",
    'x-scroll-lock': '$popup.isOpen',
    // Close popup when option is selected and return focus to button
    '@change': `
      if ($popup.isOpen) {
        $popup.close()
        await $disclosure.waitForAnimations()
        __select_buttonEl.focus()
      }
    `,
    ['x-data']() {
      return {
        __select_displayEl: null,
        __select_buttonEl: null,
        __select_panelEl: null,
        __select_optionsEl: null,
        __select_labelEl: null,
        init() {
          this.$nextTick(() => {
            var _a, _b;
            // Wait until next animation frame to prevent interfering with initial focus
            window.requestAnimationFrame(() => {
              const allOptions = Array.from(this.$listbox.options || []);
              const ariaSelectedOption = allOptions.find((option) => option.getAttribute('aria-selected') === 'true');
              const firstOption = allOptions[0];
              const initiallySelectedOption = ariaSelectedOption || firstOption;
              if (initiallySelectedOption) {
                const $optionData = Alpine.$data(initiallySelectedOption);
                $optionData.__listboxOption_select({dispatch: false, disabled: true});
              }
            });
            // If no explicit label is provided with `x-select:label`, try to find an label related to the button with for="button-id"
            // then assign a unique id to that label el
            if (!this.__select_labelEl && this.__select_buttonEl) {
              this.__select_labelEl = document.querySelector(
                `[for="${(_a = this.__select_buttonEl) === null || _a === void 0 ? void 0 : _a.id}"]`,
              );
              if (this.__select_labelEl && !((_b = this.__select_labelEl) === null || _b === void 0 ? void 0 : _b.id)) {
                this.__select_labelEl.id = this.$id('select-label');
              }
            }
          });
        },
      };
    },
  });
}

const selectors = {
  tablist: '[role="tablist"]',
  tab: '[role="tab"]',
  tabpanel: '[role="tabpanel"]',
};
/**
 * Enables the creation and management of accessible tabs components, following ARIA practices.
 * The 'tabs' directive and '$tabs' magic property provide functionality for managing tabs
 * options, selection state, and keyboard interactions.
 *
 * See https://www.w3.org/WAI/ARIA/apg/patterns/tabs/ for more information about listboxes
 *
 * TODO document directives
 *
 * The '$tabs' magic property provides an API for managing the tabs state, including methods
 * like 'select', and properties like 'isSelected'
 *
 * @example
 *
 * <div x-tabs>
 *   <ul x-tabs:tablist>
 *     <li :class="$tabs.isSelected(0) ? 'bg-primary' : 'bg-transparent'">
 *       <button type="button" x-tabs:tab>Tab 1</button>
 *     </li>
 *     <li :class="$tabs.isSelected(1) ? 'bg-primary' : 'bg-transparent'">
 *       <button type="button" x-tabs:tab>Tab 2</button>
 *     </li>
 *     <li :class="$tabs.isSelected(2) ? 'bg-primary' : 'bg-transparent'">
 *       <button type="button" x-tabs:tab>Tab 3</button>
 *     </li>
 *   </ul>
 *   <div x-tabs:tabpanel>Panel 1</div>
 *   <div x-tabs:tabpanel x-cloak>Panel 2</div>
 *   <div x-tabs:tabpanel x-cloak>Panel 3</div>
 * </div>
 */
var tabs = (Alpine) => {
  Alpine.directive('tabs', ($el, data, utilities) => {
    if (data.value == 'tab') {
      handleTab($el, Alpine, data, utilities);
    } else if (data.value == 'tablist') {
      handleTabList($el, Alpine, data, utilities);
    } else if (data.value == 'tabpanel') {
      handleTabPanel($el, Alpine, data, utilities);
    } else if (data.value == null) {
      handleRoot$d($el, Alpine, data, utilities);
    } else {
      throw new Error(`Unknown directive: x-tabs:${data.value}`);
    }
  }).before('bind');
  Alpine.magic('tabs', handleTabsMagic(Alpine));
  Alpine.magic('tab', handleTabMagic(Alpine));
};
function handleTabsMagic(Alpine) {
  return function ($el) {
    const $data = Alpine.$data($el);
    return {
      select(index) {
        var _a;
        (_a = $data.__disclosure_group_state) === null || _a === void 0 ? void 0 : _a.expand(index);
      },
      isSelected(index) {
        var _a;
        return (_a = $data.__disclosure_group_state) === null || _a === void 0 ? void 0 : _a.isExpanded(index);
      },
      get selectedIndex() {
        var _a;
        if (!$data.__disclosure_group_state) return null;
        return (_a = $data.__disclosure_group_state) === null || _a === void 0 ? void 0 : _a.expandedIndex;
      },
      get tabCount() {
        var _a;
        return (
          Array.from((_a = $data.__disclosure_group_state) === null || _a === void 0 ? void 0 : _a.items).length || 0
        );
      },
    };
  };
}
// This works for both tabs and tab panels
function handleTabMagic(Alpine) {
  return function ($el) {
    const $data = Alpine.$data($el);
    return {
      select() {
        $data.__tab_select();
      },
      get isSelected() {
        return $data.__tab_isSelected;
      },
      get index() {
        return $data.__tab_index;
      },
    };
  };
}
function handleTab($el, Alpine, {}, {}) {
  Alpine.bind($el, {
    'x-data'() {
      return {
        get __tab_isSelected() {
          return this.$disclosureGroup.isExpanded(this.__tab_index);
        },
        __tab_select() {
          this.$disclosureGroup.expand(this.__tab_index);
        },
        get __tab_index() {
          return Array.from(this.__tabs_getTabEls()).indexOf($el);
        },
      };
    },
    'x-id': "['tab']",
    ':id': `$id('tab')`,
    ':role': "'tab'",
    '@click': `$tab.select()`,
    '@mousedown.prevent': '',
    '@focus': `if (!window.matchMedia('(pointer: coarse)').matches) $tab.select()`, // Disable automatic select on touch devices
    ':tabindex': `$tab.isSelected ? 0 : -1`,
    ':aria-selected': `$disclosureGroup.isExpanded(__tab_index)`,
    ':aria-controls': `Array.from($disclosureGroup.items)[__tab_index]?.id`,
  });
}
function handleTabList($el, Alpine, {}, {}) {
  Alpine.bind($el, {
    'x-roving-tab:list': ``,
    ':role': "'tablist'",
    ':aria-orientation': `__tabs_orientation`,
    '@keydown.home.prevent.stop': '$focus.first()',
    '@keydown.page-up.prevent.stop': '$focus.first()',
    '@keydown.end.prevent.stop': '$focus.last()',
    '@keydown.page-down.prevent.stop': '$focus.last()',
  });
}
function handleTabPanel($el, Alpine, {modifiers}, {}) {
  const disclosureModifiers = modifiers.filter((modifier) => ['debug', 'open', 'static'].includes(modifier));
  Alpine.bind(
    $el,
    Object.assign(
      Object.assign(
        {
          'x-data'() {
            return {
              get __tab_isSelected() {
                return this.$disclosure.isExpanded;
              },
              __tab_select() {
                this.$disclosure.expand();
              },
              get __tab_index() {
                return this.$disclosure.groupIndex;
              },
            };
          },
          'x-id': "['tab-panel']",
          ':id': `$id('tab-panel')`,
          role: 'tabpanel',
        },
        disclosureModifiers.length
          ? {
              [`x-disclosure.noanimate.${disclosureModifiers.join('.')}`]: '',
            }
          : {
              'x-disclosure.noanimate': '',
            },
      ),
      {
        'x-disclosure:panel': '',
        ':aria-labelledby': `Array.from(__tabs_getTabEls())[$disclosureGroup.indexOf($el)]?.id`,
        ':tabindex': `$disclosure.isExpanded ? 0 : -1`,
      },
    ),
  );
}
function handleRoot$d($el, Alpine, {modifiers, expression}, {evaluate}) {
  const orientation = modifiers.includes('vertical') ? 'vertical' : 'horizontal';
  let options = evaluate(expression === '' ? '{}' : expression);
  Alpine.bind(
    $el,
    Object.assign(
      {
        ['x-data']() {
          return {
            __tabs_rootEl: $el,
            __tabs_orientation: orientation || 'horizontal',
            __tabs_getTabListEl() {
              return $el.querySelector(selectors.tablist);
            },
            __tabs_getTabEls() {
              var _a;
              return (
                ((_a = this.__tabs_getTabListEl()) === null || _a === void 0
                  ? void 0
                  : _a.querySelectorAll(selectors.tab)) || []
              );
            },
          };
        },
        'x-disclosure-group'() {
          let disclosureGroupOptions = {};
          // Rename selectedIndex property to expandedIndex which is what the disclosure group expects
          if ('selectedIndex' in options) {
            copyProperty(options, disclosureGroupOptions, 'selectedIndex', 'expandedIndex');
          } else {
            disclosureGroupOptions.initiallyExpandedIndex = 0;
          }
          return disclosureGroupOptions;
        },
      },
      orientation == 'vertical'
        ? {
            'x-roving-tab.vertical': '__tabs_getTabEls',
          }
        : {
            'x-roving-tab': '__tabs_getTabEls',
          },
    ),
  );
  return {};
}

function section(Alpine) {
  Alpine.store('sectionData', {});
  /**
   * Get and set data for the closest ancestor section in a global Alpien store keyed by section id
   * This is most useful for the theme editor when you want to maintain state between section content updates
   */
  Alpine.magic('sectionData', ($el) => {
    var _a;
    const sectionId = (_a = closestSectionEl($el)) === null || _a === void 0 ? void 0 : _a.id;
    return new Proxy(
      {},
      {
        get(_target, prop) {
          if (!sectionId) return null;
          if (!(sectionId in Alpine.store('sectionData'))) return null;
          return Alpine.store('sectionData')[sectionId][prop];
        },
        set(_target, prop, value) {
          if (!sectionId) return false;
          if (!(sectionId in Alpine.store('sectionData'))) {
            Alpine.store('sectionData')[sectionId] = {};
          }
          Alpine.store('sectionData')[sectionId][prop] = value;
          return true;
        },
      },
    );
  });
  Alpine.magic('sectionEl', ($el) => {
    return closestSectionEl($el);
  });
  Alpine.magic('sectionId', ($el) => {
    var _a;
    const rawId = (_a = closestSectionEl($el)) === null || _a === void 0 ? void 0 : _a.id;
    if (!rawId) return null;
    if (rawId.startsWith('shopify-section-')) {
      return rawId.split('shopify-section-')[1];
    } else {
      return rawId;
    }
  });
}

const DATA_EXCLUDE_SUBTREE_ATTRIBUTE = 'data-skip-animation-wait';
const DEFAULT_EXCLUDE_SUBTREE_FILTER = (element) => element.hasAttribute(DATA_EXCLUDE_SUBTREE_ATTRIBUTE);
const ANIMATION_START_TIMEOUT = 50; // ms
const ANIMATION_COMPLETION_TIMEOUT = 2000; // ms
function animationUtils(Alpine) {
  Alpine.magic('waitForAnimations', function ($el) {
    return async function (options) {
      var _a;
      const parentEl =
        (_a = options === null || options === void 0 ? void 0 : options.target) !== null && _a !== void 0 ? _a : $el;
      const animations = await getPendingAnimations(parentEl, options);
      return getCompletedAnimations(
        parentEl,
        animations,
        options === null || options === void 0 ? void 0 : options.subtree,
        options === null || options === void 0 ? void 0 : options.excludeSubtree,
      );
    };
  });
}
/**
 * Returns a promise that resolves when all animations on the element have started. Waits for a short period of time, and if no animations have started it will reject with an error
 *
 * @param $el Element to check for animations
 * @returns
 */
async function getPendingAnimations($el, options = {}) {
  return new Promise((resolve, reject) => {
    let startTimeout = ANIMATION_START_TIMEOUT;
    if ((options === null || options === void 0 ? void 0 : options.startTimeout) !== undefined) {
      if (options.startTimeout === false) {
        startTimeout = 0;
      } else {
        startTimeout = options.startTimeout;
      }
    }
    // Wait for a short period of time, and if no animations have started output an error
    setTimeout(() => {
      let animations = $el.getAnimations(options);
      if (options.excludeSubtree) {
        animations = filterSubtreeAnimations($el, animations, options.excludeSubtree);
      }
      if (animations.length === 0) {
        warnForNoAnimationsStarted($el, options === null || options === void 0 ? void 0 : options.subtree);
        resolve([]);
      } else {
        resolve(animations);
      }
    }, startTimeout);
  });
}
/**
 * Returns a promise that resolves when all animations on the element have finished, or rejects if any animations don't finish within a timeout
 * @param $el Element animations are occuring on
 * @param animations Animations to wait for
 * @param subtree Whether to include animations in subtree
 * @param excludeSubtree Optional filter to exclude certain animations in subtree
 */
async function getCompletedAnimations(
  $el,
  animations,
  subtree = false,
  excludeSubtree = DEFAULT_EXCLUDE_SUBTREE_FILTER,
) {
  let timedOutAnimations = [];
  let filteredAnimations = filterSubtreeAnimations($el, animations, excludeSubtree);
  const animationPromises = filteredAnimations.map((animation) => animation.finished);
  await promiseAllSettledWithTimeout(animationPromises, ANIMATION_COMPLETION_TIMEOUT).then((results) => {
    results.forEach((result, i) => {
      if (result.status === 'rejected' && result.reason === 'timeout') {
        timedOutAnimations = [...timedOutAnimations, filteredAnimations[i]];
      }
    });
  });
  if (timedOutAnimations.length > 0) {
    warnForNoAnimationsFinished($el, filteredAnimations, timedOutAnimations, subtree);
    return [];
  }
  return filteredAnimations;
}
function warnForNoAnimationsStarted($el, subtree = false) {
  if (process.env.NODE_ENV !== 'development') return;
  if (subtree) {
    console.warn(
      `Expected animations or transitions to start on element or its descendants, but none did after waiting ${ANIMATION_START_TIMEOUT}ms`,
      $el,
    );
  } else {
    console.warn(
      `Expected animations or transitions to start on element, but none did after waiting ${ANIMATION_START_TIMEOUT}ms`,
      $el,
    );
  }
}
function warnForNoAnimationsFinished($el, started, unfinished, subtree = false) {
  if (process.env.NODE_ENV !== 'development') return;
  if (subtree) {
    console.warn(
      `Expected all animations or transitions on element and its descendants to finish within ${ANIMATION_COMPLETION_TIMEOUT}ms, but ${unfinished.length} of ${started.length} did not`,
      $el,
      unfinished,
    );
  } else {
    console.warn(
      `Expected all animations or transitions on element to finish within ${ANIMATION_COMPLETION_TIMEOUT}ms, but ${unfinished.length} of ${started.length} did not`,
      $el,
      unfinished,
    );
  }
}
function promiseAllSettledWithTimeout(promises, timeoutMs) {
  return Promise.allSettled(promises.map((promise) => withTimeout(promise, timeoutMs)));
}
async function withTimeout(promise, timeoutMs) {
  let timeoutHandle;
  const timeoutPromise = new Promise((_resolve, reject) => {
    timeoutHandle = setTimeout(() => {
      reject('timeout');
    }, timeoutMs);
  });
  return Promise.race([promise, timeoutPromise])
    .then((result) => {
      clearTimeout(timeoutHandle);
      return result;
    })
    .catch((error) => {
      clearTimeout(timeoutHandle);
      throw error;
    });
}
function isKeyframeEffect(effect) {
  return effect instanceof KeyframeEffect;
}
/**
 * Filters out any animations who's target element matches the filter or any of its ancestors
 * @param animations
 * @param filter
 */
function filterSubtreeAnimations(rootEl, animations, filter) {
  // Traverse up the tree from the animated element to the root element, and check if any of the ancestors are excluded by the filter
  const hasExcludedAncestor = (animatedElement) => {
    let parent = animatedElement.parentElement;
    if (animatedElement === rootEl) {
      return false;
    }
    if (parent === rootEl) {
      return false;
    }
    while (parent) {
      if (filter(parent)) return true;
      parent = parent.parentElement;
    }
    return false;
  };
  // Only return animations that are not excluded by the filter
  return animations.filter((animation) => {
    if (isKeyframeEffect(animation.effect)) {
      const target = animation.effect.target;
      if (!target) {
        return true;
      }
      if (filter(target)) {
        return false;
      }
      return !hasExcludedAncestor(target);
    } else {
      return true;
    }
  });
}

/**
 * TODO document
 */
function notification(Alpine) {
  Alpine.directive('notification', ($el, data, utilities) => {
    handleNotification($el, Alpine, data);
  }).before('bind');
  Alpine.magic('notification', handleNotificationMagic(Alpine));
}
function handleNotificationMagic(Alpine) {
  return function ($el) {
    if (!isHtmlElement($el)) {
      throw new Error(`Expected HTMLElement but got ${$el}`);
    }
    const $data = Alpine.$data($el);
    return {
      dismiss: $data.__notification_dismiss.bind($data),
      startTimer: $data.__notification_startTimer.bind($data),
      cancelTimer: $data.__notification_cancelTimer.bind($data),
      get visible() {
        return $data.__notification_visible;
      },
    };
  };
}
function handleNotification($el, Alpine, {modifiers}, _utilities) {
  let duration = 5000;
  if (modifiers.includes('duration')) {
    const rawValue = modifiers[modifiers.indexOf('duration') + 1];
    let match = rawValue.match(/([0-9]+)ms/);
    if (match) duration = Number(match[1]);
  }
  Alpine.bind($el, {
    ['x-data']() {
      return {
        __notification_intervalId: undefined,
        __notification_duration: duration,
        __notification_previousActiveElement: null,
        init() {
          this.$nextTick(() => {
            this.$watch('$disclosure.isExpanded', (expanded, wasExpanded) => {
              if (expanded && !wasExpanded) {
                this.__notification_previousActiveElement = document.activeElement;
                if (this.__notification_duration !== Infinity) {
                  this.__notification_startTimer();
                }
              }
            });
          });
        },
        destroy() {
          this.__notification_cancelTimer();
        },
        __notification_cancelTimer() {
          clearTimeout(this.__notification_intervalId);
          this.__notification_intervalId = undefined;
        },
        __notification_startTimer() {
          this.__notification_cancelTimer();
          this.__notification_intervalId = setTimeout(() => {
            this.__notification_dismiss();
          }, this.__notification_duration);
        },
        get __notification_visible() {
          return this.$disclosure.isExpanded;
        },
        __notification_dismiss() {
          this.__notification_cancelTimer();
          this.$disclosure.collapse();
          if (this.__notification_previousActiveElement) {
            this.$nextTick(() => {
              var _a;
              if (this.$popup.isOpen) return;
              (_a = this.__notification_previousActiveElement) === null || _a === void 0 ? void 0 : _a.focus();
              this.__notification_previousActiveElement = null;
            });
          }
        },
      };
    },
    role: 'alert',
    'x-popover': '',
    'x-popover:panel': '',
    '@focusin': '$isKeyboardActive && $notification.cancelTimer()',
    '@focusout': '$disclosure.isExpanded && $notification.startTimer()',
    'x-hover:start': '$notification.cancelTimer()',
    'x-hover:end': '$disclosure.isExpanded && $notification.startTimer()',
  });
  return {};
}

/**
 * Enables the creation of range components.
 * The 'x-range' directive provide functionality for managing range sliding input fields.
 *
 * TODO: docs
 */
function range(Alpine) {
  Alpine.directive('range', ($el, data) => {
    if (data.value == 'number-min') {
      handleNumberMin($el, Alpine);
    } else if (data.value == 'number-max') {
      handleNumberMax($el, Alpine);
    } else if (data.value == 'range-min') {
      handleRangeMin($el, Alpine);
    } else if (data.value == 'range-max') {
      handleRangeMax($el, Alpine);
    } else if (data.value == null) {
      handleRoot$c($el, Alpine);
    } else {
      throw new Error(`Unknown directive: x-range:${data.value}`);
    }
  }).before('bind');
  Alpine.magic('range', ($el) => {
    const $data = Alpine.$data($el);
    return {
      get minLimit() {
        return $data.__range_minLimit;
      },
      get maxLimit() {
        return $data.__range_maxLimit;
      },
      get minValue() {
        return $data.__range_minValue;
      },
      get maxValue() {
        return $data.__range_maxValue;
      },
      get isDormant() {
        return $data.__range_isDormant;
      },
    };
  });
}
function handleNumberMin($el, Alpine) {
  if (isInputNumberElement($el)) {
    Alpine.bind($el, {
      'x-init': '__range_numberMinEl = $el',
      'x-model.number.fill': '__range_minValue',
    });
  } else {
    throw new Error(`Expected <input type="number"> tag for x-range:number-min but got ${$el}`);
  }
}
function handleNumberMax($el, Alpine) {
  if (isInputNumberElement($el)) {
    Alpine.bind($el, {
      'x-init': '__range_numberMaxEl = $el',
      'x-model.number.fill': '__range_maxValue',
    });
  } else {
    throw new Error(`Expected <input type="number"> tag for x-range:number-max but got ${$el}`);
  }
}
function handleRangeMin($el, Alpine) {
  if (isInputRangeElement($el)) {
    const $data = Alpine.$data($el);
    $data.__range_minLimit = Number($el.min);
    Alpine.bind($el, {
      'x-init': '__range_rangeMinEl = $el',
      ':value': '__range_minValue ?? __range_minLimit',
      // Ensure the min value is always less than the max value
      '@input': '__range_minValue = Math.min($event.target.value, (__range_maxValue ?? __range_maxLimit) - 1)',
    });
  } else {
    throw new Error(`Expected <input type="range"> tag for x-range:range-min but got ${$el}`);
  }
}
function handleRangeMax($el, Alpine) {
  if (isInputRangeElement($el)) {
    const $data = Alpine.$data($el);
    $data.__range_maxLimit = Number($el.max);
    Alpine.bind($el, {
      'x-init': '__range_rangeMaxEl = $el',
      ':value': '__range_maxValue ?? __range_maxLimit',
      // Ensure the max value is always greater than the min value
      '@input': '__range_maxValue = Math.max($event.target.value, (__range_minValue ?? __range_minLimit) + 1)',
    });
  } else {
    throw new Error(`Expected <input type="range"> tag for x-range:range-max but got ${$el}`);
  }
}
function handleRoot$c($el, Alpine) {
  Alpine.bind($el, {
    ['x-data']() {
      return {
        __range_numberMinEl: null,
        __range_numberMaxEl: null,
        __range_rangeMinEl: null,
        __range_rangeMaxEl: null,
        __range_minLimit: null,
        __range_maxLimit: null,
        __range_minValue: null,
        __range_maxValue: null,
        get __range_isDormant() {
          return this.__range_minValue === this.__range_minLimit && this.__range_maxValue === this.__range_maxLimit;
        },
      };
    },
  });
}

const DEFAULT_OFFSET$1 = 10;
/**
 * Enables the creation of tooltip components.
 * The 'x-tooltip' directive provide functionality for managing tooltips based on the "x-float" directive
 *
 * - x-tooltip - The root element of the tooltip, initializing the  tooltip functionality and adding a data context for child directives
 * - x-tooltip:trigger - The element that trigger the tooltip
 * - x-tooltip:tooltip - The element that actually floats next to the trigger with the tooltip content
 * - x-tooltip:arrow - The "arrow" element. Should be inside the "content" element
 *
 * @example
 *
  <div x-tooltip class="relative">
    <div x-tooltip:trigger></div>

    <div x-tooltip.bottom.16:panel x-cloak>
      <div x-tooltip:arrow></div>

      <span>lorem ipsum</span>
    </div>
  </div>
 */
function tooltip(Alpine) {
  Alpine.directive('tooltip', ($el, data, utilities) => {
    if (data.value == 'trigger') {
      handleTrigger($el, Alpine);
    } else if (data.value == 'panel') {
      handlePanel$1($el, Alpine, data, utilities);
    } else if (data.value == 'arrow') {
      handleArrow$1($el, Alpine);
    } else if (data.value == null) {
      handleRoot$b($el, Alpine, data);
    } else {
      throw new Error(`Unknown directive: x-tooltip:${data.value}`);
    }
  }).before('bind');
}
function handleTrigger($el, Alpine) {
  Alpine.bind($el, {
    'x-hover:start.delay.300ms': '$popup.isOpen = true',
    'x-hover:end.delay.300ms': '$popup.isOpen = false',
    'x-focus-state': '$popup.isOpen = $hasFocus',
    '@keydown.escape.stop.prevent': `$popup.close()`,
    'x-popup:target': '',
    '@mousedown.outside': '$popup.close()',
    '@focusin.window': '$el !== $event.target && $popup.close()',
    ':aria-describedby': '__tooltip_tooltipEl?.id',
  });
}
function handlePanel$1($el, Alpine, {modifiers, expression}, {}) {
  Alpine.bind(
    $el,
    Object.assign(
      Object.assign(
        {},
        modifiers.length
          ? {
              [`x-popup:popup.${modifiers.join('.')}`]: expression || '',
            }
          : {
              [`x-popup:popup.absolute.bottom.offset.${DEFAULT_OFFSET$1}px.flip.update.pad.5px`]: expression || '',
            },
      ),
      {role: 'tooltip', 'x-init': '__tooltip_tooltipEl = $el'},
    ),
  );
}
function handleArrow$1($el, Alpine) {
  Alpine.bind($el, {
    'x-float:arrow': '',
  });
}
function handleRoot$b($el, Alpine, {modifiers, expression}) {
  Alpine.bind($el, {
    [`x-popup.${modifiers.join('.')}`]: expression || '',
    ['x-id']: "['tooltip', 'tooltip-trigger']",
    'x-data'() {
      return {
        __tooltip_triggerEl: null,
        __tooltip_tooltipEl: null,
      };
    },
  });
}

/**
 * Enables the creation of popover components.
 * The 'x-popover' directive provide functionality for managing popovers based on the "x-float" directive
 *
 * - x-popover - The root element of the popover, initializing the  popover functionality and adding a data context for child directives
 * - x-popover:trigger - The element that trigger the popover
 * - x-popover:popover - The element that actually floats next to the trigger with the popover content
 * - x-popover:arrow - The "arrow" element. Should be inside the "content" element
 *
 * @example
 *
  <div x-popover class="relative">
    <div x-popover:trigger></div>

    <div x-popover.bottom.16:panel x-cloak>
      <div x-popover:arrow></div>

      <span>lorem ipsum</span>
    </div>
  </div>
 */
const DEFAULT_OFFSET = 5;
function popover(Alpine) {
  Alpine.directive('popover', ($el, data, utilities) => {
    if (data.value == 'button') {
      handleButton$2($el, Alpine);
    } else if (data.value == 'panel') {
      handlePanel($el, Alpine, data, utilities);
    } else if (data.value == 'arrow') {
      handleArrow($el, Alpine);
    } else if (data.value == null) {
      handleRoot$a($el, Alpine, data);
    } else {
      throw new Error(`Unknown directive: x-popover:${data.value}`);
    }
  }).before('bind');
  Alpine.magic('popover', handlePopoverMagic(Alpine));
}
function handlePopoverMagic(Alpine) {
  return function ($el) {
    const $data = Alpine.$data($el);
    return {
      get isOpen() {
        var _a;
        return (_a = $data.__disclosure_state) === null || _a === void 0 ? void 0 : _a.isExpanded;
      },
      set isOpen(value) {
        if (!$data.__disclosure_state) return;
        $data.__disclosure_state.isExpanded = value;
      },
      open() {
        var _a;
        (_a = $data.__disclosure_state) === null || _a === void 0 ? void 0 : _a.expand();
      },
      close() {
        var _a;
        (_a = $data.__disclosure_state) === null || _a === void 0 ? void 0 : _a.collapse();
      },
    };
  };
}
function handleButton$2($el, Alpine) {
  Alpine.bind($el, {
    'x-popup:button': '',
  });
}
function handlePanel($el, Alpine, {modifiers, expression}, {}) {
  const shouldTrap = !modifiers.includes('notrap');
  Alpine.bind(
    $el,
    Object.assign(
      Object.assign(
        Object.assign(
          {},
          modifiers.length
            ? {
                [`x-popup:popup.${modifiers.join('.')}`]: expression || '',
              }
            : {
                [`x-popup:popup.absolute.bottom.offset.${DEFAULT_OFFSET}px.flip.update.shift.fit-x.pad.5px`]:
                  expression || '',
              },
        ),
        {
          role: 'popover',
          'x-data'() {
            return {
              init() {
                this.$data.__popover_popoverEl = $el;
                // TODO investigate hooking into Alpine's el._x_doShow / el._x_doHide hooks to show / hide popover
                if (isPopoverApiSupported()) {
                  if (this.$popup.isOpen) {
                    this.$nextTick(() => {
                      // Wait until next tick to ensure that the popover is rendered and positioned
                      this.__popover_showPopover();
                    });
                  }
                  this.$watch('$popup.isOpen', async (isOpen) => {
                    if (isOpen) {
                      this.__popover_showPopover();
                    } else {
                      this.__popover_hidePopover();
                    }
                  });
                }
              },
              __popover_showPopover() {
                // Adding 'popover' attribute only when opening popover forces _this_ popover to be at the top of the top layer
                $el.popover = 'manual';
                if (isDialogApiSupported() && isDialogElement($el)) {
                  $el.showModal();
                } else {
                  $el.showPopover();
                }
              },
              async __popover_hidePopover() {
                // Wait until animations have completed before hiding the popover to avoid
                // layout shifting when popover / top-layer styles are removed
                await this.$disclosure.waitForAnimations();
                // Ensure popover hasn't been reopened
                if (this.$popup.isOpen) return;
                if ($el.popover == 'manual') {
                  if (isDialogApiSupported() && isDialogElement($el)) {
                    if ($el.open) {
                      $el.close();
                    }
                  } else {
                    $el.hidePopover();
                  }
                }
                $el.popover = null;
              },
            };
          },
        },
      ),
      shouldTrap
        ? {
            'x-trap.noreturn': '$popup.isOpen && await $disclosure.waitForAnimations()',
          }
        : {},
    ),
  );
}
function handleArrow($el, Alpine) {
  Alpine.bind($el, {
    'x-float:arrow': '',
  });
}
function handleRoot$a($el, Alpine, {modifiers, expression}) {
  Alpine.bind($el, {
    [`x-popup.${modifiers.join('.')}`]: expression || '',
    'x-data'() {
      return {
        __popover_popoverEl: null,
      };
    },
  });
}

/**
 * Creates forms that work with or without JavaScript - traditional form submission when JS is disabled,
 * enhanced async submission when JS is available. Handles form states, errors, request cancellation,
 * and prevents full page reloads for better user experience.
 *
 * Usage:
 * - x-async-form - Applied to the form element, initializing the async form functionality and adding a data context for child directives
 * - x-async-form:context - Defines the context for the async form, allowing sharing of form state with other elements.
 * - x-async-form:form - Binds to the form element to handle form submissions.
 *
 * The '$asyncForm' magic property provides a comprehensive API for managing the form state, including form data, response, parsed body, and error messages.
 *
 * ## Common Usage Scenarios
 *
 * ### Basic product form
 *
 * When JS is disabled, form will submit to the given action URL and the server will handle the success/error.
 * When JS is enabled, form will make a fetch request to the given async-action URL and the async-form plugin will handle the success/pending/error states.
 *
 * ```html
 * <form x-async-form action="/cart" async-action="/cart/add.js" method="POST">
 *   <input type="hidden" name="id" value="123456789">
 *   <select name="quantity">
 *     <option value="1">1</option>
 *     <option value="2">2</option>
 *   </select>
 *
 *   <button type="submit"
 *           :disabled="$asyncForm.state === 'pending'"
 *           :class="{ 'opacity-50': $asyncForm.state === 'pending' }">
 *     <span x-show="$asyncForm.state === 'idle'">Add to Cart</span>
 *     <span x-show="$asyncForm.state === 'pending'">Adding...</span>
 *     <span x-show="$asyncForm.state === 'success'">Added!</span>
 *   </button>
 *
 *   <div x-show="$asyncForm.state === 'error'" class="text-red-500">
 *     <p x-text="$asyncForm.errorMessage"></p>
 *   </div>
 * </form>
 * ```
 *
 * ## Customizing the form submission
 *
 * In more complex scenarios, you may want to customize the form submission. This can be done by passing a function to the x-async-form directive
 * which will be used to submit the form instead just making a fetch request which is the default behavior.
 *
 * For example, if you need to do conditional error checking on the JSON response body:
 *
 * ```html
 * <form
 *   x-data="{
 *     save(info) {
 *        const response = await fetch('/cart/add.js', { method: 'POST', body: info })
 *
 *        if (response.status === 422) {
 *          const body = await response.json()
 *          if (body.message) {
 *            throw new Error(message)
 *          }
 *        }
 *
 *        return response
 *     }
 *   }"
 *  x-async-form="save"
 * >
 *   <input type="text" name="name" value="John Doe">
 *   <button type="submit">Submit</button>
 * </form>
 * ```
 * ## Features
 *
 * - **Request Cancellation**: All fetch requests include an AbortSignal that automatically cancels pending requests when a new submission starts or the component is cleaned up
 * - **State Management**: Tracks form state (idle, pending, success, error) with automatic transitions
 * - **Error Handling**: Parses error responses and provides structured error messages
 * - **Timeout Support**: Configurable timeouts for success and error states
 *
 * ## Events
 *
 * - `form:pending` - Dispatched when the form is pending
 * - `form:success` - Dispatched when the form is successful. Event detail is the parsed body of the response.
 * - `form:error` - Dispatched when the form encounters an error. Event detail is an object with the following properties:
 *   - `message` - The error message
 *   - `description` - The error description
 *
 */
function asyncForm(Alpine) {
  Alpine.directive('async-form', ($el, data, utilities) => {
    if (data.value == 'form') {
      handleForm$5($el, Alpine, data, utilities);
    } else if (data.value == 'context') {
      handleContext$3($el, Alpine, data, utilities);
    } else if (data.value == null) {
      if (!isFormElement($el)) {
        // Handle the case of x-async-form being applied to a parent of a form element
        // In this case we look for a form element child and apply form directive to that
        const form = $el.querySelector('form');
        Alpine.bind($el, {
          [`x-async-form:context.${data.modifiers.join('.')}`]: data.expression || '',
        });
        if (form) {
          Alpine.bind(form, {
            [`x-async-form:form.${data.modifiers.join('.')}`]: '',
          });
        }
      } else {
        Alpine.bind($el, {
          [`x-async-form:context.${data.modifiers.join('.')}`]: data.expression || '',
          [`x-async-form:form.${data.modifiers.join('.')}`]: '',
        });
      }
    } else {
      throw new Error(`Unknown directive: x-async-form:${data.value}`);
    }
  }).before('bind');
  Alpine.magic('asyncForm', handleAsyncFormMagic(Alpine));
}
function handleAsyncFormMagic(Alpine) {
  return function ($el) {
    const $data = Alpine.$data($el);
    return {
      get formData() {
        return $data.__asyncForm_formData;
      },
      get state() {
        return $data.__asyncForm_state;
      },
      get response() {
        return $data.__asyncForm_response;
      },
      get parsedBody() {
        return $data.__asyncForm_parsedBody;
      },
      reset() {
        return $data.__asyncForm_reset();
      },
      submitAsync(info) {
        return $data.__asyncForm_submitAsync(info);
      },
      get errorMessage() {
        return $data.__asyncForm_errorMessage;
      },
      get errorDescription() {
        return $data.__asyncForm_errorDescription;
      },
      get signal() {
        var _a;
        return ((_a = $data.__asyncForm_abortController) === null || _a === void 0 ? void 0 : _a.signal) || null;
      },
    };
  };
}
function handleContext$3($el, Alpine, {expression, modifiers}, {evaluateLater}) {
  let getCallbackFn = expression ? evaluateLater(expression) : null;
  const errorTimeout = getErrorTimeoutModifier(modifiers) || false;
  const successTimeout = getSuccessTimeoutModifier(modifiers) || 1000;
  Alpine.bind($el, {
    'x-data'() {
      return {
        __asyncForm_formEl: null,
        __asyncForm_stateMachine: new StateMachine('idle', ['idle', 'pending', 'success', 'error'], {
          idle: ['pending'],
          pending: ['success', 'error', 'pending'],
          success: ['idle', 'pending'],
          error: ['idle', 'pending'],
        }),
        __asyncForm_callback: null,
        __asyncForm_abortController: null,
        __asyncForm_formData: null,
        __asyncForm_response: null,
        __asyncForm_parsedBody: null,
        __asyncForm_errorMessage: null,
        __asyncForm_errorDescription: null,
        __asyncForm_successTimeout: successTimeout || false,
        __asyncForm_errorTimeout: errorTimeout || false,
        init() {
          this.$watch('__asyncForm_state', (state, prevState) => {
            if ((prevState == 'success' || prevState == 'error') && state == 'idle') {
              // Wipe form data after a successful or failed submission
              this.__asyncForm_formData = null;
            }
            if (prevState == 'success' && state == 'idle') {
              // Clear error message after a successful submission
              this.__asyncForm_errorMessage = null;
              this.__asyncForm_errorDescription = null;
            }
          });
          Alpine.effect(() => {
            // Create a function which wraps the passed in callback function / expression and allows us to call it when the user clicks the link
            this.__asyncForm_callback = (callbackInfo) => {
              var _a, _b;
              // If no expression provided, use default fetch behavior
              if (!getCallbackFn) {
                const submissionInfo = Object.assign(Object.assign({}, callbackInfo), {
                  action:
                    this.$el.getAttribute('async-action') ||
                    (callbackInfo === null || callbackInfo === void 0 ? void 0 : callbackInfo.action),
                });
                return submitFormData(submissionInfo, {
                  signal: (_a = this.__asyncForm_abortController) === null || _a === void 0 ? void 0 : _a.signal,
                });
              }
              let result;
              Alpine.dontAutoEvaluateFunctions(() => {
                getCallbackFn((callbackResult) => {
                  result = callbackResult;
                });
              });
              if (typeof result === 'function') {
                const formSubmissionInfoOrPromise = result.bind(this)(callbackInfo);
                if (formSubmissionInfoOrPromise instanceof Promise) {
                  return formSubmissionInfoOrPromise;
                } else if (typeof formSubmissionInfoOrPromise === 'object' && formSubmissionInfoOrPromise !== null) {
                  const mergedInfo = Object.assign(Object.assign({}, callbackInfo), formSubmissionInfoOrPromise);
                  return submitFormData(mergedInfo, {
                    signal: (_b = this.__asyncForm_abortController) === null || _b === void 0 ? void 0 : _b.signal,
                  });
                }
              } else {
                throw new Error('x-async-form callback must return a Promise, or FormDataSubmissionInfo');
              }
              throw new Error(
                'x-async-form callback must return a Promise, partial FormDataSubmissionInfo object, or a function that returns a Promise',
              );
            };
          });
        },
        get __asyncForm_state() {
          return this.__asyncForm_stateMachine.state;
        },
        set __asyncForm_state(state) {
          this.__asyncForm_stateMachine.state = state;
        },
        get __asyncForm_form() {
          var _a;
          let form = null;
          if (this.$el.tagName === 'FORM') {
            form = this.$el;
          }
          if (
            this.__asyncForm_formEl &&
            ((_a = this.__asyncForm_formEl) === null || _a === void 0 ? void 0 : _a.tagName) === 'FORM'
          ) {
            form = this.__asyncForm_formEl;
          }
          return form;
        },
        async __asyncForm_submitAsync(info) {
          // Cancel any pending request
          if (this.__asyncForm_abortController) {
            this.__asyncForm_abortController.abort('cancelled by user');
          }
          // Create new AbortController for this request
          this.__asyncForm_abortController = new AbortController();
          if (info === null || info === void 0 ? void 0 : info.formData) {
            this.__asyncForm_formData = info.formData;
          }
          this.__asyncForm_state = 'pending';
          this.$dispatch('form:pending', this.__asyncForm_formData);
          try {
            // Run provided callback function
            const response = await this.__asyncForm_callback.bind(this)(info);
            return await this.__asyncForm_handleResponse(response);
          } catch (e) {
            if (e.name == 'AbortError') {
              return null;
            } else {
              this.__asyncForm_handleError(String((e === null || e === void 0 ? void 0 : e.message) || e));
              console.error(e);
              return Promise.resolve();
            }
          }
        },
        async __asyncForm_handleResponse(response) {
          this.__asyncForm_response = response;
          this.__asyncForm_parsedBody = await parseResponseBody(response);
          if (!response || (response === null || response === void 0 ? void 0 : response.status) == undefined) {
            // Handle the response object not being a fetch request
            this.__asyncForm_handleSuccess();
            return response;
          } else if (response.status === 200) {
            this.__asyncForm_handleSuccess();
            return response;
          } else {
            let message = getErrorMessage(response, this.__asyncForm_parsedBody);
            let description = getErrorDescription(this.__asyncForm_parsedBody);
            this.__asyncForm_handleError(message, description);
            return response;
          }
        },
        async __asyncForm_handleSuccess() {
          this.$dispatch('form:success', this.__asyncForm_parsedBody);
          if (successTimeout) {
            // Transition to success state then back to initial state after a timeout
            this.__asyncForm_stateMachine.setTransientState('success', 'idle', successTimeout);
          } else {
            this.__asyncForm_state = 'success';
          }
        },
        async __asyncForm_handleError(message, description) {
          this.$dispatch(`form:error`, {
            message: message,
            description: description,
          });
          if (errorTimeout) {
            // Transition to error state then back to initial state after a timeout
            this.__asyncForm_stateMachine.setTransientState('error', 'idle', errorTimeout);
          } else {
            this.__asyncForm_state = 'error';
          }
          this.__asyncForm_errorMessage = message;
          this.__asyncForm_errorDescription = description;
        },
        __asyncForm_reset() {
          // Cancel any pending request
          if (this.__asyncForm_abortController) {
            this.__asyncForm_abortController.abort('cancelled by user');
            this.__asyncForm_abortController = null;
          }
          this.__asyncForm_state = 'idle';
          this.__asyncForm_response = null;
          this.__asyncForm_parsedBody = null;
          this.__asyncForm_errorMessage = null;
          this.__asyncForm_errorDescription = null;
        },
      };
    },
  });
}
function handleForm$5($el, Alpine, {expression}, {}) {
  if (!isFormElement($el)) {
    throw new Error('x-async-form:form directive can only be used on form elements');
  }
  Alpine.bind($el, {
    'x-data'() {
      return {
        __asyncForm_form_onSubmit(e) {
          // Prevent default form submission behaviour so we dont get a full page reload
          e.preventDefault();
          this.__asyncForm_submitAsync(getFormSubmissionInfo($el, e.submitter));
        },
        init() {
          if (this.__asyncForm_submitAsync == undefined) {
            throw new Error('x-async-form:form directive must be used within an x-async-form:context directive');
          }
        },
      };
    },
    'x-init': '__asyncForm_formEl = $el',
    '@submit': '__asyncForm_form_onSubmit',
  });
}
function getErrorTimeoutModifier(modifiers) {
  let errorTimeout = false;
  if (modifiers.includes('wait-error')) {
    const rawValue = modifiers[modifiers.indexOf('wait-error') + 1];
    let match = rawValue.match(/([0-9]+)ms/);
    if (match) errorTimeout = Number(match[1]);
  }
  return errorTimeout;
}
function getSuccessTimeoutModifier(modifiers) {
  let successTimeout = false;
  if (modifiers.includes('wait-success')) {
    const rawValue = modifiers[modifiers.indexOf('wait-success') + 1];
    let match = rawValue.match(/([0-9]+)ms/);
    if (match) successTimeout = Number(match[1]);
  }
  return successTimeout;
}
async function parseResponseBody(response) {
  var _a;
  if (!response) return null;
  // Bail out if the response is not similar to a standard fetch Response object
  if (!isPlainObject(response) || !('json' in response)) {
    return null;
  }
  // Note: we clone the response here in case the body has already been read
  if ((_a = response.headers.get('Content-Type')) === null || _a === void 0 ? void 0 : _a.includes('text/html')) {
    return await response.clone().text();
  } else {
    // Try to parse the body as json, if it fails, return the original response
    try {
      return await response.clone().json();
    } catch (e) {
      return await response.clone().text();
    }
  }
}
function getErrorMessage(response, parsedBody) {
  if (isPlainObject(parsedBody) && parsedBody.message) {
    return parsedBody.message;
  }
  return response.statusText;
}
function getErrorDescription(parsedBody) {
  if (isPlainObject(parsedBody)) {
    if (parsedBody.description) {
      if (isPlainObject(parsedBody.description)) {
        return Object.values(parsedBody.description)
          .filter((str) => str !== undefined && str !== null)
          .join(', ');
      }
      return parsedBody.description;
    }
    if (parsedBody.error) {
      return parsedBody.error.toString();
    }
    if (parsedBody.errors) {
      return parsedBody.errors.toString();
    }
  }
  return null;
}

/**
 * A plugin that makes it easy to progressively enhance links so that they can be
 * call endpoints via the fetch API and display pending states
 * while the request is in progress
 *
 * The x-async-link expects a either a promise or a function that returns a promise.
 *
 * @example
 *
 * <a
 *   href="/some-page"
 *   x-async-link="fetchSomeData"
 *   :class="{ 'opacity-50': $asyncLink.state == 'pending' }"
 * >Click Me</a>
 *
 * @example
 *
 * <div x-async-link:context="fetch(`${$url}.js`)">
 *   <div x-show="$asyncLink.state == 'pending'">Loading!</div>
 *   <a href="/some-page" x-async-link:link >Click Me</a>
 * </div>
 *
 * TODO:
 * - Document events
 */
function asyncLink(Alpine) {
  Alpine.directive('async-link', ($el, data, {evaluateLater}) => {
    if (data.value == 'link') {
      if (!isAnchorElement($el)) {
        throw new Error('x-async-link:link directive can only be used on anchor elements');
      }
      Alpine.bind($el, {
        'x-data'() {
          return {
            __asyncLink_onClick(e) {
              if (!shouldProcessLinkClick(e, $el.target)) return;
              // If some other function has already prevented the default action, do nothing
              if (e.defaultPrevented) return;
              // If the link is not an anchor tag, do nothing
              if (!this.$el.href) return;
              e.preventDefault();
              this.__asyncLink_load(this.$el.href);
            },
            init() {
              if (this.__asyncLink_state == undefined) {
                throw new Error('x-async-link:link directive must be used within an x-async-link:context directive');
              }
            },
          };
        },
        '@click': '__asyncLink_onClick',
      });
    } else if (data.value == 'context') {
      if (!data.expression) {
        throw new Error('x-async-link:context directive requires a an async callback function');
      }
      let getCallbackFn = evaluateLater(data.expression);
      Alpine.bind($el, {
        'x-data'() {
          return {
            __asyncLink_pendingHref: null,
            __asyncLink_stateMachine: new StateMachine('idle', ['idle', 'pending'], {
              idle: ['pending'],
              pending: ['pending', 'idle'],
            }),
            __asyncLink_callback: null,
            __asyncLink_errorMessage: null,
            __asyncLink_errorDescription: null,
            init() {
              Alpine.effect(() => {
                // Create a function which wraps the passed in callback function / expression and allows us to call it when the user clicks the link
                this.__asyncLink_callback = async (href) => {
                  let resultPromise;
                  Alpine.dontAutoEvaluateFunctions(() => {
                    getCallbackFn(
                      async (result) => {
                        if (typeof result === 'function') {
                          resultPromise = result.bind(this)(href);
                        } else {
                          throw new Error(`x-async-link expects an async function as its expression`);
                        }
                      },
                      {
                        params: [href],
                        scope: {$href: href},
                      },
                    );
                  });
                  return resultPromise;
                };
              });
            },
            get __asyncLink_state() {
              return this.__asyncLink_stateMachine.state;
            },
            get __asyncLink_prevState() {
              return this.__asyncLink_stateMachine.prevState;
            },
            set __asyncLink_state(state) {
              this.__asyncLink_stateMachine.state = state;
            },
            async __asyncLink_load(href) {
              this.__asyncLink_state = 'pending';
              this.__asyncLink_pendingHref = href;
              this.$dispatch('link:pending', this.__asyncLink_pendingHref);
              try {
                // Run provided callback function
                const response = await this.__asyncLink_callback.bind(this)(href);
                if (!response || (response === null || response === void 0 ? void 0 : response.status) == undefined) {
                  // Handle the response object not being a fetch request
                  this.__asyncLink_handleSuccess();
                  return response;
                } else if (response.status === 200) {
                  this.__asyncLink_handleSuccess();
                  return response;
                } else if (response.status === 422) {
                  const body = await response.json();
                  this.__asyncLink_handleError(body.message, body.description);
                  return response;
                } else {
                  this.__asyncLink_handleError(response.statusText);
                  return response;
                }
              } catch (e) {
                if (e.name == 'AbortError') {
                  this.__asyncLink_pendingHref = null;
                  this.__asyncLink_state = 'idle';
                  return false;
                } else {
                  this.__asyncLink_handleError(String((e === null || e === void 0 ? void 0 : e.message) || e));
                  throw e;
                }
              }
            },
            async __asyncLink_handleSuccess() {
              this.$dispatch('link:loaded', this.__asyncLink_pendingHref);
              this.__asyncLink_state = 'idle';
              this.__asyncLink_pendingHref = null;
            },
            async __asyncLink_handleError(message, description) {
              this.__asyncLink_state = 'idle';
              this.__asyncLink_errorMessage = message;
              this.__asyncLink_errorDescription = description;
              this.__asyncLink_pendingHref = null;
            },
            __asyncLink_reset() {
              this.__asyncLink_state = 'idle';
              this.__asyncLink_errorMessage = null;
              this.__asyncLink_errorDescription = null;
              this.__asyncLink_pendingHref = null;
            },
          };
        },
      });
    } else {
      if (!data.expression) {
        throw new Error('x-async-link directive requires a an async callback function');
      }
      if (!isAnchorElement($el)) {
        throw new Error('x-async-link directive can only be used on anchor elements');
      }
      Alpine.bind($el, {
        'x-async-link:context': data.expression,
        [`x-async-link:link.${data.modifiers.join('.')}`]: '',
      });
    }
  }).before('bind');
  Alpine.magic('asyncLink', ($el) => {
    const $data = Alpine.$data($el);
    return {
      get pendingHref() {
        return $data.__asyncLink_pendingHref;
      },
      get state() {
        return $data.__asyncLink_state;
      },
      get reset() {
        return $data.__asyncLink_reset();
      },
      get errorMessage() {
        return $data.__asyncLink_errorMessage;
      },
      get errorDescription() {
        return $data.__asyncLink_errorDescription;
      },
    };
  });
}

/**
 * This Alpine.js plugin provides a directive for handling navigation via links and forms,
 * allowing for asynchronous navigation without a full page reload. This is particularly useful
 * for creating single-page applications or enhancing user experience with faster navigation.
 *
 * The core functionality of this plugin is to interrupt the default page reloading behavior
 * of links and forms, and instead call a custom navigation callback function. This function
 * is responsible for re-rendering the page content dynamically.
 *
 * ## Custom Navigation Callback
 *
 * The `x-router` directive requires an async callback function that returns a fetch promise.
 * This function is crucial as it defines how the page content should be re-rendered when
 * navigation occurs. You can specify this callback using the `x-router` directive with an expression:
 *
 * ```html
 * <div x-router="customNavigate">
 *   <!-- Custom navigation logic here -->
 * </div>
 * ```
 *
 * The expression should be an async function that handles the fetch request and updates the view accordingly.
 *
 * ## Usage
 *
 * ### Link Navigation
 *
 * To use the `x-router` directive for link navigation, add the `x-router:link` directive to an anchor element:
 *
 * ```html
 * <a x-router:link href="/new-page">Go to New Page</a>
 * ```
 *
 * When the link is clicked, the plugin will handle the navigation asynchronously using the custom callback.
 *
 * ### Form Navigation
 *
 * To use the `x-router` directive for form navigation, add the `x-router:form` directive to a form element:
 *
 * ```html
 * <form x-router:form action="/submit-form" method="POST">
 *   <input type="text" name="example" />
 *   <button type="submit">Submit</button>
 * </form>
 * ```
 *
 * When the form is submitted, the plugin will handle the navigation asynchronously using the custom callback.
 *
 * ## History Management
 *
 * The plugin also manages browser history to ensure that back/forward navigation works as expected.
 *
 * When the user navigates back or forward, the plugin will reload the page to reflect the correct state.
 *
 * ## Example
 *
 * ```html
 * <a x-router:link href="/new-page">Go to New Page</a>
 *
 * <form x-router:form action="/submit-form" method="POST">
 *   <input type="text" name="example" />
 *   <button type="submit">Submit</button>
 * </form>
 *
 * <div x-router="customNavigate">
 *   <!-- Custom navigation logic here -->
 * </div>
 * ```
 */
function router(Alpine) {
  Alpine.directive('router', ($el, data, {evaluateLater}) => {
    const historyMode = getHistoryModeModifier(data.modifiers);
    if (data.value == 'link') {
      Alpine.bind($el, {
        [`x-async-link`]() {
          return async (href) => {
            const url = getNavigationUrl({action: href}).toString();
            return this.__router_navigate(url, historyMode);
          };
        },
      });
    } else if (data.value == 'form') {
      Alpine.bind($el, {
        [`x-async-form`]() {
          return async (info) => {
            const url = getNavigationUrl(info).toString();
            return this.__router_navigate(url, historyMode);
          };
        },
      });
    } else {
      if (!data.expression) {
        throw new Error('x-router directive requires an async callback function that returns a fetch promise');
      }
      let getCallbackFn = evaluateLater(data.expression);
      if (!window._x_router_initialized) {
        // Add initial state to the history object so that popstate event is fired when the user navigates back/forward
        window.history.replaceState(
          {
            fromRouter: true,
            url: document.location.href,
          },
          '',
          document.location.href,
        );
        // Reload the page when the user navigates back/forward since our usage of pushState/replaceState would cause the browser not to trigger a page reload
        window.addEventListener('popstate', (event) => {
          var _a;
          if ((_a = event.state) === null || _a === void 0 ? void 0 : _a.fromRouter) {
            // NOTE this is a quick fix in order to get back/forward buttons working as expected with the router,
            // however a better solution for things like the collection view would probably be to call the callback function
            // with the correct href and then update the view accordingly without a page reload i.e. when using $sectionApi.
            // We'll revisit that when we have time
            window.location.reload();
          }
        });
        window._x_router_initialized = true;
      }
      Alpine.bind($el, {
        'x-data'() {
          return {
            __router_callback: null,
            init() {
              Alpine.effect(() => {
                // Create a function which wraps the passed in callback function / expression and allows us to call it when the user clicks the link
                this.__router_callback = async (href) => {
                  let resultPromise;
                  Alpine.dontAutoEvaluateFunctions(() => {
                    getCallbackFn(async (result) => {
                      if (typeof result === 'function') {
                        resultPromise = result.bind(this)(href);
                      } else {
                        throw new Error(`x-async-link expects an async function as its expression`);
                      }
                    });
                  });
                  return resultPromise;
                };
              });
            },
            async __router_navigate(urlOrHref, historyMode) {
              const url = new URL(urlOrHref);
              if (historyMode == 'replace') {
                window.history.replaceState({fromRouter: true, url: url.toString()}, '', url.toString());
              } else if (historyMode == 'push') {
                window.history.pushState({fromRouter: true, url: url.toString()}, '', url.toString());
              }
              const promise = this.__router_callback(url);
              return promise;
            },
          };
        },
      });
    }
  }).before('bind');
  Alpine.magic('router', ($el) => {
    const $data = Alpine.$data($el);
    return {
      navigate(url, historyMode) {
        return $data.__router_navigate(url, historyMode);
      },
    };
  });
}
function getHistoryModeModifier(modifiers, defaultMode = 'push') {
  if (modifiers.includes('replace')) {
    return 'replace';
  } else if (modifiers.includes('push')) {
    return 'push';
  } else if (modifiers.includes('nopush')) {
    return 'none';
  } else {
    return defaultMode;
  }
}
function getNavigationUrl(navigationInfo) {
  let url = new URL(navigationInfo.action);
  if (
    (navigationInfo === null || navigationInfo === void 0 ? void 0 : navigationInfo.formData) &&
    (navigationInfo === null || navigationInfo === void 0 ? void 0 : navigationInfo.method) === 'GET'
  ) {
    let formData = navigationInfo.formData;
    let searchParams = new URLSearchParams(formData);
    url.search = searchParams.toString();
  }
  return url;
}

const DEFAULT_SLIDE_DURATION = 1000;
/**
 * TODO document me
 */
function slideshow(Alpine) {
  Alpine.directive('slideshow', ($el, data, utilities) => {
    if (!isHtmlElement($el)) {
      throw new Error(`Expected HTMLElement but got ${$el}`);
    }
    if (data.value === 'slide') {
      handleSlide($el, Alpine);
    } else if (data.value === 'control') {
      handleControl($el, Alpine);
    } else if (data.value === 'play') {
      handlePlayButton($el, Alpine);
    } else if (data.value === 'pause') {
      handlePauseButton($el, Alpine);
    } else if (data.value === 'next') {
      handleNextButton($el, Alpine);
    } else if (data.value === 'prev') {
      handlePrevButton($el, Alpine);
    } else if (data.value === 'toggle') {
      handleToggleButton($el, Alpine);
    } else if (data.value === 'viewport') {
      handleViewport($el, Alpine);
    } else if (data.value === null) {
      handleRoot$9($el, Alpine, data, utilities);
    } else {
      throw new Error(`Unknown directive: x-slideshow:${data.value}`);
    }
  }).before('bind');
  Alpine.magic('slideshow', function ($el) {
    const $data = Alpine.$data($el);
    // Could probably just rename __slideshow_state to $slideshow and get rid of this magic
    // but I want to think through the implications of that before establishing a precedent
    return $data.__slideshow_state || {};
  });
  Alpine.magic('slide', function ($el) {
    const $data = Alpine.$data($el);
    return {
      get slideIndex() {
        return $data.__slideshowSlide_slideIndex;
      },
      get isCurrentSlide() {
        return $data.__slideshowSlide_isCurrentSlide;
      },
      get wasLastSlide() {
        return $data.__slideshowSlide_wasLastSlide;
      },
    };
  });
}
function handleControl($el, Alpine) {
  Alpine.bind($el, {
    ':aria-controls': '$id("slideshow")',
  });
}
function handlePlayButton($el, Alpine) {
  Alpine.bind($el, {
    '@click': '$slideshow.play()',
    'x-slideshow:control': '',
  });
}
function handlePauseButton($el, Alpine) {
  Alpine.bind($el, {
    '@click': '$slideshow.pause()',
    'x-slideshow:control': '',
  });
}
function handleNextButton($el, Alpine) {
  Alpine.bind($el, {
    '@click': '$slideshow.pause(); $slideshow.next()',
    'x-slideshow:control': '',
  });
}
function handlePrevButton($el, Alpine) {
  Alpine.bind($el, {
    '@click': '$slideshow.pause(); $slideshow.prev()',
    'x-slideshow:control': '',
  });
}
function handleToggleButton($el, Alpine) {
  Alpine.bind($el, {
    '@click': '$slideshow.toggle()',
    'x-slideshow:control': '',
  });
}
function handleSlide($el, Alpine) {
  Alpine.bind($el, {
    ['x-data']() {
      return {
        init() {
          this.__slideshow_state.register(this.$el);
        },
        destroy() {
          this.__slideshow_state.unregister(this.$el);
        },
        get __slideshowSlide_slideIndex() {
          return Array.from(this.__slideshow_state.slides).indexOf(this.$el);
        },
        get __slideshowSlide_isCurrentSlide() {
          return this.__slideshow_state.currentSlideIndex === this.__slideshowSlide_slideIndex;
        },
        get __slideshowSlide_wasLastSlide() {
          return this.__slideshow_state.lastSlideIndex === this.__slideshowSlide_slideIndex;
        },
      };
    },
    role: 'group',
    'aria-roledescription': 'slide',
  });
}
function handleViewport($el, Alpine) {
  Alpine.bind($el, {
    ':id': `$id('slideshow')`,
    role: 'region',
    'aria-roledescription': 'carousel',
    ':aria-live': '$slideshow.state == "playing" ? "off" : "polite"',
    '@keydown.left.stop.prevent': '$slideshow.prev()',
    '@keydown.right.stop.prevent': '$slideshow.next()',
    '@focus': '$slideshow.pause()',
  });
}
function handleRoot$9($el, Alpine, data, {evaluate}) {
  let slideDuration = DEFAULT_SLIDE_DURATION;
  const autoplay = data.modifiers.includes('autoplay');
  if (data.modifiers.includes('duration')) {
    const rawValue = data.modifiers[data.modifiers.indexOf('duration') + 1];
    // Support x-slideshow.duration.500ms which will wait 500ms before transitioning to next slide
    let match = rawValue.match(/([0-9]+)ms/);
    if (match) slideDuration = Number(match[1]);
  }
  let expression = data.expression === '' ? '{}' : data.expression;
  let options = evaluate(expression);
  options.slideDuration = slideDuration;
  options.autoplay = autoplay;
  if (options !== undefined && options !== null && !isPlainObject(options)) {
    throw new Error(`options must be an object, but got ${options}`);
  }
  let state = buildSlideshowState(options);
  Alpine.bind($el, {
    ['x-data']() {
      return {
        __slideshow_autoplayTimeoutId: undefined,
        __slideshow_animationFrameId: undefined,
        __slideshow_state: state,
        init() {
          let lastTimestamp;
          const updateProgress = (timestamp) => {
            if (lastTimestamp === undefined) lastTimestamp = timestamp;
            const deltaTime = timestamp - lastTimestamp;
            lastTimestamp = timestamp;
            // Update the elapsed time
            this.__slideshow_state.currentSlideElapsedTime = Math.round(
              this.__slideshow_state.currentSlideElapsedTime + deltaTime,
            );
            // Request the next frame if playing
            if (this.__slideshow_state.state === 'playing') {
              this.__slideshow_animationFrameId = requestAnimationFrame(updateProgress);
            }
          };
          const startProgressUpdates = () => {
            // Cancel any existing animation frame
            if (this.__slideshow_animationFrameId !== undefined) {
              cancelAnimationFrame(this.__slideshow_animationFrameId);
            }
            // Start updating progress
            lastTimestamp = undefined;
            this.__slideshow_animationFrameId = requestAnimationFrame(updateProgress);
          };
          const stopProgressUpdates = () => {
            if (this.__slideshow_animationFrameId !== undefined) {
              cancelAnimationFrame(this.__slideshow_animationFrameId);
              this.__slideshow_animationFrameId = undefined;
            }
          };
          const scheduleNextSlide = () => {
            // Clear any existing timeout
            if (this.__slideshow_autoplayTimeoutId !== undefined) {
              clearTimeout(this.__slideshow_autoplayTimeoutId);
              this.__slideshow_autoplayTimeoutId = undefined;
            }
            if (this.__slideshow_state.state === 'playing') {
              // Start progress updates
              startProgressUpdates();
              // Schedule the next slide
              const remainingTime =
                this.__slideshow_state.slideDuration - this.__slideshow_state.currentSlideElapsedTime;
              this.__slideshow_autoplayTimeoutId = window.setTimeout(() => {
                // Move to the next slide
                this.__slideshow_state.next();
                // Reset elapsed time
                this.__slideshow_state.currentSlideElapsedTime = 0;
                // Schedule next slide
                scheduleNextSlide();
              }, remainingTime);
            } else {
              // Slideshow is paused, stop progress updates
              stopProgressUpdates();
            }
          };
          // Watch for changes in play state
          this.$watch('__slideshow_state.state', () => {
            scheduleNextSlide();
          });
          // Watch for slide changes (e.g., manual navigation)
          this.$watch('__slideshow_state.currentSlideIndex', (_nextIndex, prevIndex) => {
            // Reset elapsed time and schedule next slide
            this.__slideshow_state.currentSlideElapsedTime = 0;
            scheduleNextSlide();
          });
          // Initial scheduling
          scheduleNextSlide();
        },
        destroy() {
          if (this.__slideshow_autoplayTimeoutId !== undefined) {
            clearTimeout(this.__slideshow_autoplayTimeoutId);
          }
          if (this.__slideshow_animationFrameId !== undefined) {
            cancelAnimationFrame(this.__slideshow_animationFrameId);
          }
        },
      };
    },
    'x-id': "['slideshow']",
  });
}
function buildSlideshowState(options = {}) {
  let state = {
    state: options.autoplay ? 'playing' : 'paused',
    slideDuration: options.slideDuration || 1000,
    currentSlideIndex: options.initialSlideIndex || 0,
    currentSlideElapsedTime: 0,
    slides: new Set(),
    lastSlideIndex: null,
    get totalSlides() {
      return this.slides.size;
    },
    get nextSlideIndex() {
      return mod(this.currentSlideIndex + 1, this.totalSlides);
    },
    get prevSlideIndex() {
      return mod(this.currentSlideIndex - 1, this.totalSlides);
    },
    register(el) {
      this.slides.add(el);
    },
    unregister(el) {
      this.slides.delete(el);
    },
    next() {
      this.currentSlideIndex = this.nextSlideIndex;
    },
    prev() {
      this.currentSlideIndex = this.prevSlideIndex;
    },
    play() {
      if (this.state === 'playing') return;
      this.state = 'playing';
    },
    pause() {
      if (this.state === 'paused') return;
      this.state = 'paused';
    },
    toggle() {
      if (this.state === 'playing') {
        this.pause();
      } else {
        this.play();
      }
    },
  };
  state = trackProperty(state, 'currentSlideIndex', 'lastSlideIndex');
  if ((options === null || options === void 0 ? void 0 : options.state) !== undefined) {
    copyProperty(options, state, 'state');
  }
  if ((options === null || options === void 0 ? void 0 : options.currentSlideIndex) !== undefined) {
    copyProperty(options, state, 'currentSlideIndex');
  }
  return state;
}

function prettyPrintError(err) {
  let output = '';
  if (typeof err === 'string') {
    output = err;
  } else if (err instanceof Error) {
    output = err.message;
  } else if (err && typeof err.toString === 'function') {
    output = err.toString();
  } else if (err && typeof err.message === 'string') {
    output = err.message;
  } else {
    output = 'An unknown error occurred.';
  }
  return output;
}

/**
 * Function that combines some default morph behavior with custom behavior
 * @param options - The custom behavior to combine with the default behavior
 * @returns The combined morph behavior
 */
function buildMorphConfig(options) {
  return Object.assign(Object.assign({}, options), {
    updating(el, toEl, childrenOnly, skip) {
      var _a;
      // Allow elements to opt-out of resetting their alpine state by adding the data-morph-children-only attribute
      if (el.hasAttribute && el.hasAttribute('data-morph-children-only')) {
        childrenOnly();
      }
      // Allow elements to opt-out of morphing altogether with data-morph-skip
      if (el.hasAttribute && el.hasAttribute('data-morph-skip')) {
        skip();
      }
      (_a = options === null || options === void 0 ? void 0 : options.updating) === null || _a === void 0
        ? void 0
        : _a.call(options, el, toEl, childrenOnly, skip);
    },
    removing(el, skip) {
      var _a;
      // Allow elements to opt-out of morphing altogether with data-morph-skip
      if (el.hasAttribute && el.hasAttribute('data-morph-skip')) {
        skip();
      }
      (_a = options === null || options === void 0 ? void 0 : options.removing) === null || _a === void 0
        ? void 0
        : _a.call(options, el, skip);
    },
  });
}

class FetchBatcher {
  constructor(timeoutDuration = 100) {
    this.batchMap = new Map();
    this.timeoutMap = new Map();
    this.timeoutDuration = timeoutDuration;
    this.requestPromises = new Map();
  }
  // Main method to handle incoming requests
  request(url) {
    return new Promise((resolve, reject) => {
      const baseUrl = this.getBaseUrl(url);
      const queryParams = this.getQueryParams(url);
      const sectionsParam = queryParams
        .getAll('sections')
        .concat(queryParams.getAll('section_id'))
        .concat(queryParams.getAll('sections[]'));
      if (!this.batchMap.has(baseUrl)) {
        this.batchMap.set(baseUrl, new Set());
      }
      const sectionsSet = this.batchMap.get(baseUrl);
      if (sectionsSet) {
        sectionsParam.forEach((section) => sectionsSet.add(section));
      }
      if (!this.requestPromises.has(baseUrl)) {
        this.requestPromises.set(baseUrl, []);
      }
      const promisesList = this.requestPromises.get(baseUrl);
      if (promisesList) {
        promisesList.push({resolve, reject});
      }
      // Set a timeout to batch requests
      if (!this.timeoutMap.has(baseUrl)) {
        const timeoutId = setTimeout(() => {
          this.fetchBatch(baseUrl);
        }, this.timeoutDuration);
        this.timeoutMap.set(baseUrl, timeoutId);
      }
    });
  }
  // Extract base URL from full URL
  getBaseUrl(url) {
    const [baseUrl, _queryParams] = url.split('?');
    return baseUrl;
  }
  // Extract query parameters from full URL
  getQueryParams(url) {
    const [_baseUrl, queryParams] = url.split('?');
    return new URLSearchParams(queryParams);
  }
  // Construct the batched URL with all sections
  buildBatchUrl(baseUrl, sections) {
    return `${baseUrl}?sections=${Array.from(sections).join(',')}`;
  }
  // Fetch batched request
  async fetchBatch(baseUrl) {
    const sections = this.batchMap.get(baseUrl);
    if (!sections) return;
    const batchUrl = this.buildBatchUrl(baseUrl, sections);
    this.batchMap.delete(baseUrl);
    this.timeoutMap.delete(baseUrl);
    try {
      const response = await fetch(batchUrl);
      if (response.ok) {
        const data = await response.json();
        const requestPromises = this.requestPromises.get(baseUrl);
        if (requestPromises) {
          requestPromises.forEach(({resolve}) => resolve(data));
          this.requestPromises.delete(baseUrl);
        }
      } else {
        throw response.statusText;
      }
    } catch (error) {
      const requestPromises = this.requestPromises.get(baseUrl);
      if (requestPromises) {
        requestPromises.forEach(({reject}) => reject(error));
        this.requestPromises.delete(baseUrl);
      }
    }
  }
}

var __rest$1 =
  (undefined && undefined.__rest) ||
  function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
      }
    return t;
  };
const THEME_SECTION_CONTEXT_KEY = Symbol('THEME_SECTION_CONTEXT_KEY');
const THEME_SECTION_FRAME_CONTEXT_KEY = Symbol('THEME_SECTION_FRAME_CONTEXT_KEY');
const fetchBatcher = new FetchBatcher();
const DEFAULT_MORPH_CONFIG = {
  updating(el, _toEl, _childrenOnly, skip) {
    // Skip any built-in shopify elements
    if (el.hasAttribute && el.hasAttribute('data-shopify')) {
      skip();
    }
  },
  removing(el, skip) {
    // Skip any built-in shopify elements
    if (el.hasAttribute && el.hasAttribute('data-shopify')) {
      skip();
    }
  },
};
var sectionApi = (options) => {
  let morphConfig = (options === null || options === void 0 ? void 0 : options.morphConfig) || DEFAULT_MORPH_CONFIG;
  return function (Alpine) {
    if ('morph' in Alpine === false) {
      throw new Error('The x-section-api directive requires the @alpinejs/morph plugin');
    }
    if (!Alpine.store('cache')) {
      throw new Error('The x-section-api directive requires the method-ui cache plugin');
    }
    if (!Alpine.store('cache').resources.sectionHtml) {
      Alpine.store('cache').addResource('sectionHtml');
    }
    Alpine.directive('section-api', ($el, data, utilities) => {
      if (!isHtmlElement($el)) {
        throw new Error(`Expected HTMLElement but got ${$el}`);
      }
      if (data.value === 'frame') {
        handleFrame($el, data, utilities, Alpine, morphConfig);
      } else if (data.value === 'form') {
        handleForm$4($el, data, utilities, Alpine);
      } else if (data.value === 'link') {
        handleLink($el, data, utilities, Alpine);
      } else if (data.value === null) {
        handleRoot$8($el, data, utilities, Alpine, morphConfig);
      } else {
        throw new Error(`Unknown directive: x-section-api:${data.value}`);
      }
    }).before('bind');
    Alpine.magic('sectionApi', handleSectionMagic(Alpine));
    Alpine.magic('sectionApiFrame', handleFrameMagic(Alpine));
    Alpine.magic('sectionApiCache', handleSectionCacheMagic(Alpine));
    bindAllThemeSections(Alpine, (el) => {
      // Add x-section-api directive to all sections making it possible to reload them via section rendering API with $sectionApi.load(...)
      const sectionIdForSectionRenderingApi = el.id.split('shopify-section-')[1]; // e.g. section-featured-product from shopify-section-section-featured-product
      Alpine.bind(el, {
        ['x-section-api']: sectionIdForSectionRenderingApi,
      });
    });
  };
};
function handleSectionMagic(Alpine) {
  return function ($el) {
    const context = Alpine.$data($el)[THEME_SECTION_CONTEXT_KEY];
    return {
      get morphConfig() {
        return context === null || context === void 0 ? void 0 : context.morphConfig;
      },
      set morphConfig(value) {
        context.morphConfig = value;
      },
      get sectionId() {
        return context === null || context === void 0 ? void 0 : context.sectionId;
      },
      get state() {
        return context === null || context === void 0 ? void 0 : context.state;
      },
      get error() {
        return context === null || context === void 0 ? void 0 : context.error;
      },
      update(options) {
        return context === null || context === void 0 ? void 0 : context.update(options);
      },
      load(options) {
        return context === null || context === void 0 ? void 0 : context.load(options);
      },
      navigate(url, historyMode) {
        return context === null || context === void 0 ? void 0 : context.navigate(url, historyMode);
      },
      setHtml(html, options) {
        return context === null || context === void 0 ? void 0 : context.setHtml(html, options);
      },
      // subscribe() {
      //   return context?.subscribe();
      // },
      // unsubscribe() {
      //   return context?.unsubscribe();
      // },
    };
  };
}
function handleFrameMagic(Alpine) {
  return function ($el) {
    const context = Alpine.$data($el)[THEME_SECTION_FRAME_CONTEXT_KEY];
    return {
      get morphConfig() {
        return context === null || context === void 0 ? void 0 : context.morphConfig;
      },
      set morphConfig(value) {
        context.morphConfig = value;
      },
      get el() {
        return context === null || context === void 0 ? void 0 : context.rootEl;
      },
      get state() {
        return context === null || context === void 0 ? void 0 : context.state;
      },
      get error() {
        return context === null || context === void 0 ? void 0 : context.error;
      },
      update(options) {
        return context === null || context === void 0 ? void 0 : context.update(options);
      },
      load(options) {
        return context === null || context === void 0 ? void 0 : context.load(options);
      },
    };
  };
}
function handleSectionCacheMagic(Alpine) {
  return function () {
    return {
      set(sectionId, html, options) {
        const url = buildSectionUrl(sectionId, options);
        Alpine.store('cache').resources.sectionHtml.set(url, html);
      },
      get(sectionId, options) {
        const url = buildSectionUrl(sectionId, options);
        return Alpine.store('cache').resources.sectionHtml.get(url);
      },
    };
  };
}
// TODO refactor this to use Alpine.morphBetween: https://github.com/alpinejs/alpine/blob/df63fe2f6eb416bb7f46c449f2ee6aaf3c0b304e/packages/morph/src/morph.js#L33
function handleFrame($el, data, {cleanup}, Alpine, morphConfig) {
  const rootContext = Alpine.$data($el)[THEME_SECTION_CONTEXT_KEY];
  if (!rootContext) return;
  const sectionId = rootContext.sectionId;
  const frameContext = buildContext(Alpine, $el, sectionId, {
    targetId: $el.id,
    rootEl: rootContext.rootEl,
    morphConfig,
  });
  if (!$el.hasAttribute('id')) {
    throw new Error(`Elements using x-section-api:frame must have a unique id property`);
  }
  Alpine.addScopeToNode($el, {
    [THEME_SECTION_FRAME_CONTEXT_KEY]: frameContext,
  });
  $el._x_sectionApi_isFrame = true;
  cleanup(() => {
    var _a;
    // Abort any pending fetches when element is removed from DOM
    (_a = frameContext.abortController) === null || _a === void 0 ? void 0 : _a.abort();
    // Delete custom properties from element
    delete $el._x_sectionApi_isFrame;
  });
}
function handleForm$4($el, data, _utilities, Alpine) {
  if (!isFormElement($el)) {
    throw new Error('x-section-api:form directive can only be used on form elements');
  }
  if ($el.method.toLowerCase() == 'post') {
    throw new Error('x-section-api:form directive does not support POST requests');
  }
  Alpine.bind($el, {
    [`x-router:form.${data.modifiers}`]: '',
  });
}
function handleLink($el, data, _utilities, Alpine) {
  if (!isAnchorElement($el)) {
    throw new Error('x-section-api:link directive can only be used on anchor elements');
  }
  Alpine.bind($el, {
    [`x-router:link.${data.modifiers}`]: '',
  });
}
function handleRoot$8($el, data, {cleanup}, Alpine, morphConfig) {
  // Grab section id from directive expression
  const sectionId = data.expression;
  if (!sectionId) {
    throw new Error(`x-section-api directive requires a section id to be passed`);
  }
  const context = buildContext(Alpine, $el, sectionId, {morphConfig});
  // Section will update automatically when the section HTML is updated
  // const subscribe = data.modifiers.includes('subscribe');
  Alpine.addScopeToNode($el, {
    [THEME_SECTION_CONTEXT_KEY]: context,
  });
  // if (subscribe) {
  //   context.subscribe();
  // }
  Alpine.bind($el, {
    'aria-atomic': 'true',
    [':aria-busy']() {
      return context.state == 'loading';
    },
    [`x-router`]() {
      return async (url) => {
        const baseUrl = `${url.pathname}${url.search}`;
        window.dispatchEvent(
          new CustomEvent('theme:section:navigate', {
            detail: {
              sectionId,
              url: baseUrl,
            },
          }),
        );
        return context.update({baseUrl});
      };
    },
  });
  cleanup(() => {
    var _a;
    // Abort any pending fetches when element is removed from DOM
    (_a = context.abortController) === null || _a === void 0 ? void 0 : _a.abort();
    // context.unsubscribe();
  });
}
function buildContext(Alpine, $el, sectionId, options) {
  return Alpine.reactive({
    rootEl: (options === null || options === void 0 ? void 0 : options.rootEl) || $el,
    state: 'initial',
    error: null,
    targetId: (options === null || options === void 0 ? void 0 : options.targetId) || null,
    sectionId,
    pendingUrl: null,
    abortController: null,
    subscription: null,
    morphConfig: (options === null || options === void 0 ? void 0 : options.morphConfig) || DEFAULT_MORPH_CONFIG,
    buildUrl(options) {
      var _a;
      return buildSectionUrl(
        (_a = options === null || options === void 0 ? void 0 : options.sectionId) !== null && _a !== void 0
          ? _a
          : this.sectionId,
        Object.assign(Object.assign({}, options), {targetId: this.targetId}),
      );
    },
    /**
     * Update the section either from the cache or the network depending on the cache policy
     */
    update: async function (options) {
      const _notify = (url) => {
        window.dispatchEvent(new CustomEvent('theme:section:update', {detail: {sectionId: this.sectionId, url}}));
      };
      const _update = async () => {
        var _a;
        const cachePolicy =
          (_a = options === null || options === void 0 ? void 0 : options.cachePolicy) !== null && _a !== void 0
            ? _a
            : 'cache-and-network';
        const url = this.buildUrl(options);
        let resultHtml;
        if (cachePolicy == 'cache-only') {
          const cachedHtml = Alpine.store('cache').resources.sectionHtml.get(url);
          if (cachedHtml) {
            this.setHtml(cachedHtml, {
              mode: options === null || options === void 0 ? void 0 : options.htmlMode,
              morphConfig: options === null || options === void 0 ? void 0 : options.morphConfig,
            });
            _notify(url);
          }
          resultHtml = cachedHtml;
        } else if (cachePolicy == 'network-only') {
          const updatedHtml = await this.load(Object.assign({url}, options));
          if (updatedHtml) {
            this.setHtml(updatedHtml, {
              mode: options === null || options === void 0 ? void 0 : options.htmlMode,
              morphConfig: options === null || options === void 0 ? void 0 : options.morphConfig,
            });
            _notify(url);
          }
          resultHtml = updatedHtml;
        } else if (cachePolicy == 'cache-first') {
          const cachedHtml = Alpine.store('cache').resources.sectionHtml.get(url);
          if (cachedHtml) {
            this.setHtml(cachedHtml, {
              mode: options === null || options === void 0 ? void 0 : options.htmlMode,
              morphConfig: options === null || options === void 0 ? void 0 : options.morphConfig,
            });
            _notify(url);
            return cachedHtml;
          } else {
            const updatedHtml = await this.load(Object.assign({url}, options));
            if (updatedHtml) {
              _notify(url);
              this.setHtml(updatedHtml, {
                mode: options === null || options === void 0 ? void 0 : options.htmlMode,
                morphConfig: options === null || options === void 0 ? void 0 : options.morphConfig,
              });
            }
            resultHtml = updatedHtml;
          }
        } else if (cachePolicy == 'cache-and-network') {
          const cachedHtml = Alpine.store('cache').resources.sectionHtml.get(url);
          if (cachedHtml) {
            this.setHtml(cachedHtml, {
              mode: options === null || options === void 0 ? void 0 : options.htmlMode,
              morphConfig: options === null || options === void 0 ? void 0 : options.morphConfig,
            });
          }
          const updatedHtml = await this.load(Object.assign({url}, options));
          if (updatedHtml) {
            _notify(url);
            this.setHtml(updatedHtml, {
              mode: options === null || options === void 0 ? void 0 : options.htmlMode,
              morphConfig: options === null || options === void 0 ? void 0 : options.morphConfig,
            });
          }
          resultHtml = updatedHtml;
        } else {
          throw new Error(`Unknown cache policy: ${cachePolicy}`);
        }
        return resultHtml;
      };
      if (options === null || options === void 0 ? void 0 : options.waitForIdle) {
        return new Promise(async (resolve) => {
          window.requestIdleCallback(async () => {
            resolve(await _update());
          });
        });
      } else {
        return await _update();
      }
    },
    /**
     * Load data for the section from the network into the cache without actually updating the section html
     */
    load: async function (options) {
      var _a;
      try {
        const _b = options || {},
          {url, baseUrl, sectionId, batch} = _b,
          fetchOptions = __rest$1(_b, ['url', 'baseUrl', 'sectionId', 'batch']);
        // Allow overriding the section rendering API for a single request
        const requestUrl = url !== null && url !== void 0 ? url : this.buildUrl({baseUrl, sectionId});
        this.state = 'loading';
        window.dispatchEvent(
          new CustomEvent('theme:section:load', {detail: {sectionId: this.sectionId, url: requestUrl}}),
        );
        this.pendingUrl = requestUrl;
        if (batch) {
          const result = await fetchBatcher.request(requestUrl);
          // Grab the HTML for this section from the batch result
          const html = result[this.sectionId];
          // Store that HTML in the cache
          Alpine.store('cache').resources.sectionHtml.set(this.buildUrl({baseUrl, sectionId}), html);
          this.state = 'loaded';
          window.dispatchEvent(
            new CustomEvent('theme:section:loaded', {detail: {sectionId: this.sectionId, url: requestUrl}}),
          );
          return html;
        } else {
          if ((options === null || options === void 0 ? void 0 : options.abortPending) != false) {
            (_a = this.abortController) === null || _a === void 0 ? void 0 : _a.abort();
          }
          this.abortController = new AbortController();
          const result = await fetch(requestUrl, Object.assign({signal: this.abortController.signal}, fetchOptions));
          // TODO figure out what to do in error cases, right now we just throw an error...
          if (!result.ok) {
            throw new Error(result.statusText);
          }
          const responseHtml = await result.text();
          Alpine.store('cache').resources.sectionHtml.set(this.buildUrl({baseUrl, sectionId}), responseHtml);
          this.state = 'loaded';
          window.dispatchEvent(
            new CustomEvent('theme:section:loaded', {detail: {sectionId: this.sectionId, url: requestUrl}}),
          );
          return responseHtml;
        }
      } catch (e) {
        if (e.name == 'AbortError');
        else {
          // Update state so UI can display error
          this.state = 'error';
          this.error = prettyPrintError(e);
          throw e;
        }
      } finally {
        this.pendingUrl = null;
      }
    },
    navigate: async function (url, historyMode) {
      const $data = Alpine.$data($el);
      return $data.$router.navigate(url, historyMode);
    },
    // TODO implement subscriptions, and ensure they can't cause infinite loops
    // subscribe(options) {
    //   this.subscription = Alpine.effect(() => {
    //     const subscriptionUrl = this.buildUrl(options);
    //     const html = Alpine.store('cache').resources.sectionHtml.get(subscriptionUrl);
    //     if (typeof html == 'string') {
    //       this.setHtml(html, {mode: options?.htmlMode});
    //     }
    //   });
    // },
    // unsubscribe() {
    //   if (this.subscription) {
    //     Alpine.release(this.subscription);
    //     this.subscription = null;
    //   }
    // },
    setHtml(html, options) {
      var _a;
      // Shopify inserts an extra comment when using section rendering API in the theme editor which
      // breaks the morphing process. This removes it.
      const sanitizedHtml = html.replace(/<!--shopify:rendered_by_section_api-->/g, '');
      const morphConfig =
        (_a = options === null || options === void 0 ? void 0 : options.morphConfig) !== null && _a !== void 0
          ? _a
          : this.morphConfig;
      if ((options === null || options === void 0 ? void 0 : options.mode) == 'replace') {
        Alpine.mutateDom(() => {
          this.rootEl.innerHTML = sanitizedHtml;
          // Re-initialize alpine on cloned node
          Alpine.skipDuringClone(() => Alpine.initTree(this.rootEl))();
        });
      } else {
        Alpine.morph(
          this.rootEl,
          sanitizedHtml,
          buildMorphConfig({
            updating: (fromEl, toEl, childrenOnly, skip) => {
              var _a;
              if (isHtmlElement(fromEl) && isHtmlElement(toEl)) {
                if (fromEl == this.rootEl) {
                  // Skip morphing the root section el itself, only morph children
                  childrenOnly();
                } else {
                  // Check if the directive element is a frame or a section
                  if ($el._x_sectionApi_isFrame) {
                    if (fromEl._x_sectionApi_isFrame) {
                      if (this.targetId == fromEl.id) {
                        // Skip morphing the frame section el itself, only morph children
                        childrenOnly();
                      } else {
                        // Skip updating other frames
                        skip();
                      }
                    } else if (!fromEl.contains($el) && !$el.contains(fromEl)) {
                      // Skip any element which is not part of the frame's tree
                      skip();
                    }
                  }
                }
                (_a = morphConfig === null || morphConfig === void 0 ? void 0 : morphConfig.updating) === null ||
                _a === void 0
                  ? void 0
                  : _a.call(morphConfig, fromEl, toEl, childrenOnly, skip);
              }
            },
            updated: morphConfig === null || morphConfig === void 0 ? void 0 : morphConfig.updated,
            removing: morphConfig === null || morphConfig === void 0 ? void 0 : morphConfig.removing,
            removed: morphConfig === null || morphConfig === void 0 ? void 0 : morphConfig.removed,
            adding: morphConfig === null || morphConfig === void 0 ? void 0 : morphConfig.adding,
            added: morphConfig === null || morphConfig === void 0 ? void 0 : morphConfig.added,
            key: morphConfig === null || morphConfig === void 0 ? void 0 : morphConfig.key,
            lookahead: morphConfig === null || morphConfig === void 0 ? void 0 : morphConfig.lookahead,
          }),
        );
      }
    },
  });
}
function buildSectionUrl(sectionId, options) {
  var _a, _b, _c;
  const DEFAULT_BASE_URL =
    ((_b = (_a = window.theme) === null || _a === void 0 ? void 0 : _a.routes) === null || _b === void 0
      ? void 0
      : _b.root) || '/';
  // This is such an ugly hack but unfortunately necessary until this is fixed: https://github.com/whatwg/url/issues/531
  const FAKE_HOST = 'https://fake-host';
  const fullUrl = new URL(
    (_c = options === null || options === void 0 ? void 0 : options.baseUrl) !== null && _c !== void 0
      ? _c
      : DEFAULT_BASE_URL,
    FAKE_HOST,
  );
  let sanitizedSectionId;
  // Handle case of section ID from section DOM element being passed in (i.e. prepended with 'shopify-section-')
  if (sectionId.startsWith('shopify-section-')) {
    sanitizedSectionId = sectionId.split('shopify-section-')[1];
  } else {
    sanitizedSectionId = sectionId;
  }
  if (options === null || options === void 0 ? void 0 : options.targetId) {
    fullUrl.hash = options.targetId;
  }
  fullUrl.searchParams.append('section_id', sanitizedSectionId);
  return fullUrl.toString().replace(FAKE_HOST, '');
}

/**
 * Hijacks product form submissions and serializes form data and submits to the cart/add.js endpoint instead of a normal HTTP form submission.
 *
 * - Looks for sections marked with data-cart-api-section and adds them in the 'sections' form data parameter so that the theme can update the sections in response to the form submission.
 * - Dispatches a theme:cart:add event with the parsed body of the response.
 *
 * @example
 *
 * ```liquid
 * {% form 'product', product, x-product-form: '' %}
 *   <input type="hidden" name="id" value="123">
 *   <input type="text" name="name" value="Product Name">
 *   <button type="submit">Add to cart</button>
 * {% endform %}
 * ```
 */
function productForm(Alpine) {
  Alpine.directive('product-form', ($el, data, utilities) => {
    var _a, _b;
    if (data.value == 'form') {
      handleForm$3($el, Alpine);
    } else if (data.value == 'context') {
      handleContext$2($el, Alpine, data);
    } else {
      const xFormModifiers = data.modifiers.length ? data.modifiers.join('.') : null;
      if (
        !((_b =
          (_a = window === null || window === void 0 ? void 0 : window.theme) === null || _a === void 0
            ? void 0
            : _a.routes) === null || _b === void 0
          ? void 0
          : _b.cartAdd)
      ) {
        throw new Error('window.theme.routes.cartAdd is not defined');
      }
      if (!isFormElement($el)) {
        // Handle the case of x-async-form being applied to a parent of a form element
        // In this case we look for a form element child and apply form directive to that
        Alpine.bind($el, {
          [`x-product-form:context${xFormModifiers ? `.${xFormModifiers}` : ``}`]: '',
        });
        const form = $el.querySelector('form');
        if (form) {
          Alpine.bind(form, {
            [`x-product-form:form`]: '',
          });
        }
      } else {
        Alpine.bind($el, {
          [`x-product-form:context${xFormModifiers ? `.${xFormModifiers}` : ``}`]: '',
          [`x-product-form:form`]: '',
        });
      }
    }
  }).before('bind');
  Alpine.magic('productForm', handleAsyncFormMagic(Alpine));
}
function handleForm$3($el, Alpine, data, utilities) {
  Alpine.bind($el, {
    method: 'POST',
  });
}
function handleContext$2($el, Alpine, data, _utilities) {
  const xFormModifiers = data.modifiers.length ? data.modifiers.join('.') : null;
  Alpine.bind($el, {
    [`x-async-form${xFormModifiers ? `.${xFormModifiers}` : ``}`]: () => {
      return (data) => {
        const formData = data.formData;
        if (!formData) return submitFormData(data);

        // Gather sections for cart redraw
        const sections = getCartApiSections();

        const mainVariantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const giftVariantId = Number(formData.get('properties[_gift_variant_id]') || 0);

        // If no gift marker, keep existing flow
        if (!giftVariantId || Number.isNaN(giftVariantId)) {
          formData.append('sections', sections.join(','));
          data.action = `${window.theme.routes.cartAdd}.js`;
          return submitFormData(data);
        }

        // Optional: prevent internal marker from showing in cart line item properties
        formData.delete('properties[_gift_variant_id]');

        const items = [
          {
            id: mainVariantId,
            quantity,
          },
          {
            id: giftVariantId,
            quantity,
            properties: {
              _gift_auto: 'true',
              _gift_for_variant_id: String(mainVariantId),
            },
          },
        ];

        return fetch(`${window.theme.routes.cartAdd}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({items, sections}),
        });
      };
    },
    '@form:success'() {
      this.$dispatch('theme:cart:add', this.$event.detail);
    },
  });
}

/**
 * Plugin to show a loading placeholder for an image until it has loaded
 *
 * To use:
 * 1. Create a smaller sized version of your image and place it next to (before or after) the original
 * 2. Style it to be the same size as the original and absolutely positioned above or below the original
 * 3. Add the x-img-loading-placeholder directive on the placeholder image
 *
 * <div class="relative">
 *   <img src="/test?width=1000&height=100.png" class="relative z-10" width="1000" height="1000">
 *   <img src="/test.png?width=4&height=4.png" x-img-loading-placeholder class="absolute inset-0 z-0" role="presentation">
 * </div>
 *
 * Or you can pass a reference directly to the directive
 *
 * <div class="relative">
 *   <img x-ref="original" src="/test?width=1000&height=100.png" class="relative z-10" width="1000" height="1000">
 *   <div>
 *    <img src="/test.png?width=4&height=4.png" x-img-loading-placeholder="$refs.original" class="absolute inset-0 z-0" role="presentation">
 *   </div>
 * </div>
 *
 * You can also force the placeholder to show by default by adding the .show modifier
 *
 * <div class="relative">
 *   <img src="/test?width=1000&height=100.png" class="relative z-10" width="1000" height="1000">
 *   <img src="/test.png?width=4&height=4.png" x-img-loading-placeholder.show class="absolute inset-0 z-0" role="presentation">
 * </div>
 */
var imageLoadingPlaceholder = (Alpine) => {
  Alpine.directive('img-loading-placeholder', ($el, {expression}, {evaluate}) => {
    if (!isHtmlElement($el)) {
      throw new Error(`Expected HTMLImageElement but got ${$el}`);
    }
    let targetImage = null;
    if (expression) {
      targetImage = evaluate(expression) || null;
      if (!isImageElement(targetImage)) {
        throw new Error(`Expected targetImage to be HTMLImageElement but got ${$el}`);
      }
    }
    Alpine.bind($el, {
      'x-data'() {
        return {
          __imgLoadingPlaceholder_showPlaceholder: true,
          __imgLoadingPlaceholder_targetImage: targetImage,
          init() {
            var _a, _b;
            // Look at the next and previous siblings to see if they are images and
            // if so then set the target image to that
            if (
              !this.__imgLoadingPlaceholder_targetImage &&
              ((_a = this.$el.nextElementSibling) === null || _a === void 0 ? void 0 : _a.nodeName) === 'IMG'
            ) {
              this.__imgLoadingPlaceholder_targetImage = this.$el.nextElementSibling;
            }
            if (
              !this.__imgLoadingPlaceholder_targetImage &&
              ((_b = this.$el.previousElementSibling) === null || _b === void 0 ? void 0 : _b.nodeName) === 'IMG'
            ) {
              this.__imgLoadingPlaceholder_targetImage = this.$el.previousElementSibling;
            }
            // If no target image, don't show a placeholder
            if (!this.__imgLoadingPlaceholder_targetImage) {
              this.__imgLoadingPlaceholder_showPlaceholder = false;
              return;
            }
            // If image already loaded, hide the placeholder
            if (this.__imgLoadingPlaceholder_targetImage.complete) {
              this.$nextTick(() => {
                this.__imgLoadingPlaceholder_showPlaceholder = false;
              });
            } else {
              const handleLoad = (_e) => {
                this.__imgLoadingPlaceholder_showPlaceholder = false;
              };
              this.__imgLoadingPlaceholder_targetImage.onload = handleLoad.bind(this);
            }
          },
        };
      },
      'x-show': '__imgLoadingPlaceholder_showPlaceholder',
      'aria-hidden': 'true',
      role: 'presentation',
    });
  }).before('bind');
};

/**
 * Plugin for managing hover states on elements. Automatically adds/removes event listeners, ignores touch events,
 * and optionally adds a delay before evaluating the expression for cases like tooltips
 *
 * @example
 * <div x-hover:start="console.log('hover started')"></div>
 * <div x-hover:end="console.log('hover ended')"></div>
 * <div x-hover:start.delay.300ms="console.log('hover started with delay')"></div>
 */
var hover = (Alpine) => {
  // Define the x-hover directive
  Alpine.directive('hover', ($el, data, utilities) => {
    if (!isHtmlElement($el)) {
      throw new Error(`Expected HTMLElement but got ${$el}`);
    }
    // Determine which handler to use based on the directive value
    switch (data.value) {
      case 'start':
        handleStart($el, data, utilities);
        break;
      case 'end':
        handleEnd($el, data, utilities);
        break;
      default:
        throw new Error(`Unknown directive: x-hover:${data.value}`);
    }
  }).before('bind');
  /**
   * Handles the x-hover:start directive
   */
  function handleStart($el, {expression, modifiers}, {evaluateLater, cleanup}) {
    const expressionFn = expression ? evaluateLater(expression) : null;
    // Determine modifiers
    const shouldDelay = modifiers.includes('delay');
    let delayTimeoutId = null;
    $el._x_hover_hasEnterCallback = true;
    let delay = 0;
    if (shouldDelay) {
      delay = getDelayModifier(modifiers);
    }
    /**
     * Evaluates the callback expression provided in the directive
     */
    function evaluateCallbackExpression(e) {
      expressionFn === null || expressionFn === void 0
        ? void 0
        : expressionFn(() => {}, {
            scope: {
              $event: e,
            },
            params: [e],
          });
    }
    /**
     * Handles pointer/mouse leave events
     */
    function onPointerLeave(e) {
      var _a;
      if ($el._x_hover_leaveCallback) {
        // If x-hover:end is used on the same element, call the leave callback
        (_a = $el._x_hover_leaveCallback) === null || _a === void 0 ? void 0 : _a.call($el, e);
      }
      // Clear any timeouts
      if (delayTimeoutId !== null) {
        clearTimeout(delayTimeoutId);
        delayTimeoutId = null;
      }
    }
    /**
     * Handles pointer/mouse enter events
     */
    function onPointerEnter(e) {
      if (isTouchEvent(e)) return;
      $el.addEventListener('pointerleave', onPointerLeave, {
        once: true,
      });
      if (shouldDelay) {
        // Handle delay before triggering the callback
        delayTimeoutId = setTimeout(() => {
          evaluateCallbackExpression === null || evaluateCallbackExpression === void 0
            ? void 0
            : evaluateCallbackExpression(e);
        }, delay);
      } else {
        // No delay, trigger callback immediately
        evaluateCallbackExpression === null || evaluateCallbackExpression === void 0
          ? void 0
          : evaluateCallbackExpression(e);
      }
    }
    // Bind the appropriate enter event
    Alpine.bind(
      $el,
      {
        '@pointerenter'(e) {
          onPointerEnter(e);
        },
      } /* Remove 'any' when @alpinejs/types is fixed */,
    );
    // Clean up any timeouts and event listeners on cleanup
    cleanup(() => {
      if (delayTimeoutId !== null) {
        clearTimeout(delayTimeoutId);
      }
      $el.removeEventListener('pointerleave', onPointerLeave);
    });
  }
  /**
   * Handles the x-hover:end directive
   */
  function handleEnd($el, {expression, modifiers}, {evaluateLater, cleanup}) {
    const expressionFn = evaluateLater(expression);
    let onPointerReenter = () => {};
    const shouldDelay = modifiers.includes('delay');
    let delayTimeoutId = null;
    let delay = 0;
    if (shouldDelay) {
      delay = getDelayModifier(modifiers);
    }
    /**
     * Evaluates the callback expression provided in the directive
     */
    function evaluateCallbackExpression(e) {
      expressionFn === null || expressionFn === void 0
        ? void 0
        : expressionFn(() => {}, {
            scope: {
              $event: e,
            },
            params: [e],
          });
    }
    /**
     * Handles pointer/mouse leave events
     */
    function onPointerLeave(e) {
      if (shouldDelay) {
        onPointerReenter = () => {
          if (delayTimeoutId !== null) {
            clearTimeout(delayTimeoutId);
            delayTimeoutId = null;
          }
        };
        // Start a timer to execute the expression after the delay
        delayTimeoutId = setTimeout(() => {
          $el.removeEventListener('pointerenter', onPointerReenter);
          evaluateCallbackExpression(e);
        }, delay);
        // If pointer re-enters before delay is over, clear the timeout
        $el.addEventListener('pointerenter', onPointerReenter, {once: true});
      } else {
        evaluateCallbackExpression(e);
      }
    }
    if ($el._x_hover_hasEnterCallback) {
      // If x-hover:start is already also used on this element, store the leave callback
      $el._x_hover_leaveCallback = onPointerLeave;
    } else {
      // If x-hover:end is used alone, add the leave event listener directly
      Alpine.bind(
        $el,
        {
          '@pointerleave'(e) {
            onPointerLeave(e);
          },
        } /* Remove 'any' when @alpinejs/types is fixed */,
      );
    }
    cleanup(() => {
      if (delayTimeoutId !== null) {
        clearTimeout(delayTimeoutId);
      }
      $el.removeEventListener('pointerenter', onPointerReenter);
    });
  }
  /**
   * Retrieves the delay value from the modifiers
   */
  function getDelayModifier(modifiers) {
    const delayIndex = modifiers.indexOf('delay');
    const timeModifier = modifiers[delayIndex + 1];
    if (timeModifier) {
      const parsedTime = Number(timeModifier.replace('ms', ''));
      if (!isNaN(parsedTime)) {
        return parsedTime;
      }
    }
    // Default delay value if not specified
    return 0;
  }
};

const FOCUS_STATE_CONTEXT_KEY = Symbol('FOCUS_STATE_CONTEXT_KEY');
/**
 * Plugin to allow for easily binding an external x-data variable to the focus state of an element
 *
 * e.g of instead of this
 *
 * <button x-data="{ hasFocus: false }" @focus="hasFocus = true" @blur="hasFocus = false"></button></button>
 *
 * you can just do this:
 *
 * <button x-data="{ hasFocus: false }" x-focus-state="hasFocus = $hasFocus">Focus on me</button>
 *
 * The expression passed to `x-focus-state` is evaluated when it receives the `focus` (`$hasFocus` will be true), and again when it receives the
 * `blur` event (`$hasFocus` will be false).
 *
 * This plugin has the added benefit that the `blur` listener isn't bound until the `focus` element is fired, and also is destroyed when the element is destroyed or `blur` is fired
 */
var focusState = (Alpine) => {
  Alpine.directive('focus-state', ($el, {expression}, {evaluateLater, effect, cleanup}) => {
    if (!isHtmlElement($el)) {
      throw new Error(`Expected HTMLElement but got ${$el}`);
    }
    const expressionFn = evaluateLater(expression);
    const context = Alpine.reactive({
      hasFocus: false,
      lastEvent: null,
      abortController: null,
      onFocus(e) {
        this.abortController = new AbortController();
        this.lastEvent = e;
        if (this.hasFocus == true) {
          return;
        }
        this.hasFocus = true;
        expressionFn(() => {}, {
          scope: {
            $event: this.lastEvent,
            $hasFocus: this.hasFocus,
          },
          params: [this.lastEvent, this.hasFocus],
        });
        $el.addEventListener('blur', this.onBlur.bind(this), {
          signal: this.abortController.signal,
        });
      },
      onBlur(e) {
        this.hasFocus = false;
        this.lastEvent = e;
        expressionFn(() => {}, {
          scope: {
            $event: this.lastEvent,
            $hasFocus: this.hasFocus,
          },
          params: [this.lastEvent, this.hasFocus],
        });
        this.abortController.abort();
      },
    });
    Alpine.addScopeToNode($el, {
      [FOCUS_STATE_CONTEXT_KEY]: context,
    });
    Alpine.bind(
      $el,
      {
        '@focus'(e) {
          return context.onFocus(e);
        },
      } /* TODO remove this one @alpinejs/types is fixed */,
    );
    cleanup(() => {
      var _a;
      (_a = context.abortController) === null || _a === void 0 ? void 0 : _a.abort();
    });
  }).before('bind');
  Alpine.magic('hasFocus', ($el) => {
    const context = Alpine.$data($el)[FOCUS_STATE_CONTEXT_KEY];
    if (!context) throw new Error('$hasFocus needs to be used on or inside an element with x-focus-state');
    return context.hasFocus;
  });
};

const FOCUS_IN_STATE_CONTEXT_KEY = Symbol('FOCUS_IN_STATE_CONTEXT_KEY');
/**
 * Plugin to allow for easily binding an external x-data variable to whether an element contains focus or not
 *
 * e.g of instead of this
 *
 * <div x-data="{ hasFocusIn: false }" @focusin="hasFocusIn = true" @focusout="hasFocusIn = false">
 *   </button></button>
 * </div>
 *
 * you can just do this:
 *
 * <button x-data="{ hasFocusIn: false }" x-focusin-state="hasFocusIn = $hasFocusIn">Focus on me</button>
 *
 * The expression passed to `x-focusin-state` is evaluated when it receives the `focusin` (`$hasFocusIn` will be true), and again when it receives the
 * `focusout` event (`$hasFocusIn` will be false).
 *
 * This plugin has a few added benefits in addition to simpler code:
 * - The `focusout` listener isn't bound until the `focusin` element is fired, and also is destroyed when the element is destroyed or `focusout` is fired
 * - This plugin checks that when focusout occurs, the new focused element is actually outside of the wrapper
 */
var focusInState = (Alpine) => {
  Alpine.directive('focusin-state', ($el, {expression}, {evaluateLater, cleanup}) => {
    if (!isHtmlElement($el)) {
      throw new Error(`Expected HTMLElement but got ${$el}`);
    }
    const expressionFn = evaluateLater(expression);
    const context = Alpine.reactive({
      hasFocusIn: false,
      lastEvent: null,
      abortController: null,
      onFocusIn(e) {
        this.abortController = new AbortController();
        this.lastEvent = e;
        if (this.hasFocusIn == true) {
          return;
        }
        this.hasFocusIn = true;
        expressionFn(() => {}, {
          scope: {
            $event: this.lastEvent,
            $hasFocusIn: this.hasFocusIn,
          },
          params: [this.lastEvent, this.hasFocusIn],
        });
        $el.addEventListener('focusout', this.onFocusOut.bind(this), {
          signal: this.abortController.signal,
        });
      },
      onFocusOut(e) {
        if ($el.isSameNode(e.relatedTarget) || $el.contains(e.relatedTarget)) {
          return;
        }
        this.lastEvent = e;
        this.hasFocusIn = false;
        expressionFn(() => {}, {
          scope: {
            $event: this.lastEvent,
            $hasFocusIn: this.hasFocusIn,
          },
          params: [this.lastEvent, this.hasFocusIn],
        });
        this.abortController.abort();
      },
    });
    Alpine.addScopeToNode($el, {
      [FOCUS_IN_STATE_CONTEXT_KEY]: context,
    });
    Alpine.bind(
      $el,
      {
        '@focusin'(e) {
          return context.onFocusIn(e);
        },
      } /* TODO remove this one @alpinejs/types is fixed */,
    );
    cleanup(() => {
      var _a;
      (_a = context.abortController) === null || _a === void 0 ? void 0 : _a.abort();
    });
  }).before('bind');
  Alpine.magic('hasFocusIn', ($el) => {
    const context = Alpine.$data($el)[FOCUS_IN_STATE_CONTEXT_KEY];
    if (!context) throw new Error('$hasFocusIn needs to be used on or inside an element with x-focusin-state');
    return context.hasFocusIn;
  });
};

var __rest =
  (undefined && undefined.__rest) ||
  function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
      }
    return t;
  };
const ANIMATE_CONTEXT_KEY = Symbol('ANIMATE_CONTEXT_KEY');
function motion(Alpine) {
  Alpine.directive('animate', ($el, {expression, modifiers}, {evaluateLater, effect}) => {
    if (!isHtmlElement($el)) {
      throw new Error(`Expected HTMLElement but got ${$el}`);
    }
    if (!expression) {
      throw new Error(
        'Expected x-animate to be passed a motion keyframes object but was passed nothing. See https://motion.dev/dom/animate#keyframes',
      );
    }
    const keyframesFn = evaluateLater(expression);
    const context = Alpine.reactive({
      controls: null,
    });
    // Autoplay the animation unless .pause modifier is present
    const autoplay = !modifiers.includes('pause');
    effect(() => {
      keyframesFn((keyframes) => {
        if (!isPlainObject(keyframes)) {
          throw new Error(
            String.raw`Expected x-animate to be passed a motion keyframes object but got '${String(keyframes)}'. See https://motion.dev/dom/animate#keyframes`,
          );
        }
        context.controls = animate($el, keyframes, {
          autoplay,
        });
      });
      // Make controls available on node
      Alpine.addScopeToNode($el, {
        [ANIMATE_CONTEXT_KEY]: context,
      });
    });
  });
  Alpine.directive('animate-scroll', ($el, {expression}, {evaluate}) => {
    if (!isHtmlElement($el)) {
      throw new Error(`Expected HTMLElement but got ${$el}`);
    }
    if (!expression) {
      throw new Error(
        'Expected x-animate to be passed a motion keyframes object but was passed nothing. See https://motion.dev/dom/animate#keyframes',
      );
    }
    const keyframes = evaluate(expression);
    Alpine.bind($el, {
      'x-data'() {
        return {
          __animateScroll_isVisible: false,
          __animateScroll_animation: null,
          __animateScroll_cancelScrollAnimation: null,
          init() {
            this.__animateScroll_animation = animate($el, keyframes);
            this.$watch('__animateScroll_isVisible', (isVisible) => {
              var _a, _b;
              if (isVisible) {
                (_a = this.__animateScroll_cancelScrollAnimation) === null || _a === void 0 ? void 0 : _a.call(this);
                this.__animateScroll_cancelScrollAnimation = scroll(this.__animateScroll_animation, {
                  target: $el,
                  offset: ['0% 100%', '100% 0%'],
                });
              } else {
                (_b = this.__animateScroll_cancelScrollAnimation) === null || _b === void 0 ? void 0 : _b.call(this);
              }
            });
          },
          destroy() {
            var _a;
            (_a = this.__animateScroll_cancelScrollAnimation) === null || _a === void 0 ? void 0 : _a.call(this);
          },
        };
      },
      'x-intersect:enter': '__animateScroll_isVisible = true',
      'x-intersect:leave': '__animateScroll_isVisible = false',
    });
  });
  Alpine.directive('animate-scroll-stagger', ($el, {expression, value}, {evaluate}) => {
    if (value == 'enter') {
      const keyframes = evaluate(expression);
      Alpine.bind($el, {
        'x-init'() {
          this.$data.__animateScrollStagger_enterKeyframes = keyframes;
        },
      });
    } else if (value == 'leave') {
      const keyframes = evaluate(expression);
      Alpine.bind($el, {
        'x-init'() {
          this.$data.__animateScrollStagger_leaveKeyframes = keyframes;
        },
      });
    } else {
      const _a = expression ? evaluate(expression) : {},
        {
          selector: optionalSelector,
          stagger: optionalStagger,
          scrollOffset: optionalScrollOffset,
          target: optionalTarget,
        } = _a,
        visibleKeyframes = __rest(_a, ['selector', 'stagger', 'scrollOffset', 'target']);
      const selector = optionalSelector || '[data-animate-stagger-item]';
      let stagger = optionalStagger || 0.2;
      let scrollOffset = optionalScrollOffset || ['25% 100%', '0% 50%', '0% 0%', '75% 0%'];
      let target = optionalTarget || $el;
      Alpine.bind($el, {
        'x-data'() {
          return {
            __animateScrollStagger_cancelScroll: null,
            __animateScrollStagger_fitsInViewport: null,
            __animateScrollStagger_didBeginFullyVisible: false,
            __animateScrollStagger_wasFullyVisible: null,
            __animateScrollStagger_isFullyVisible: null,
            __animateScrollStagger_wasPartiallyVisible: null,
            __animateScrollStagger_isPartiallyVisible: null,
            __animateScrollStagger_enterKeyframes: {},
            __animateScrollStagger_visibleKeyframes: visibleKeyframes,
            __animateScrollStagger_leaveKeyframes: {},
            get __animateScrollStagger_items() {
              return Array.from($el.querySelectorAll(selector));
            },
            init() {
              this.$watch('__animateScrollStagger_wasFullyVisible', (isFullyVisible) => {
                this.__animateScrollStagger_wasFullyVisible = isFullyVisible;
              });
              this.$watch('__animateScrollStagger_wasPartiallyVisible', (isPartiallyVisible) => {
                this.__animateScrollStagger_wasPartiallyVisible = isPartiallyVisible;
              });
            },
            destroy() {
              this.__animateScrollStagger_cancelScrollAnimation();
            },
            __animateScrollStagger_startScrollAnimation() {
              if (this.__animateScrollStagger_cancelScroll !== null) return;
              // Duration of the staggerItem animation. Doesn't have any effect when using the scroll animation
              const staggerItemDuration = 1.0;
              // The offset (in terms of % of staggerItem duration) that each staggerItem should be offset from the previous staggerItem
              const staggerItemOffset = stagger || 0.2;
              // When each staggerItem animation should start in relation to the previous staggerItem
              const at = `-${staggerItemDuration * (1 - staggerItemOffset)}`;
              // staggerItem animation sequence when element enters the viewport
              const entrySequence = this.__animateScrollStagger_items.map((staggerEl) => [
                staggerEl,
                this.__animateScrollStagger_enterKeyframes,
                {
                  ease: 'easeOut',
                  duration: staggerItemDuration,
                  at: at,
                },
              ]);
              const visibleKeyframes =
                this.__animateScrollStagger_visibleKeyframes !== null &&
                Object.keys(this.__animateScrollStagger_visibleKeyframes).length > 0
                  ? this.__animateScrollStagger_visibleKeyframes
                  : buildStaticKeyframes(this.__animateScrollStagger_enterKeyframes);
              // Sequence to run when the element is fully visible where no animation occurs
              const visibleSequence = this.__animateScrollStagger_items.map((staggerEl) => [
                staggerEl,
                visibleKeyframes,
                {duration: staggerItemDuration, at: at, ease: 'easeOut'},
              ]);
              // staggerItem animation sequence when element exits the viewport
              const exitSequence = this.__animateScrollStagger_items.map((staggerEl) => [
                staggerEl,
                this.__animateScrollStagger_leaveKeyframes,
                {
                  ease: 'easeOut',
                  duration: staggerItemDuration,
                  at: at,
                },
              ]);
              if (this.__animateScrollStagger_fitsInViewport == false) {
                // If the element doesn't fit in the viewport height-wise we only use the entry sequence
                // and run it the whole time the element is in the viewport
                this.__animateScrollStagger_cancelScroll = scroll(animate(entrySequence), {
                  target: target,
                  offset: ['0% 100%', '100% 0%'],
                });
              } else {
                this.__animateScrollStagger_cancelScroll = scroll(
                  animate([...entrySequence, ...visibleSequence, ...exitSequence]),
                  {
                    target: target,
                    offset: scrollOffset,
                  },
                );
              }
            },
            __animateScrollStagger_cancelScrollAnimation() {
              var _a;
              (_a = this.__animateScrollStagger_cancelScroll) === null || _a === void 0 ? void 0 : _a.call(this);
              this.__animateScrollStagger_cancelScroll = null;
            },
          };
        },
        'x-intersect:enter.threshold.0': '__animateScrollStagger_isPartiallyVisible = true',
        'x-intersect:leave.threshold.0': '__animateScrollStagger_isPartiallyVisible = false',
        'x-intersect:enter.full': '__animateScrollStagger_isFullyVisible = true',
        'x-intersect:leave.full': '__animateScrollStagger_isFullyVisible = false',
        async 'x-effect'() {
          if (this.__animateScrollStagger_wasFullyVisible == null && this.__animateScrollStagger_isFullyVisible) {
            // Whenever the element is fully visible, play the in view animation then start the scroll animation once it's done
            this.__animateScrollStagger_startScrollAnimation();
          } else if (this.__animateScrollStagger_isFullyVisible == false) {
            if (this.__animateScrollStagger_isPartiallyVisible == true) {
              // Whenever the element is partially visible, start the scroll animation
              this.__animateScrollStagger_startScrollAnimation();
            } else if (
              this.__animateScrollStagger_wasPartiallyVisible == true &&
              this.__animateScrollStagger_isPartiallyVisible == false
            ) {
              // Stop the scroll animation when element has fully exited the viewport
              this.__animateScrollStagger_cancelScrollAnimation();
            }
          }
        },
        'x-resize'() {
          this.__animateScrollStagger_fitsInViewport = this.$height <= window.innerHeight;
        },
      });
    }
  });
  Alpine.magic('m', handleMotionMagic());
  Alpine.magic('animation', ($el) => {
    const context = Alpine.$data($el)[ANIMATE_CONTEXT_KEY];
    if (!context) throw new Error('$animation needs to be used on or inside an element with x-animate directive');
    return context.controls;
  });
}
// TODO Test me
/**
 * Creates a reactive motion value that updates Alpine state when the motion value changes.
 *
 * @param Alpine
 * @param initialMotionValue
 * @returns MotionValue<T>
 */
function reactiveMotionValue(_Alpine, initialMotionValue) {
  const value = motionValue(initialMotionValue);
  const reactiveValue = _Alpine.reactive({value: value.get()});
  value.on('change', (newValue) => {
    reactiveValue.value = newValue;
  });
  return new Proxy(value, {
    get(target, prop, receiver) {
      if (prop === 'get') {
        // Calling this here is a bit of a hack to make vue/reactivity pick up changes to the motion value
        reactiveValue.value;
      }
      return Reflect.get(target, prop, receiver);
    },
  });
}
function handleMotionMagic(_Alpine) {
  return function (_$el) {
    return {
      animate,
      stagger,
      spring,
      scroll,
      inView,
      motionValue,
      mapValue,
      transformValue,
      springValue,
      attrEffect,
      svgEffect,
      propEffect,
      styleEffect,
      animateView,
      transform,
    };
  };
}
/**
 * Builds a keyframes object that has the last value of each keyframe
 *
 * @param enterKeyframes
 * @returns ObjectTarget<{}>
 */
function buildStaticKeyframes(enterKeyframes) {
  return Object.entries(enterKeyframes).reduce((keyframes, [key, value]) => {
    return Object.assign(Object.assign({}, keyframes), {
      [key]: Array.isArray(value) ? (value.length > 1 ? [value[1], value[1]] : value[0]) : [value, value],
    });
  }, {});
}

/**
 * Enables the creation of stepper components.
 * The 'x-stepper' directive provide functionality for managing stepper input fields.
 *
 * x-stepper -  The root element of the stepper, initializing the stepper functionality and adding a data context for child directives. Use the 'modal' modifier (x-dialog.modal) to make the dialog modal.
 * x-stepper:input - The input element
 * x-stepper:minus - The minus button
 * x-stepper:plus - The plus button
 *
 * @example
 *
  <div x-stepper>
    <button type="button" x-stepper:minus>−</button>
    <input type="number" name="stepper" min="1" max="10" value="1" x-stepper:input>
    <button type="button" x-stepper:plus>+</button>
  </div>

 */
function stepper(Alpine) {
  Alpine.directive('stepper', ($el, data) => {
    if (data.value == 'input') {
      handleInput$1($el, Alpine);
    } else if (data.value == 'minus') {
      handleButtonMinus($el, Alpine);
    } else if (data.value == 'plus') {
      handleButtonPlus($el, Alpine);
    } else if (data.value == null) {
      handleRoot$7($el, Alpine);
    } else {
      throw new Error(`Unknown directive: x-stepper:${data.value}`);
    }
  }).before('bind');
  Alpine.magic('stepper', ($el) => {
    const $data = Alpine.$data($el);
    return {
      get value() {
        return $data.__stepper_value;
      },
      increment() {
        $data.__stepper_increment();
      },
      decrement() {
        $data.__stepper_decrement();
      },
    };
  });
}
function handleInput$1($el, Alpine) {
  if (isInputNumberElement($el)) {
    Alpine.bind($el, {
      'x-init': '__stepper_inputEl = $el',
    });
  } else {
    throw new Error(`Expected <input type="number"> tag for x-stepper:input but got ${$el}`);
  }
}
function handleButtonMinus($el, Alpine) {
  if (isButtonElement($el)) {
    Alpine.bind($el, {
      '@click.prevent': '$stepper.decrement',
    });
  } else {
    throw new Error(`Expected <button> tag for x-stepper:minus but got ${$el}`);
  }
}
function handleButtonPlus($el, Alpine) {
  if (isButtonElement($el)) {
    Alpine.bind($el, {
      '@click.prevent': '$stepper.increment',
    });
  } else {
    throw new Error(`Expected <button> tag for x-stepper:plus but got ${$el}`);
  }
}
function handleRoot$7($el, Alpine) {
  Alpine.bind($el, {
    ['x-data']() {
      return {
        __stepper_inputEl: null,
        __stepper_value: null,
        init() {
          queueMicrotask(() => {
            Alpine.effect(() => {
              if (this.__stepper_inputEl) {
                const value = Alpine.bound(this.__stepper_inputEl, 'value', null);
                this.__stepper_value = value !== null && value !== undefined ? Number(value) : null;
              }
            });
          });
        },
        __stepper_decrement() {
          var _a, _b, _c, _d;
          (_a = this.__stepper_inputEl) === null || _a === void 0 ? void 0 : _a.stepDown();
          // Browsers don't dispatch input/change events when the value is decremented/incremented so we do that
          // manually so that things like Alpine x-model still work
          (_b = this.__stepper_inputEl) === null || _b === void 0
            ? void 0
            : _b.dispatchEvent(new Event('input', {bubbles: true}));
          (_c = this.__stepper_inputEl) === null || _c === void 0
            ? void 0
            : _c.dispatchEvent(new Event('change', {bubbles: true}));
          this.$dispatch('decrement', (_d = this.__stepper_inputEl) === null || _d === void 0 ? void 0 : _d.value);
        },
        __stepper_increment() {
          var _a, _b, _c, _d;
          (_a = this.__stepper_inputEl) === null || _a === void 0 ? void 0 : _a.stepUp();
          (_b = this.__stepper_inputEl) === null || _b === void 0
            ? void 0
            : _b.dispatchEvent(new Event('input', {bubbles: true}));
          (_c = this.__stepper_inputEl) === null || _c === void 0
            ? void 0
            : _c.dispatchEvent(new Event('change', {bubbles: true}));
          this.$dispatch('increment', (_d = this.__stepper_inputEl) === null || _d === void 0 ? void 0 : _d.value);
        },
      };
    },
    '@click.self'() {
      var _a;
      (_a = this.__stepper_inputEl) === null || _a === void 0 ? void 0 : _a.focus();
    },
  });
}

function submittableTextarea(Alpine) {
  Alpine.directive('submittable-textarea', ($el, data) => {
    if (!isHtmlElement($el)) {
      throw new Error(`Expected HTMLElement but got ${$el}`);
    }
    if (data.value == null) {
      handleSubmit($el, Alpine);
    } else {
      throw new Error(`Unknown directive: x-submittable-textarea:${data.value}`);
    }
  }).before('bind');
}
function handleSubmit($el, Alpine) {
  const isMac = Boolean(navigator.userAgent.indexOf('Mac OS X') !== -1);
  Alpine.bind($el, {
    ['x-data']() {
      return keyActions(isMac);
    },
    '@keydown': '__onKeyDown',
    '@keyup': '__onKeyUp',
  });
}
function keyActions(isMac) {
  return {
    isMetaKeyPressed: false,
    key: isMac ? 'Meta' : 'Control',
    __onKeyDown(e) {
      var _a;
      if (this.isMetaKeyPressed && e.key === 'Enter' && !e.repeat) {
        const target = e.target;
        (_a = target === null || target === void 0 ? void 0 : target.closest('form')) === null || _a === void 0
          ? void 0
          : _a.requestSubmit();
      }
      if (e.key === this.key) {
        this.isMetaKeyPressed = true;
      }
    },
    __onKeyUp(e) {
      if (e.key === this.key) {
        this.isMetaKeyPressed = false;
      }
    },
  };
}

function clone(Alpine) {
  Alpine.directive('clone', ($targetEl, {expression}, {effect, evaluate, cleanup}) => {
    if (!isHtmlElement($targetEl)) {
      throw new Error(`Expected HTMLElement but got ${$targetEl}`);
    }
    $targetEl._x_insertClone = (sourceEl) => {
      var _a;
      if (!isHtmlElement(sourceEl)) return;
      if (!isTemplateElement($targetEl)) {
        throw new Error(`x-clone can only be used on a <template> tag`);
      }
      if ($targetEl._x_clonedElement) {
        (_a = $targetEl._x_undoClone) === null || _a === void 0 ? void 0 : _a.call($targetEl);
      }
      let clone = isTemplateElement(sourceEl)
        ? sourceEl.content.cloneNode(true).firstElementChild
        : sourceEl.cloneNode(true);
      if (!clone) return;
      // Add new parent element's scope to cloned element
      Alpine.addScopeToNode(clone, {}, $targetEl);
      Alpine.mutateDom(() => {
        // Insert cloned node after element with x-clone attribute
        $targetEl.after(clone);
        // Re-initialize alpine on cloned node
        Alpine.skipDuringClone(() => Alpine.initTree(clone))();
      });
      $targetEl._x_clonedElement = clone;
      $targetEl._x_undoClone = () => {
        clone.remove();
        Alpine.destroyTree(clone);
        delete $targetEl._x_clonedElement;
      };
    };
    // Evaluate expression to the source element that will be cloned into the target element
    $targetEl._x_insertClone(evaluate(expression));
    cleanup(() => $targetEl._x_undoClone && $targetEl._x_undoClone());
  }).before('bind');
}

function clipboard(Alpine) {
  Alpine.directive('clipboard', ($el, data) => {
    if (data.value == 'target') {
      handleTarget($el, Alpine, data);
    } else if (data.value == 'button') {
      handleButton$1($el, Alpine);
    } else if (data.value == null) {
      handleRoot$6($el, Alpine);
    } else {
      throw new Error(`Unknown directive: x-clipboard:${data.value}`);
    }
  }).before('bind');
  Alpine.magic('clipboard', handleClipboardMagic(Alpine));
}
function handleClipboardMagic(Alpine) {
  return function ($el) {
    const $data = Alpine.$data($el);
    return {
      save(text) {
        navigator.clipboard.writeText(text);
        $data.handleSuccess();
      },
      get state() {
        return $data.state;
      },
      get isClipboardWriteAllowed() {
        return $data.isClipboardWriteAllowed;
      },
    };
  };
}
function handleTarget($el, Alpine, {expression}) {
  const attributes = {};
  const $data = Alpine.$data($el);
  $data.target = $el;
  if (isInputElement($el)) {
    $data.content = $el.value;
  } else if (isHtmlElement($el)) {
    $data.content = expression || $el.textContent || '';
  }
  Alpine.bind($el, attributes);
}
function handleButton$1($el, Alpine) {
  Alpine.bind($el, {
    '@click': 'copyToClipboard',
  });
}
function handleRoot$6($el, Alpine) {
  Alpine.bind($el, {
    ['x-data']() {
      return {
        state: 'initial',
        target: undefined,
        content: '',
        timeoutDuration: 2500,
        isClipboardWriteAllowed: null,
        async init() {
          await isClipboardWriteAllowed().then((allowed) => (this.isClipboardWriteAllowed = allowed));
        },
        async copyToClipboard(event) {
          event.preventDefault();
          if (this.isClipboardWriteAllowed) {
            // This doesn't work inside the Shopify's Customizer <iframe> for policy reasons
            navigator.clipboard.writeText(this.content).then(() => {
              if (this.state === 'success') return;
              this.handleSuccess();
              this.selectText();
            });
          } else {
            console.log('Clipboard access is denied');
            // Simulate success behavior when in the Theme editor
            if (window.Shopify.designMode) {
              if (this.state === 'success') return;
              this.handleSuccess();
              this.selectText();
            } else {
              this.state = 'denied';
              setTimeout(() => {
                if (this.state === 'denied') {
                  this.state = 'initial';
                }
              }, 4000);
            }
          }
        },
        handleSuccess() {
          this.state = 'success';
          setTimeout(() => {
            this.state = 'initial';
          }, this.timeoutDuration);
        },
        selectText() {
          var _a, _b;
          if (isInputElement(this.target)) {
            this.target.select();
          } else if (isHtmlElement(this.target)) {
            // Enable this for non-input tags too (<div>, etc.)
            const range = document.createRange();
            range.selectNode(this.target);
            (_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.removeAllRanges();
            (_b = window.getSelection()) === null || _b === void 0 ? void 0 : _b.addRange(range);
          }
        },
      };
    },
  });
}

function scrollLock(Alpine) {
  Alpine.directive(
    'scroll-lock',
    Alpine.skipDuringClone(($el, {expression}, {effect, evaluateLater, cleanup}) => {
      if (!isHtmlElement($el)) {
        throw new Error(`Expected HTMLElement but got ${$el}`);
      }
      let evaluator = evaluateLater(expression);
      let wasScrollLocked = false;
      function unlockScrolling() {
        document.body.style.removeProperty('overscroll-behavior');
        document.body.style.removeProperty('overflow');
        document.body.style.removeProperty('padding-right');
      }
      function lockScrolling() {
        let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        // Stop desktop browsers from window scroll
        document.body.style.overflow = 'hidden';
        // Stop mobile browsers from body scroll
        document.body.style.overscrollBehavior = 'none';
        if (window.innerWidth > 1024) {
          document.body.style.paddingRight = `${scrollbarWidth}px`;
        }
      }
      effect(() =>
        evaluator((isScrollLocked) => {
          if (wasScrollLocked === isScrollLocked) return;
          if (isScrollLocked && !wasScrollLocked) {
            setTimeout(() => {
              lockScrolling();
            });
          } else if (!isScrollLocked && wasScrollLocked) {
            setTimeout(() => {
              unlockScrolling();
            });
          }
          wasScrollLocked = !!isScrollLocked;
        }),
      );
      cleanup(() => {
        unlockScrolling();
      });
    }),
  );
}

const SEARCH_FIELDS = [
  'resources[type]',
  'resources[limit]',
  'resources[limit_scope]',
  'resources[options][unavailable_products]',
  'resources[options][fields]',
];
async function predictiveSearch$1(query, sectionId, formData, options) {
  var _a, _b;
  if (
    !((_b = (_a = window.theme) === null || _a === void 0 ? void 0 : _a.routes) === null || _b === void 0
      ? void 0
      : _b.predictiveSearch)
  ) {
    throw new Error('window.theme.routes.predictiveSearch is not defined');
  }
  const queryParams = new URLSearchParams();
  queryParams.set('q', query);
  queryParams.set('section_id', sectionId);
  [...formData.entries()]
    .filter(([key]) => key.includes('resources'))
    .forEach(([key, value]) => {
      if (SEARCH_FIELDS.includes(key)) {
        queryParams.set(key, value.toString());
      }
    });
  return fetch(`${window.theme.routes.predictiveSearch}?${queryParams.toString()}`, options);
}

const CANCEL_REQUEST_REASON = 'Cancel request';
const PREDICTIVE_SEARCH_CONTEXT_KEY = Symbol('PREDICTIVE_SEARCH_CONTEXT_KEY');
/**
 * Plugin to add integration with Shopify's predictive search API (GET /{locale}/search/suggest).
 *
 * Usage:
 *
 * - x-predictive-search='your-result-section' - Applied to the root element of the predictive search, initializing the predictive search functionality and adding a data context for child directives. Pass the id of the search results section as the expression.
 * - x-predictive-search:form - Specifies the form element that contains the search input. The data from this form element will be sent to the predictive search API using FormData
 * - x-predictive-search:input - Specifies the input element that will be used to search. When input value changes, the predictive search will be triggered.
 * - x-predictive-search:results - Specifies the element that will contain the search results. The inner HTML of this element will be replaced with the search results
 * - x-predictive-search:options - Specifies the element that will contain the search options
 * - x-predictive-search:option - Specifies the element that will be used to render a search option
 *
 * @example
 *
 * ## Your search form:
 *
 * ```html
 * <div x-data x-predictive-search="some-search-results-section">
 *   <form action="{{ routes.search_url }}" x-predictive-search:form>
 *     <input type="hidden" name="resources[type]" value="product" />
 *     <input type="hidden" name="resources[options][unavailable_products]" value="hide" />
 *     <input x-predictive-search:input type="search" placeholder="Search" />
 *     <button type="submit">Search</button>
 *   </form>
 *   <div x-show="$predictiveSearch.state == 'success'" x-predictive-search:results>
 *   </div>
 * </div>
 * ```
 *
 * ## Your search results section (some-search-results-section):
 *
 * <ul x-predictive-search:options>
 *   {% assign product_results = predictive_search.resources.products %}
 *   {% for result in product_results %}
 *     <li role="presentation">
 *       <a x-predictive-search:option href="{{ result.url }}">{{ result.title }}</a>
 *     </li>
 *   {% endfor %}
 * </ul>
 *
 */
// TODO refactor this to use x-async-form
function predictiveSearch(Alpine) {
  Alpine.directive('predictive-search', ($el, data, utilities) => {
    if (data.value === 'form') {
      handleForm$2($el, Alpine);
    } else if (data.value === 'input') {
      handleInput($el, Alpine);
    } else if (data.value === 'results') {
      handleResults($el, Alpine, utilities);
    } else if (data.value === 'options') {
      handleOptions($el, Alpine);
    } else if (data.value === 'option') {
      handleOption($el, Alpine);
    } else if (data.value === null) {
      handleRoot$5($el, Alpine, data, utilities);
    } else {
      throw new Error(`Unknown directive: x-predictive-search:${data.value}`);
    }
  }).before('bind');
  Alpine.magic('predictiveSearch', ($el) => {
    const context = Alpine.$data($el)[PREDICTIVE_SEARCH_CONTEXT_KEY];
    if (!context) {
      throw new Error('$predictiveSearch needs to be used on or inside an element with x-predictive-search');
    }
    return {
      get state() {
        return context.state;
      },
      get error() {
        return context.error;
      },
      set query(query) {
        context.query = query;
      },
      get query() {
        return context.query;
      },
      get resultHtml() {
        return context.resultHtml;
      },
      search: context.search.bind(context),
      reset: context.reset.bind(context),
    };
  });
}
function handleForm$2($el, Alpine) {
  const context = Alpine.$data($el)[PREDICTIVE_SEARCH_CONTEXT_KEY];
  Alpine.bind($el, {
    'x-init'() {
      context.formEl = $el;
    },
    '@submit'() {
      // Cancel any pending requests when form is submitted since they wont be shown
      context.abort();
    },
  });
}
function handleInput($el, Alpine) {
  const context = Alpine.$data($el)[PREDICTIVE_SEARCH_CONTEXT_KEY];
  Alpine.bind($el, {
    ':id': '$el.id || $id("predictive-search-input")',
    'x-init'() {
      context.inputEl = $el;
    },
    ':aria-controls'() {
      var _a;
      return (_a = context.resultsEl) === null || _a === void 0 ? void 0 : _a.id;
    },
    ':aria-owns'() {
      var _a;
      return (_a = context.optionsEl) === null || _a === void 0 ? void 0 : _a.id;
    },
    'aria-autocomplete': 'list',
    'x-model.fill': '$predictiveSearch.query',
    '@input.debounce.350ms': '$predictiveSearch.search()',
    autocomplete: 'off',
    role: 'combobox',
    '@keydown.down.prevent.stop': '$rovingTab.focusFirst()',
    '@keydown.up.prevent.stop': '$rovingTab.focusLast()',
  });
}
function handleResults($el, Alpine, {effect, cleanup}) {
  const context = Alpine.$data($el)[PREDICTIVE_SEARCH_CONTEXT_KEY];
  let prevHtml = '';
  effect(() => {
    // Unforunatley we cannot use x-html in this plugin as you might expect. x-html does not clean up previous trees which causes errors
    // when we update the HTML and then our fetch promise runs but the old Alpine reactive bindings are still in memory
    // TODO maybe extract this to new directive like x-html-safe or something
    Alpine.mutateDom(() => {
      if (prevHtml !== '') {
        Alpine.destroyTree($el);
      }
      $el.innerHTML = prevHtml = context.resultHtml;
      $el._x_ignoreSelf = true;
      Alpine.initTree($el);
      delete $el._x_ignoreSelf;
    });
  });
  cleanup(() => {
    prevHtml = '';
  });
  Alpine.bind($el, {
    ':id': '$el.id ||$id("predictive-search-results")',
    'x-init'() {
      context.resultsEl = $el;
    },
  });
}
function handleOptions($el, Alpine) {
  const context = Alpine.$data($el)[PREDICTIVE_SEARCH_CONTEXT_KEY];
  Alpine.bind($el, {
    ':id': '$el.id ||$id("predictive-search-options")',
    'x-roving-tab:list': '',
    role: 'listbox',
    'x-init'() {
      context.optionsEl = $el;
    },
  });
}
function handleOption($el, Alpine) {
  Alpine.bind($el, {
    role: 'option',
  });
}
function handleRoot$5($el, Alpine, data, {cleanup}) {
  const resultSectionId = data.expression;
  if (!resultSectionId) {
    throw new Error('predictive search results section id must be passed to x-predictive-search');
  }
  const context = Alpine.reactive({
    formEl: null,
    inputEl: null,
    resultsEl: null,
    optionsEl: null,
    resultSectionId,
    query: '',
    resultHtml: null,
    state: 'idle',
    error: null,
    abortController: null,
    abort() {
      var _a;
      // Abort any existing requests
      (_a = this.abortController) === null || _a === void 0 ? void 0 : _a.abort(CANCEL_REQUEST_REASON);
    },
    reset() {
      this.query = '';
      this.state = 'idle';
      this.resultHtml = null;
      this.abort();
    },
    async search() {
      if (this.query.trim().length == 0) {
        return null;
      }
      if (!this.formEl) {
        throw new Error('Could find a form element. x-predictive-search:form directive must be used on a form element');
      }
      this.state = 'loading';
      // If there's already an abort controller in use, abort it to cancel any pending requests
      if (this.abortController != null) {
        this.abort();
        this.abortController = null;
      }
      this.abortController = new AbortController();
      try {
        const response = await predictiveSearch$1(this.query, this.resultSectionId, new FormData(this.formEl), {
          signal: this.abortController.signal,
        });
        if (response.status === 200) {
          const resultHtml = await response.text();
          this.resultHtml = resultHtml;
          // Wait results have (presumably) been rendered before setting state to success
          // so that you can do stuff like x-collapse without any jankiness
          Alpine.nextTick(() => {
            this.state = 'success';
          });
          return resultHtml;
        } else {
          const resultText = await response.text();
          this.handleRequestError(new Error(`Request failed with status ${response.status}: ${resultText}`));
          return null;
        }
      } catch (e) {
        if (e == CANCEL_REQUEST_REASON);
        else {
          this.handleRequestError(e);
        }
        return null;
      }
    },
    handleRequestError(e) {
      this.state = 'error';
      this.error = prettyPrintError(e);
      throw e;
    },
  });
  Alpine.effect(() => {
    // Wipe search results when query is cleared
    if (context.query == '') {
      context.reset();
    }
  });
  Alpine.addScopeToNode($el, {
    [PREDICTIVE_SEARCH_CONTEXT_KEY]: context,
  });
  Alpine.bind($el, {
    'x-id': '["predictive-search-results", "predictive-search-options", "predictive-search-input"]',
    'x-roving-tab.vertical.nowrap': '',
  });
  cleanup(() => {
    if (context.abortController != null) {
      context.abortController.abort();
    }
  });
}

/**
 * Plugin which provides various directives and magics for working with responsive design.
 *
 * ## `x-screen:*` directives
 *
 * This directive
 *
 * @example
 *
 * Setup the plugin by passing your screen sizes to the plugin fn. You can pass both pixel values and CSS variables
 *
 * ```js
 * import {screen} from '@groupthought/method-ui/alpine';
 *
 * Alpine.plugin(screen({
 *   sm: '(max-width: 1023px)',
 *   md: '(min-width: 1024px) and (max-width: 1156px)',
 *   // ...
 * }))
 * ```
 *
 * Use the directive to conditionally run code based on the current screen size
 *
 * ```html
 * <div
 *  x-screen:sm="console.log('screen sizes matches small')"
 *  x-screen:md="console.log('screen size matches medium')"
 * >
 * </div>
 * ```
 */
var media = (queries) => {
  return (Alpine) => {
    Alpine.store('media', {
      queries: queries,
      matches: {},
    });
    let abortController = null;
    Alpine.effect(() => {
      if (abortController) {
        abortController.abort();
      }
      abortController = new AbortController();
      Alpine.store('media').matches = {};
      Object.entries(Alpine.store('media').queries).forEach(([key, value]) => {
        const mediaQuery = window.matchMedia(value);
        // Set the initial value for the media query
        Alpine.store('media').matches[key] = mediaQuery.matches;
        // Add event listener to update the store when the media query changes
        mediaQuery.addEventListener(
          'change',
          (e) => {
            Alpine.store('media').matches[key] = e.matches;
          },
          {
            signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
          },
        );
      });
    });
    Alpine.directive('screen', ($el, {value, expression}, {effect, evaluateLater}) => {
      if (!isHtmlElement($el)) {
        throw new Error(`Expected HTMLElement but got ${$el}`);
      }
      const evaluateExpression = evaluateLater(expression);
      if (value !== null) {
        if (!(value in Alpine.store('media').queries)) {
          throw new Error(`Unknown screen size: ${value}`);
        }
        Alpine.nextTick(() => {
          effect(() => {
            const match = Alpine.store('media').matches[value];
            if (match) {
              evaluateExpression(() => {});
            }
          });
        });
      } else {
        Alpine.nextTick(() => {
          effect(() => {
            const matches = Alpine.store('media').matches;
            if (matches !== null) {
              evaluateExpression(() => {}, {
                params: [matches],
                scope: {
                  $matches: matches,
                },
              });
            }
          });
        });
      }
    });
    Alpine.magic('media', () => {
      return Alpine.store('media');
    });
  };
};

function record(Alpine) {
  Alpine.directive('record', ($el, data) => {
    handleRoot$4($el, Alpine, data);
  }).before('bind');
  Alpine.magic('recordings', handleRecordMagic());
}
function handleRecordMagic(Alpine) {
  return function ($el) {
    // const $data = Alpine.$data($el) as RecordComponent;
    return {
      get recentlyViewed() {
        // return $data.__recentlyViewed;
        return JSON.parse(localStorage.getItem('recentlyViewed'));
      },
      get comparable() {
        // return $data.__comparable;
        return JSON.parse(localStorage.getItem('comparable'));
      },
    };
  };
}
function handleRoot$4($el, Alpine, data) {
  Alpine.bind($el, {
    ['x-data']: function () {
      return {
        __recentlyViewed: Alpine.$persist([]).as('recentlyViewed'),
        __comparable: Alpine.$persist([]).as('comparable'),
        __key: data.value,
        __value: data.expression,
        init() {
          let isNewValue = false;
          switch (this.__key) {
            case 'recentlyviewed':
              isNewValue = !this.__recentlyViewed.some((value) => value == this.__value);
              isNewValue && this.__recentlyViewed.push(this.__value);
              break;
            case 'comparable':
              isNewValue = !this.__comparable.some((value) => value == this.__value);
              isNewValue && this.__comparable.push(this.__value);
              break;
          }
        },
      };
    },
  });
}

/**
 * Enables the creation of a countdown timer component.
 *
 * - x-countdown - The root element of the component, initializing the countdown functionality and adding a data context for child directives. Requires the expiration date in ISO 8601 format to be passed as value
 * - x-countdown:days - The element containing the remaining 'days'
 * - x-countdown:hours - The element containing the remaining 'hours'
 * - x-countdown:minutes - The element containing the remaining 'minutes'
 * - x-countdown:seconds - The element containing the remaining 'seconds'
 *
 * @example
 *
  <time x-countdown="2028-12-31T11:59:00.000-0500">
    <span x-countdown:days></span>
    <span x-countdown:hours></span>
    <span x-countdown:minutes></span>
    <span x-countdown:seconds></span>
  </time>
 */
function countdown(Alpine) {
  Alpine.directive('countdown', ($el, data) => {
    if (data.value == 'days') {
      handleDays($el, Alpine);
    } else if (data.value == 'hours') {
      handleHours($el, Alpine);
    } else if (data.value == 'minutes') {
      handleMinutes($el, Alpine);
    } else if (data.value == 'seconds') {
      handleSeconds($el, Alpine);
    } else if (data.value == null) {
      handleRoot$3($el, Alpine, data);
    } else {
      throw new Error(`Unknown directive: x-countdown:${data.value}`);
    }
  }).before('bind');
  Alpine.magic('countdown', handleCountdownMagic(Alpine));
}
function handleCountdownMagic(Alpine) {
  return function ($el) {
    const $data = Alpine.$data($el);
    return {
      days: $data.__countdown_days,
      hours: $data.__countdown_hours,
      minutes: $data.__countdown_minutes,
      seconds: $data.__countdown_seconds,
      endDate(date) {
        $data.__countdown_endDate = date;
      },
      get isExpired() {
        return $data.__countdown_isExpired;
      },
    };
  };
}
function handleDays($el, Alpine) {
  Alpine.bind($el, {
    'x-text': '__countdown_days',
  });
}
function handleHours($el, Alpine) {
  Alpine.bind($el, {
    'x-text': '__countdown_hours',
  });
}
function handleMinutes($el, Alpine) {
  Alpine.bind($el, {
    'x-text': '__countdown_minutes',
  });
}
function handleSeconds($el, Alpine) {
  Alpine.bind($el, {
    'x-text': '__countdown_seconds',
  });
}
function handleRoot$3($el, Alpine, data) {
  Alpine.bind($el, {
    ['x-data']() {
      return countdown$1(data.expression);
    },
  });
}
function countdown$1(endDate) {
  return {
    __countdown_endDate: endDate || '',
    __countdown_msPerDay: 1000 * 60 * 60 * 24,
    __countdown_msPerHour: (1000 * 60 * 60 * 24) / 24, // msPerDay / 24
    __countdown_msPerMinute: (1000 * 60 * 60 * 24) / 24 / 60, // msPerHour / 60
    __countdown_msPerSecond: (1000 * 60 * 60 * 24) / 24 / 60 / 60, // msPerMinute / 60,
    __countdown_intervalTimer: undefined,
    __countdown_remainingTime: 0,
    __countdown_days: '0',
    __countdown_hours: '0',
    __countdown_minutes: '0',
    __countdown_seconds: '0',
    get __countdown_endDateParsed() {
      return Date.parse(this.__countdown_endDate);
    },
    get __countdown_isExpired() {
      return this.__countdown_remainingTime <= 0;
    },
    __countdown_formatDigits(number) {
      let numberAsString = number.toString();
      const numberAsNumber = number;
      if (numberAsNumber < 10) numberAsString = '0' + numberAsNumber;
      return numberAsString;
    },
    __countdown_update() {
      this.__countdown_remainingTime = this.__countdown_endDateParsed - Date.now();
      let days = 0;
      let hours = 0;
      let minutes = 0;
      let seconds = 0;
      let tempTime = this.__countdown_remainingTime;
      if (tempTime > 0) {
        days = parseInt((tempTime / this.__countdown_msPerDay).toString(), 10);
        tempTime -= days * this.__countdown_msPerDay;
        hours = parseInt((tempTime / this.__countdown_msPerHour).toString(), 10);
        tempTime -= hours * this.__countdown_msPerHour;
        minutes = parseInt((tempTime / this.__countdown_msPerMinute).toString(), 10);
        tempTime -= minutes * this.__countdown_msPerMinute;
        seconds = parseInt((tempTime / this.__countdown_msPerSecond).toString(), 10);
      }
      this.__countdown_days = this.__countdown_formatDigits(days);
      this.__countdown_hours = this.__countdown_formatDigits(hours);
      this.__countdown_minutes = this.__countdown_formatDigits(minutes);
      this.__countdown_seconds = this.__countdown_formatDigits(seconds);
      if (this.__countdown_isExpired) {
        clearInterval(this.__countdown_intervalTimer);
      }
    },
    init() {
      this.__countdown_update();
      // Update the countdown every second
      this.__countdown_intervalTimer = setInterval(() => {
        this.__countdown_update();
      }, 1000);
    },
  };
}

const KEYBOARD_ACTIVE_CONTEXT_KEY = Symbol('KEYBOARD_ACTIVE_CONTEXT_KEY');
/**
 * Add 'keyboard-active' class to the body when user is navigating with the keyboard
 */
function keyboardActive(Alpine) {
  let isTabKeyDown = false;
  const context = Alpine.reactive({
    isKeyboardActive: false,
  });
  Alpine.addScopeToNode(document.body, {
    [KEYBOARD_ACTIVE_CONTEXT_KEY]: context,
  });
  Alpine.bind(document.body, {
    '@keydown.window.tab'() {
      isTabKeyDown = true;
    },
    '@keyup.window'() {
      isTabKeyDown = false;
    },
    '@focusin.window'() {
      if (isTabKeyDown) {
        context.isKeyboardActive = true;
      }
    },
    '@mousedown'() {
      context.isKeyboardActive = false;
    },
  });
  Alpine.magic('isKeyboardActive', ($el) => {
    return Alpine.$data($el)[KEYBOARD_ACTIVE_CONTEXT_KEY].isKeyboardActive;
  });
  Alpine.magic('hasKeyboardFocus', ($el) => {
    return Alpine.$data($el)[KEYBOARD_ACTIVE_CONTEXT_KEY].isKeyboardActive && document.activeElement === $el;
  });
}

/**
 * Formats a number as currency based on locale and currency settings.
 * Supports displaying currency symbol, code, or name. Allows optional rounding and customization of display.
 * Utilizes the Intl.NumberFormat API to manage currency formatting complexities, providing better consistency
 * across different markets, locales, and currencies, in contrast to Shopify's Liquid limitations.
 *
 * Expects the following code in theme.liquid:
 *  window.theme.currency: {
 *    currencyCode: '{{ cart.currency.iso_code }}',
 *    locale:  '{{ request.locale.iso_code }}'
 *  };
 *  window.theme.translations: {
 *    other: {
 *      free: {{ 'other.free' | t | json }},
 *    }
 *  };
 *
 *
 * Using money_with_trailing_zeros with CurrencyFormat={rounded: true | false | undefined}
 * - true matches `money | rounded`
 * - undefined matches `money_without_trailing_zeros`
 * - false matches `money`
 *
 * References:
 * - ISO 4217 currency codes via Unicode CLDR for currency translation.
 * - Uses browser’s Intl.NumberFormat for better handling across locales, removing Liquid inconsistencies.
 */
function formatCurrency(amount, format = {}) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
  // Set up defaults
  let defaultCurrency = 'USD'; // Fallback if nothing is available
  let defaultLocale = 'en-US'; // Fallback if locale isn't provided
  let defaultFreeTranslation;
  // Retrieve defaults from theme/Shopify if present
  if (typeof window !== 'undefined') {
    defaultCurrency =
      ((_b = (_a = window.theme) === null || _a === void 0 ? void 0 : _a.currency) === null || _b === void 0
        ? void 0
        : _b.currencyCode) ||
      ((_d = (_c = window.Shopify) === null || _c === void 0 ? void 0 : _c.currency) === null || _d === void 0
        ? void 0
        : _d.active) ||
      defaultCurrency;
    defaultLocale =
      ((_f = (_e = window.theme) === null || _e === void 0 ? void 0 : _e.currency) === null || _f === void 0
        ? void 0
        : _f.locale) ||
      ((_g = window.Shopify) === null || _g === void 0 ? void 0 : _g.locale) ||
      defaultLocale;
    defaultFreeTranslation =
      (_k =
        (_j = (_h = window.theme) === null || _h === void 0 ? void 0 : _h.translations) === null || _j === void 0
          ? void 0
          : _j.other) === null || _k === void 0
        ? void 0
        : _k.free;
  }
  // Destructure format options, applying defaults
  const {form = 'short', rounded, currency = defaultCurrency, locale = defaultLocale, legacyFormat} = format;
  // Handle null, undefined, or NaN amount
  if (amount == null || isNaN(amount)) {
    return 'x.xx'; // Fallback to generic price with no language context
  }
  // Handle 'Free' case or zero
  if (amount === 0 && form === 'short' && rounded === true && defaultFreeTranslation) {
    return defaultFreeTranslation;
  }
  // Liquid returns cents for all currencies including YEN
  const amountInDollars = amount / 100;
  // Use legacy formatting if specified
  let amountWithSymbol;
  if (legacyFormat) {
    amountWithSymbol = formatCurrencyLegacy(amountInDollars, {
      currency,
      legacyFormat,
      rounded: format.rounded,
    });
  } else {
    amountWithSymbol = formatCurrencyNew(amountInDollars, {currency, locale, rounded: format.rounded});
  }
  // Append currency code if explicit form is specified
  const codeString = form === 'explicit' ? ` ${currency}` : '';
  return `${amountWithSymbol}${codeString}`;
}
function formatCurrencyNew(amount, format) {
  // Configure Intl.NumberFormat options
  const options = {
    style: 'currency',
    currency: format.currency,
    currencyDisplay: 'symbol', // Default to symbol for short form
  };
  // Adjust fraction digits based on the amount and rounding option
  if (format.rounded) {
    options.maximumFractionDigits = 0;
  }
  // Use Intl.NumberFormat to format the currency
  let price = new Intl.NumberFormat(format.locale, options).format(amount);
  // Remove decimals if they are zeros and rounding is not specified
  if (typeof format.rounded === 'undefined') {
    // ([.,]00) – matches “.00” or “,00”
    // (?=\D*$) – ensures that only non-digits follow the decimals”
    price = price.replace(/([.,]00)(?=\D*$)/g, '');
  }
  return price;
}
/**
 * Deprecated liquid Currency Helpers
 * -----------------------------------------------------------------------------
 * Based on @shopify/theme-currency but updated with new liquid currency options.
 * This function should be phased out in favor of the new `formatCurrency`.
 */
function formatCurrencyLegacy(amount, format) {
  var _a;
  // Destructure format options, applying defaults
  const legacyFormat = (_a = format.legacyFormat) !== null && _a !== void 0 ? _a : '${{amount}}';
  let precision = 2;
  if (format.rounded) precision = 0;
  // Helper to format numbers with thousands and decimal separators
  const formatWithDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
    if (isNaN(number) || number == null) {
      return '0';
    }
    number = parseFloat(number.toFixed(precision));
    const parts = number.toFixed(precision).split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`); // regex adds a ',' for thousands(every 3 digits - 1,234,567)
    const centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  };
  // Regex for extracting liquid format placeholder - {{ something }}
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const match = legacyFormat.match(placeholderRegex);
  let formattedValue = '';
  if (match) {
    // Handle different liquid-like formats
    switch (match[1]) {
      case 'amount':
        formattedValue = formatWithDelimiters(amount, precision);
        break;
      case 'amount_no_decimals':
        formattedValue = formatWithDelimiters(amount, precision);
        break;
      case 'amount_with_comma_separator':
        formattedValue = formatWithDelimiters(amount, precision, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formattedValue = formatWithDelimiters(amount, precision, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        formattedValue = formatWithDelimiters(amount, precision, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        formattedValue = formatWithDelimiters(amount, precision, ' ');
        break;
      case 'amount_with_space_separator':
        formattedValue = formatWithDelimiters(amount, precision, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        formattedValue = formatWithDelimiters(amount, precision, ' ', '.');
        break;
      default:
        throw new Error(`Unknown format type: ${match[1]}`);
    }
    // Replace the placeholder in format string with the formatted value
    formattedValue = legacyFormat.replace(placeholderRegex, formattedValue);
    // Remove decimals if they are zeros and rounding is not specified
    if (typeof format.rounded === 'undefined' && legacyFormat.includes('no_decimals')) {
      // ([.,]00) – matches “.00” or “,00”
      // (?=\D*$) – ensures that only non-digits follow the decimals”
      formattedValue = formattedValue.replace(/([.,]00)(?=\D*$)/g, '');
    }
  }
  // Append currency if provided
  return formattedValue;
}
/**
 * Calculates currency for rate
 * -----------------------------------------------------------------------------
 */
function convertCurrency(amount, rate) {
  var _a, _b;
  const currencyRate =
    rate ||
    ((_b = (_a = window.Shopify) === null || _a === void 0 ? void 0 : _a.currency) === null || _b === void 0
      ? void 0
      : _b.rate) ||
    1;
  // Handle null, undefined, or NaN amount
  if (amount == null || isNaN(amount)) {
    amount = 0;
  }
  return amount * currencyRate;
}

// See utils/currency.ts for details on the complexity of currency formatting
function currency(Alpine) {
  Alpine.magic('formatCurrency', () => {
    return formatCurrency;
  });
  Alpine.magic('convertCurrency', () => {
    return convertCurrency;
  });
}

/*!
 * PhotoSwipe Lightbox 5.4.4 - https://photoswipe.com
 * (c) 2024 Dmytro Semenov
 */
/** @typedef {import('../photoswipe.js').Point} Point */

/**
 * @template {keyof HTMLElementTagNameMap} T
 * @param {string} className
 * @param {T} tagName
 * @param {Node} [appendToEl]
 * @returns {HTMLElementTagNameMap[T]}
 */
function createElement(className, tagName, appendToEl) {
  const el = document.createElement(tagName);

  if (className) {
    el.className = className;
  }

  if (appendToEl) {
    appendToEl.appendChild(el);
  }

  return el;
}
/**
 * Get transform string
 *
 * @param {number} x
 * @param {number} [y]
 * @param {number} [scale]
 * @returns {string}
 */

function toTransformString(x, y, scale) {
  let propValue = `translate3d(${x}px,${0}px,0)`;

  if (scale !== undefined) {
    propValue += ` scale3d(${scale},${scale},1)`;
  }

  return propValue;
}
/**
 * Apply width and height CSS properties to element
 *
 * @param {HTMLElement} el
 * @param {string | number} w
 * @param {string | number} h
 */

function setWidthHeight(el, w, h) {
  el.style.width = typeof w === 'number' ? `${w}px` : w;
  el.style.height = typeof h === 'number' ? `${h}px` : h;
}
/** @typedef {LOAD_STATE[keyof LOAD_STATE]} LoadState */

/** @type {{ IDLE: 'idle'; LOADING: 'loading'; LOADED: 'loaded'; ERROR: 'error' }} */

const LOAD_STATE = {
  IDLE: 'idle',
  LOADING: 'loading',
  LOADED: 'loaded',
  ERROR: 'error',
};
/**
 * Check if click or keydown event was dispatched
 * with a special key or via mouse wheel.
 *
 * @param {MouseEvent | KeyboardEvent} e
 * @returns {boolean}
 */

function specialKeyUsed(e) {
  return ('button' in e && e.button === 1) || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey;
}
/**
 * Parse `gallery` or `children` options.
 *
 * @param {import('../photoswipe.js').ElementProvider} [option]
 * @param {string} [legacySelector]
 * @param {HTMLElement | Document} [parent]
 * @returns HTMLElement[]
 */

function getElementsFromOption(option, legacySelector, parent = document) {
  /** @type {HTMLElement[]} */
  let elements = [];

  if (option instanceof Element) {
    elements = [option];
  } else if (option instanceof NodeList || Array.isArray(option)) {
    elements = Array.from(option);
  } else {
    const selector = typeof option === 'string' ? option : legacySelector;

    if (selector) {
      elements = Array.from(parent.querySelectorAll(selector));
    }
  }

  return elements;
}
/**
 * Check if variable is PhotoSwipe class
 *
 * @param {any} fn
 * @returns {boolean}
 */

function isPswpClass(fn) {
  return typeof fn === 'function' && fn.prototype && fn.prototype.goTo;
}
/**
 * Check if browser is Safari
 *
 * @returns {boolean}
 */

function isSafari() {
  return !!(navigator.vendor && navigator.vendor.match(/apple/i));
}

/** @typedef {import('../lightbox/lightbox.js').default} PhotoSwipeLightbox */

/** @typedef {import('../photoswipe.js').default} PhotoSwipe */

/** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */

/** @typedef {import('../photoswipe.js').DataSource} DataSource */

/** @typedef {import('../ui/ui-element.js').UIElementData} UIElementData */

/** @typedef {import('../slide/content.js').default} ContentDefault */

/** @typedef {import('../slide/slide.js').default} Slide */

/** @typedef {import('../slide/slide.js').SlideData} SlideData */

/** @typedef {import('../slide/zoom-level.js').default} ZoomLevel */

/** @typedef {import('../slide/get-thumb-bounds.js').Bounds} Bounds */

/**
 * Allow adding an arbitrary props to the Content
 * https://photoswipe.com/custom-content/#using-webp-image-format
 * @typedef {ContentDefault & Record<string, any>} Content
 */

/** @typedef {{ x?: number; y?: number }} Point */

/**
 * @typedef {Object} PhotoSwipeEventsMap https://photoswipe.com/events/
 *
 *
 * https://photoswipe.com/adding-ui-elements/
 *
 * @prop {undefined} uiRegister
 * @prop {{ data: UIElementData }} uiElementCreate
 *
 *
 * https://photoswipe.com/events/#initialization-events
 *
 * @prop {undefined} beforeOpen
 * @prop {undefined} firstUpdate
 * @prop {undefined} initialLayout
 * @prop {undefined} change
 * @prop {undefined} afterInit
 * @prop {undefined} bindEvents
 *
 *
 * https://photoswipe.com/events/#opening-or-closing-transition-events
 *
 * @prop {undefined} openingAnimationStart
 * @prop {undefined} openingAnimationEnd
 * @prop {undefined} closingAnimationStart
 * @prop {undefined} closingAnimationEnd
 *
 *
 * https://photoswipe.com/events/#closing-events
 *
 * @prop {undefined} close
 * @prop {undefined} destroy
 *
 *
 * https://photoswipe.com/events/#pointer-and-gesture-events
 *
 * @prop {{ originalEvent: PointerEvent }} pointerDown
 * @prop {{ originalEvent: PointerEvent }} pointerMove
 * @prop {{ originalEvent: PointerEvent }} pointerUp
 * @prop {{ bgOpacity: number }} pinchClose can be default prevented
 * @prop {{ panY: number }} verticalDrag can be default prevented
 *
 *
 * https://photoswipe.com/events/#slide-content-events
 *
 * @prop {{ content: Content }} contentInit
 * @prop {{ content: Content; isLazy: boolean }} contentLoad can be default prevented
 * @prop {{ content: Content; isLazy: boolean }} contentLoadImage can be default prevented
 * @prop {{ content: Content; slide: Slide; isError?: boolean }} loadComplete
 * @prop {{ content: Content; slide: Slide }} loadError
 * @prop {{ content: Content; width: number; height: number }} contentResize can be default prevented
 * @prop {{ content: Content; width: number; height: number; slide: Slide }} imageSizeChange
 * @prop {{ content: Content }} contentLazyLoad can be default prevented
 * @prop {{ content: Content }} contentAppend can be default prevented
 * @prop {{ content: Content }} contentActivate can be default prevented
 * @prop {{ content: Content }} contentDeactivate can be default prevented
 * @prop {{ content: Content }} contentRemove can be default prevented
 * @prop {{ content: Content }} contentDestroy can be default prevented
 *
 *
 * undocumented
 *
 * @prop {{ point: Point; originalEvent: PointerEvent }} imageClickAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} bgClickAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} tapAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} doubleTapAction can be default prevented
 *
 * @prop {{ originalEvent: KeyboardEvent }} keydown can be default prevented
 * @prop {{ x: number; dragging: boolean }} moveMainScroll
 * @prop {{ slide: Slide }} firstZoomPan
 * @prop {{ slide: Slide | undefined, data: SlideData, index: number }} gettingData
 * @prop {undefined} beforeResize
 * @prop {undefined} resize
 * @prop {undefined} viewportSize
 * @prop {undefined} updateScrollOffset
 * @prop {{ slide: Slide }} slideInit
 * @prop {{ slide: Slide }} afterSetContent
 * @prop {{ slide: Slide }} slideLoad
 * @prop {{ slide: Slide }} appendHeavy can be default prevented
 * @prop {{ slide: Slide }} appendHeavyContent
 * @prop {{ slide: Slide }} slideActivate
 * @prop {{ slide: Slide }} slideDeactivate
 * @prop {{ slide: Slide }} slideDestroy
 * @prop {{ destZoomLevel: number, centerPoint: Point | undefined, transitionDuration: number | false | undefined }} beforeZoomTo
 * @prop {{ slide: Slide }} zoomPanUpdate
 * @prop {{ slide: Slide }} initialZoomPan
 * @prop {{ slide: Slide }} calcSlideSize
 * @prop {undefined} resolutionChanged
 * @prop {{ originalEvent: WheelEvent }} wheel can be default prevented
 * @prop {{ content: Content }} contentAppendImage can be default prevented
 * @prop {{ index: number; itemData: SlideData }} lazyLoadSlide can be default prevented
 * @prop {undefined} lazyLoad
 * @prop {{ slide: Slide }} calcBounds
 * @prop {{ zoomLevels: ZoomLevel, slideData: SlideData }} zoomLevelsUpdate
 *
 *
 * legacy
 *
 * @prop {undefined} init
 * @prop {undefined} initialZoomIn
 * @prop {undefined} initialZoomOut
 * @prop {undefined} initialZoomInEnd
 * @prop {undefined} initialZoomOutEnd
 * @prop {{ dataSource: DataSource | undefined, numItems: number }} numItems
 * @prop {{ itemData: SlideData; index: number }} itemData
 * @prop {{ index: number, itemData: SlideData, instance: PhotoSwipe }} thumbBounds
 */

/**
 * @typedef {Object} PhotoSwipeFiltersMap https://photoswipe.com/filters/
 *
 * @prop {(numItems: number, dataSource: DataSource | undefined) => number} numItems
 * Modify the total amount of slides. Example on Data sources page.
 * https://photoswipe.com/filters/#numitems
 *
 * @prop {(itemData: SlideData, index: number) => SlideData} itemData
 * Modify slide item data. Example on Data sources page.
 * https://photoswipe.com/filters/#itemdata
 *
 * @prop {(itemData: SlideData, element: HTMLElement, linkEl: HTMLAnchorElement) => SlideData} domItemData
 * Modify item data when it's parsed from DOM element. Example on Data sources page.
 * https://photoswipe.com/filters/#domitemdata
 *
 * @prop {(clickedIndex: number, e: MouseEvent, instance: PhotoSwipeLightbox) => number} clickedIndex
 * Modify clicked gallery item index.
 * https://photoswipe.com/filters/#clickedindex
 *
 * @prop {(placeholderSrc: string | false, content: Content) => string | false} placeholderSrc
 * Modify placeholder image source.
 * https://photoswipe.com/filters/#placeholdersrc
 *
 * @prop {(isContentLoading: boolean, content: Content) => boolean} isContentLoading
 * Modify if the content is currently loading.
 * https://photoswipe.com/filters/#iscontentloading
 *
 * @prop {(isContentZoomable: boolean, content: Content) => boolean} isContentZoomable
 * Modify if the content can be zoomed.
 * https://photoswipe.com/filters/#iscontentzoomable
 *
 * @prop {(useContentPlaceholder: boolean, content: Content) => boolean} useContentPlaceholder
 * Modify if the placeholder should be used for the content.
 * https://photoswipe.com/filters/#usecontentplaceholder
 *
 * @prop {(isKeepingPlaceholder: boolean, content: Content) => boolean} isKeepingPlaceholder
 * Modify if the placeholder should be kept after the content is loaded.
 * https://photoswipe.com/filters/#iskeepingplaceholder
 *
 *
 * @prop {(contentErrorElement: HTMLElement, content: Content) => HTMLElement} contentErrorElement
 * Modify an element when the content has error state (for example, if image cannot be loaded).
 * https://photoswipe.com/filters/#contenterrorelement
 *
 * @prop {(element: HTMLElement, data: UIElementData) => HTMLElement} uiElement
 * Modify a UI element that's being created.
 * https://photoswipe.com/filters/#uielement
 *
 * @prop {(thumbnail: HTMLElement | null | undefined, itemData: SlideData, index: number) => HTMLElement} thumbEl
 * Modify the thumbnail element from which opening zoom animation starts or ends.
 * https://photoswipe.com/filters/#thumbel
 *
 * @prop {(thumbBounds: Bounds | undefined, itemData: SlideData, index: number) => Bounds} thumbBounds
 * Modify the thumbnail bounds from which opening zoom animation starts or ends.
 * https://photoswipe.com/filters/#thumbbounds
 *
 * @prop {(srcsetSizesWidth: number, content: Content) => number} srcsetSizesWidth
 *
 * @prop {(preventPointerEvent: boolean, event: PointerEvent, pointerType: string) => boolean} preventPointerEvent
 *
 */

/**
 * @template {keyof PhotoSwipeFiltersMap} T
 * @typedef {{ fn: PhotoSwipeFiltersMap[T], priority: number }} Filter
 */

/**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {PhotoSwipeEventsMap[T] extends undefined ? PhotoSwipeEvent<T> : PhotoSwipeEvent<T> & PhotoSwipeEventsMap[T]} AugmentedEvent
 */

/**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {(event: AugmentedEvent<T>) => void} EventCallback
 */

/**
 * Base PhotoSwipe event object
 *
 * @template {keyof PhotoSwipeEventsMap} T
 */
class PhotoSwipeEvent {
  /**
   * @param {T} type
   * @param {PhotoSwipeEventsMap[T]} [details]
   */
  constructor(type, details) {
    this.type = type;
    this.defaultPrevented = false;

    if (details) {
      Object.assign(this, details);
    }
  }

  preventDefault() {
    this.defaultPrevented = true;
  }
}
/**
 * PhotoSwipe base class that can listen and dispatch for events.
 * Shared by PhotoSwipe Core and PhotoSwipe Lightbox, extended by base.js
 */

class Eventable {
  constructor() {
    /**
     * @type {{ [T in keyof PhotoSwipeEventsMap]?: ((event: AugmentedEvent<T>) => void)[] }}
     */
    this._listeners = {};
    /**
     * @type {{ [T in keyof PhotoSwipeFiltersMap]?: Filter<T>[] }}
     */

    this._filters = {};
    /** @type {PhotoSwipe | undefined} */

    this.pswp = undefined;
    /** @type {PhotoSwipeOptions | undefined} */

    this.options = undefined;
  }
  /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {PhotoSwipeFiltersMap[T]} fn
   * @param {number} priority
   */

  addFilter(name, fn, priority = 100) {
    var _this$_filters$name, _this$_filters$name2, _this$pswp;

    if (!this._filters[name]) {
      this._filters[name] = [];
    }

    (_this$_filters$name = this._filters[name]) === null ||
      _this$_filters$name === void 0 ||
      _this$_filters$name.push({
        fn,
        priority,
      });
    (_this$_filters$name2 = this._filters[name]) === null ||
      _this$_filters$name2 === void 0 ||
      _this$_filters$name2.sort((f1, f2) => f1.priority - f2.priority);
    (_this$pswp = this.pswp) === null || _this$pswp === void 0 || _this$pswp.addFilter(name, fn, priority);
  }
  /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {PhotoSwipeFiltersMap[T]} fn
   */

  removeFilter(name, fn) {
    if (this._filters[name]) {
      // @ts-expect-error
      this._filters[name] = this._filters[name].filter((filter) => filter.fn !== fn);
    }

    if (this.pswp) {
      this.pswp.removeFilter(name, fn);
    }
  }
  /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {Parameters<PhotoSwipeFiltersMap[T]>} args
   * @returns {Parameters<PhotoSwipeFiltersMap[T]>[0]}
   */

  applyFilters(name, ...args) {
    var _this$_filters$name3;

    (_this$_filters$name3 = this._filters[name]) === null ||
      _this$_filters$name3 === void 0 ||
      _this$_filters$name3.forEach((filter) => {
        // @ts-expect-error
        args[0] = filter.fn.apply(this, args);
      });
    return args[0];
  }
  /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {EventCallback<T>} fn
   */

  on(name, fn) {
    var _this$_listeners$name, _this$pswp2;

    if (!this._listeners[name]) {
      this._listeners[name] = [];
    }

    (_this$_listeners$name = this._listeners[name]) === null ||
      _this$_listeners$name === void 0 ||
      _this$_listeners$name.push(fn); // When binding events to lightbox,
    // also bind events to PhotoSwipe Core,
    // if it's open.

    (_this$pswp2 = this.pswp) === null || _this$pswp2 === void 0 || _this$pswp2.on(name, fn);
  }
  /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {EventCallback<T>} fn
   */

  off(name, fn) {
    var _this$pswp3;

    if (this._listeners[name]) {
      // @ts-expect-error
      this._listeners[name] = this._listeners[name].filter((listener) => fn !== listener);
    }

    (_this$pswp3 = this.pswp) === null || _this$pswp3 === void 0 || _this$pswp3.off(name, fn);
  }
  /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {PhotoSwipeEventsMap[T]} [details]
   * @returns {AugmentedEvent<T>}
   */

  dispatch(name, details) {
    var _this$_listeners$name2;

    if (this.pswp) {
      return this.pswp.dispatch(name, details);
    }

    const event =
      /** @type {AugmentedEvent<T>} */
      new PhotoSwipeEvent(name, details);
    (_this$_listeners$name2 = this._listeners[name]) === null ||
      _this$_listeners$name2 === void 0 ||
      _this$_listeners$name2.forEach((listener) => {
        listener.call(this, event);
      });
    return event;
  }
}

class Placeholder {
  /**
   * @param {string | false} imageSrc
   * @param {HTMLElement} container
   */
  constructor(imageSrc, container) {
    // Create placeholder
    // (stretched thumbnail or simple div behind the main image)

    /** @type {HTMLImageElement | HTMLDivElement | null} */
    this.element = createElement('pswp__img pswp__img--placeholder', imageSrc ? 'img' : 'div', container);

    if (imageSrc) {
      const imgEl =
        /** @type {HTMLImageElement} */
        this.element;
      imgEl.decoding = 'async';
      imgEl.alt = '';
      imgEl.src = imageSrc;
      imgEl.setAttribute('role', 'presentation');
    }

    this.element.setAttribute('aria-hidden', 'true');
  }
  /**
   * @param {number} width
   * @param {number} height
   */

  setDisplayedSize(width, height) {
    if (!this.element) {
      return;
    }

    if (this.element.tagName === 'IMG') {
      // Use transform scale() to modify img placeholder size
      // (instead of changing width/height directly).
      // This helps with performance, specifically in iOS15 Safari.
      setWidthHeight(this.element, 250, 'auto');
      this.element.style.transformOrigin = '0 0';
      this.element.style.transform = toTransformString(0, 0, width / 250);
    } else {
      setWidthHeight(this.element, width, height);
    }
  }

  destroy() {
    var _this$element;

    if ((_this$element = this.element) !== null && _this$element !== void 0 && _this$element.parentNode) {
      this.element.remove();
    }

    this.element = null;
  }
}

/** @typedef {import('./slide.js').default} Slide */

/** @typedef {import('./slide.js').SlideData} SlideData */

/** @typedef {import('../core/base.js').default} PhotoSwipeBase */

/** @typedef {import('../util/util.js').LoadState} LoadState */

class Content {
  /**
   * @param {SlideData} itemData Slide data
   * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox instance
   * @param {number} index
   */
  constructor(itemData, instance, index) {
    this.instance = instance;
    this.data = itemData;
    this.index = index;
    /** @type {HTMLImageElement | HTMLDivElement | undefined} */

    this.element = undefined;
    /** @type {Placeholder | undefined} */

    this.placeholder = undefined;
    /** @type {Slide | undefined} */

    this.slide = undefined;
    this.displayedImageWidth = 0;
    this.displayedImageHeight = 0;
    this.width = Number(this.data.w) || Number(this.data.width) || 0;
    this.height = Number(this.data.h) || Number(this.data.height) || 0;
    this.isAttached = false;
    this.hasSlide = false;
    this.isDecoding = false;
    /** @type {LoadState} */

    this.state = LOAD_STATE.IDLE;

    if (this.data.type) {
      this.type = this.data.type;
    } else if (this.data.src) {
      this.type = 'image';
    } else {
      this.type = 'html';
    }

    this.instance.dispatch('contentInit', {
      content: this,
    });
  }

  removePlaceholder() {
    if (this.placeholder && !this.keepPlaceholder()) {
      // With delay, as image might be loaded, but not rendered
      setTimeout(() => {
        if (this.placeholder) {
          this.placeholder.destroy();
          this.placeholder = undefined;
        }
      }, 1000);
    }
  }
  /**
   * Preload content
   *
   * @param {boolean} isLazy
   * @param {boolean} [reload]
   */

  load(isLazy, reload) {
    if (this.slide && this.usePlaceholder()) {
      if (!this.placeholder) {
        const placeholderSrc = this.instance.applyFilters(
          'placeholderSrc', // use  image-based placeholder only for the first slide,
          // as rendering (even small stretched thumbnail) is an expensive operation
          this.data.msrc && this.slide.isFirstSlide ? this.data.msrc : false,
          this,
        );
        this.placeholder = new Placeholder(placeholderSrc, this.slide.container);
      } else {
        const placeholderEl = this.placeholder.element; // Add placeholder to DOM if it was already created

        if (placeholderEl && !placeholderEl.parentElement) {
          this.slide.container.prepend(placeholderEl);
        }
      }
    }

    if (this.element && !reload) {
      return;
    }

    if (
      this.instance.dispatch('contentLoad', {
        content: this,
        isLazy,
      }).defaultPrevented
    ) {
      return;
    }

    if (this.isImageContent()) {
      this.element = createElement('pswp__img', 'img'); // Start loading only after width is defined, as sizes might depend on it.
      // Due to Safari feature, we must define sizes before srcset.

      if (this.displayedImageWidth) {
        this.loadImage(isLazy);
      }
    } else {
      this.element = createElement('pswp__content', 'div');
      this.element.innerHTML = this.data.html || '';
    }

    if (reload && this.slide) {
      this.slide.updateContentSize(true);
    }
  }
  /**
   * Preload image
   *
   * @param {boolean} isLazy
   */

  loadImage(isLazy) {
    var _this$data$src, _this$data$alt;

    if (
      !this.isImageContent() ||
      !this.element ||
      this.instance.dispatch('contentLoadImage', {
        content: this,
        isLazy,
      }).defaultPrevented
    ) {
      return;
    }

    const imageElement =
      /** @type HTMLImageElement */
      this.element;
    this.updateSrcsetSizes();

    if (this.data.srcset) {
      imageElement.srcset = this.data.srcset;
    }

    imageElement.src = (_this$data$src = this.data.src) !== null && _this$data$src !== void 0 ? _this$data$src : '';
    imageElement.alt = (_this$data$alt = this.data.alt) !== null && _this$data$alt !== void 0 ? _this$data$alt : '';
    this.state = LOAD_STATE.LOADING;

    if (imageElement.complete) {
      this.onLoaded();
    } else {
      imageElement.onload = () => {
        this.onLoaded();
      };

      imageElement.onerror = () => {
        this.onError();
      };
    }
  }
  /**
   * Assign slide to content
   *
   * @param {Slide} slide
   */

  setSlide(slide) {
    this.slide = slide;
    this.hasSlide = true;
    this.instance = slide.pswp; // todo: do we need to unset slide?
  }
  /**
   * Content load success handler
   */

  onLoaded() {
    this.state = LOAD_STATE.LOADED;

    if (this.slide && this.element) {
      this.instance.dispatch('loadComplete', {
        slide: this.slide,
        content: this,
      }); // if content is reloaded

      if (this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode) {
        this.append();
        this.slide.updateContentSize(true);
      }

      if (this.state === LOAD_STATE.LOADED || this.state === LOAD_STATE.ERROR) {
        this.removePlaceholder();
      }
    }
  }
  /**
   * Content load error handler
   */

  onError() {
    this.state = LOAD_STATE.ERROR;

    if (this.slide) {
      this.displayError();
      this.instance.dispatch('loadComplete', {
        slide: this.slide,
        isError: true,
        content: this,
      });
      this.instance.dispatch('loadError', {
        slide: this.slide,
        content: this,
      });
    }
  }
  /**
   * @returns {Boolean} If the content is currently loading
   */

  isLoading() {
    return this.instance.applyFilters('isContentLoading', this.state === LOAD_STATE.LOADING, this);
  }
  /**
   * @returns {Boolean} If the content is in error state
   */

  isError() {
    return this.state === LOAD_STATE.ERROR;
  }
  /**
   * @returns {boolean} If the content is image
   */

  isImageContent() {
    return this.type === 'image';
  }
  /**
   * Update content size
   *
   * @param {Number} width
   * @param {Number} height
   */

  setDisplayedSize(width, height) {
    if (!this.element) {
      return;
    }

    if (this.placeholder) {
      this.placeholder.setDisplayedSize(width, height);
    }

    if (
      this.instance.dispatch('contentResize', {
        content: this,
        width,
        height,
      }).defaultPrevented
    ) {
      return;
    }

    setWidthHeight(this.element, width, height);

    if (this.isImageContent() && !this.isError()) {
      const isInitialSizeUpdate = !this.displayedImageWidth && width;
      this.displayedImageWidth = width;
      this.displayedImageHeight = height;

      if (isInitialSizeUpdate) {
        this.loadImage(false);
      } else {
        this.updateSrcsetSizes();
      }

      if (this.slide) {
        this.instance.dispatch('imageSizeChange', {
          slide: this.slide,
          width,
          height,
          content: this,
        });
      }
    }
  }
  /**
   * @returns {boolean} If the content can be zoomed
   */

  isZoomable() {
    return this.instance.applyFilters(
      'isContentZoomable',
      this.isImageContent() && this.state !== LOAD_STATE.ERROR,
      this,
    );
  }
  /**
   * Update image srcset sizes attribute based on width and height
   */

  updateSrcsetSizes() {
    // Handle srcset sizes attribute.
    //
    // Never lower quality, if it was increased previously.
    // Chrome does this automatically, Firefox and Safari do not,
    // so we store largest used size in dataset.
    if (!this.isImageContent() || !this.element || !this.data.srcset) {
      return;
    }

    const image =
      /** @type HTMLImageElement */
      this.element;
    const sizesWidth = this.instance.applyFilters('srcsetSizesWidth', this.displayedImageWidth, this);

    if (!image.dataset.largestUsedSize || sizesWidth > parseInt(image.dataset.largestUsedSize, 10)) {
      image.sizes = sizesWidth + 'px';
      image.dataset.largestUsedSize = String(sizesWidth);
    }
  }
  /**
   * @returns {boolean} If content should use a placeholder (from msrc by default)
   */

  usePlaceholder() {
    return this.instance.applyFilters('useContentPlaceholder', this.isImageContent(), this);
  }
  /**
   * Preload content with lazy-loading param
   */

  lazyLoad() {
    if (
      this.instance.dispatch('contentLazyLoad', {
        content: this,
      }).defaultPrevented
    ) {
      return;
    }

    this.load(true);
  }
  /**
   * @returns {boolean} If placeholder should be kept after content is loaded
   */

  keepPlaceholder() {
    return this.instance.applyFilters('isKeepingPlaceholder', this.isLoading(), this);
  }
  /**
   * Destroy the content
   */

  destroy() {
    this.hasSlide = false;
    this.slide = undefined;

    if (
      this.instance.dispatch('contentDestroy', {
        content: this,
      }).defaultPrevented
    ) {
      return;
    }

    this.remove();

    if (this.placeholder) {
      this.placeholder.destroy();
      this.placeholder = undefined;
    }

    if (this.isImageContent() && this.element) {
      this.element.onload = null;
      this.element.onerror = null;
      this.element = undefined;
    }
  }
  /**
   * Display error message
   */

  displayError() {
    if (this.slide) {
      var _this$instance$option, _this$instance$option2;

      let errorMsgEl = createElement('pswp__error-msg', 'div');
      errorMsgEl.innerText =
        (_this$instance$option =
          (_this$instance$option2 = this.instance.options) === null || _this$instance$option2 === void 0
            ? void 0
            : _this$instance$option2.errorMsg) !== null && _this$instance$option !== void 0
          ? _this$instance$option
          : '';
      errorMsgEl =
        /** @type {HTMLDivElement} */
        this.instance.applyFilters('contentErrorElement', errorMsgEl, this);
      this.element = createElement('pswp__content pswp__error-msg-container', 'div');
      this.element.appendChild(errorMsgEl);
      this.slide.container.innerText = '';
      this.slide.container.appendChild(this.element);
      this.slide.updateContentSize(true);
      this.removePlaceholder();
    }
  }
  /**
   * Append the content
   */

  append() {
    if (this.isAttached || !this.element) {
      return;
    }

    this.isAttached = true;

    if (this.state === LOAD_STATE.ERROR) {
      this.displayError();
      return;
    }

    if (
      this.instance.dispatch('contentAppend', {
        content: this,
      }).defaultPrevented
    ) {
      return;
    }

    const supportsDecode = 'decode' in this.element;

    if (this.isImageContent()) {
      // Use decode() on nearby slides
      //
      // Nearby slide images are in DOM and not hidden via display:none.
      // However, they are placed offscreen (to the left and right side).
      //
      // Some browsers do not composite the image until it's actually visible,
      // using decode() helps.
      //
      // You might ask "why dont you just decode() and then append all images",
      // that's because I want to show image before it's fully loaded,
      // as browser can render parts of image while it is loading.
      // We do not do this in Safari due to partial loading bug.
      if (supportsDecode && this.slide && (!this.slide.isActive || isSafari())) {
        this.isDecoding = true; // purposefully using finally instead of then,
        // as if srcset sizes changes dynamically - it may cause decode error

        /** @type {HTMLImageElement} */

        this.element
          .decode()
          .catch(() => {})
          .finally(() => {
            this.isDecoding = false;
            this.appendImage();
          });
      } else {
        this.appendImage();
      }
    } else if (this.slide && !this.element.parentNode) {
      this.slide.container.appendChild(this.element);
    }
  }
  /**
   * Activate the slide,
   * active slide is generally the current one,
   * meaning the user can see it.
   */

  activate() {
    if (
      this.instance.dispatch('contentActivate', {
        content: this,
      }).defaultPrevented ||
      !this.slide
    ) {
      return;
    }

    if (this.isImageContent() && this.isDecoding && !isSafari()) {
      // add image to slide when it becomes active,
      // even if it's not finished decoding
      this.appendImage();
    } else if (this.isError()) {
      this.load(false, true); // try to reload
    }

    if (this.slide.holderElement) {
      this.slide.holderElement.setAttribute('aria-hidden', 'false');
    }
  }
  /**
   * Deactivate the content
   */

  deactivate() {
    this.instance.dispatch('contentDeactivate', {
      content: this,
    });

    if (this.slide && this.slide.holderElement) {
      this.slide.holderElement.setAttribute('aria-hidden', 'true');
    }
  }
  /**
   * Remove the content from DOM
   */

  remove() {
    this.isAttached = false;

    if (
      this.instance.dispatch('contentRemove', {
        content: this,
      }).defaultPrevented
    ) {
      return;
    }

    if (this.element && this.element.parentNode) {
      this.element.remove();
    }

    if (this.placeholder && this.placeholder.element) {
      this.placeholder.element.remove();
    }
  }
  /**
   * Append the image content to slide container
   */

  appendImage() {
    if (!this.isAttached) {
      return;
    }

    if (
      this.instance.dispatch('contentAppendImage', {
        content: this,
      }).defaultPrevented
    ) {
      return;
    } // ensure that element exists and is not already appended

    if (this.slide && this.element && !this.element.parentNode) {
      this.slide.container.appendChild(this.element);
    }

    if (this.state === LOAD_STATE.LOADED || this.state === LOAD_STATE.ERROR) {
      this.removePlaceholder();
    }
  }
}

/** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */

/** @typedef {import('../core/base.js').default} PhotoSwipeBase */

/** @typedef {import('../photoswipe.js').Point} Point */

/** @typedef {import('../slide/slide.js').SlideData} SlideData */

/**
 * @param {PhotoSwipeOptions} options
 * @param {PhotoSwipeBase} pswp
 * @returns {Point}
 */
function getViewportSize(options, pswp) {
  if (options.getViewportSizeFn) {
    const newViewportSize = options.getViewportSizeFn(options, pswp);

    if (newViewportSize) {
      return newViewportSize;
    }
  }

  return {
    x: document.documentElement.clientWidth,
    // TODO: height on mobile is very incosistent due to toolbar
    // find a way to improve this
    //
    // document.documentElement.clientHeight - doesn't seem to work well
    y: window.innerHeight,
  };
}
/**
 * Parses padding option.
 * Supported formats:
 *
 * // Object
 * padding: {
 *  top: 0,
 *  bottom: 0,
 *  left: 0,
 *  right: 0
 * }
 *
 * // A function that returns the object
 * paddingFn: (viewportSize, itemData, index) => {
 *  return {
 *    top: 0,
 *    bottom: 0,
 *    left: 0,
 *    right: 0
 *  };
 * }
 *
 * // Legacy variant
 * paddingLeft: 0,
 * paddingRight: 0,
 * paddingTop: 0,
 * paddingBottom: 0,
 *
 * @param {'left' | 'top' | 'bottom' | 'right'} prop
 * @param {PhotoSwipeOptions} options PhotoSwipe options
 * @param {Point} viewportSize PhotoSwipe viewport size, for example: { x:800, y:600 }
 * @param {SlideData} itemData Data about the slide
 * @param {number} index Slide index
 * @returns {number}
 */

function parsePaddingOption(prop, options, viewportSize, itemData, index) {
  let paddingValue = 0;

  if (options.paddingFn) {
    paddingValue = options.paddingFn(viewportSize, itemData, index)[prop];
  } else if (options.padding) {
    paddingValue = options.padding[prop];
  } else {
    const legacyPropName = 'padding' + prop[0].toUpperCase() + prop.slice(1); // @ts-expect-error

    if (options[legacyPropName]) {
      // @ts-expect-error
      paddingValue = options[legacyPropName];
    }
  }

  return Number(paddingValue) || 0;
}
/**
 * @param {PhotoSwipeOptions} options
 * @param {Point} viewportSize
 * @param {SlideData} itemData
 * @param {number} index
 * @returns {Point}
 */

function getPanAreaSize(options, viewportSize, itemData, index) {
  return {
    x:
      viewportSize.x -
      parsePaddingOption('left', options, viewportSize, itemData, index) -
      parsePaddingOption('right', options, viewportSize, itemData, index),
    y:
      viewportSize.y -
      parsePaddingOption('top', options, viewportSize, itemData, index) -
      parsePaddingOption('bottom', options, viewportSize, itemData, index),
  };
}

const MAX_IMAGE_WIDTH = 4000;
/** @typedef {import('../photoswipe.js').default} PhotoSwipe */

/** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */

/** @typedef {import('../photoswipe.js').Point} Point */

/** @typedef {import('../slide/slide.js').SlideData} SlideData */

/** @typedef {'fit' | 'fill' | number | ((zoomLevelObject: ZoomLevel) => number)} ZoomLevelOption */

/**
 * Calculates zoom levels for specific slide.
 * Depends on viewport size and image size.
 */

class ZoomLevel {
  /**
   * @param {PhotoSwipeOptions} options PhotoSwipe options
   * @param {SlideData} itemData Slide data
   * @param {number} index Slide index
   * @param {PhotoSwipe} [pswp] PhotoSwipe instance, can be undefined if not initialized yet
   */
  constructor(options, itemData, index, pswp) {
    this.pswp = pswp;
    this.options = options;
    this.itemData = itemData;
    this.index = index;
    /** @type { Point | null } */

    this.panAreaSize = null;
    /** @type { Point | null } */

    this.elementSize = null;
    this.fit = 1;
    this.fill = 1;
    this.vFill = 1;
    this.initial = 1;
    this.secondary = 1;
    this.max = 1;
    this.min = 1;
  }
  /**
   * Calculate initial, secondary and maximum zoom level for the specified slide.
   *
   * It should be called when either image or viewport size changes.
   *
   * @param {number} maxWidth
   * @param {number} maxHeight
   * @param {Point} panAreaSize
   */

  update(maxWidth, maxHeight, panAreaSize) {
    /** @type {Point} */
    const elementSize = {
      x: maxWidth,
      y: maxHeight,
    };
    this.elementSize = elementSize;
    this.panAreaSize = panAreaSize;
    const hRatio = panAreaSize.x / elementSize.x;
    const vRatio = panAreaSize.y / elementSize.y;
    this.fit = Math.min(1, hRatio < vRatio ? hRatio : vRatio);
    this.fill = Math.min(1, hRatio > vRatio ? hRatio : vRatio); // zoom.vFill defines zoom level of the image
    // when it has 100% of viewport vertical space (height)

    this.vFill = Math.min(1, vRatio);
    this.initial = this._getInitial();
    this.secondary = this._getSecondary();
    this.max = Math.max(this.initial, this.secondary, this._getMax());
    this.min = Math.min(this.fit, this.initial, this.secondary);

    if (this.pswp) {
      this.pswp.dispatch('zoomLevelsUpdate', {
        zoomLevels: this,
        slideData: this.itemData,
      });
    }
  }
  /**
   * Parses user-defined zoom option.
   *
   * @private
   * @param {'initial' | 'secondary' | 'max'} optionPrefix Zoom level option prefix (initial, secondary, max)
   * @returns { number | undefined }
   */

  _parseZoomLevelOption(optionPrefix) {
    const optionName =
      /** @type {'initialZoomLevel' | 'secondaryZoomLevel' | 'maxZoomLevel'} */
      optionPrefix + 'ZoomLevel';
    const optionValue = this.options[optionName];

    if (!optionValue) {
      return;
    }

    if (typeof optionValue === 'function') {
      return optionValue(this);
    }

    if (optionValue === 'fill') {
      return this.fill;
    }

    if (optionValue === 'fit') {
      return this.fit;
    }

    return Number(optionValue);
  }
  /**
   * Get zoom level to which image will be zoomed after double-tap gesture,
   * or when user clicks on zoom icon,
   * or mouse-click on image itself.
   * If you return 1 image will be zoomed to its original size.
   *
   * @private
   * @return {number}
   */

  _getSecondary() {
    let currZoomLevel = this._parseZoomLevelOption('secondary');

    if (currZoomLevel) {
      return currZoomLevel;
    } // 3x of "fit" state, but not larger than original

    currZoomLevel = Math.min(1, this.fit * 3);

    if (this.elementSize && currZoomLevel * this.elementSize.x > MAX_IMAGE_WIDTH) {
      currZoomLevel = MAX_IMAGE_WIDTH / this.elementSize.x;
    }

    return currZoomLevel;
  }
  /**
   * Get initial image zoom level.
   *
   * @private
   * @return {number}
   */

  _getInitial() {
    return this._parseZoomLevelOption('initial') || this.fit;
  }
  /**
   * Maximum zoom level when user zooms
   * via zoom/pinch gesture,
   * via cmd/ctrl-wheel or via trackpad.
   *
   * @private
   * @return {number}
   */

  _getMax() {
    // max zoom level is x4 from "fit state",
    // used for zoom gesture and ctrl/trackpad zoom
    return this._parseZoomLevelOption('max') || Math.max(1, this.fit * 4);
  }
}

/**
 * Lazy-load an image
 * This function is used both by Lightbox and PhotoSwipe core,
 * thus it can be called before dialog is opened.
 *
 * @param {SlideData} itemData Data about the slide
 * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox instance
 * @param {number} index
 * @returns {Content} Image that is being decoded or false.
 */

function lazyLoadData(itemData, instance, index) {
  const content = instance.createContentFromData(itemData, index);
  /** @type {ZoomLevel | undefined} */

  let zoomLevel;
  const {options} = instance; // We need to know dimensions of the image to preload it,
  // as it might use srcset, and we need to define sizes

  if (options) {
    zoomLevel = new ZoomLevel(options, itemData, -1);
    let viewportSize;

    if (instance.pswp) {
      viewportSize = instance.pswp.viewportSize;
    } else {
      viewportSize = getViewportSize(options, instance);
    }

    const panAreaSize = getPanAreaSize(options, viewportSize, itemData, index);
    zoomLevel.update(content.width, content.height, panAreaSize);
  }

  content.lazyLoad();

  if (zoomLevel) {
    content.setDisplayedSize(
      Math.ceil(content.width * zoomLevel.initial),
      Math.ceil(content.height * zoomLevel.initial),
    );
  }

  return content;
}
/**
 * Lazy-loads specific slide.
 * This function is used both by Lightbox and PhotoSwipe core,
 * thus it can be called before dialog is opened.
 *
 * By default, it loads image based on viewport size and initial zoom level.
 *
 * @param {number} index Slide index
 * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox eventable instance
 * @returns {Content | undefined}
 */

function lazyLoadSlide(index, instance) {
  const itemData = instance.getItemData(index);

  if (
    instance.dispatch('lazyLoadSlide', {
      index,
      itemData,
    }).defaultPrevented
  ) {
    return;
  }

  return lazyLoadData(itemData, instance, index);
}

/** @typedef {import("../photoswipe.js").default} PhotoSwipe */

/** @typedef {import("../slide/slide.js").SlideData} SlideData */

/**
 * PhotoSwipe base class that can retrieve data about every slide.
 * Shared by PhotoSwipe Core and PhotoSwipe Lightbox
 */

class PhotoSwipeBase extends Eventable {
  /**
   * Get total number of slides
   *
   * @returns {number}
   */
  getNumItems() {
    var _this$options;

    let numItems = 0;
    const dataSource =
      (_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.dataSource;

    if (dataSource && 'length' in dataSource) {
      // may be an array or just object with length property
      numItems = dataSource.length;
    } else if (dataSource && 'gallery' in dataSource) {
      // query DOM elements
      if (!dataSource.items) {
        dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
      }

      if (dataSource.items) {
        numItems = dataSource.items.length;
      }
    } // legacy event, before filters were introduced

    const event = this.dispatch('numItems', {
      dataSource,
      numItems,
    });
    return this.applyFilters('numItems', event.numItems, dataSource);
  }
  /**
   * @param {SlideData} slideData
   * @param {number} index
   * @returns {Content}
   */

  createContentFromData(slideData, index) {
    return new Content(slideData, this, index);
  }
  /**
   * Get item data by index.
   *
   * "item data" should contain normalized information that PhotoSwipe needs to generate a slide.
   * For example, it may contain properties like
   * `src`, `srcset`, `w`, `h`, which will be used to generate a slide with image.
   *
   * @param {number} index
   * @returns {SlideData}
   */

  getItemData(index) {
    var _this$options2;

    const dataSource =
      (_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2.dataSource;
    /** @type {SlideData | HTMLElement} */

    let dataSourceItem = {};

    if (Array.isArray(dataSource)) {
      // Datasource is an array of elements
      dataSourceItem = dataSource[index];
    } else if (dataSource && 'gallery' in dataSource) {
      // dataSource has gallery property,
      // thus it was created by Lightbox, based on
      // gallery and children options
      // query DOM elements
      if (!dataSource.items) {
        dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
      }

      dataSourceItem = dataSource.items[index];
    }

    let itemData = dataSourceItem;

    if (itemData instanceof Element) {
      itemData = this._domElementToItemData(itemData);
    } // Dispatching the itemData event,
    // it's a legacy verion before filters were introduced

    const event = this.dispatch('itemData', {
      itemData: itemData || {},
      index,
    });
    return this.applyFilters('itemData', event.itemData, index);
  }
  /**
   * Get array of gallery DOM elements,
   * based on childSelector and gallery element.
   *
   * @param {HTMLElement} galleryElement
   * @returns {HTMLElement[]}
   */

  _getGalleryDOMElements(galleryElement) {
    var _this$options3, _this$options4;

    if (
      ((_this$options3 = this.options) !== null && _this$options3 !== void 0 && _this$options3.children) ||
      ((_this$options4 = this.options) !== null && _this$options4 !== void 0 && _this$options4.childSelector)
    ) {
      return getElementsFromOption(this.options.children, this.options.childSelector, galleryElement) || [];
    }

    return [galleryElement];
  }
  /**
   * Converts DOM element to item data object.
   *
   * @param {HTMLElement} element DOM element
   * @returns {SlideData}
   */

  _domElementToItemData(element) {
    /** @type {SlideData} */
    const itemData = {
      element,
    };
    const linkEl =
      /** @type {HTMLAnchorElement} */
      element.tagName === 'A' ? element : element.querySelector('a');

    if (linkEl) {
      // src comes from data-pswp-src attribute,
      // if it's empty link href is used
      itemData.src = linkEl.dataset.pswpSrc || linkEl.href;

      if (linkEl.dataset.pswpSrcset) {
        itemData.srcset = linkEl.dataset.pswpSrcset;
      }

      itemData.width = linkEl.dataset.pswpWidth ? parseInt(linkEl.dataset.pswpWidth, 10) : 0;
      itemData.height = linkEl.dataset.pswpHeight ? parseInt(linkEl.dataset.pswpHeight, 10) : 0; // support legacy w & h properties

      itemData.w = itemData.width;
      itemData.h = itemData.height;

      if (linkEl.dataset.pswpType) {
        itemData.type = linkEl.dataset.pswpType;
      }

      const thumbnailEl = element.querySelector('img');

      if (thumbnailEl) {
        var _thumbnailEl$getAttri;

        // msrc is URL to placeholder image that's displayed before large image is loaded
        // by default it's displayed only for the first slide
        itemData.msrc = thumbnailEl.currentSrc || thumbnailEl.src;
        itemData.alt =
          (_thumbnailEl$getAttri = thumbnailEl.getAttribute('alt')) !== null && _thumbnailEl$getAttri !== void 0
            ? _thumbnailEl$getAttri
            : '';
      }

      if (linkEl.dataset.pswpCropped || linkEl.dataset.cropped) {
        itemData.thumbCropped = true;
      }
    }

    return this.applyFilters('domItemData', itemData, element, linkEl);
  }
  /**
   * Lazy-load by slide data
   *
   * @param {SlideData} itemData Data about the slide
   * @param {number} index
   * @returns {Content} Image that is being decoded or false.
   */

  lazyLoadData(itemData, index) {
    return lazyLoadData(itemData, this, index);
  }
}

/**
 * @template T
 * @typedef {import('../types.js').Type<T>} Type<T>
 */

/** @typedef {import('../photoswipe.js').default} PhotoSwipe */

/** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */

/** @typedef {import('../photoswipe.js').DataSource} DataSource */

/** @typedef {import('../photoswipe.js').Point} Point */

/** @typedef {import('../slide/content.js').default} Content */

/** @typedef {import('../core/eventable.js').PhotoSwipeEventsMap} PhotoSwipeEventsMap */

/** @typedef {import('../core/eventable.js').PhotoSwipeFiltersMap} PhotoSwipeFiltersMap */

/**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {import('../core/eventable.js').EventCallback<T>} EventCallback<T>
 */

/**
 * PhotoSwipe Lightbox
 *
 * - If user has unsupported browser it falls back to default browser action (just opens URL)
 * - Binds click event to links that should open PhotoSwipe
 * - parses DOM strcture for PhotoSwipe (retrieves large image URLs and sizes)
 * - Initializes PhotoSwipe
 *
 *
 * Loader options use the same object as PhotoSwipe, and supports such options:
 *
 * gallery - Element | Element[] | NodeList | string selector for the gallery element
 * children - Element | Element[] | NodeList | string selector for the gallery children
 *
 */

class PhotoSwipeLightbox extends PhotoSwipeBase {
  /**
   * @param {PhotoSwipeOptions} [options]
   */
  constructor(options) {
    super();
    /** @type {PhotoSwipeOptions} */

    this.options = options || {};
    this._uid = 0;
    this.shouldOpen = false;
    /**
     * @private
     * @type {Content | undefined}
     */

    this._preloadedContent = undefined;
    this.onThumbnailsClick = this.onThumbnailsClick.bind(this);
  }
  /**
   * Initialize lightbox, should be called only once.
   * It's not included in the main constructor, so you may bind events before it.
   */

  init() {
    // Bind click events to each gallery
    getElementsFromOption(this.options.gallery, this.options.gallerySelector).forEach((galleryElement) => {
      galleryElement.addEventListener('click', this.onThumbnailsClick, false);
    });
  }
  /**
   * @param {MouseEvent} e
   */

  onThumbnailsClick(e) {
    // Exit and allow default browser action if:
    if (
      specialKeyUsed(e) || // ... if clicked with a special key (ctrl/cmd...)
      window.pswp
    ) {
      // ... if PhotoSwipe is already open
      return;
    } // If both clientX and clientY are 0 or not defined,
    // the event is likely triggered by keyboard,
    // so we do not pass the initialPoint
    //
    // Note that some screen readers emulate the mouse position,
    // so it's not the ideal way to detect them.
    //

    /** @type {Point | null} */

    let initialPoint = {
      x: e.clientX,
      y: e.clientY,
    };

    if (!initialPoint.x && !initialPoint.y) {
      initialPoint = null;
    }

    let clickedIndex = this.getClickedIndex(e);
    clickedIndex = this.applyFilters('clickedIndex', clickedIndex, e, this);
    /** @type {DataSource} */

    const dataSource = {
      gallery:
        /** @type {HTMLElement} */
        e.currentTarget,
    };

    if (clickedIndex >= 0) {
      e.preventDefault();
      this.loadAndOpen(clickedIndex, dataSource, initialPoint);
    }
  }
  /**
   * Get index of gallery item that was clicked.
   *
   * @param {MouseEvent} e click event
   * @returns {number}
   */

  getClickedIndex(e) {
    // legacy option
    if (this.options.getClickedIndexFn) {
      return this.options.getClickedIndexFn.call(this, e);
    }

    const clickedTarget =
      /** @type {HTMLElement} */
      e.target;
    const childElements = getElementsFromOption(
      this.options.children,
      this.options.childSelector,
      /** @type {HTMLElement} */
      e.currentTarget,
    );
    const clickedChildIndex = childElements.findIndex(
      (child) => child === clickedTarget || child.contains(clickedTarget),
    );

    if (clickedChildIndex !== -1) {
      return clickedChildIndex;
    } else if (this.options.children || this.options.childSelector) {
      // click wasn't on a child element
      return -1;
    } // There is only one item (which is the gallery)

    return 0;
  }
  /**
   * Load and open PhotoSwipe
   *
   * @param {number} index
   * @param {DataSource} [dataSource]
   * @param {Point | null} [initialPoint]
   * @returns {boolean}
   */

  loadAndOpen(index, dataSource, initialPoint) {
    // Check if the gallery is already open
    if (window.pswp || !this.options) {
      return false;
    } // Use the first gallery element if dataSource is not provided

    if (!dataSource && this.options.gallery && this.options.children) {
      const galleryElements = getElementsFromOption(this.options.gallery);

      if (galleryElements[0]) {
        dataSource = {
          gallery: galleryElements[0],
        };
      }
    } // set initial index

    this.options.index = index; // define options for PhotoSwipe constructor

    this.options.initialPointerPos = initialPoint;
    this.shouldOpen = true;
    this.preload(index, dataSource);
    return true;
  }
  /**
   * Load the main module and the slide content by index
   *
   * @param {number} index
   * @param {DataSource} [dataSource]
   */

  preload(index, dataSource) {
    const {options} = this;

    if (dataSource) {
      options.dataSource = dataSource;
    } // Add the main module

    /** @type {Promise<Type<PhotoSwipe>>[]} */

    const promiseArray = [];
    const pswpModuleType = typeof options.pswpModule;

    if (isPswpClass(options.pswpModule)) {
      promiseArray.push(
        Promise.resolve(
          /** @type {Type<PhotoSwipe>} */
          options.pswpModule,
        ),
      );
    } else if (pswpModuleType === 'string') {
      throw new Error('pswpModule as string is no longer supported');
    } else if (pswpModuleType === 'function') {
      promiseArray.push(
        /** @type {() => Promise<Type<PhotoSwipe>>} */
        options.pswpModule(),
      );
    } else {
      throw new Error('pswpModule is not valid');
    } // Add custom-defined promise, if any

    if (typeof options.openPromise === 'function') {
      // allow developers to perform some task before opening
      promiseArray.push(options.openPromise());
    }

    if (options.preloadFirstSlide !== false && index >= 0) {
      this._preloadedContent = lazyLoadSlide(index, this);
    } // Wait till all promises resolve and open PhotoSwipe

    const uid = ++this._uid;
    Promise.all(promiseArray).then((iterableModules) => {
      if (this.shouldOpen) {
        const mainModule = iterableModules[0];

        this._openPhotoswipe(mainModule, uid);
      }
    });
  }
  /**
   * @private
   * @param {Type<PhotoSwipe> | { default: Type<PhotoSwipe> }} module
   * @param {number} uid
   */

  _openPhotoswipe(module, uid) {
    // Cancel opening if UID doesn't match the current one
    // (if user clicked on another gallery item before current was loaded).
    //
    // Or if shouldOpen flag is set to false
    // (developer may modify it via public API)
    if (uid !== this._uid && this.shouldOpen) {
      return;
    }

    this.shouldOpen = false; // PhotoSwipe is already open

    if (window.pswp) {
      return;
    }
    /**
     * Pass data to PhotoSwipe and open init
     *
     * @type {PhotoSwipe}
     */

    const pswp =
      typeof module === 'object'
        ? new module.default(this.options) // eslint-disable-line
        : new module(this.options); // eslint-disable-line

    this.pswp = pswp;
    window.pswp = pswp; // map listeners from Lightbox to PhotoSwipe Core

    /** @type {(keyof PhotoSwipeEventsMap)[]} */

    Object.keys(this._listeners).forEach((name) => {
      var _this$_listeners$name;

      (_this$_listeners$name = this._listeners[name]) === null ||
        _this$_listeners$name === void 0 ||
        _this$_listeners$name.forEach((fn) => {
          pswp.on(
            name,
            /** @type {EventCallback<typeof name>} */
            fn,
          );
        });
    }); // same with filters

    /** @type {(keyof PhotoSwipeFiltersMap)[]} */

    Object.keys(this._filters).forEach((name) => {
      var _this$_filters$name;

      (_this$_filters$name = this._filters[name]) === null ||
        _this$_filters$name === void 0 ||
        _this$_filters$name.forEach((filter) => {
          pswp.addFilter(name, filter.fn, filter.priority);
        });
    });

    if (this._preloadedContent) {
      pswp.contentLoader.addToCache(this._preloadedContent);
      this._preloadedContent = undefined;
    }

    pswp.on('destroy', () => {
      // clean up public variables
      this.pswp = undefined;
      delete window.pswp;
    });
    pswp.init();
  }
  /**
   * Unbinds all events, closes PhotoSwipe if it's open.
   */

  destroy() {
    var _this$pswp;

    (_this$pswp = this.pswp) === null || _this$pswp === void 0 || _this$pswp.destroy();
    this.shouldOpen = false;
    this._listeners = {};
    getElementsFromOption(this.options.gallery, this.options.gallerySelector).forEach((galleryElement) => {
      galleryElement.removeEventListener('click', this.onThumbnailsClick, false);
    });
  }
}

const defaultOptions = {
  videoAttributes: {controls: '', playsinline: '', preload: 'auto'},
  autoplay: true,

  // prevent drag/swipe gesture over the bottom part of video
  // set to 0 to disable
  preventDragOffset: 40,
};

/**
 * Check if slide has video content
 *
 * @param {Slide|Content} content Slide or Content object
 * @returns Boolean
 */
function isVideoContent(content) {
  return content && content.data && content.data.type === 'video';
}

class VideoContentSetup {
  constructor(lightbox, options) {
    this.options = options;

    this.initLightboxEvents(lightbox);
    lightbox.on('init', () => {
      this.initPswpEvents(lightbox.pswp);
    });
  }

  initLightboxEvents(lightbox) {
    lightbox.on('contentLoad', this.onContentLoad.bind(this));
    lightbox.on('contentDestroy', this.onContentDestroy.bind(this));
    lightbox.on('contentActivate', this.onContentActivate.bind(this));
    lightbox.on('contentDeactivate', this.onContentDeactivate.bind(this));
    lightbox.on('contentAppend', this.onContentAppend.bind(this));
    lightbox.on('contentResize', this.onContentResize.bind(this));

    lightbox.addFilter('isKeepingPlaceholder', this.isKeepingPlaceholder.bind(this));
    lightbox.addFilter('isContentZoomable', this.isContentZoomable.bind(this));
    lightbox.addFilter('useContentPlaceholder', this.useContentPlaceholder.bind(this));

    lightbox.addFilter('domItemData', (itemData, element, linkEl) => {
      if (itemData.type === 'video' && linkEl) {
        if (linkEl.dataset.pswpVideoSources) {
          itemData.videoSources = JSON.parse(pswpVideoSources);
        } else if (linkEl.dataset.pswpVideoSrc) {
          itemData.videoSrc = linkEl.dataset.pswpVideoSrc;
        } else {
          itemData.videoSrc = linkEl.href;
        }
      }
      return itemData;
    });
  }

  initPswpEvents(pswp) {
    // Prevent draggin when pointer is in bottom part of the video
    // todo: add option for this
    pswp.on('pointerDown', (e) => {
      const slide = pswp.currSlide;
      if (isVideoContent(slide) && this.options.preventDragOffset) {
        const origEvent = e.originalEvent;
        if (origEvent.type === 'pointerdown') {
          const videoHeight = Math.ceil(slide.height * slide.currZoomLevel);
          const verticalEnding = videoHeight + slide.bounds.center.y;
          const pointerYPos = origEvent.pageY - pswp.offset.y;
          if (pointerYPos > verticalEnding - this.options.preventDragOffset && pointerYPos < verticalEnding) {
            e.preventDefault();
          }
        }
      }
    });

    // do not append video on nearby slides
    pswp.on('appendHeavy', (e) => {
      if (isVideoContent(e.slide) && !e.slide.isActive) {
        e.preventDefault();
      }
    });

    pswp.on('close', () => {
      if (isVideoContent(pswp.currSlide.content)) {
        // Switch from zoom to fade closing transition,
        // as zoom transition is choppy for videos
        if (!pswp.options.showHideAnimationType || pswp.options.showHideAnimationType === 'zoom') {
          pswp.options.showHideAnimationType = 'fade';
        }

        // pause video when closing
        this.pauseVideo(pswp.currSlide.content);
      }
    });
  }

  onContentDestroy({content}) {
    if (isVideoContent(content)) {
      if (content._videoPosterImg) {
        content._videoPosterImg.onload = content._videoPosterImg.onerror = null;
        content._videoPosterImg = null;
      }
    }
  }

  onContentResize(e) {
    if (isVideoContent(e.content)) {
      e.preventDefault();

      const width = e.width;
      const height = e.height;
      const content = e.content;

      if (content.element) {
        content.element.style.width = width + 'px';
        content.element.style.height = height + 'px';
      }

      if (content.slide && content.slide.placeholder) {
        // override placeholder size, so it more accurately matches the video
        const placeholderElStyle = content.slide.placeholder.element.style;
        placeholderElStyle.transform = 'none';
        placeholderElStyle.width = width + 'px';
        placeholderElStyle.height = height + 'px';
      }
    }
  }

  isKeepingPlaceholder(isZoomable, content) {
    if (isVideoContent(content)) {
      return false;
    }
    return isZoomable;
  }

  isContentZoomable(isZoomable, content) {
    if (isVideoContent(content)) {
      return false;
    }
    return isZoomable;
  }

  onContentActivate({content}) {
    if (isVideoContent(content) && this.options.autoplay) {
      this.playVideo(content);
    }
  }

  onContentDeactivate({content}) {
    if (isVideoContent(content)) {
      this.pauseVideo(content);
    }
  }

  onContentAppend(e) {
    if (isVideoContent(e.content)) {
      e.preventDefault();
      e.content.isAttached = true;
      e.content.appendImage();
    }
  }

  onContentLoad(e) {
    const content = e.content; // todo: videocontent

    if (!isVideoContent(e.content)) {
      return;
    }

    // stop default content load
    e.preventDefault();

    if (content.element) {
      return;
    }

    content.state = 'loading';
    content.type = 'video'; // TODO: move this to pswp core?

    content.element = document.createElement('video');

    if (this.options.videoAttributes) {
      for (let key in this.options.videoAttributes) {
        content.element.setAttribute(key, this.options.videoAttributes[key] || '');
      }
    }

    content.element.setAttribute('poster', content.data.msrc);

    this.preloadVideoPoster(content, content.data.msrc);

    content.element.style.position = 'absolute';
    content.element.style.left = 0;
    content.element.style.top = 0;

    if (content.data.videoSources) {
      content.data.videoSources.forEach((source) => {
        let sourceEl = document.createElement('source');
        sourceEl.src = source.src;
        sourceEl.type = source.type;
        content.element.appendChild(sourceEl);
      });
    } else if (content.data.videoSrc) {
      // Force video preload
      // https://muffinman.io/blog/hack-for-ios-safari-to-display-html-video-thumbnail/
      // this.element.src = this.data.videoSrc + '#t=0.001';
      content.element.src = content.data.videoSrc;
    }
  }

  preloadVideoPoster(content, src) {
    if (!content._videoPosterImg && src) {
      content._videoPosterImg = new Image();
      content._videoPosterImg.src = src;
      if (content._videoPosterImg.complete) {
        content.onLoaded();
      } else {
        content._videoPosterImg.onload = content._videoPosterImg.onerror = () => {
          content.onLoaded();
        };
      }
    }
  }

  playVideo(content) {
    if (content.element) {
      content.element.play();
    }
  }

  pauseVideo(content) {
    if (content.element) {
      content.element.pause();
    }
  }

  useContentPlaceholder(usePlaceholder, content) {
    if (isVideoContent(content)) {
      return true;
    }
    return usePlaceholder;
  }
}

class PhotoSwipeVideoPlugin {
  constructor(lightbox, options) {
    new VideoContentSetup(lightbox, {
      ...defaultOptions,
      ...options,
    });
  }
}

/**
 * Photoswipe plugin for Alpine.js
 *
 * Adds PhotoSwipe lightbox functionality to Alpine.js applications.
 *
 * Usage:
 * - x-photoswipe: Root directive that initializes PhotoSwipe
 * - x-photoswipe:image: Marks an image to be included in the lightbox
 * - x-photoswipe:video: Marks an video to be included in the lightbox
 * - x-photoswipe:button: Creates a button to open the lightbox
 * - x-photoswipe:counter: Template for the slide counter
 *
 * Example:
 * ```html
 * <div x-photoswipe>
 *   <img x-photoswipe:image src="image.jpg" width="600" height="400" alt="My Image">
 *   <button x-photoswipe:button>Open Lightbox</button>
 *   <template x-photoswipe:counter>
 *     <div><span x-text="currentIndex + 1"></span> of <span x-text="totalSlides"></span></div>
 *   </template>
 * </div>
 * ```
 */
function photoSwipe(defaultConfig = {}) {
  return function (Alpine) {
    Alpine.directive('photoswipe', ($el, data, utilities) => {
      if (!isHtmlElement($el)) {
        throw new Error(`Expected HTMLElement but got ${$el}`);
      }
      if (data.value === 'data') {
        handleData($el, Alpine);
      } else if (data.value === 'button') {
        handleButton($el, Alpine, data, utilities);
      } else if (data.value === 'counter') {
        handleCounter($el, Alpine, data);
      } else if (data.value === null) {
        handleRoot$2($el, Alpine, data, utilities, defaultConfig);
      } else {
        throw new Error(`Unknown directive: x-photoswipe:${data.value}`);
      }
    }).before('bind');
    Alpine.magic('photoswipe', ($el) => {
      const $data = Alpine.$data($el);
      return $data.__photoswipe_lightbox;
    });
  };
}
function handleCounter($el, Alpine, {expression}) {
  if (!isTemplateElement($el)) {
    throw new Error(`Expected TemplateElement but got ${$el}`);
  }
  Alpine.bind($el, {
    'x-init'() {
      this.__photoswipe_counterEl = $el.content.firstElementChild;
    },
  });
}
function handleData($el, Alpine) {
  if ($el.nodeName !== 'SCRIPT') {
    throw new Error('x-photoswipe:data can only be used on script tags');
  }
  Alpine.bind($el, {
    'x-init'() {
      this.$nextTick(() => {
        var _a, _b;
        if (!this.__photoswipe_lightbox) return;
        if (((_a = $el.textContent) === null || _a === void 0 ? void 0 : _a.trim()) == '') {
          return;
        }
        let json;
        try {
          json = JSON.parse($el.textContent || '{}');
        } catch (e) {
          throw new Error(`Could not parse ${$el.textContent} as JSON: ${e}`);
        }
        if (isPlainObject(json)) {
          ((_b = this.$data.__photoswipe_lightbox) === null || _b === void 0 ? void 0 : _b.options.dataSource).push(
            json,
          );
        } else {
          console.warn('x-photoswipe:data expected an object but got', json);
        }
      });
    },
  });
}
function handleButton($el, Alpine, {expression}, {evaluateLater}) {
  const indexFn = expression ? evaluateLater(expression) : null;
  if (!indexFn) {
    throw new Error(`x-photoswipe:button requires an index`);
  }
  Alpine.bind($el, {
    '@click.stop.prevent'() {
      indexFn((index) => {
        if (!isNaN(index)) {
          this.$data.__photoswipe_loadAndOpen(index);
        } else {
          throw new Error(`x-photoswipe:button requires an index but received ${index}`);
        }
      });
    },
  });
}
function handleRoot$2($el, Alpine, {expression}, {evaluate}, defaultConfig) {
  Alpine.bind($el, {
    'x-data'() {
      return {
        __photoswipe_lightbox: null,
        __photoswipe_buttonHeight: 0,
        __photoswipe_counterHeight: 0,
        __photoswipe_counterEl: null,
        init() {
          const instanceConfig = expression ? evaluate(expression) : {};
          const config = Object.assign(Object.assign({}, defaultConfig), instanceConfig);
          this.__photoswipe_lightbox = new PhotoSwipeLightbox(Object.assign({dataSource: []}, config));
          this.__photoswipe_lightbox.addFilter('uiElement', (element, data) => {
            if (!this.__photoswipe_lightbox) return element;
            if (data.name === 'counter') {
              if (!this.__photoswipe_counterEl) return element;
              const pswp = this.__photoswipe_lightbox.pswp;
              if (!pswp) return element;
              const counterClone = this.__photoswipe_counterEl.cloneNode(true);
              const counterScope = Alpine.reactive({
                currentIndex: pswp.currIndex,
                totalSlides: pswp.getNumItems(),
              });
              Alpine.addScopeToNode(counterClone, counterScope);
              Alpine.initTree(counterClone);
              this.__photoswipe_lightbox.on('change', () => {
                counterScope.currentIndex = pswp.currIndex;
                element.replaceChildren(counterClone);
              });
            }
            return element;
          });
          new PhotoSwipeVideoPlugin(this.__photoswipe_lightbox);
          Alpine.mutateDom(() => {
            var _a;
            (_a = this.__photoswipe_lightbox) === null || _a === void 0 ? void 0 : _a.init();
          });
        },
        __photoswipe_loadAndOpen(index, dataSource, initialPoint) {
          let result = false;
          Alpine.mutateDom(() => {
            result = this.__photoswipe_lightbox.loadAndOpen(index, dataSource, initialPoint);
          });
          return result;
        },
        destroy() {
          Alpine.mutateDom(() => {
            var _a;
            (_a = this.__photoswipe_lightbox) === null || _a === void 0 ? void 0 : _a.destroy();
            this.__photoswipe_lightbox = null;
          });
        },
      };
    },
  });
}

/**
 * Plugin to create a custom cursor that snaps to snap points on mouse enter and unsnap on mouse leave.
 *
 * Inspired by https://medium.com/14islands/developing-a-performant-custom-cursor-89f1688a02eb
 *
 * @example
 *
 * ```
 * <div x-custom-cursor class="absolute inset-[100px] bg-[grey]">
 *   <div x-custom-cursor:element data-test-id="cursor-element" class="absolute w-5 h-5 bg-red-500 z-10 translate-x-[--cursor-x] translate-y-[--cursor-y]"></div>
 *   <div x-custom-cursor:snap-point class="absolute top-1/2 left-1/2 w-[50px] h-[50px] bg-blue-500 z-0"></div>
 * </div>
 * ```
 */
function customCursor(Alpine) {
  Alpine.directive('custom-cursor', ($el, data) => {
    if (data.value === 'element') {
      handleElement($el, Alpine, data);
    } else if (data.value === 'snap-point') {
      handleSnapPoint($el, Alpine);
    } else if (data.value === null) {
      handleRoot$1($el, Alpine);
    } else {
      throw new Error(`Unknown directive: x-custom-cursor:${data.value}`);
    }
  }).before('bind');
  Alpine.magic('customCursor', ($el) => {
    const $data = Alpine.$data($el);
    return {
      get isSnapped() {
        return $data.__customCursor_isSnapped;
      },
      get isActive() {
        return $data.__customCursor_isActive;
      },
      get targetPosition() {
        return $data.__customCursor_targetPosition;
      },
      snap(el) {
        $data.__customCursor_setCurrentSnapPoint(el);
      },
      unsnap() {
        $data.__customCursor_unsetCurrentSnapPoint();
      },
    };
  });
}
function handleElement($el, Alpine, data) {
  let cursorSpeed = 0.5;
  if (data.modifiers.includes('speed')) {
    const rawValue = data.modifiers[data.modifiers.indexOf('speed') + 1];
    let match = rawValue.match(/([0-9]+)%/);
    // Match percentage and clamp between 0% and 100%
    if (match) cursorSpeed = Math.max(Math.min(Number(match[1]) / 100, 1), 0);
  }
  Alpine.bind($el, {
    'aria-hidden': 'true',
    'x-data'() {
      return {
        __customCursor_cursorEl_cursorPosition: null,
        __customCursor_cursorEl_rAF: null,
        __customCursor_cursorEl_dimensions: null,
        init() {
          this.$nextTick(() => {
            this.__customCursor_cursorEl_dimensions = {width: this.$el.clientWidth, height: this.$el.clientHeight};
            this.$watch('__customCursor_targetPosition', (targetPosition, previousTargetPosition) => {
              if (targetPosition != null && previousTargetPosition != null) {
                if (targetPosition.x != previousTargetPosition.x || targetPosition.y != previousTargetPosition.y) {
                  if (!this.__customCursor_cursorEl_rAF) {
                    this.__customCursor_cursorEl_rAF = requestAnimationFrame(
                      this.__customCursor_cursorEl_updatePosition.bind(this),
                    );
                  }
                }
              } else if (targetPosition != null) {
                this.__customCursor_cursorEl_cursorPosition = targetPosition;
              } else {
                this.__customCursor_cursorEl_stopUpdatingPosition();
              }
            });
            this.$watch('__customCursor_isActive', (isActive, wasActive) => {
              if (!isActive && wasActive) {
                this.__customCursor_cursorEl_stopUpdatingPosition();
              }
            });
          });
        },
        destroy() {
          this.__customCursor_cursorEl_stopUpdatingPosition();
        },
        __customCursor_cursorEl_stopUpdatingPosition() {
          if (this.__customCursor_cursorEl_rAF) {
            cancelAnimationFrame(this.__customCursor_cursorEl_rAF);
            this.__customCursor_cursorEl_rAF = null;
          }
        },
        __customCursor_cursorEl_updatePosition() {
          const targetPosition = this.$data.__customCursor_targetPosition;
          if (targetPosition == null) return;
          // Prevent throwing an error when the cursor is not yet initialized
          if (this.__customCursor_cursorEl_cursorPosition == null) {
            this.__customCursor_cursorEl_cursorPosition = targetPosition;
          }
          const {x: cursorX, y: cursorY} = this.__customCursor_cursorEl_cursorPosition;
          const {x: targetX, y: targetY} = targetPosition;
          const cursorNewX = lerp(cursorX, targetX, cursorSpeed);
          const cursorNewY = lerp(cursorY, targetY, cursorSpeed);
          const newPosition = buildPosition(cursorNewX, cursorNewY);
          const delta = Math.sqrt(Math.pow(targetX - cursorX, 2) + Math.pow(targetY - cursorY, 2));
          // Stop updating position if delta is too small
          if (delta < 0.001) {
            this.__customCursor_cursorEl_stopUpdatingPosition();
            return;
          }
          this.__customCursor_cursorEl_cursorPosition = newPosition;
          this.__customCursor_cursorEl_rAF = requestAnimationFrame(
            this.__customCursor_cursorEl_updatePosition.bind(this),
          );
        },
      };
    },
    ':style'() {
      if (
        this.__customCursor_cursorEl_cursorPosition == null ||
        this.__customCursor_cursorEl_dimensions == null ||
        !this.$data.__customCursor_isActive
      ) {
        return {
          contain: 'layout',
          visibility: 'hidden',
        };
      }
      const {x, y} = this.__customCursor_cursorEl_cursorPosition;
      const {width, height} = this.__customCursor_cursorEl_dimensions;
      return {
        transformOrigin: '50% 50% 0',
        contain: 'layout',
        'will-change': 'transform',
        transform: `translate3d(${x - width / 2}px, ${y - height / 2}px, 0)`,
      };
    },
  });
}
function handleSnapPoint($el, Alpine) {
  // Bail early if we're not inside of x-custom-cursor
  if (!Alpine.$data($el).__customCursor_rootEl) return;
  Alpine.bind($el, {
    'x-data'() {
      return {
        __customCursor_snapPoint_handleMouseEnter() {
          this.$data.__customCursor_setCurrentSnapPoint(this.$el);
        },
        __customCursor_snapPoint_handleMouseLeave() {
          this.$data.__customCursor_unsetCurrentSnapPoint();
        },
      };
    },
    'x-hover:start': '__customCursor_snapPoint_handleMouseEnter',
    'x-hover:end': '__customCursor_snapPoint_handleMouseLeave',
  });
}
function buildPosition(x, y) {
  return {
    x,
    y,
  };
}
function handleRoot$1($el, Alpine, data) {
  Alpine.bind($el, {
    'x-data'() {
      return {
        __customCursor_rootEl: $el,
        __customCursor_isActive: false,
        __customCursor_cursorEl: null,
        __customCursor_cursorEl_dimensions: null,
        __customCursor_currentSnapPointEl: null,
        __customCursor_currentSnapPointRect: null,
        __customCursor_targetPosition: null,
        __customCursor_setCurrentSnapPoint(el) {
          const {x, y, width, height} = el.getBoundingClientRect();
          this.__customCursor_currentSnapPointEl = el;
          this.__customCursor_currentSnapPointRect = {x, y, width, height};
        },
        __customCursor_unsetCurrentSnapPoint() {
          this.__customCursor_currentSnapPointEl = null;
          this.__customCursor_currentSnapPointRect = null;
        },
        __customCursor_handleMouseEnter(e) {
          this.__customCursor_targetPosition = buildPosition(e.clientX, e.clientY);
        },
        __customCursor_handleMouseMove(e) {
          this.__customCursor_isActive = true;
          if (this.__customCursor_currentSnapPointEl) {
            const {x: snapX, y: snapY, width: snapWidth, height: snapHeight} = this.__customCursor_currentSnapPointRect;
            const snapPosition = {
              x: snapX + snapWidth / 2,
              y: snapY + snapHeight / 2,
            };
            this.__customCursor_targetPosition = snapPosition;
          } else {
            this.__customCursor_targetPosition = buildPosition(e.clientX, e.clientY);
          }
        },
        __customCursor_handleMouseLeave(e) {
          this.__customCursor_isActive = false;
          this.__customCursor_currentSnapPointEl = null;
          this.__customCursor_targetPosition = null;
        },
        get __customCursor_isSnapped() {
          return !!this.__customCursor_currentSnapPointEl;
        },
      };
    },
    '@mouseenter': '__customCursor_handleMouseEnter',
    '@mouseleave': '__customCursor_handleMouseLeave',
    '@mousemove.throttle.16ms': '__customCursor_handleMouseMove',
  });
}
// TODO replace with motion
/**
 * Linear interpolation between two values.
 *
 * @param a - The starting value.
 * @param b - The ending value.
 * @param n - The interpolation factor.
 * @returns The interpolated value.
 */
const lerp = (a, b, n) => (1 - n) * a + n * b;

const DEFAULT_SPEED = 60; // px/s
const DEFAULT_ATTRIBUTE_BLACKLIST = ['id'];
/**
 * This plugin provides a smoothly scrolling marquee effect by creating duplicates of items in a
 * “source” element and placing them into a matching “target” container. As the original content
 * scrolls away, the duplicated set seamlessly appears, forming an infinite loop that prevents any
 * abrupt restart.
 *
 * Inspired by: https://ryanmulligan.dev/blog/css-marquee/
 *
 * Modifiers:
 *  - speed.X: Adjusts the scrolling pace (e.g., speed.60 sets 60px per second). Negative value scrolls backwards
 *  - fill: Ensures content is repeated and appended until the visual area is completely covered.
 *  - pause: Begins the marquee in a paused state, requiring a play action to begin moving.
 *
 * General usage:
 *  1. Mark the scrolled content with x-marquee:source.
 *  2. Provide an empty container with x-marquee:target, to receive the duplicated set of items.
 *  3. Attach x-marquee to a parent element with optional modifiers like speed.X, fill, or pause.
 *
 * Programmatic control is available through $marquee, enabling methods like play, pause, or toggle
 * at any time.
 *
 * @example
 *   <div x-data x-marquee.speed.60.fill>
 *     <div x-marquee:source>
 *       <span>First Item</span>
 *       <span>Second Item</span>
 *       <span>Third Item</span>
 *     </div>
 *     <div x-marquee:target aria-hidden="true"></div>
 *   </div>
 *
 */
function marquee(Alpine) {
  Alpine.directive('marquee', ($el, {value, modifiers}) => {
    if (value == 'source') {
      Alpine.bind($el, {
        'x-init': '__marquee_sourceEl = $el',
      });
    } else if (value == 'target') {
      Alpine.bind($el, {
        'x-init': '__marquee_targetEl = $el',
      });
    } else if (value == null) {
      let speed = DEFAULT_SPEED;
      let fill = modifiers.includes('fill');
      let autoplay = !modifiers.includes('pause');
      if (modifiers.includes('speed')) {
        speed = Number(modifiers[modifiers.indexOf('speed') + 1]);
      }
      Alpine.bind($el, {
        'x-data'() {
          return {
            __marquee_state: buildMarqueeState({isPlaying: autoplay}),
            __marquee_isInitialized: false,
            __marquee_isActive: false,
            __marquee_isRendering: false,
            __marquee_sourceEl: null,
            __marquee_targetEl: null,
            __marquee_originalContentFragment: document.createDocumentFragment(),
            __marquee_originalContentWidth: 0,
            __marquee_sourceElWidth: 0,
            __marquee_viewportWidth: 0,
            __marquee_sourceAnimation: null,
            __marquee_targetAnimation: null,
            __marquee_sentinel: null,
            __marquee_cancelInView: null,
            get __marquee_animationDuration() {
              return (this.__marquee_sourceElWidth / Math.abs(speed)) * 1000;
            },
            /**
             * Clones source el children until source element width is gte to viewport width
             */
            __marquee_fillSource() {
              return new Promise((resolve) => {
                // When the marquee does not have width, i.e. it was initially hidden
                if (this.__marquee_originalContentWidth === 0) {
                  // Measure the width of the original content so we know later how many times to clone it
                  this.__marquee_originalContentWidth = this.__marquee_sourceEl.clientWidth;
                  this.__marquee_sourceElWidth = this.__marquee_originalContentWidth;
                }
                // If we haven't yet added our sentinel, do it now:
                Alpine.mutateDom(() => {
                  if (!this.__marquee_sentinel) {
                    // Use a comment node or any other marker
                    this.__marquee_sentinel = document.createComment('marquee-sentinel');
                    this.__marquee_sourceEl.appendChild(this.__marquee_sentinel);
                  } else {
                    // Remove all nodes after the sentinel, so we don't stack infinite clones when re-rendering
                    let next = this.__marquee_sentinel.nextSibling;
                    while (next) {
                      const toRemove = next;
                      next = next.nextSibling;
                      this.__marquee_sourceEl.removeChild(toRemove);
                    }
                    // Update the original content width in case screen size has changed it or something
                    this.__marquee_originalContentWidth = this.__marquee_sourceEl.clientWidth;
                    // Update the source element width to match the original content width now that we've removed clones
                    this.__marquee_sourceElWidth = this.__marquee_originalContentWidth;
                  }
                });
                const spaceToFill = Math.max(0, this.__marquee_viewportWidth - this.__marquee_originalContentWidth);
                if (spaceToFill === 0) return resolve();
                // Count how many times we need to clone the original content to fill the screen
                const timesToClone = Math.ceil(spaceToFill / this.__marquee_originalContentWidth);
                // Clone the original content until the animation wrapper fills the screen
                const fragment = document.createDocumentFragment();
                for (let i = 0; i < timesToClone; i++) {
                  const clone = this.__marquee_originalContentFragment.cloneNode(true);
                  fragment.appendChild(clone);
                }
                Alpine.mutateDom(() => {
                  // Insert the new clones after our sentinel:
                  this.__marquee_sentinel.after(fragment);
                  Alpine.skipDuringClone(() => Alpine.initTree(this.__marquee_sourceEl))();
                  // Wait until next paint to measure the new width of the source element so we don't cause a reflow
                  window.requestAnimationFrame(() => {
                    this.__marquee_sourceElWidth = this.__marquee_sourceEl.clientWidth;
                    resolve();
                  });
                });
              });
            },
            __marquee_cloneSourceToTarget() {
              return new Promise((resolve) => {
                // If the content is smaller than the viewport, don't duplicate the content because we're not
                if (this.__marquee_sourceElWidth < this.__marquee_viewportWidth) {
                  return resolve();
                }
                Alpine.mutateDom(() => {
                  // Clone the nodes from the source to the target
                  const clone = this.__marquee_sourceEl.cloneNode(true);
                  this.__marquee_targetEl.replaceChildren(...clone.children);
                  // Re-initialize alpine on cloned nodes
                  Alpine.skipDuringClone(() => Alpine.initTree(this.__marquee_targetEl))();
                  resolve();
                });
              });
            },
            __marquee_setupAnimations() {
              var _a, _b;
              const animationDirection = speed < 0 ? 'reverse' : 'normal';
              const animationDurationInMs = this.__marquee_animationDuration;
              const keyframes = [{transform: `translateX(0%)`}, {transform: `translateX(-100%)`}];
              const animationOptions = {
                duration: animationDurationInMs,
                iterations: Infinity,
                direction: animationDirection,
              };
              if (this.__marquee_sourceAnimation == null) {
                let sourceAnimation = new Animation(
                  new KeyframeEffect(this.__marquee_sourceEl, keyframes, animationOptions),
                );
                this.__marquee_sourceAnimation = sourceAnimation;
              } else {
                (_a = this.__marquee_sourceAnimation.effect) === null || _a === void 0
                  ? void 0
                  : _a.updateTiming({
                      duration: animationDurationInMs,
                    });
              }
              if (this.__marquee_targetAnimation == null) {
                let targetAnimation = new Animation(
                  new KeyframeEffect(this.__marquee_targetEl, keyframes, animationOptions),
                );
                targetAnimation.startTime = this.__marquee_sourceAnimation.startTime;
                targetAnimation.currentTime = this.__marquee_sourceAnimation.currentTime;
                this.__marquee_targetAnimation = targetAnimation;
              } else {
                (_b = this.__marquee_targetAnimation.effect) === null || _b === void 0
                  ? void 0
                  : _b.updateTiming({
                      duration: animationDurationInMs,
                    });
              }
              if (this.__marquee_state.isPlaying && this.__marquee_sourceElWidth >= this.__marquee_viewportWidth) {
                this.__marquee_sourceAnimation.play();
                this.__marquee_targetAnimation.play();
              }
            },
            __marquee_scrollTo(element) {
              var _a, _b;
              if (!isFinite(this.__marquee_animationDuration)) return;
              let offset = element.offsetLeft;
              let leftSpacingBuffer = 24; // (px) To allow for the focus outline to be fully visible when tabbed through
              // When the animation is reversed
              if (
                ((_b = (_a = this.__marquee_sourceAnimation) === null || _a === void 0 ? void 0 : _a.effect) === null ||
                _b === void 0
                  ? void 0
                  : _b.getComputedTiming().direction) === 'reverse'
              ) {
                offset = this.__marquee_sourceElWidth - offset;
                leftSpacingBuffer = leftSpacingBuffer * -1;
              }
              const elementPositionPercentage = (offset - leftSpacingBuffer) / this.__marquee_sourceElWidth;
              const elementPositionTime = elementPositionPercentage * this.__marquee_animationDuration;
              if (isFinite(elementPositionTime)) {
                // Update animation timing to match the timing position of the selected element
                this.__marquee_targetAnimation.currentTime = elementPositionTime;
                this.__marquee_sourceAnimation.currentTime = elementPositionTime;
              }
            },
            async __marquee_render() {
              var _a;
              if (!this.__marquee_isActive) return;
              if (this.__marquee_isRendering) return;
              try {
                this.__marquee_isRendering = true;
                if (fill) {
                  await this.__marquee_fillSource();
                }
                await this.__marquee_cloneSourceToTarget();
                // Prevent cloned "target" items from being focused by keyboard users
                focusable(this.__marquee_targetEl).forEach((element) => element.setAttribute('tabindex', '-1'));
                // Prevent cloned "source" items from being focused by keyboard users
                const sentinelNextSibling =
                  (_a = this.__marquee_sentinel) === null || _a === void 0 ? void 0 : _a.nextSibling;
                if (sentinelNextSibling) {
                  const sourceChildren = [...this.__marquee_sourceEl.children];
                  const clonedSourceChildren = sourceChildren.splice(sourceChildren.indexOf(sentinelNextSibling));
                  clonedSourceChildren.forEach((child) => {
                    child.setAttribute('aria-hidden', 'true');
                    if (isFocusable(child)) {
                      child.setAttribute('tabindex', '-1');
                    }
                  });
                }
                // Don't animate if in reduced motion mode
                if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                  // Setup animations after the content has been cloned in order to measure the width of the content element without causing reflow
                  this.__marquee_setupAnimations();
                }
                this.__marquee_isInitialized = true;
                window.requestAnimationFrame(() => {
                  this.__marquee_isRendering = false;
                });
              } finally {
                this.__marquee_isRendering = false;
              }
            },
            __marquee_teardown() {
              var _a, _b, _c, _d;
              // Pause and cancel any running animations
              (_a = this.__marquee_sourceAnimation) === null || _a === void 0 ? void 0 : _a.pause();
              (_b = this.__marquee_targetAnimation) === null || _b === void 0 ? void 0 : _b.pause();
              (_c = this.__marquee_sourceAnimation) === null || _c === void 0 ? void 0 : _c.cancel();
              (_d = this.__marquee_targetAnimation) === null || _d === void 0 ? void 0 : _d.cancel();
              this.__marquee_sourceAnimation = null;
              this.__marquee_targetAnimation = null;
              this.__marquee_isInitialized = false;
            },
            init() {
              this.$nextTick(() => {
                if (this.__marquee_sourceEl == null) {
                  throw new Error(
                    'Source element not found, x-marquee:source must be applied to a child element of the x-marquee directive',
                  );
                }
                if (this.__marquee_targetEl == null) {
                  throw new Error(
                    'Target element not found, x-marquee:target must be applied to a child element of the x-marquee directive',
                  );
                }
                this.__marquee_targetEl.setAttribute('aria-hidden', 'true');
                // Clone the contents of the animation wrapper so we can clone it until the animation wrapper fills the screen
                Array.from(this.__marquee_sourceEl.children).forEach((element) => {
                  const clone = element.cloneNode(true);
                  for (const blacklistedAttribute of DEFAULT_ATTRIBUTE_BLACKLIST) {
                    clone.removeAttribute(blacklistedAttribute);
                  }
                  this.__marquee_originalContentFragment.append(clone);
                });
                // Measure the width of the original content so we know later how many times to clone it
                this.__marquee_originalContentWidth = this.__marquee_sourceEl.clientWidth;
                this.__marquee_sourceElWidth = this.__marquee_originalContentWidth;
                this.__marquee_viewportWidth = this.$el.clientWidth;
                // Start/stop when in view similar to parallax
                this.__marquee_cancelInView = inView(this.$el, () => {
                  this.__marquee_isActive = true;
                  window.requestAnimationFrame(() => {
                    this.__marquee_render();
                  });
                  return () => {
                    this.__marquee_isActive = false;
                    this.__marquee_teardown();
                  };
                });
              });
              this.$watch('__marquee_state.isPlaying', (playing) => {
                var _a, _b, _c, _d;
                if (playing) {
                  (_a = this.__marquee_sourceAnimation) === null || _a === void 0 ? void 0 : _a.play();
                  (_b = this.__marquee_targetAnimation) === null || _b === void 0 ? void 0 : _b.play();
                } else {
                  (_c = this.__marquee_sourceAnimation) === null || _c === void 0 ? void 0 : _c.pause();
                  (_d = this.__marquee_targetAnimation) === null || _d === void 0 ? void 0 : _d.pause();
                }
              });
            },
            destroy() {
              var _a, _b, _c, _d, _e;
              (_a = this.__marquee_cancelInView) === null || _a === void 0 ? void 0 : _a.call(this);
              (_b = this.__marquee_sourceEl) === null || _b === void 0
                ? void 0
                : _b.replaceChildren(this.__marquee_originalContentFragment);
              this.__marquee_originalContentFragment = document.createDocumentFragment();
              (_c = this.__marquee_sentinel) === null || _c === void 0 ? void 0 : _c.remove();
              (_d = this.__marquee_sourceAnimation) === null || _d === void 0 ? void 0 : _d.cancel();
              (_e = this.__marquee_targetAnimation) === null || _e === void 0 ? void 0 : _e.cancel();
              this.__marquee_sourceAnimation = null;
              this.__marquee_targetAnimation = null;
            },
          };
        },
        'x-resize.document'() {
          this.__marquee_viewportWidth = this.$el.clientWidth;
          this.__marquee_render();
        },
      });
    } else {
      throw new Error(`Unknown directive: x-marquee:${value}`);
    }
  }).before('bind');
  Alpine.magic('marquee', ($el) => {
    const $data = Alpine.$data($el);
    return {
      get isPlaying() {
        var _a;
        return (_a = $data.__marquee_state) === null || _a === void 0 ? void 0 : _a.isPlaying;
      },
      play() {
        var _a;
        (_a = $data.__marquee_state) === null || _a === void 0 ? void 0 : _a.play();
      },
      pause() {
        var _a;
        (_a = $data.__marquee_state) === null || _a === void 0 ? void 0 : _a.pause();
      },
      toggle() {
        var _a;
        (_a = $data.__marquee_state) === null || _a === void 0 ? void 0 : _a.toggle();
      },
      scrollTo(element) {
        var _a;
        (_a = $data.__marquee_scrollTo) === null || _a === void 0 ? void 0 : _a.call($data, element);
      },
      get isReady() {
        return $data.__marquee_isInitialized;
      },
    };
  });
}
function buildMarqueeState(options) {
  var _a;
  return {
    isPlaying:
      (_a = options === null || options === void 0 ? void 0 : options.isPlaying) !== null && _a !== void 0 ? _a : false,
    play() {
      this.isPlaying = true;
    },
    pause() {
      this.isPlaying = false;
    },
    toggle() {
      this.isPlaying = !this.isPlaying;
    },
  };
}

// Animation helpers
function sliderReveal(Alpine) {
  Alpine.directive('slider-reveal', ($el, data) => {
    if (data.value == 'handle') {
      handleHandle($el, Alpine);
    } else if (data.value == 'reveal') {
      handleReveal($el, Alpine);
    } else if (data.value == null) {
      handleRoot($el, Alpine, data);
    } else {
      throw new Error(`Unknown directive: x-slider-reveal:${data.value}`);
    }
  }).before('bind');
  Alpine.magic('sliderReveal', handleSliderRevealMagic(Alpine));
}
function handleHandle($el, Alpine, _data) {
  Alpine.bind($el, {
    'x-init': '__sliderReveal_handle = $el',
  });
}
function handleReveal($el, Alpine, _data) {
  Alpine.bind($el, {
    'x-init': '__sliderReveal_reveal = $el',
  });
}
function handleRoot($el, Alpine, data) {
  const orientation = data.modifiers.includes('vertical') ? 'vertical' : 'horizontal';
  let initialProgress = 0;
  if (data.modifiers.includes('initial')) {
    initialProgress = Number(data.modifiers[data.modifiers.indexOf('initial') + 1]);
  }
  if (data.modifiers.includes('progress')) {
    const rawValue = data.modifiers[data.modifiers.indexOf('progress') + 1];
    if (!rawValue) {
      throw new Error('x-slider-reveal.progress requires a value (e.g. x-slider-reveal.progress.50%)');
    }
    // Support x-slider-reveal.progress.50% which will set the initial progress to 50%
    let match = rawValue.match(/([0-9]+)%/);
    if (match) initialProgress = Number(match[1]);
  }
  const progressToPercent = transform([0, 100], ['0%', '100%']);
  Alpine.bind($el, {
    'x-data'() {
      return {
        __sliderReveal_progressMotionValue: reactiveMotionValue(Alpine, initialProgress),
        __sliderReveal_handle: null,
        __sliderReveal_reveal: null,
        __sliderReveal_scrollAnimationFn: null,
        init() {
          this.$nextTick(() => {
            // Update elements with initial progress
            this.__sliderReveal_updateElements(initialProgress);
            // Update elements on progress change
            this.__sliderReveal_progressMotionValue.on('change', this.__sliderReveal_updateElements.bind(this));
          });
        },
        __enableScroll() {
          if (this.__sliderReveal_scrollAnimationFn) return;
          this.__sliderReveal_scrollAnimationFn = scroll(
            (scrollProgress) => {
              const currentProgress = this.__sliderReveal_progressMotionValue.get();
              let lowerBound = Math.max(0, currentProgress - 15);
              let upperBound = Math.min(100, currentProgress + 15);
              const scrollToProgress = transform([0.0, 1.0], [0, 100]);
              const progressToBoundedProgress = transform([0, 100], [lowerBound, upperBound]);
              const normalizedScrollProgress = scrollToProgress(scrollProgress);
              const boundedNewProgress = progressToBoundedProgress(normalizedScrollProgress);
              this.__sliderReveal_updateElements(boundedNewProgress);
            },
            {
              target: $el,
              offset: ['end start', 'start end'],
            },
          );
        },
        __disableScroll() {
          var _a;
          (_a = this.__sliderReveal_scrollAnimationFn) === null || _a === void 0 ? void 0 : _a.call(this);
          this.__sliderReveal_scrollAnimationFn = null;
        },
        __sliderReveal_updateElements(progress) {
          const percentProgress = progressToPercent(progress);
          if (orientation === 'vertical') {
            if (this.__sliderReveal_handle) {
              if (document.dir == 'rtl') {
                this.__sliderReveal_handle.style.transform = `translateY(-${percentProgress})`;
                this.__sliderReveal_reveal.style.clipPath = `inset(0% 0% ${percentProgress} 0%)`;
              } else {
                this.__sliderReveal_handle.style.transform = `translateY(${percentProgress})`;
                this.__sliderReveal_reveal.style.clipPath = `inset(${percentProgress} 0% 0% 0%)`;
              }
            }
          } else {
            if (this.__sliderReveal_handle) {
              if (document.dir == 'rtl') {
                this.__sliderReveal_handle.style.transform = `translateX(-${percentProgress})`;
                this.__sliderReveal_reveal.style.clipPath = `inset(0% ${percentProgress} 0% 0%)`;
              } else {
                this.__sliderReveal_handle.style.transform = `translateX(${percentProgress})`;
                this.__sliderReveal_reveal.style.clipPath = `inset(0% 0% 0% ${percentProgress})`;
              }
            }
          }
        },
      };
    },
  });
}
function handleSliderRevealMagic(Alpine) {
  return function ($el) {
    const $data = Alpine.$data($el);
    return {
      get progressMotionValue() {
        return $data.__sliderReveal_progressMotionValue;
      },
      get progress() {
        return $data.__sliderReveal_progressMotionValue.get();
      },
      set progress(value) {
        $data.__sliderReveal_progressMotionValue.set(value);
      },
      enableScroll() {
        $data.__enableScroll();
      },
      disableScroll() {
        $data.__disableScroll();
      },
    };
  };
}

function utils(Alpine) {
  Alpine.magic('debounce', function () {
    return Alpine.debounce;
  });
  Alpine.magic('throttle', function () {
    return Alpine.throttle;
  });
}

/**
 * Plugin which improves sticky behaviour in column layouts by allowing
 * the shorter column to scroll independently of the taller column. Instead
 * of having to scroll the taller column to see the shorter column, the
 * shorter column will scroll up immediately.
 *
 * @usage
 *
 * To use this plugin simply, create a column layout and add the `x-sticky-scroll` directive to the sticky column
 *
 * @example
 *
 * <div class="flex flex-row">
 *   <div>
 *     ... Very long content..
 *   </div>
 *
 *   <div x-sticky-scroll class="sticky top-0">
 *     ... Short content ...
 *   </div>
 * </div>
 */
function stickyScroll(Alpine) {
  Alpine.directive('sticky-scroll', ($el) => {
    Alpine.bind($el, {
      'x-data'() {
        return {
          __stickyScroll_initialTop: 0,
          __stickyScroll_currentTop: 0,
          __stickyScroll_lastScrollY: 0,
          __stickyScroll_isSticky: false,
          __stickyScroll_canFitInViewport: false,
          __stickyScroll_cancelScrollListener: null,
          __stickyScroll_updateBounds() {
            this.$el.style.removeProperty('top');
            this.__stickyScroll_canFitInViewport = this.$el.clientHeight < window.innerHeight;
            const styles = getComputedStyle(this.$el);
            this.__stickyScroll_initialTop = parseInt(styles.top);
            this.__stickyScroll_isSticky = styles.position == 'sticky';
            this.__stickyScroll_updatePosition();
          },
          __stickyScroll_updatePosition() {
            if (!this.__stickyScroll_isSticky || this.__stickyScroll_canFitInViewport) {
              this.$el.style.removeProperty('top');
              return;
            }
            const bounds = this.$el.getBoundingClientRect();
            const maxScroll = bounds.top + window.scrollY - this.$el.offsetTop + this.__stickyScroll_initialTop;
            const minScroll = this.$el.clientHeight - window.innerHeight;
            const scrollDelta = window.scrollY - this.__stickyScroll_lastScrollY;
            this.__stickyScroll_currentTop = Math.min(
              Math.max(this.__stickyScroll_currentTop - scrollDelta, -minScroll),
              maxScroll,
              this.__stickyScroll_initialTop,
            );
            this.__stickyScroll_lastScrollY = window.scrollY;
            this.$el.style.top = `${Math.round(this.__stickyScroll_currentTop)}px`;
          },
          __stickyScroll_setupScrollListener() {
            var _a;
            (_a = this.__stickyScroll_cancelScrollListener) === null || _a === void 0 ? void 0 : _a.call(this);
            this.__stickyScroll_cancelScrollListener = scroll(this.__stickyScroll_updatePosition.bind(this));
          },
          destroy() {
            var _a;
            (_a = this.__stickyScroll_cancelScrollListener) === null || _a === void 0 ? void 0 : _a.call(this);
          },
        };
      },
      ['x-resize']() {
        this.__stickyScroll_updateBounds();
      },
      ['x-resize.document']() {
        this.__stickyScroll_updateBounds();
      },
      ['x-effect']() {
        var _a;
        // Only setup the scroll listener if the column is not able to fit in the viewport (and thus can be scrolled)
        if (this.__stickyScroll_canFitInViewport) {
          (_a = this.__stickyScroll_cancelScrollListener) === null || _a === void 0 ? void 0 : _a.call(this);
        } else {
          this.__stickyScroll_setupScrollListener();
        }
      },
    });
  });
}

function pan(Alpine) {
  Alpine.directive('pan', ($el, data, {cleanup}) => {
    const panGestureRecognizer = new PanGestureRecognizer($el);
    cleanup(() => {
      panGestureRecognizer.destroy();
    });
  }).before('bind');
}

/**
 * Hijacks cart form submissions and serializes form data and submits to the cart/add.js endpoint instead of a normal HTTP form submission.
 *
 * - Looks for sections marked with data-cart-api-section and adds them in the 'sections' form data parameter so that the theme can update the sections in response to the form submission.
 * - Dispatches a theme:cart:update event with the parsed body of the response.
 *
 * @example
 *
 * ```liquid
 * {% form 'cart', cart, x-cart-form: '' %}
 *   {% for item in cart.items %}
 *     <li>
 *       <span>{{ item.product.title }}</span>
 *       <span>{{ item.quantity }}</span>
 *       <span>{{ item.price | money }}</span>
 *       <input type="number" name="updates[]" value="{{ item.quantity }}">
 *     </li>
 *   {% endfor %}
 *   <button type="submit">Check out</button>
 * {% endform %}
 * ```
 */
function cartForm(Alpine) {
  Alpine.directive('cart-form', ($el, data, utilities) => {
    var _a, _b;
    if (data.value == 'form') {
      handleForm$1($el, Alpine);
    } else if (data.value == 'context') {
      handleContext$1($el, Alpine, data);
    } else {
      const xFormModifiers = data.modifiers.length ? data.modifiers.join('.') : null;
      if (
        !((_b =
          (_a = window === null || window === void 0 ? void 0 : window.theme) === null || _a === void 0
            ? void 0
            : _a.routes) === null || _b === void 0
          ? void 0
          : _b.cartUpdate)
      ) {
        throw new Error('window.theme.routes.cartUpdate is not defined');
      }
      if (!isFormElement($el)) {
        // Handle the case of x-async-form being applied to a parent of a form element
        // In this case we look for a form element child and apply form directive to that
        Alpine.bind($el, {
          [`x-cart-form:context${xFormModifiers ? `.${xFormModifiers}` : ``}`]: '',
        });
        const form = $el.querySelector('form');
        if (form) {
          Alpine.bind(form, {
            [`x-cart-form:form`]: '',
          });
        }
      } else {
        Alpine.bind($el, {
          [`x-cart-form:context${xFormModifiers ? `.${xFormModifiers}` : ``}`]: '',
          [`x-cart-form:form`]: '',
        });
      }
    }
  }).before('bind');
  Alpine.magic('cartForm', handleAsyncFormMagic(Alpine));
}
function handleForm$1($el, Alpine, data, _utilities) {
  Alpine.bind($el, {
    method: 'POST',
  });
}
function handleContext$1($el, Alpine, data, _utilities) {
  const xFormModifiers = data.modifiers.length ? data.modifiers.join('.') : null;
  Alpine.bind($el, {
    [`x-async-form${xFormModifiers ? `.${xFormModifiers}` : ``}`]: () => {
      return (data) => {
        var _a;
        // Gather up all the sections marked with data-cart-api-section and add them in the 'sections' form data parameter
        (_a = data.formData) === null || _a === void 0 ? void 0 : _a.append('sections', getCartApiSections().join(','));
        data.action = `${window.theme.routes.cartUpdate}.js`;
        return submitFormData(data);
      };
    },
    '@form:success'() {
      this.$dispatch('theme:cart:update', this.$event.detail);
    },
  });
}

async function get(init) {
  var _a, _b;
  if (
    !((_b =
      (_a = window === null || window === void 0 ? void 0 : window.theme) === null || _a === void 0
        ? void 0
        : _a.routes) === null || _b === void 0
      ? void 0
      : _b.cart)
  ) {
    throw new Error('window.theme.routes.cart is not defined');
  }
  return fetch(
    `${window.theme.routes.cart}.js`,
    Object.assign(
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
      init,
    ),
  );
}

/**
 * Hijacks cart form submissions and serializes form data and submits to the cart/add.js endpoint instead of a normal HTTP form submission.
 *
 * - Looks for sections marked with data-cart-api-section and adds them in the 'sections' form data parameter so that the theme can update the sections in response to the form submission.
 * - Dispatches a theme:cart:change event with the parsed body of the response.
 *
 * @example W
 *
 * ```liquid
 * {% for item in cart.items %}
 *   <li>
 *     <span>{{ item.product.title }}</span>
 *     <span>{{ item.quantity }}</span>
 *     <span>{{ item.price | money }}</span>
 *     <form x-cart-item>
 *       <input type="number" x-cart-item:quantity name="updates[]" value="{{ item.quantity }}" @input.debounce.500ms="$el.closest('form').requestSubmit()">
 *     </form>
 *   </li>
 * {% endfor %}
 * ```
 *
 * @example Within another form
 *
 * ```liquid
 * {% form 'cart', cart, x-cart-item: '' %}
 *   {% for item in cart.items %}
 *     <li x-cart-item>
 *       <span>{{ item.product.title }}</span>
 *       <span>{{ item.quantity }}</span>
 *       <span>{{ item.price | money }}</span>
 *       <input type="number" x-cart-item:quantity name="updates[]" value="{{ item.quantity }}" @input.debounce.500ms="$cartItem.requestSubmit()">
 *     </li>
 *   {% endfor %}
 *   <button type="submit">Check out</button>
 * {% endform %}
 * ```
 */
function cartItem(Alpine) {
  Alpine.directive('cart-item', ($el, data) => {
    var _a, _b;
    if (data.value == 'form') {
      handleForm($el, Alpine);
    } else if (data.value == 'context') {
      handleContext($el, Alpine, data);
    } else if (data.value == 'quantity') {
      handleQuantityInput($el, Alpine);
    } else {
      const xFormModifiers = data.modifiers.length ? data.modifiers.join('.') : null;
      if (
        !((_b =
          (_a = window === null || window === void 0 ? void 0 : window.theme) === null || _a === void 0
            ? void 0
            : _a.routes) === null || _b === void 0
          ? void 0
          : _b.cartChange)
      ) {
        throw new Error('window.theme.routes.cartChange is not defined');
      }
      if (!isFormElement($el)) {
        // Handle the case of x-async-form being applied to a parent of a form element
        // In this case we look for a form element child and apply form directive to that
        Alpine.bind($el, {
          [`x-cart-item:context${xFormModifiers ? `.${xFormModifiers}` : ``}`]: data.expression,
        });
        const form = $el.querySelector('form');
        if (form) {
          Alpine.bind(form, {
            [`x-cart-item:form`]: '',
          });
        }
      } else {
        Alpine.bind($el, {
          [`x-cart-item:context${xFormModifiers ? `.${xFormModifiers}` : ``}`]: data.expression,
          [`x-cart-item:form`]: '',
        });
      }
    }
  }).before('bind');
  Alpine.magic('cartItem', ($el) => {
    const $data = Alpine.$data($el);
    return mergeProperties(
      {},
      {
        get quantityInputEl() {
          return $data.__cartItem_quantityInput;
        },
        get isRemoving() {
          return $data.__cartItem_isRemoving;
        },
        remove: $data.__cartItem_remove.bind($data),
      },
      handleAsyncFormMagic(Alpine)($el),
    );
  });
}
function handleForm($el, Alpine) {
  Alpine.bind($el, {
    method: 'POST',
  });
}
function handleContext($el, Alpine, data) {
  const xFormModifiers = data.modifiers.length ? data.modifiers.join('.') : null;
  const line = parseInt(data.expression, 10);
  if (isNaN(line)) {
    throw new Error('x-cart-item requires a line number');
  }
  Alpine.bind($el, {
    'x-data'() {
      return {
        __cartItem_quantityInput: null,
        __cartItem_quantity: null,
        get __cartItem_isRemoving() {
          var _a;
          if (this.$asyncForm.state === 'pending') {
            return (
              parseInt((_a = this.$asyncForm.formData) === null || _a === void 0 ? void 0 : _a.get('quantity'), 10) ===
              0
            );
          }
          return this.__cartItem_quantity === 0;
        },
        async __cartItem_remove() {
          const formData = new FormData();
          formData.append('quantity', '0');
          return await this.__asyncForm_submitAsync({formData});
        },
        __cartItem_save(info) {
          const formData = (info === null || info === void 0 ? void 0 : info.formData) || new FormData();
          formData.append('line', line.toString());
          // Gather up all the sections marked with data-cart-api-section and add them in the 'sections' form data parameter
          formData.append('sections', getCartApiSections().join(','));
          if (!formData.has('quantity') && this.__cartItem_quantityInput) {
            formData.append('quantity', this.__cartItem_quantity);
          }
          const changeRequest = submitFormData({
            action: `${window.theme.routes.cartChange}`,
            method: 'POST',
            enctype: 'application/json',
            formData,
          });
          // If the change request is a 422, we need to get the current cart and update the quantity input to the quantity of the item in the cart
          // so that the quantity input has the max quantity available for the item
          if (this.__cartItem_quantityInput) {
            changeRequest.then(async (response) => {
              var _a;
              if ((response === null || response === void 0 ? void 0 : response.status) == 422) {
                // Re-use the same abort controller to get the current cart so that if the user starts changing the quantity input again, the request will be cancelled
                const cartRequestResponse = await get({signal: this.$asyncForm.signal});
                const cartRequestResponseBody = await (cartRequestResponse === null || cartRequestResponse === void 0
                  ? void 0
                  : cartRequestResponse.json());
                const cartItem =
                  (_a =
                    cartRequestResponseBody === null || cartRequestResponseBody === void 0
                      ? void 0
                      : cartRequestResponseBody.items) === null || _a === void 0
                    ? void 0
                    : _a[line - 1];
                if (cartItem) {
                  this.__cartItem_quantity = cartItem.quantity;
                }
              }
            });
          }
          return changeRequest;
        },
      };
    },
    [`x-async-form${xFormModifiers ? `.${xFormModifiers}` : ``}`]: '__cartItem_save',
    '@form:success'() {
      var _a, _b;
      this.__cartItem_quantity = (
        (_a = this.$asyncForm.formData) === null || _a === void 0 ? void 0 : _a.get('quantity')
      )
        ? parseInt(((_b = this.$asyncForm.formData) === null || _b === void 0 ? void 0 : _b.get('quantity')) || '0', 10)
        : null;
      this.$dispatch('theme:cart:change', this.$event.detail);
    },
  });
}
function handleQuantityInput($el, Alpine) {
  if (!isInputNumberElement($el)) {
    throw new Error('Expected <input type="number"> tag for x-cart-item:quantity but got ' + $el);
  }
  Alpine.bind($el, {
    'x-init': '__cartItem_quantityInput = $el',
    '@input.debounce.500ms'() {
      if ($el.checkValidity()) {
        const formData = new FormData();
        formData.append('quantity', $el.value);
        this.$asyncForm.submitAsync({formData});
      }
    },
    'x-model.fill.number': '__cartItem_quantity',
  });
}

// Alpine Data for variant-based product cards
function productCardVariants(productId, initialVariantId) {
  return {
    productId,
    userSelectedVariantId: null,
    autoSelectedVariantId: null,
    previewVariantId: null,
    get variantId() {
      return this.autoSelectedVariantId ?? this.userSelectedVariantId ?? initialVariantId;
    },
    set variantId(variantId) {
      this.userSelectedVariantId = variantId;
    },
    get product() {
      return this.$cache.products.get(this.productId);
    },
    get productCardUrl() {
      return this.displayVariantId ? `${this.product?.url}?variant=${this.displayVariantId}` : this.product?.url;
    },
    get hasSelectedVariant() {
      return this.variantId !== null;
    },
    clearPreviewVariant() {
      this.previewVariantId = null;
    },
    get displayVariantId() {
      return this.previewVariantId ?? this.variantId;
    },
    get hasDisplayVariant() {
      return this.displayVariantId !== null;
    },
    clearVariant() {
      this.userSelectedVariantId = null;
      this.previewVariantId = null;
    },
  };
}
// Alpine Data for sibling-based product cards
function productCardSiblings(productId) {
  return {
    productId,
    previewProductId: null,
    get variantId() {
      return this.product?.selected_or_first_available_variant?.id ?? null;
    },
    get product() {
      return this.$cache.products.get(this.productId);
    },
    get productCardUrl() {
      return this.displayProduct?.url;
    },
    clearPreviewProduct() {
      this.previewProductId = null;
    },
    get displayProductId() {
      return this.previewProductId ?? this.productId;
    },
    get displayProduct() {
      if (this.displayProductId === null) return null;
      return this.$cache.products.get(this.displayProductId) || null;
    },
    get previewProduct() {
      if (this.previewProductId === null) return null;
      return this.$cache.products.get(this.previewProductId) || null;
    },
    get hasDisplayProduct() {
      return this.displayProductId !== null;
    },
  };
}
Alpine.data('productCardVariants', productCardVariants);
Alpine.data('productCardSiblings', productCardSiblings);

/**
 * Magic to read/write/destroy browser cookies
 * @param name
 * @param value
 * @returns
 */
function cookie() {
  const configuration = {
    expires: null,
    path: '/',
    domain: window.location.hostname,
  };
  return {
    write(name, value) {
      document.cookie = `${name}=${value}; expires=${configuration.expires}; path=${configuration.path}; domain=${configuration.domain}`;
    },
    read(name) {
      let cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].split('=');
        if (name == cookie[0].trim()) {
          return decodeURIComponent(cookie[1]);
        }
      }
      return null;
    },
    destroy(name) {
      if (document.cookie.split('; ').find((row) => row.startsWith(name))) {
        document.cookie = `${name}=; Max-Age=0; path=${configuration.path}; domain=${configuration.domain}`;
      }
    },
  };
}
Alpine.magic('cookie', cookie);

function load() {
  return {
    script(url) {
      return new Promise((resolve, reject) => {
        const existingScript = document.querySelector(`script[src="${url}"]`);
        if (existingScript) {
          resolve('Script already exists.');
          return;
        }
        const newScript = document.createElement('script');
        newScript.src = url;
        newScript.async = true;
        newScript.onload = () => resolve('Script loaded successfully.');
        newScript.onerror = () => reject('Failed to load script.');
        document.head.appendChild(newScript);
        return;
      });
    },
  };
}
Alpine.magic('load', load);

Alpine.directive('quick-add-form', ($el) => {
  Alpine.bind($el, {
    'x-product-form.wait-error.2000ms.wait-success.1500ms': '',
  });
});

Alpine.directive('body-scroll', ($el) => {
  Alpine.bind($el, {
    'x-init'() {
      this.$nextTick(() => {
        if (!this.$store.page) return;
        this.$m.scroll((newScrollProgress, info) => {
          if (info.y.velocity !== 0) {
            this.$store.page.scrollProgress = newScrollProgress;
          }
          if (info.y.velocity > 0) {
            this.$store.page.scrollDirection = 'down';
          } else if (info.y.velocity < 0) {
            this.$store.page.scrollDirection = 'up';
          }
        });
      });
    },
    '@scrollend.window'() {
      if (document.documentElement.scrollTop === 0) {
        this.$store.page.scrollProgress = 0;
      }
    },
    'x-resize.document'() {
      this.$store.page.pageHeight = this.$height;
    },
  });
});

/**
 * Directive to manage which header link has the floating hover indicator
 *
 * Links that have a popup attached are handled differently than plain links in that
 * they keep their hover indicator while their popup is open instead of based on whether
 * they are hovered or focused.
 */
Alpine.directive('header-active-indicator', ($el, data) => {
  const isInitialTarget = data.modifiers.includes('initial');
  Alpine.bind($el, {
    'x-init'() {
      if (isInitialTarget) {
        // Set the initial indicator target so that we can for example highlight the current page when the page loads
        this.$data.initialIndicatorTarget = this.$refs.indicatorTarget;
      }
    },
    'x-hover:start'() {
      if (this.$data.hasPopup) return;
      this.$data.indicatorTarget = this.$refs.indicatorTarget;
    },
    'x-hover:end.delay.100ms'() {
      if (this.$data.hasPopup) return;
      // After a delay, check if the link is still active (i.e. no other link is being hoverednk) and if so deactivate it
      if (this.$data.indicatorTarget == this.$refs.indicatorTarget) {
        this.$data.prevIndicatorTarget = this.$refs.indicatorTarget;
        this.$data.indicatorTarget = this.$data.initialIndicatorTarget;
      }
    },
    'x-focusin-state'() {
      if (this.$data.hasPopup) return;
      this.$data.indicatorTarget = this.$refs.indicatorTarget;
    },
    'x-effect'() {
      // When link has a popup drive the 'active' state based on whether the popup is open
      if (this.$data.hasPopup) {
        if (this.$data.hasActivePopup) {
          this.$data.indicatorTarget = this.$refs.indicatorTarget;
        } else if (this.$data.indicatorTarget == this.$refs.indicatorTarget) {
          this.$data.prevIndicatorTarget = this.$refs.indicatorTarget;
          this.$data.indicatorTarget = this.$data.initialIndicatorTarget;
        }
      }
    },
  });
});

Alpine.directive('card', ($el) => {
  Alpine.bind($el, {
    ['x-data']() {
      const $card = {
        isInView: false,
        wasInView: false,
        isHovering: false,
        hasFocusWithin: false,
        wasActive: false,
        isQuickAddActive: false,
        get isActive() {
          return this.isInView && (this.isHovering || this.hasFocusWithin);
        },
      };
      return {
        $card,
      };
    },
    'x-intersect.threshold.20': `$card.isInView = true`,
    'x-focusin-state': `$card.hasFocusWithin = $hasFocusIn`,
    'x-hover:start.delay.150ms': `$card.isHovering = true`,
    'x-hover:end.delay.200ms': `$card.isHovering = false`,
    'x-effect': `
      if ($card.isActive) {
        $card.wasActive = true
      }
      if ($card.isInView) {
        $card.wasInView = true
      }
    `,
  });
}).before('bind');

Alpine.directive('button-cursor', ($el, data) => {
  Alpine.bind($el, {
    ['x-data']() {
      return {
        x: this.$m.springValue(0, {
          stiffness: 1000,
          damping: 100,
        }),
        y: this.$m.springValue(0, {
          stiffness: 1000,
          damping: 100,
        }),
        styleEffect: null,
        width: 0,
        height: 0,
      };
    },
    '@pointerenter'() {
      const {width, height} = $el.getBoundingClientRect();
      this.$el.style.removeProperty('--cursor-x');
      this.$el.style.removeProperty('--cursor-y');
      this.width = width;
      this.height = height;
      this.styleEffect?.();
      this.styleEffect = null;
      this.styleEffect = this.$m.styleEffect($el, {
        '--cursor-x': this.$m.transformValue(() => `${this.x.get()}%`),
        '--cursor-y': this.$m.transformValue(() => `${this.y.get()}%`),
      });
      const newX = (this.$event.offsetX / this.width) * 100;
      const newY = (this.$event.offsetY / this.height) * 100;
      Alpine.raw(this.x).jump(newX);
      Alpine.raw(this.y).jump(newY);
    },
    '@pointermove'() {
      if (this.width === 0 || this.height === 0) return;
      const newX = (this.$event.offsetX / this.width) * 100;
      const newY = (this.$event.offsetY / this.height) * 100;
      Alpine.raw(this.x).set(newX);
      Alpine.raw(this.y).set(newY);
    },
    '@pointerleave'() {
      this.styleEffect?.();
      this.styleEffect = null;
    },
  });
}).before('bind');

const DEFAULT_PAN_THRESHOLD = 10;
/**
 * Enhances slideshows to allow for mobile swipe gestures to navigate between slides.
 */
Alpine.directive('slideshow-mobile-swipe', ($el) => {
  Alpine.bind($el, {
    'x-pan': '',
    '@panend'() {
      if (!this.$media.matches.touch) return;
      if (this.$event.detail.panSession.panDeltaX > DEFAULT_PAN_THRESHOLD) {
        this.$nextTick(() => {
          this.$slideshow.pause();
          this.$slideshow.prev();
        });
      } else if (this.$event.detail.panSession.panDeltaX < -DEFAULT_PAN_THRESHOLD) {
        this.$nextTick(() => {
          this.$slideshow.pause();
          this.$slideshow.next();
        });
      }
    },
  });
});

Alpine.directive('cart-api-section', ($el) => {
  Alpine.bind($el, {
    // Mark this section so that it's id is included in the 'sections' parameter of the cart API requests
    'data-cart-api-section': 'true',
    // Look for updated HTML for this section in the cart API response 'sections' parameter and update the section if it is
    '@theme:cart:add.window'() {
      if (
        !this.$sectionId ||
        !this.$event.detail.sections ||
        !(this.$sectionId in this.$event.detail.sections) ||
        typeof this.$event.detail.sections[this.$sectionId] !== 'string'
      ) {
        // Fall back to manually updating the section with a seperate section rendering API request
        this.$sectionApi.update({batch: true, cachePolicy: 'network-only'});
        return;
      }
      const updatedSectionHtml = this.$event.detail.sections[this.$sectionId];
      this.$sectionApi.setHtml(updatedSectionHtml, {mode: 'morph'});
    },
    '@theme:cart:update.window'() {
      if (
        !this.$sectionId ||
        !this.$event.detail.sections ||
        !(this.$sectionId in this.$event.detail.sections) ||
        typeof this.$event.detail.sections[this.$sectionId] !== 'string'
      ) {
        // Fall back to manually updating the section with a seperate section rendering API request
        this.$sectionApi.update({batch: true, cachePolicy: 'network-only'});
        return;
      }
      const updatedSectionHtml = this.$event.detail.sections[this.$sectionId];
      this.$sectionApi.setHtml(updatedSectionHtml, {mode: 'morph'});
    },
    '@theme:cart:change.window'() {
      if (
        !this.$sectionId ||
        !this.$event.detail.sections ||
        !(this.$sectionId in this.$event.detail.sections) ||
        typeof this.$event.detail.sections[this.$sectionId] !== 'string'
      ) {
        // Fall back to manually updating the section with a seperate section rendering API request
        this.$sectionApi.update({batch: true, cachePolicy: 'network-only'});
        return;
      }
      const updatedSectionHtml = this.$event.detail.sections[this.$sectionId];
      this.$sectionApi.setHtml(updatedSectionHtml, {mode: 'morph'});
    },
    '@theme:cart:clear.window'() {
      if (
        !this.$sectionId ||
        !this.$event.detail.sections ||
        !(this.$sectionId in this.$event.detail.sections) ||
        typeof this.$event.detail.sections[this.$sectionId] !== 'string'
      ) {
        // Fall back to manually updating the section with a seperate section rendering API request
        this.$sectionApi.update({batch: true, cachePolicy: 'network-only'});
        return;
      }
      const updatedSectionHtml = this.$event.detail.sections[this.$sectionId];
      this.$sectionApi.setHtml(updatedSectionHtml, {mode: 'morph'});
    },
    // Refresh the section when the page tab becomes active to ensure the cart data is correct when switching between tabs.
    '@visibilitychange.window.throttle.1000ms'() {
      if (document.hidden) return;
      this.$sectionApi.update({batch: true, cachePolicy: 'network-only'});
    },
  });
});

const cachedRecommendations = new Map();
Alpine.directive('product-complementary', ($el, {expression, modifiers}) => {
  const productId = expression;
  let limit = 1;
  if (modifiers.includes('limit')) {
    const limitIndex = modifiers.indexOf('limit');
    const rawValue = limitIndex >= 0 && limitIndex < modifiers.length - 1 ? modifiers[limitIndex + 1] : undefined;
    if (rawValue) {
      const match = rawValue.match(/([0-9]+)/);
      if (match) limit = Number(match[1]);
    }
  }
  Alpine.bind($el, {
    'x-data'() {
      return {
        abortController: null,
        hasLoaded: false,
        init() {
          if (!this.$el.id) {
            throw new Error('Product complementary element must have an id');
          }
        },
        async fetchProductRecommendations() {
          const sectionId = this.$sectionEl?.id.split('shopify-section-')[1];
          if (!sectionId) return;
          const url = `${window.theme.routes.productRecommendations}?section_id=${sectionId}&product_id=${productId}&limit=${limit}&intent=complementary`;
          const cachedResult = cachedRecommendations.get(url);
          if (cachedResult) {
            this.hasLoaded = true;
            return cachedResult;
          }
          // Abort any in-flight request
          this.abortController?.abort();
          const currentController = new AbortController();
          this.abortController = currentController;
          try {
            // Fetch the updated version of this DOM element from the section rendering API
            const response = await fetch(url, {signal: currentController.signal});
            const result = await response.text();
            // Only set hasLoaded after we have a valid result
            if (!result) return;
            // Parse the result into a DOM tree and find the updated version of this DOM element
            const parsedResult = new DOMParser().parseFromString(result, 'text/html');
            const recommendationHtml = parsedResult.getElementById(this.$el.id)?.outerHTML;
            if (!recommendationHtml) return;
            // Only mark as loaded and cache if we got valid HTML
            this.hasLoaded = true;
            cachedRecommendations.set(url, recommendationHtml);
            return recommendationHtml;
          } catch (error) {
            // Ignore abort errors, but re-throw other errors
            if (error instanceof Error && error.name !== 'AbortError') {
              console.error('Failed to fetch product recommendations:', error);
            }
            return undefined;
          } finally {
            // Only clear the controller if it's still the current one (wasn't replaced by a new request)
            if (this.abortController === currentController) {
              this.abortController = null;
            }
          }
        },
        async updateProductRecommendations() {
          try {
            const result = await this.fetchProductRecommendations();
            if (result) {
              Alpine.morph(this.$el, result);
            }
          } catch (error) {
            console.error('Failed to update product recommendations:', error);
          }
        },
      };
    },
    'x-intersect.once'() {
      if (this.hasLoaded) return;
      window.requestIdleCallback(() => {
        this.updateProductRecommendations();
      });
    },
  });
});

Alpine.directive('header-menu-navigation-item', ($el, {expression, modifiers}, {evaluate}) => {
  const isDesignMode = window.Shopify?.designMode;
  // Expression is the menu id, sublinks modifier indicates if it has sub links
  const menuId = expression;
  const hasSubLinks = modifiers.includes('sublinks');
  Alpine.bind($el, {
    'x-data'() {
      return {
        customMegaMenu: null,
        init() {
          window.requestIdleCallback(() => {
            // Grab the first custom mega menu element matching this menu id
            this.customMegaMenu = document.querySelector(`[data-custom-megamenu="${menuId}"]`);
          });
        },
        get hasCustomMegaMenu() {
          return this.customMegaMenu !== null;
        },
        get hasSubLinks() {
          return hasSubLinks;
        },
        get hasPopup() {
          return this.hasCustomMegaMenu || this.hasSubLinks;
        },
        get hasActivePopup() {
          return this.$store.headerMenu.activePopupId == menuId;
        },
        get isSelectedInThemeEditor() {
          return this.$store.headerMenu.themeEditorSelectedPopupId == menuId;
        },
        selectFromThemeEditor() {
          this.$store.headerMenu.themeEditorSelectedPopupId = menuId;
          this.$popover.open();
        },
        deselectFromThemeEditor() {
          if (this.$store.headerMenu.themeEditorSelectedPopupId == menuId) {
            this.$store.headerMenu.themeEditorSelectedPopupId = null;
          }
          this.$popover.close();
        },
      };
    },
    'x-popover.noreturn.noclose'() {
      return {
        get isOpen() {
          return Alpine.store('headerMenu').activePopupId == menuId;
        },
        set isOpen(value) {
          if (value) {
            Alpine.store('headerMenu').activePopupId = menuId;
          } else {
            if (Alpine.store('headerMenu').activePopupId == menuId) {
              Alpine.store('headerMenu').activePopupId = null;
            }
          }
        },
      };
    },
    'x-hover:start.delay.100ms'() {
      const data = this.$data;
      if (data.hasPopup && !data.hasActivePopup) {
        this.$popover.open();
      }
    },
    'x-hover:end.delay.200ms'() {
      const data = this.$data;
      if (isDesignMode && data.isSelectedInThemeEditor) return;
      if (data.hasActivePopup) {
        this.$popover.close();
      }
    },
    '@mousedown.outside'() {
      const data = this.$data;
      if (data.hasActivePopup) {
        if (isDesignMode) {
          data.deselectFromThemeEditor();
        } else {
          this.$popover.close();
        }
      }
    },
  });
}).before('bind');

class IntersectionObserverManager {
  observers = new Map();
  sections = new Map();
  configs = [{rootMargin: '5% 0% 5% 100%'}, {rootMargin: '-50% 0% -50% 0%'}];
  getObserver(config) {
    const key = `${config.rootMargin}:${config.threshold}`;
    if (!this.observers.has(key)) {
      this.observers.set(
        key,
        new IntersectionObserver((entries) => this.handleIntersection(entries, config), {
          rootMargin: config.rootMargin,
          threshold: config.threshold,
        }),
      );
    }
    return this.observers.get(key);
  }
  handleIntersection(entries, config) {
    const store = Alpine.store('sections');
    for (const entry of entries) {
      const sectionEntry = this.sections.get(entry.target);
      if (!sectionEntry) continue;
      const {sectionId} = sectionEntry;
      const isIntersecting = entry.isIntersecting;
      if (config.rootMargin === '5% 0% 5% 100%') {
        // Standard intersection tracking
        if (isIntersecting) {
          store.intersecting.add(sectionId);
        } else {
          store.intersecting.delete(sectionId);
        }
        // Once-only intersection tracking
        if (isIntersecting && !sectionEntry.hasIntersected) {
          sectionEntry.hasIntersected = true;
          store.intersected.add(sectionId);
        }
      } else if (config.rootMargin === '-50% 0% -50% 0%') {
        // Centered tracking
        if (isIntersecting) {
          store.centered = sectionId;
        } else if (store.centered === sectionId) {
          store.centered = null;
        }
      }
    }
  }
  observe(element, sectionId) {
    if (this.sections.has(element)) return;
    const entry = {
      element,
      sectionId,
      hasIntersected: false,
    };
    this.sections.set(element, entry);
    // Observe with all configurations
    for (const config of this.configs) {
      const observer = this.getObserver(config);
      observer.observe(element);
    }
  }
  unobserve(element) {
    if (!this.sections.has(element)) return;
    // Unobserve from all observers
    for (const observer of this.observers.values()) {
      observer.unobserve(element);
    }
    this.sections.delete(element);
  }
  disconnect() {
    for (const observer of this.observers.values()) {
      observer.disconnect();
    }
    this.observers.clear();
    this.sections.clear();
  }
}
const manager = new IntersectionObserverManager();
// Cleanup on page unload
if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', () => {
    manager.disconnect();
  });
}
Alpine.directive('section-intersection', ($el) => {
  // Use Alpine.bind for reactive data attributes and lifecycle hooks
  Alpine.bind($el, {
    'x-data'() {
      return {
        init() {
          if (!this.$sectionId) return;
          manager.observe($el, this.$sectionId);
        },
        destroy() {
          manager.unobserve($el);
        },
      };
    },
    ':data-intersecting': 'Array.from($store.sections.intersecting).includes($sectionId) ? "true" : "false"',
    ':data-intersected': 'Array.from($store.sections.intersected).includes($sectionId) ? "true" : "false"',
    ':data-centered': '$store.sections.centered == $sectionId ? "true" : "false"',
  });
});

const headerMenuStore = new Proxy(
  {
    prevActivePopupId: null,
    prevActivePopupType: null,
    activePopupId: null,
    popups: new Map(),
    themeEditorSelectedPopupId: null,
    get activePopup() {
      if (this.activePopupId == null) return null;
      return this.popups.get(this.activePopupId)?.el || null;
    },
    get activePopupType() {
      if (this.activePopupId == null) return null;
      return this.popups.get(this.activePopupId)?.type || null;
    },
  },
  {
    set(target, prop, value) {
      // Automatically track the previous active popup so that we can smoothly
      // transition between prev and next popups
      if (prop === 'activePopupId' && value !== target.activePopupId) {
        target.prevActivePopupId = target.activePopupId;
        target.prevActivePopupType = target.activePopupType;
      }
      if (prop !== 'prevActivePopupId' && prop !== 'prevActivePopupType') {
        Reflect.set(target, prop, value);
      }
      return true;
    },
  },
);
Alpine.store('headerMenu', headerMenuStore);

/**
 * Track various information about the sections on the page
 */
const sectionsStore = {
  intersected: new Set(),
  intersecting: new Set(),
  centered: null,
  isIntersecting(id) {
    return this.intersecting?.has(id);
  },
  hasIntersected(id) {
    return this.intersected?.has(id);
  },
};
Alpine.store('sections', sectionsStore);

/**
 * Track various information about the page that needs
 * to be globally accessible
 */
const pageStore = {
  scrollDirection: null,
  scrollProgress: 0,
  pageHeight: 0,
  // Current height of the header (tracked by resize observer)
  headerHeight: 0,
  // The distance from the top of the viewport to the bottom of the last currently sticky header
  headerStickyOffset: 0,
  get isScrolled() {
    return this.scrollProgress > 0;
  },
  // Has the user scrolled past expanded header height?
  get isScrolledPastHeader() {
    if (this.scrollProgress == 0) return false;
    return this.scrollProgress > this.headerHeight / this.pageHeight;
  },
};
Alpine.store('page', pageStore);

/**
 * Store the state of the currently active drawer
 */
Alpine.store(
  'drawer',
  new Proxy(
    {
      isOpen: false,
      type: null,
      data: null,
      prevIsOpen: false,
      prevType: null,
      prevData: null,
    },
    {
      set(target, prop, value, receiver) {
        if (prop === 'isOpen' && value === false) {
          target.type = null;
          target.data = null;
        }
        if (prop === 'isOpen') {
          target.prevIsOpen = target.isOpen;
        }
        if (prop === 'type') {
          target.prevType = target.type;
        }
        if (prop === 'data') {
          target.prevData = target.data;
        }
        return Reflect.set(target, prop, value, receiver);
      },
    },
  ),
);

/**
 * Ensemble brings together multiple elements and binds them to the same data
 *
 * e.g.
 * <div x-ensemble>
 *   <div x-ensemble:slideshow.duration.{{ section.settings.duration | times: 1000 }}ms>...</div>
 *   <div x-ensemble:accordion>...</div>
 * </div>
 */
function ensemble(Alpine) {
  Alpine.directive('ensemble', ($el, {value, modifiers}) => {
    const {$ensemble} = Alpine.$data($el);
    switch (value) {
      case 'slideshow':
        Alpine.bind($el, {
          [`x-slideshow.${modifiers.join('.')}`]() {
            return {
              get currentSlideIndex() {
                if (!$ensemble) return 0;
                if ($ensemble.selectedIndex === null) return 0;
                // If this is the last slide of this particular ensemble members slideshow but there are more slides in the ensemble
                // then just show the last slide of the ensemble
                if ($ensemble.selectedIndex >= this.totalSlides) {
                  return this.totalSlides - 1;
                }
                return $ensemble.selectedIndex;
              },
              set currentSlideIndex(value) {
                $ensemble.selectedIndex = value;
              },
              get state() {
                if (!$ensemble) return 'paused';
                // If this particular ensemble member's slideshow has less slides than the ensemble itself (i.e. there are other slideshows in the ensemble)
                // then pause _this_ slideshow and let the other slideshows take over
                if (this.totalSlides < $ensemble.totalSlides) {
                  return 'paused';
                }
                return $ensemble.isPlaying ? 'playing' : 'paused';
              },
            };
          },
          'x-effect'() {
            if (!this.$ensemble) return;
            if (this.$slideshow.totalSlides > this.$ensemble.totalSlides) {
              this.$ensemble.totalSlides = this.$slideshow.totalSlides;
            }
          },
        });
        break;
      case 'disclosure-group':
        Alpine.bind($el, {
          [`x-disclosure-group.${modifiers.join('.')}`]() {
            return {
              get expandedIndex() {
                // If there is no selectedIndex for some reason, show the first disclosure
                if ($ensemble.selectedIndex === null) return 0;
                // If the selectedIndex doesn't match any disclosures, show the last disclosure
                const lastDisclosureIndex = Array.from(this.items).length - 1;
                if ($ensemble.selectedIndex > lastDisclosureIndex) return lastDisclosureIndex;
                return $ensemble.selectedIndex;
              },
              set expandedIndex(value) {
                // Only allow opening new accordion items, not closing them
                if (Number.isNaN(value) || value === null || value < 0) return;
                $ensemble.selectedIndex = value;
              },
            };
          },
        });
        break;
      case 'tabs':
        Alpine.bind($el, {
          [`x-tabs.${modifiers.join('.')}`]() {
            return {
              get selectedIndex() {
                // If there is no selectedIndex for some reason, show the first tab
                if ($ensemble.selectedIndex === null) return 0;
                // If the selectedIndex doesn't match any tabs, show the last tab
                const lastTabIndex = Array.from(this.items).length - 1;
                if ($ensemble.selectedIndex > lastTabIndex) return lastTabIndex;
                return $ensemble.selectedIndex;
              },
              set selectedIndex(value) {
                $ensemble.selectedIndex = value;
              },
            };
          },
        });
        break;
      case 'carousel':
        Alpine.bind($el, {
          [`x-carousel.${modifiers.join('.')}`]: '',
          ['x-effect']() {
            if (!this.$ensemble) return;
            this.$watch('$carousel.centeredIndex', (centeredIndex) => {
              this.$ensemble.selectedIndex = centeredIndex;
            });
            this.$watch('$ensemble.selectedIndex', (selectedIndex) => {
              const centeredIndex = this.$carousel.centeredIndex;
              if (centeredIndex !== selectedIndex) {
                this.$carousel.scrollTo(selectedIndex, {align: 'center'});
              }
            });
          },
        });
        break;
      case 'hotspots':
        Alpine.bind($el, {
          ['x-list-state']() {
            return {
              scope: 'hotspots',
              get selectedIndex() {
                if ($ensemble.selectedIndex === null) {
                  return null;
                }
                return $ensemble.selectedIndex;
              },
              set selectedIndex(value) {
                $ensemble.hasFocus = true;
                if (Number.isNaN(value) || value === null || value < 0) return;
                $ensemble.selectedIndex = value;
              },
            };
          },
        });
        break;
      case null:
        const autoplay = modifiers.includes('autoplay');
        const $data = Alpine.$data($el);
        const sectionData = $data.$sectionData;
        Alpine.bind($el, {
          ['x-data']() {
            const $ensemble = {
              titleEl: null,
              // Store the current slide index in $sectionData so that we can restore it when the section is reloaded in the theme editor
              get selectedIndex() {
                return sectionData?.selectedIndex ?? 0;
              },
              set selectedIndex(value) {
                sectionData.selectedIndex = value;
              },
              totalSlides: 0,
              autoplay: autoplay,
              hasFocus: false,
              isInView: false,
              get isPlaying() {
                return this.autoplay && this.isInView && !this.hasFocus;
              },
              members: {},
              registerMember(id, el) {
                this.members[id] = el;
              },
              getPeerIds(id) {
                return Object.keys(this.members).filter((memberId) => memberId !== id);
              },
            };
            return {
              $ensemble,
            };
          },
          'x-intersect:enter.half': `$ensemble.isInView = true`,
          'x-intersect:leave.half': `
            $ensemble.isInView = false
            $ensemble.hasFocus = false
          `,
          '@focusin': '$ensemble.hasFocus = true',
          '@pointerdown': '$ensemble.hasFocus = true',
          ':aria-labelledby': '$ensemble.titleEl?.id || null',
        });
        if (window.Shopify?.designMode) {
          Alpine.bind($el, {
            'x-effect': `$ensemble.hasFocus = $isSelectedSection`,
          });
        }
        break;
      default:
        throw new Error(`Invalid ensemble directive: ${value}`);
    }
  }).before('bind');
}
Alpine.plugin(ensemble);

function productMedia(Alpine) {
  Alpine.directive('product-media', ($el, data) => {
    switch (data.value) {
      case 'model':
        handleModel($el, Alpine);
        break;
      case 'youtube':
        handleYoutubeVideo($el, data, Alpine);
        break;
      case 'vimeo':
        handleVimeoVideo($el, data, Alpine);
        break;
    }
  }).before('bind');
}
function handleModel($el, Alpine) {
  Alpine.bind($el, {
    'x-data'() {
      return {
        state: 'initial',
        pointerStartX: 0,
        pointerStartY: 0,
        get hasLoaded() {
          return this.state != 'initial' && this.state != 'loading';
        },
        get isLoading() {
          return this.state == 'loading';
        },
        initModel() {
          this.state = 'loading';
          window.Shopify?.loadFeatures?.([
            {
              name: 'model-viewer-ui',
              version: '1.0',
              onLoad: this.setupModelViewerUI.bind(this),
            },
          ]);
        },
        async setupModelViewerUI(errors) {
          if (errors) {
            console.error('Failed to load model viewer UI:', errors);
            this.state = 'initial';
            return;
          }
          if (!window.Shopify?.ModelViewerUI) {
            await this.waitForModelViewerUIOnSafari();
          }
          if (!window.Shopify?.ModelViewerUI) {
            console.error('ModelViewerUI not available after waiting');
            this.state = 'initial';
            return;
          }
          this.state = 'ready';
          this.$nextTick(() => {
            const element = this.$root.querySelector('model-viewer');
            if (!element) {
              console.error('No model-viewer element found');
              this.state = 'initial';
              return;
            }
            try {
              this.$el._x_modelViewer = new window.Shopify.ModelViewerUI(element);
              if (!this.$el._x_modelViewer) {
                console.error('Failed to create ModelViewerUI instance');
                this.state = 'initial';
                return;
              }
              this.playModel();
              this.$dispatch('theme:model:loaded', {details: this.$el._x_modelViewer});
            } catch (error) {
              console.error('Error initializing model viewer:', error);
              this.state = 'initial';
            }
          });
        },
        playModel() {
          if (!this.$el._x_modelViewer || this.state == 'playing') return;
          try {
            this.$el._x_modelViewer.play();
            this.state = 'playing';
          } catch (error) {
            console.error('Error playing model:', error);
          }
        },
        pauseModel() {
          if (!this.$el._x_modelViewer || this.state == 'paused') return;
          try {
            this.$el._x_modelViewer.pause();
            this.state = 'paused';
          } catch (error) {
            console.error('Error pausing model:', error);
          }
        },
        getPointerCoordinates(event) {
          if (!this.$el._x_modelViewer) return;
          this.pointerStartX = event.clientX;
          this.pointerStartY = event.clientY;
        },
        togglePlayPause(event) {
          if (!this.$el._x_modelViewer) return;
          const distanceX = Math.abs(event.clientX - this.pointerStartX);
          const distanceY = Math.abs(event.clientY - this.pointerStartY);
          const totalDistance = Math.sqrt(distanceX * distanceX + distanceY * distanceY);
          // Try to ensure that this is a tap, not a drag.
          if (totalDistance < 10) {
            if (this.state == 'playing') {
              this.pauseModel();
            } else {
              this.playModel();
            }
          }
        },
        async waitForModelViewerUIOnSafari() {
          // Waits for Shopify.ModelViewerUI to be defined.
          // This seems to be necessary for Safari since Shopify.ModelViewerUI is always undefined on the first try.
          const maxAttempts = 10;
          const interval = 50;
          for (let i = 0; i < maxAttempts; i++) {
            if (window.Shopify?.ModelViewerUI) {
              return;
            }
            await new Promise((resolve) => setTimeout(resolve, interval));
          }
        },
      };
    },
  });
}
function handleYoutubeVideo($el, {modifiers, expression}, Alpine) {
  const isLazy = modifiers.includes('lazy');
  const autoplay = modifiers.includes('autoplay');
  if (typeof expression !== 'string') {
    console.warn('Invalid youtube video ID', expression);
    return;
  }
  const videoId = expression;
  Alpine.bind($el, {
    'x-data'() {
      return {
        state: 'initial',
        isLazy,
        videoId,
        autoplay,
        init() {
          if (!this.isLazy) {
            this.loadPlayer();
          }
        },
        destroy() {
          this.destroyPlayer();
        },
        loadPlayer() {
          this.$load
            .script('https://www.youtube.com/iframe_api')
            .then(() => {
              // Initialize videos when the API is ready
              if (window.YT?.loaded) {
                this.$dispatch('theme:youtube:init');
              } else {
                window.onYouTubeIframeAPIReady = () => this.$dispatch('theme:youtube:init');
              }
            })
            .catch((error) => {
              console.error('Failed to load YouTube API:', error);
            });
        },
        initVideo() {
          // Don't initialize the video twice
          if (this.$el._x_youtubePlayer) return;
          // Try to find the iframe or element to attach the player to
          let el = this.$el.querySelector('[data-youtube-player]');
          if (!el) {
            console.warn('No element found for YouTube player');
            return;
          }
          this.state = 'loading';
          try {
            // We store the player on the element as opposed to in alpine state because that will cause
            // it to be wrapped in a proxy and not be able to access the original methods.
            this.$el._x_youtubePlayer = new window.YT.Player(el, {
              videoId: this.videoId,
              playerVars: {
                cc_load_policy: 1,
                iv_load_policy: 3,
                modestbranding: 1,
                autoplay: this.autoplay,
                playsinline: 1,
                controls: 1,
                showinfo: 0,
                ecver: 2,
                fs: 1,
                rel: 0,
              },
              events: {
                onReady: () => {
                  this.state = 'ready';
                  this.$dispatch('theme:youtube:loaded', {videoId: this.videoId});
                },
                onStateChange: (event) => {
                  // Map YT states to our state
                  const YTState = window.YT.PlayerState;
                  switch (event.data) {
                    case YTState.PLAYING:
                      this.state = 'playing';
                      break;
                    case YTState.PAUSED:
                      this.state = 'paused';
                      break;
                    case YTState.ENDED:
                      break;
                    case YTState.BUFFERING:
                      this.state = 'loading';
                      break;
                    case YTState.CUED:
                      this.state = 'ready';
                      break;
                    default:
                      this.state = 'initial';
                  }
                },
                onError: (event) => {
                  console.error('YouTube player error:', event.data);
                  this.state = 'initial';
                },
              },
            });
          } catch (error) {
            console.error('Error initializing YouTube player:', error);
            this.state = 'initial';
          }
        },
        playVideo() {
          try {
            if (this.$el._x_youtubePlayer && typeof this.$el._x_youtubePlayer.playVideo === 'function') {
              this.$el._x_youtubePlayer.playVideo();
            }
          } catch (e) {
            console.warn('Error playing YouTube video:', e);
          }
        },
        async pauseVideo() {
          try {
            if (this.$el._x_youtubePlayer && typeof this.$el._x_youtubePlayer.pauseVideo === 'function') {
              this.$el._x_youtubePlayer.pauseVideo();
            }
          } catch (e) {
            console.warn('Error pausing YouTube video:', e);
          }
        },
        // Unloads the video to its initial state showing placeholder image
        async unloadPlayer() {
          try {
            if (this.$el._x_youtubePlayer && typeof this.$el._x_youtubePlayer.cueVideoById === 'function') {
              this.$el._x_youtubePlayer.cueVideoById({videoId: this.videoId});
              this.state = 'ready';
            }
          } catch (e) {
            console.warn('Error unloading YouTube player:', e);
          }
        },
        destroyPlayer() {
          try {
            if (this.$el._x_youtubePlayer && typeof this.$el._x_youtubePlayer.destroy === 'function') {
              this.$el._x_youtubePlayer.destroy();
              this.$el._x_youtubePlayer = undefined;
              this.state = 'initial';
            }
          } catch (e) {
            console.warn('Error destroying YouTube player:', e);
            // Clean up even if destroy fails
            this.$el._x_youtubePlayer = undefined;
            this.state = 'initial';
          }
        },
      };
    },
    // Wait for any youtube:init from any component to initialize the video
    '@theme:youtube:init.window': 'initVideo',
  });
}
function handleVimeoVideo($el, {modifiers, expression}, Alpine) {
  const isLazy = modifiers.includes('lazy');
  const autoplay = modifiers.includes('autoplay');
  if (typeof expression !== 'string') {
    console.warn('Invalid vimeo video ID', expression);
    return;
  }
  const videoId = Number(expression);
  if (isNaN(videoId)) {
    console.warn('Invalid vimeo video ID', expression);
    return;
  }
  Alpine.bind($el, {
    'x-data'() {
      return {
        state: 'initial',
        isLazy,
        autoplay,
        videoId,
        init() {
          if (!this.isLazy) {
            this.loadPlayer();
          }
        },
        destroy() {
          this.destroyPlayer();
        },
        loadPlayer() {
          this.$load
            .script('https://player.vimeo.com/api/player.js')
            .then(() => {
              this.$dispatch('theme:vimeo:init');
            })
            .catch((error) => {
              console.error('Failed to load Vimeo API:', error);
            });
        },
        initVideo() {
          // Don't initialize the video twice
          if (this.$el._x_vimeoPlayer) return;
          // Try to find the iframe or element to attach the player to
          let el = this.$el.querySelector('[data-vimeo-player]');
          if (!el) {
            console.warn('No element found for Vimeo player');
            return;
          }
          if (!window.Vimeo) return;
          this.state = 'loading';
          try {
            // We store the player on the element as opposed to in alpine state because that will cause
            // it to be wrapped in a proxy and not be able to access the original methods.
            this.$el._x_vimeoPlayer = new window.Vimeo.Player(el, {
              id: this.videoId,
              autoplay: this.autoplay,
              loop: false,
              controls: true,
              muted: false,
              playsinline: true,
            });
            const events = ['play', 'pause', 'ended', 'loaded'];
            events.forEach((event) => {
              this.$el._x_vimeoPlayer?.on(event, () => {
                switch (event) {
                  case 'play':
                    this.state = 'playing';
                    break;
                  case 'pause':
                    this.state = 'paused';
                    break;
                  case 'loaded':
                    this.state = 'ready';
                    break;
                  default:
                    this.state = event;
                    break;
                }
              });
            });
            this.$dispatch('theme:vimeo:loaded', {videoId: this.videoId});
          } catch (error) {
            console.error('Error initializing Vimeo player:', error);
            this.state = 'initial';
          }
        },
        playVideo() {
          if (this.$el._x_vimeoPlayer?.play) {
            // Only play if the video is paused
            this.$el._x_vimeoPlayer
              .getPaused()
              .then((paused) => {
                if (paused) {
                  this.$el._x_vimeoPlayer?.play().catch((error) => {
                    console.error('Error playing Vimeo video:', error);
                  });
                }
              })
              .catch((error) => {
                console.error('Error checking Vimeo player state:', error);
              });
          }
        },
        async pauseVideo() {
          try {
            const paused = await this.$el._x_vimeoPlayer?.getPaused();
            if (!paused && this.$el._x_vimeoPlayer?.pause) {
              await this.$el._x_vimeoPlayer.pause();
            }
          } catch (error) {
            console.error('Error pausing Vimeo video:', error);
          }
        },
        // Unloads the video to its initial state showing placeholder image
        async unloadPlayer() {
          try {
            await this.pauseVideo();
            await this.$el._x_vimeoPlayer?.setCurrentTime(0);
            await this.$el._x_vimeoPlayer?.unload();
          } catch (error) {
            console.error('Error unloading Vimeo player:', error);
          }
        },
        destroyPlayer() {
          try {
            if (this.$el._x_vimeoPlayer?.destroy) {
              this.$el._x_vimeoPlayer.destroy().catch((error) => {
                console.error('Error destroying Vimeo player:', error);
              });
            }
          } catch (e) {
            console.warn('Error destroying Vimeo player:', e);
          } finally {
            // Clean up even if destroy fails
            this.$el._x_vimeoPlayer = undefined;
            this.state = 'initial';
          }
        },
      };
    },
    // Wait for any vimeo:init from any component to initialize the video
    '@theme:vimeo:init.window': 'initVideo',
  });
}
Alpine.plugin(productMedia);

// Cache for sticky modes to avoid redundant DOM reads
const stickyModeCache = new WeakMap();
function getStickyMode(el) {
  if (stickyModeCache.has(el)) {
    return stickyModeCache.get(el);
  }
  const firstChild = el.firstElementChild;
  if (!firstChild) {
    stickyModeCache.set(el, 'never');
    return 'never';
  }
  const mode = firstChild.getAttribute('data-sticky-header');
  const stickyMode = mode === 'always' || mode === 'scroll' || mode === 'never' ? mode : 'never';
  stickyModeCache.set(el, stickyMode);
  return stickyMode;
}
function isCurrentlySticky(item, stickyMode) {
  if (stickyMode === 'never') return false;
  if (stickyMode === 'always') return true;
  if (stickyMode === 'scroll') {
    return Alpine.store('page').scrollDirection === 'up';
  }
  return false;
}
function headerStack(Alpine) {
  Alpine.directive('header-stack', ($el, data) => {
    Alpine.bind($el, {
      'x-data'() {
        return {
          resizeObserver: null,
          mutationObserver: null,
          rafId: null,
          observeChildren() {
            // Observe all current children with ResizeObserver
            if (this.resizeObserver) {
              for (const item of $el.children) {
                this.resizeObserver.observe(item);
              }
            }
          },
          recalculate() {
            // Cancel any pending RAF to batch multiple calls
            if (this.rafId !== null) {
              cancelAnimationFrame(this.rafId);
            }
            this.rafId = requestAnimationFrame(() => {
              this.rafId = null;
              this._performRecalculate();
            });
          },
          _performRecalculate() {
            const pageStore = Alpine.store('page');
            let headerHeight = 0;
            let stickyOffset = 0;
            const stickyTopValues = new WeakMap();
            const childElements = [];
            const childHeights = [];
            const childStickyModes = [];
            // Batch all DOM reads first
            for (const child of $el.children) {
              const childEl = child;
              childElements.push(childEl);
              childHeights.push(childEl.offsetHeight);
              childStickyModes.push(getStickyMode(childEl));
            }
            // Calculate sticky positions using cached values
            for (let i = 0; i < childElements.length; i++) {
              const childEl = childElements[i];
              const height = childHeights[i];
              const stickyMode = childStickyModes[i];
              const isSticky = isCurrentlySticky(childEl, stickyMode);
              headerHeight += height;
              if (isSticky) {
                let top = 0;
                // Calculate top position from previous sticky siblings
                for (let j = i - 1; j >= 0; j--) {
                  const prevStickyMode = childStickyModes[j];
                  if (isCurrentlySticky(childElements[j], prevStickyMode)) {
                    top += childHeights[j];
                  }
                }
                const stickyTop = Math.max(top, 0);
                stickyTopValues.set(childEl, stickyTop);
                if (stickyTop >= 0) {
                  stickyOffset = stickyTop + height;
                }
              } else if (stickyMode === 'scroll') {
                // For scroll mode when not sticky, position off-screen
                stickyTopValues.set(childEl, -height);
              }
            }
            // Batch all DOM writes
            pageStore.headerHeight = headerHeight;
            pageStore.headerStickyOffset = stickyOffset;
            for (const childEl of childElements) {
              const stickyTop = stickyTopValues.get(childEl);
              if (stickyTop === undefined) {
                childEl.style.removeProperty('position');
                childEl.style.removeProperty('transition');
                childEl.style.removeProperty('top');
              } else {
                childEl.style.position = 'sticky';
                childEl.style.transition = 'top 0.3s var(--ease-out-fast)';
                childEl.style.top = `${stickyTop}px`;
              }
            }
          },
          init() {
            this.$nextTick(() => {
              this.recalculate();
            });
            // Use requestAnimationFrame for ResizeObserver to batch with other work
            this.resizeObserver = new ResizeObserver(() => {
              this.recalculate();
            });
            // Only observe the header container and its children, not the entire document
            this.resizeObserver.observe($el);
            this.observeChildren();
            // Watch for child additions/removals (e.g., in theme editor)
            this.mutationObserver = new MutationObserver((mutations) => {
              let shouldRecalculate = false;
              for (const mutation of mutations) {
                if (mutation.type === 'childList') {
                  // Invalidate cache for removed nodes
                  for (const removedNode of mutation.removedNodes) {
                    if (removedNode instanceof HTMLElement) {
                      stickyModeCache.delete(removedNode);
                    }
                  }
                  // Observe newly added children
                  for (const addedNode of mutation.addedNodes) {
                    if (addedNode instanceof HTMLElement && addedNode.parentElement === $el) {
                      if (this.resizeObserver) {
                        this.resizeObserver.observe(addedNode);
                      }
                      shouldRecalculate = true;
                    }
                  }
                  if (mutation.removedNodes.length > 0) {
                    shouldRecalculate = true;
                  }
                }
              }
              if (shouldRecalculate) {
                this.recalculate();
              }
            });
            this.mutationObserver.observe($el, {
              childList: true,
              subtree: false,
            });
            this.$watch('$store.page.scrollDirection', () => {
              this.recalculate();
            });
            this.$watch('$store.page.isScrolled', (isScrolled) => {
              if (!isScrolled) {
                this.recalculate();
              }
            });
          },
          destroy() {
            if (this.rafId !== null) {
              cancelAnimationFrame(this.rafId);
            }
            if (this.resizeObserver) {
              this.resizeObserver.disconnect();
            }
            if (this.mutationObserver) {
              this.mutationObserver.disconnect();
            }
          },
        };
      },
    });
  }).before('bind');
}
Alpine.plugin(headerStack);

function headerFlyoutBackdrop(Alpine) {
  Alpine.directive('header-flyout-backdrop', ($el, data, {effect, cleanup}) => {
    let resizeObserver = null;
    let rafId = null;
    let currentPopup = null;
    let isInitialMount = true;
    const updateHeight = (popup) => {
      // Cancel any pending RAF to batch updates
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
      }
      rafId = requestAnimationFrame(() => {
        rafId = null;
        if (!popup) {
          // No popup active, animate to 0
          $el.style.transition = 'opacity var(--header-menu-flyout-exit-duration) ease-in-out';
          $el.style.opacity = '0';
          isInitialMount = true;
          return;
        }
        const popupRect = popup.getBoundingClientRect();
        // Skip if popup isn't positioned yet (height is 0)
        if (popupRect.height === 0) {
          return;
        }
        const backdropHeight = popupRect.bottom;
        // Only update if height actually changed
        const currentHeight = $el.clientHeight;
        const needsTransition = currentHeight > 0 && !isInitialMount;
        if (needsTransition) {
          $el.style.transition = 'height var(--header-menu-flyout-enter-duration) ease-in-out';
        } else {
          $el.style.transition = 'opacity var(--header-menu-flyout-exit-duration) ease-in-out';
        }
        $el.style.height = `${backdropHeight}px`;
        $el.style.opacity = '1';
        isInitialMount = false;
      });
    };
    const observePopup = (popup) => {
      // Clean up previous observer
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }
      currentPopup = popup;
      if (!popup) {
        updateHeight(null);
        return;
      }
      // Create new observer for the active popup
      resizeObserver = new ResizeObserver(() => {
        // Only update if this is still the current popup (handles rapid switching)
        if (currentPopup === popup) {
          updateHeight(popup);
        }
      });
      resizeObserver.observe(popup);
      // Initial height calculation
      updateHeight(popup);
    };
    // Watch for changes to the active popup
    effect(() => {
      const store = Alpine.store('headerMenu');
      const activePopup = store.activePopup;
      const activePopupType = store.activePopupType;
      if (activePopupType === 'flyout' && activePopup) {
        observePopup(activePopup);
      } else {
        observePopup(null);
      }
    });
    // Cleanup on unmount
    cleanup(() => {
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }
      currentPopup = null;
    });
  }).before('bind');
}
Alpine.plugin(headerFlyoutBackdrop);

function isProductForm(el) {
  return isFormElement(el) && el.getAttribute('action')?.includes('cart/add');
}
function isInProductForm(el) {
  return isHtmlElement(el) && !isProductForm(el) && el.closest('form[action*="cart/add"]');
}
function isHiddenInput(el) {
  return isInputElement(el) && el.type === 'hidden';
}
function isShopifyAppBlock(el) {
  return isHtmlElement(el) && el.classList.contains('shopify-app-block');
}
function isShopifyElement(el) {
  return isHtmlElement(el) && el.hasAttribute('data-shopify');
}

/* Method UI plugins */
Alpine.plugin([
  module_default$5,
  module_default$4,
  module_default$3,
  module_default$2,
  module_default$1,
  module_default,
  rovingTab,
  focusMatch,
  parallax,
  popup,
  float,
  overflow,
  hold,
  tabs,
  listbox,
  select,
  scrollList,
  carousel,
  animationUtils,
  range,
  disclosure,
  dialog,
  section,
  cache,
  asyncLink,
  asyncForm,
  router,
  slideshow,
  notification,
  productForm,
  imageLoadingPlaceholder,
  tooltip,
  stepper,
  motion,
  marquee,
  hover,
  focusState,
  focusInState,
  clone,
  submittableTextarea,
  predictiveSearch,
  scrollLock,
  record,
  countdown,
  currency,
  customCursor,
  listState,
  popover,
  sliderReveal,
  clipboard,
  keyboardActive,
  utils,
  stickyScroll,
  pan,
  cartForm,
  cartItem,
  photoSwipe({
    pswpModule: () => import('photoswipe'),
    // Plugin requires a container element to be present in the DOM preferably at the end of the body tag
    appendToEl: document.querySelector('[data-photoswipe-container]') || undefined,
  }),
]);
Alpine.plugin(
  sectionApi({
    morphConfig: {
      // Customize theme-wide section morphing behaviour here
      updating(el, toEl, childrenOnly, skip) {
        // Call `skip()` to prevent an element from being removed
        // Call `childrenOnly()` to prevent an element from being updated but allow it's children to be updated
        // Skip any built-in shopify elements
        if (isShopifyElement(el)) {
          skip();
        }
        // Skip updating app blocks to prevent breaking apps like Recharge. You may want to update or remove this logic depending on your theme's needs
        if (isShopifyAppBlock(el)) {
          skip();
        }
      },
      removing(el, skip) {
        // Call `skip()` to prevent an element from being removed
        if (isShopifyElement(el)) {
          skip();
        }
        if (isShopifyAppBlock(el)) {
          skip();
        }
      },
      key(el) {
        if (isInProductForm(el) && isHiddenInput(el)) {
          return el.getAttribute('name');
        }
        return el.getAttribute('key');
      },
    },
  }),
);
// TODO check if we actually use this for anything anymore and if not then remove it
Alpine.store('cache').addResource('products');
Alpine.store('cache').addResource('models');
Alpine.plugin(
  // These breakpoints should match the CSS breakpoint values
  media({
    sm: `(max-width: ${window.theme.screen.md - 1}px)`,
    md: `(min-width: ${window.theme.screen.md}px) and (max-width: ${window.theme.screen.lg - 1}px)`,
    lg: `(min-width: ${window.theme.screen.lg}px) and (max-width: ${window.theme.screen.xl - 1}px)`,
    xl: `(min-width: ${window.theme.screen.xl}px) and (max-width: ${window.theme.screen['2xl'] - 1}px)`,
    '2xl': `(min-width: ${window.theme.screen['2xl']}px)`,
    touch: '(pointer: coarse) and (hover: none)',
  }),
);
// Allow global access to Alpine in case things like Alpine.bind or Alpine.store are needed
window.Alpine = Alpine;
// Wait until DOM has loaded before starting Alpine so that any script tags that add plugins, data, stores, etc. have all run
document.addEventListener('DOMContentLoaded', () => {
  /* Initialization */
  Alpine.start();
});
